(() => {

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9339"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9339"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("yIC3S", function(module, exports) {

(function() {
    /*jshint eqeqeq:false curly:false latedef:false */ "use strict";
    function setup($) {
        $.fn._fadeIn = $.fn.fadeIn;
        var noOp = $.noop || function() {};
        // this bit is to ensure we don't call setExpression when we shouldn't (with extra muscle to handle
        // confusing userAgent strings on Vista)
        var msie = /MSIE/.test(navigator.userAgent);
        var ie6 = /MSIE 6.0/.test(navigator.userAgent) && !/MSIE 8.0/.test(navigator.userAgent);
        var mode = document.documentMode || 0;
        var setExpr = $.isFunction(document.createElement("div").style.setExpression);
        // global $ methods for blocking/unblocking the entire page
        $.blockUI = function(opts) {
            install(window, opts);
        };
        $.unblockUI = function(opts) {
            remove(window, opts);
        };
        // convenience method for quick growl-like notifications  (http://www.google.com/search?q=growl)
        $.growlUI = function(title, message, timeout, onClose) {
            var $m = $('<div class="growlUI"></div>');
            if (title) $m.append("<h1>" + title + "</h1>");
            if (message) $m.append("<h2>" + message + "</h2>");
            if (timeout === undefined) timeout = 3000;
            // Added by konapun: Set timeout to 30 seconds if this growl is moused over, like normal toast notifications
            var callBlock = function(opts) {
                opts = opts || {};
                $.blockUI({
                    message: $m,
                    fadeIn: typeof opts.fadeIn !== "undefined" ? opts.fadeIn : 700,
                    fadeOut: typeof opts.fadeOut !== "undefined" ? opts.fadeOut : 1000,
                    timeout: typeof opts.timeout !== "undefined" ? opts.timeout : timeout,
                    centerY: false,
                    showOverlay: false,
                    onUnblock: onClose,
                    css: $.blockUI.defaults.growlCSS
                });
            };
            callBlock();
            var nonmousedOpacity = $m.css("opacity");
            $m.mouseover(function() {
                callBlock({
                    fadeIn: 0,
                    timeout: 30000
                });
                var displayBlock = $(".blockMsg");
                displayBlock.stop(); // cancel fadeout if it has started
                displayBlock.fadeTo(300, 1); // make it easier to read the message by removing transparency
            }).mouseout(function() {
                $(".blockMsg").fadeOut(1000);
            });
        // End konapun additions
        };
        // plugin method for blocking element content
        $.fn.block = function(opts) {
            if (this[0] === window) {
                $.blockUI(opts);
                return this;
            }
            var fullOpts = $.extend({}, $.blockUI.defaults, opts || {});
            this.each(function() {
                var $el = $(this);
                if (fullOpts.ignoreIfBlocked && $el.data("blockUI.isBlocked")) return;
                $el.unblock({
                    fadeOut: 0
                });
            });
            return this.each(function() {
                if ($.css(this, "position") == "static") {
                    this.style.position = "relative";
                    $(this).data("blockUI.static", true);
                }
                this.style.zoom = 1; // force 'hasLayout' in ie
                install(this, opts);
            });
        };
        // plugin method for unblocking element content
        $.fn.unblock = function(opts) {
            if (this[0] === window) {
                $.unblockUI(opts);
                return this;
            }
            return this.each(function() {
                remove(this, opts);
            });
        };
        $.blockUI.version = 2.70; // 2nd generation blocking at no extra cost!
        // override these in your code to change the default behavior and style
        $.blockUI.defaults = {
            // message displayed when blocking (use null for no message)
            message: "<h1>Please wait...</h1>",
            title: null,
            draggable: true,
            theme: false,
            // styles for the message when blocking; if you wish to disable
            // these and use an external stylesheet then do this in your code:
            // $.blockUI.defaults.css = {};
            css: {
                padding: 0,
                margin: 0,
                width: "30%",
                top: "40%",
                left: "35%",
                textAlign: "center",
                color: "#000",
                border: "3px solid #aaa",
                backgroundColor: "#fff",
                cursor: "wait"
            },
            // minimal style set used when themes are used
            themedCSS: {
                width: "30%",
                top: "40%",
                left: "35%"
            },
            // styles for the overlay
            overlayCSS: {
                backgroundColor: "#000",
                opacity: 0.6,
                cursor: "wait"
            },
            // style to replace wait cursor before unblocking to correct issue
            // of lingering wait cursor
            cursorReset: "default",
            // styles applied when using $.growlUI
            growlCSS: {
                width: "350px",
                top: "10px",
                left: "",
                right: "10px",
                border: "none",
                padding: "5px",
                opacity: 0.6,
                cursor: "default",
                color: "#fff",
                backgroundColor: "#000",
                "-webkit-border-radius": "10px",
                "-moz-border-radius": "10px",
                "border-radius": "10px"
            },
            // IE issues: 'about:blank' fails on HTTPS and javascript:false is s-l-o-w
            // (hat tip to Jorge H. N. de Vasconcelos)
            /*jshint scripturl:true */ iframeSrc: /^https/i.test(window.location.href || "") ? "javascript:false" : "about:blank",
            // force usage of iframe in non-IE browsers (handy for blocking applets)
            forceIframe: false,
            // z-index for the blocking overlay
            baseZ: 1000,
            // set these to true to have the message automatically centered
            centerX: true,
            centerY: true,
            // allow body element to be stetched in ie6; this makes blocking look better
            // on "short" pages.  disable if you wish to prevent changes to the body height
            allowBodyStretch: true,
            // enable if you want key and mouse events to be disabled for content that is blocked
            bindEvents: true,
            // be default blockUI will supress tab navigation from leaving blocking content
            // (if bindEvents is true)
            constrainTabKey: true,
            // fadeIn time in millis; set to 0 to disable fadeIn on block
            fadeIn: 200,
            // fadeOut time in millis; set to 0 to disable fadeOut on unblock
            fadeOut: 400,
            // time in millis to wait before auto-unblocking; set to 0 to disable auto-unblock
            timeout: 0,
            // disable if you don't want to show the overlay
            showOverlay: true,
            // if true, focus will be placed in the first available input field when
            // page blocking
            focusInput: true,
            // elements that can receive focus
            focusableElements: ":input:enabled:visible",
            // suppresses the use of overlay styles on FF/Linux (due to performance issues with opacity)
            // no longer needed in 2012
            // applyPlatformOpacityRules: true,
            // callback method invoked when fadeIn has completed and blocking message is visible
            onBlock: null,
            // callback method invoked when unblocking has completed; the callback is
            // passed the element that has been unblocked (which is the window object for page
            // blocks) and the options that were passed to the unblock call:
            //	onUnblock(element, options)
            onUnblock: null,
            // callback method invoked when the overlay area is clicked.
            // setting this will turn the cursor to a pointer, otherwise cursor defined in overlayCss will be used.
            onOverlayClick: null,
            // don't ask; if you really must know: http://groups.google.com/group/jquery-en/browse_thread/thread/36640a8730503595/2f6a79a77a78e493#2f6a79a77a78e493
            quirksmodeOffsetHack: 4,
            // class name of the message block
            blockMsgClass: "blockMsg",
            // if it is already blocked, then ignore it (don't unblock and reblock)
            ignoreIfBlocked: false
        };
        // private data and functions follow...
        var pageBlock = null;
        var pageBlockEls = [];
        function install(el, opts) {
            var css, themedCSS;
            var full = el == window;
            var msg = opts && opts.message !== undefined ? opts.message : undefined;
            opts = $.extend({}, $.blockUI.defaults, opts || {});
            if (opts.ignoreIfBlocked && $(el).data("blockUI.isBlocked")) return;
            opts.overlayCSS = $.extend({}, $.blockUI.defaults.overlayCSS, opts.overlayCSS || {});
            css = $.extend({}, $.blockUI.defaults.css, opts.css || {});
            if (opts.onOverlayClick) opts.overlayCSS.cursor = "pointer";
            themedCSS = $.extend({}, $.blockUI.defaults.themedCSS, opts.themedCSS || {});
            msg = msg === undefined ? opts.message : msg;
            // remove the current block (if there is one)
            if (full && pageBlock) remove(window, {
                fadeOut: 0
            });
            // if an existing element is being used as the blocking content then we capture
            // its current place in the DOM (and current display style) so we can restore
            // it when we unblock
            if (msg && typeof msg != "string" && (msg.parentNode || msg.jquery)) {
                var node = msg.jquery ? msg[0] : msg;
                var data = {};
                $(el).data("blockUI.history", data);
                data.el = node;
                data.parent = node.parentNode;
                data.display = node.style.display;
                data.position = node.style.position;
                if (data.parent) data.parent.removeChild(node);
            }
            $(el).data("blockUI.onUnblock", opts.onUnblock);
            var z = opts.baseZ;
            // blockUI uses 3 layers for blocking, for simplicity they are all used on every platform;
            // layer1 is the iframe layer which is used to supress bleed through of underlying content
            // layer2 is the overlay layer which has opacity and a wait cursor (by default)
            // layer3 is the message content that is displayed while blocking
            var lyr1, lyr2, lyr3, s;
            if (msie || opts.forceIframe) lyr1 = $('<iframe class="blockUI" style="z-index:' + z++ + ';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="' + opts.iframeSrc + '"></iframe>');
            else lyr1 = $('<div class="blockUI" style="display:none"></div>');
            if (opts.theme) lyr2 = $('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:' + z++ + ';display:none"></div>');
            else lyr2 = $('<div class="blockUI blockOverlay" style="z-index:' + z++ + ';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');
            if (opts.theme && full) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:fixed">';
                if (opts.title) s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || "&nbsp;") + "</div>";
                s += '<div class="ui-widget-content ui-dialog-content"></div>';
                s += "</div>";
            } else if (opts.theme) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:absolute">';
                if (opts.title) s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || "&nbsp;") + "</div>";
                s += '<div class="ui-widget-content ui-dialog-content"></div>';
                s += "</div>";
            } else if (full) s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage" style="z-index:' + (z + 10) + ';display:none;position:fixed"></div>';
            else s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement" style="z-index:' + (z + 10) + ';display:none;position:absolute"></div>';
            lyr3 = $(s);
            // if we have a message, style it
            if (msg) {
                if (opts.theme) {
                    lyr3.css(themedCSS);
                    lyr3.addClass("ui-widget-content");
                } else lyr3.css(css);
            }
            // style the overlay
            if (!opts.theme /*&& (!opts.applyPlatformOpacityRules)*/ ) lyr2.css(opts.overlayCSS);
            lyr2.css("position", full ? "fixed" : "absolute");
            // make iframe layer transparent in IE
            if (msie || opts.forceIframe) lyr1.css("opacity", 0.0);
            //$([lyr1[0],lyr2[0],lyr3[0]]).appendTo(full ? 'body' : el);
            var layers = [
                lyr1,
                lyr2,
                lyr3
            ], $par = full ? $("body") : $(el);
            $.each(layers, function() {
                this.appendTo($par);
            });
            if (opts.theme && opts.draggable && $.fn.draggable) lyr3.draggable({
                handle: ".ui-dialog-titlebar",
                cancel: "li"
            });
            // ie7 must use absolute positioning in quirks mode and to account for activex issues (when scrolling)
            var expr = setExpr && (!$.support.boxModel || $("object,embed", full ? null : el).length > 0);
            if (ie6 || expr) {
                // give body 100% height
                if (full && opts.allowBodyStretch && $.support.boxModel) $("html,body").css("height", "100%");
                // fix ie6 issue when blocked element has a border width
                if ((ie6 || !$.support.boxModel) && !full) {
                    var t = sz(el, "borderTopWidth"), l = sz(el, "borderLeftWidth");
                    var fixT = t ? "(0 - " + t + ")" : 0;
                    var fixL = l ? "(0 - " + l + ")" : 0;
                }
                // simulate fixed position
                $.each(layers, function(i, o) {
                    var s = o[0].style;
                    s.position = "absolute";
                    if (i < 2) {
                        if (full) s.setExpression("height", "Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:" + opts.quirksmodeOffsetHack + ') + "px"');
                        else s.setExpression("height", 'this.parentNode.offsetHeight + "px"');
                        if (full) s.setExpression("width", 'jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"');
                        else s.setExpression("width", 'this.parentNode.offsetWidth + "px"');
                        if (fixL) s.setExpression("left", fixL);
                        if (fixT) s.setExpression("top", fixT);
                    } else if (opts.centerY) {
                        if (full) s.setExpression("top", '(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');
                        s.marginTop = 0;
                    } else if (!opts.centerY && full) {
                        var top = opts.css && opts.css.top ? parseInt(opts.css.top, 10) : 0;
                        var expression = "((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + " + top + ') + "px"';
                        s.setExpression("top", expression);
                    }
                });
            }
            // show the message
            if (msg) {
                if (opts.theme) lyr3.find(".ui-widget-content").append(msg);
                else lyr3.append(msg);
                if (msg.jquery || msg.nodeType) $(msg).show();
            }
            if ((msie || opts.forceIframe) && opts.showOverlay) lyr1.show(); // opacity is zero
            if (opts.fadeIn) {
                var cb = opts.onBlock ? opts.onBlock : noOp;
                var cb1 = opts.showOverlay && !msg ? cb : noOp;
                var cb2 = msg ? cb : noOp;
                if (opts.showOverlay) lyr2._fadeIn(opts.fadeIn, cb1);
                if (msg) lyr3._fadeIn(opts.fadeIn, cb2);
            } else {
                if (opts.showOverlay) lyr2.show();
                if (msg) lyr3.show();
                if (opts.onBlock) opts.onBlock.bind(lyr3)();
            }
            // bind key and mouse events
            bind(1, el, opts);
            if (full) {
                pageBlock = lyr3[0];
                pageBlockEls = $(opts.focusableElements, pageBlock);
                if (opts.focusInput) setTimeout(focus, 20);
            } else center(lyr3[0], opts.centerX, opts.centerY);
            if (opts.timeout) {
                // auto-unblock
                var to = setTimeout(function() {
                    if (full) $.unblockUI(opts);
                    else $(el).unblock(opts);
                }, opts.timeout);
                $(el).data("blockUI.timeout", to);
            }
        }
        // remove the block
        function remove(el, opts) {
            var count;
            var full = el == window;
            var $el = $(el);
            var data = $el.data("blockUI.history");
            var to = $el.data("blockUI.timeout");
            if (to) {
                clearTimeout(to);
                $el.removeData("blockUI.timeout");
            }
            opts = $.extend({}, $.blockUI.defaults, opts || {});
            bind(0, el, opts); // unbind events
            if (opts.onUnblock === null) {
                opts.onUnblock = $el.data("blockUI.onUnblock");
                $el.removeData("blockUI.onUnblock");
            }
            var els;
            if (full) els = $("body").children().filter(".blockUI").add("body > .blockUI");
            else els = $el.find(">.blockUI");
            // fix cursor issue
            if (opts.cursorReset) {
                if (els.length > 1) els[1].style.cursor = opts.cursorReset;
                if (els.length > 2) els[2].style.cursor = opts.cursorReset;
            }
            if (full) pageBlock = pageBlockEls = null;
            if (opts.fadeOut) {
                count = els.length;
                els.stop().fadeOut(opts.fadeOut, function() {
                    if (--count === 0) reset(els, data, opts, el);
                });
            } else reset(els, data, opts, el);
        }
        // move blocking element back into the DOM where it started
        function reset(els, data, opts, el) {
            var $el = $(el);
            if ($el.data("blockUI.isBlocked")) return;
            els.each(function(i, o) {
                // remove via DOM calls so we don't lose event handlers
                if (this.parentNode) this.parentNode.removeChild(this);
            });
            if (data && data.el) {
                data.el.style.display = data.display;
                data.el.style.position = data.position;
                data.el.style.cursor = "default"; // #59
                if (data.parent) data.parent.appendChild(data.el);
                $el.removeData("blockUI.history");
            }
            if ($el.data("blockUI.static")) $el.css("position", "static"); // #22
            if (typeof opts.onUnblock == "function") opts.onUnblock(el, opts);
            // fix issue in Safari 6 where block artifacts remain until reflow
            var body = $(document.body), w = body.width(), cssW = body[0].style.width;
            body.width(w - 1).width(w);
            body[0].style.width = cssW;
        }
        // bind/unbind the handler
        function bind(b, el, opts) {
            var full = el == window, $el = $(el);
            // don't bother unbinding if there is nothing to unbind
            if (!b && (full && !pageBlock || !full && !$el.data("blockUI.isBlocked"))) return;
            $el.data("blockUI.isBlocked", b);
            // don't bind events when overlay is not in use or if bindEvents is false
            if (!full || !opts.bindEvents || b && !opts.showOverlay) return;
            // bind anchors and inputs for mouse and key events
            var events = "mousedown mouseup keydown keypress keyup touchstart touchend touchmove";
            if (b) $(document).bind(events, opts, handler);
            else $(document).unbind(events, handler);
        // former impl...
        //		var $e = $('a,:input');
        //		b ? $e.bind(events, opts, handler) : $e.unbind(events, handler);
        }
        // event handler to suppress keyboard/mouse events when blocking
        function handler(e) {
            // allow tab navigation (conditionally)
            if (e.type === "keydown" && e.keyCode && e.keyCode == 9) {
                if (pageBlock && e.data.constrainTabKey) {
                    var els = pageBlockEls;
                    var fwd = !e.shiftKey && e.target === els[els.length - 1];
                    var back = e.shiftKey && e.target === els[0];
                    if (fwd || back) {
                        setTimeout(function() {
                            focus(back);
                        }, 10);
                        return false;
                    }
                }
            }
            var opts = e.data;
            var target = $(e.target);
            if (target.hasClass("blockOverlay") && opts.onOverlayClick) opts.onOverlayClick(e);
            // allow events within the message content
            if (target.parents("div." + opts.blockMsgClass).length > 0) return true;
            // allow events for content that is not being blocked
            return target.parents().children().filter("div.blockUI").length === 0;
        }
        function focus(back) {
            if (!pageBlockEls) return;
            var e = pageBlockEls[back === true ? pageBlockEls.length - 1 : 0];
            if (e) e.focus();
        }
        function center(el, x, y) {
            var p = el.parentNode, s = el.style;
            var l = (p.offsetWidth - el.offsetWidth) / 2 - sz(p, "borderLeftWidth");
            var t = (p.offsetHeight - el.offsetHeight) / 2 - sz(p, "borderTopWidth");
            if (x) s.left = l > 0 ? l + "px" : "0";
            if (y) s.top = t > 0 ? t + "px" : "0";
        }
        function sz(el, p) {
            return parseInt($.css(el, p), 10) || 0;
        }
    }
    /*global define:true */ if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery"
    ], setup);
    else // Node/CommonJS
    setup((parcelRequire("iUSsr")));
})();

});

parcelRegister("3qR9V", function(module, exports) {
$(document).ready(function() {
    // Add smooth scrolling to all links
    $("a").on("click", function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();
            // Store hash
            var hash = this.hash;
            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $("html, body").animate({
                scrollTop: $(hash).offset().top
            }, 800, function() {
                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
        } // End if
    });
});
// we're in an upper section and we want to do a move to an order
$("[name=order_type]").bind("click", function() {
    if ($(this).closest("[id^=section]").length || $(this).closest("[id=details]").length) $("a:contains(I need this right now)")[0].click();
});

});

parcelRegister("cLR2A", function(module, exports) {
/*!
 * Knockout JavaScript library v3.5.1
 * (c) The Knockout.js team - http://knockoutjs.com/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */ (function() {
    (function(n) {
        var A = this || (0, eval)("this"), w = A.document, R = A.navigator, v = A.jQuery, H = A.JSON;
        v || "undefined" === typeof jQuery || (v = jQuery);
        (function(n) {
            "function" === typeof define && define.amd ? define([
                "exports",
                "require"
            ], n) : n(module.exports || module.exports);
        })(function(S, T) {
            function K(a, c) {
                return null === a || typeof a in W ? a === c : !1;
            }
            function X(b, c) {
                var d;
                return function() {
                    d || (d = a.a.setTimeout(function() {
                        d = n;
                        b();
                    }, c));
                };
            }
            function Y(b, c) {
                var d;
                return function() {
                    clearTimeout(d);
                    d = a.a.setTimeout(b, c);
                };
            }
            function Z(a, c) {
                c && "change" !== c ? "beforeChange" === c ? this.pc(a) : this.gb(a, c) : this.qc(a);
            }
            function aa(a, c) {
                null !== c && c.s && c.s();
            }
            function ba(a, c) {
                var d = this.qd, e = d[r];
                e.ra || (this.Qb && this.mb[c] ? (d.uc(c, a, this.mb[c]), this.mb[c] = null, --this.Qb) : e.I[c] || d.uc(c, a, e.J ? {
                    da: a
                } : d.$c(a)), a.Ja && a.gd());
            }
            var a = "undefined" !== typeof S ? S : {};
            a.b = function(b, c) {
                for(var d = b.split("."), e = a, f = 0; f < d.length - 1; f++)e = e[d[f]];
                e[d[d.length - 1]] = c;
            };
            a.L = function(a, c, d) {
                a[c] = d;
            };
            a.version = "3.5.1";
            a.b("version", a.version);
            a.options = {
                deferUpdates: !1,
                useOnlyNativeEvents: !1,
                foreachHidesDestroyed: !1
            };
            a.a = function() {
                function b(a, b) {
                    for(var c in a)f.call(a, c) && b(c, a[c]);
                }
                function c(a, b) {
                    if (b) for(var c in b)f.call(b, c) && (a[c] = b[c]);
                    return a;
                }
                function d(a, b) {
                    a.__proto__ = b;
                    return a;
                }
                function e(b, c, d, e) {
                    var l = b[c].match(q) || [];
                    a.a.D(d.match(q), function(b) {
                        a.a.Na(l, b, e);
                    });
                    b[c] = l.join(" ");
                }
                var f = Object.prototype.hasOwnProperty, g = ({
                    __proto__: []
                }) instanceof Array, h = "function" === typeof Symbol, m = {}, k = {};
                m[R && /Firefox\/2/i.test(R.userAgent) ? "KeyboardEvent" : "UIEvents"] = [
                    "keyup",
                    "keydown",
                    "keypress"
                ];
                m.MouseEvents = "click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave".split(" ");
                b(m, function(a, b) {
                    if (b.length) for(var c = 0, d = b.length; c < d; c++)k[b[c]] = a;
                });
                var l = {
                    propertychange: !0
                }, p = w && function() {
                    for(var a = 3, b = w.createElement("div"), c = b.getElementsByTagName("i"); b.innerHTML = "<!--[if gt IE " + ++a + "]><i></i><![endif]-->", c[0];);
                    return 4 < a ? a : n;
                }(), q = /\S+/g, t;
                return {
                    Jc: [
                        "authenticity_token",
                        /^__RequestVerificationToken(_.*)?$/
                    ],
                    D: function(a, b, c) {
                        for(var d = 0, e = a.length; d < e; d++)b.call(c, a[d], d, a);
                    },
                    A: "function" == typeof Array.prototype.indexOf ? function(a, b) {
                        return Array.prototype.indexOf.call(a, b);
                    } : function(a, b) {
                        for(var c = 0, d = a.length; c < d; c++)if (a[c] === b) return c;
                        return -1;
                    },
                    Lb: function(a, b, c) {
                        for(var d = 0, e = a.length; d < e; d++)if (b.call(c, a[d], d, a)) return a[d];
                        return n;
                    },
                    Pa: function(b, c) {
                        var d = a.a.A(b, c);
                        0 < d ? b.splice(d, 1) : 0 === d && b.shift();
                    },
                    wc: function(b) {
                        var c = [];
                        b && a.a.D(b, function(b) {
                            0 > a.a.A(c, b) && c.push(b);
                        });
                        return c;
                    },
                    Mb: function(a, b, c) {
                        var d = [];
                        if (a) for(var e = 0, l = a.length; e < l; e++)d.push(b.call(c, a[e], e));
                        return d;
                    },
                    jb: function(a, b, c) {
                        var d = [];
                        if (a) for(var e = 0, l = a.length; e < l; e++)b.call(c, a[e], e) && d.push(a[e]);
                        return d;
                    },
                    Nb: function(a, b) {
                        if (b instanceof Array) a.push.apply(a, b);
                        else for(var c = 0, d = b.length; c < d; c++)a.push(b[c]);
                        return a;
                    },
                    Na: function(b, c, d) {
                        var e = a.a.A(a.a.bc(b), c);
                        0 > e ? d && b.push(c) : d || b.splice(e, 1);
                    },
                    Ba: g,
                    extend: c,
                    setPrototypeOf: d,
                    Ab: g ? d : c,
                    P: b,
                    Ga: function(a, b, c) {
                        if (!a) return a;
                        var d = {}, e;
                        for(e in a)f.call(a, e) && (d[e] = b.call(c, a[e], e, a));
                        return d;
                    },
                    Tb: function(b) {
                        for(; b.firstChild;)a.removeNode(b.firstChild);
                    },
                    Yb: function(b) {
                        b = a.a.la(b);
                        for(var c = (b[0] && b[0].ownerDocument || w).createElement("div"), d = 0, e = b.length; d < e; d++)c.appendChild(a.oa(b[d]));
                        return c;
                    },
                    Ca: function(b, c) {
                        for(var d = 0, e = b.length, l = []; d < e; d++){
                            var k = b[d].cloneNode(!0);
                            l.push(c ? a.oa(k) : k);
                        }
                        return l;
                    },
                    va: function(b, c) {
                        a.a.Tb(b);
                        if (c) for(var d = 0, e = c.length; d < e; d++)b.appendChild(c[d]);
                    },
                    Xc: function(b, c) {
                        var d = b.nodeType ? [
                            b
                        ] : b;
                        if (0 < d.length) {
                            for(var e = d[0], l = e.parentNode, k = 0, f = c.length; k < f; k++)l.insertBefore(c[k], e);
                            k = 0;
                            for(f = d.length; k < f; k++)a.removeNode(d[k]);
                        }
                    },
                    Ua: function(a, b) {
                        if (a.length) {
                            for(b = 8 === b.nodeType && b.parentNode || b; a.length && a[0].parentNode !== b;)a.splice(0, 1);
                            for(; 1 < a.length && a[a.length - 1].parentNode !== b;)a.length--;
                            if (1 < a.length) {
                                var c = a[0], d = a[a.length - 1];
                                for(a.length = 0; c !== d;)a.push(c), c = c.nextSibling;
                                a.push(d);
                            }
                        }
                        return a;
                    },
                    Zc: function(a, b) {
                        7 > p ? a.setAttribute("selected", b) : a.selected = b;
                    },
                    Db: function(a) {
                        return null === a || a === n ? "" : a.trim ? a.trim() : a.toString().replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
                    },
                    Ud: function(a, b) {
                        a = a || "";
                        return b.length > a.length ? !1 : a.substring(0, b.length) === b;
                    },
                    vd: function(a, b) {
                        if (a === b) return !0;
                        if (11 === a.nodeType) return !1;
                        if (b.contains) return b.contains(1 !== a.nodeType ? a.parentNode : a);
                        if (b.compareDocumentPosition) return 16 == (b.compareDocumentPosition(a) & 16);
                        for(; a && a != b;)a = a.parentNode;
                        return !!a;
                    },
                    Sb: function(b) {
                        return a.a.vd(b, b.ownerDocument.documentElement);
                    },
                    kd: function(b) {
                        return !!a.a.Lb(b, a.a.Sb);
                    },
                    R: function(a) {
                        return a && a.tagName && a.tagName.toLowerCase();
                    },
                    Ac: function(b) {
                        return a.onError ? function() {
                            try {
                                return b.apply(this, arguments);
                            } catch (c) {
                                throw a.onError && a.onError(c), c;
                            }
                        } : b;
                    },
                    setTimeout: function(b, c) {
                        return setTimeout(a.a.Ac(b), c);
                    },
                    Gc: function(b) {
                        setTimeout(function() {
                            a.onError && a.onError(b);
                            throw b;
                        }, 0);
                    },
                    B: function(b, c, d) {
                        var e = a.a.Ac(d);
                        d = l[c];
                        if (a.options.useOnlyNativeEvents || d || !v) {
                            if (d || "function" != typeof b.addEventListener) {
                                if ("undefined" != typeof b.attachEvent) {
                                    var k = function(a) {
                                        e.call(b, a);
                                    }, f = "on" + c;
                                    b.attachEvent(f, k);
                                    a.a.K.za(b, function() {
                                        b.detachEvent(f, k);
                                    });
                                } else throw Error("Browser doesn't support addEventListener or attachEvent");
                            } else b.addEventListener(c, e, !1);
                        } else t || (t = "function" == typeof v(b).on ? "on" : "bind"), v(b)[t](c, e);
                    },
                    Fb: function(b, c) {
                        if (!b || !b.nodeType) throw Error("element must be a DOM node when calling triggerEvent");
                        var d;
                        "input" === a.a.R(b) && b.type && "click" == c.toLowerCase() ? (d = b.type, d = "checkbox" == d || "radio" == d) : d = !1;
                        if (a.options.useOnlyNativeEvents || !v || d) {
                            if ("function" == typeof w.createEvent) {
                                if ("function" == typeof b.dispatchEvent) d = w.createEvent(k[c] || "HTMLEvents"), d.initEvent(c, !0, !0, A, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, b), b.dispatchEvent(d);
                                else throw Error("The supplied element doesn't support dispatchEvent");
                            } else if (d && b.click) b.click();
                            else if ("undefined" != typeof b.fireEvent) b.fireEvent("on" + c);
                            else throw Error("Browser doesn't support triggering events");
                        } else v(b).trigger(c);
                    },
                    f: function(b) {
                        return a.O(b) ? b() : b;
                    },
                    bc: function(b) {
                        return a.O(b) ? b.v() : b;
                    },
                    Eb: function(b, c, d) {
                        var l;
                        c && ("object" === typeof b.classList ? (l = b.classList[d ? "add" : "remove"], a.a.D(c.match(q), function(a) {
                            l.call(b.classList, a);
                        })) : "string" === typeof b.className.baseVal ? e(b.className, "baseVal", c, d) : e(b, "className", c, d));
                    },
                    Bb: function(b, c) {
                        var d = a.a.f(c);
                        if (null === d || d === n) d = "";
                        var e = a.h.firstChild(b);
                        !e || 3 != e.nodeType || a.h.nextSibling(e) ? a.h.va(b, [
                            b.ownerDocument.createTextNode(d)
                        ]) : e.data = d;
                        a.a.Ad(b);
                    },
                    Yc: function(a, b) {
                        a.name = b;
                        if (7 >= p) try {
                            var c = a.name.replace(/[&<>'"]/g, function(a) {
                                return "&#" + a.charCodeAt(0) + ";";
                            });
                            a.mergeAttributes(w.createElement("<input name='" + c + "'/>"), !1);
                        } catch (d) {}
                    },
                    Ad: function(a) {
                        9 <= p && (a = 1 == a.nodeType ? a : a.parentNode, a.style && (a.style.zoom = a.style.zoom));
                    },
                    wd: function(a) {
                        if (p) {
                            var b = a.style.width;
                            a.style.width = 0;
                            a.style.width = b;
                        }
                    },
                    Pd: function(b, c) {
                        b = a.a.f(b);
                        c = a.a.f(c);
                        for(var d = [], e = b; e <= c; e++)d.push(e);
                        return d;
                    },
                    la: function(a) {
                        for(var b = [], c = 0, d = a.length; c < d; c++)b.push(a[c]);
                        return b;
                    },
                    Da: function(a) {
                        return h ? Symbol(a) : a;
                    },
                    Zd: 6 === p,
                    $d: 7 === p,
                    W: p,
                    Lc: function(b, c) {
                        for(var d = a.a.la(b.getElementsByTagName("input")).concat(a.a.la(b.getElementsByTagName("textarea"))), e = "string" == typeof c ? function(a) {
                            return a.name === c;
                        } : function(a) {
                            return c.test(a.name);
                        }, l = [], k = d.length - 1; 0 <= k; k--)e(d[k]) && l.push(d[k]);
                        return l;
                    },
                    Nd: function(b) {
                        return "string" == typeof b && (b = a.a.Db(b)) ? H && H.parse ? H.parse(b) : new Function("return " + b)() : null;
                    },
                    hc: function(b, c, d) {
                        if (!H || !H.stringify) throw Error("Cannot find JSON.stringify(). Some browsers (e.g., IE < 8) don't support it natively, but you can overcome this by adding a script reference to json2.js, downloadable from http://www.json.org/json2.js");
                        return H.stringify(a.a.f(b), c, d);
                    },
                    Od: function(c, d, e) {
                        e = e || {};
                        var l = e.params || {}, k = e.includeFields || this.Jc, f = c;
                        if ("object" == typeof c && "form" === a.a.R(c)) for(var f = c.action, h = k.length - 1; 0 <= h; h--)for(var g = a.a.Lc(c, k[h]), m = g.length - 1; 0 <= m; m--)l[g[m].name] = g[m].value;
                        d = a.a.f(d);
                        var p = w.createElement("form");
                        p.style.display = "none";
                        p.action = f;
                        p.method = "post";
                        for(var q in d)c = w.createElement("input"), c.type = "hidden", c.name = q, c.value = a.a.hc(a.a.f(d[q])), p.appendChild(c);
                        b(l, function(a, b) {
                            var c = w.createElement("input");
                            c.type = "hidden";
                            c.name = a;
                            c.value = b;
                            p.appendChild(c);
                        });
                        w.body.appendChild(p);
                        e.submitter ? e.submitter(p) : p.submit();
                        setTimeout(function() {
                            p.parentNode.removeChild(p);
                        }, 0);
                    }
                };
            }();
            a.b("utils", a.a);
            a.b("utils.arrayForEach", a.a.D);
            a.b("utils.arrayFirst", a.a.Lb);
            a.b("utils.arrayFilter", a.a.jb);
            a.b("utils.arrayGetDistinctValues", a.a.wc);
            a.b("utils.arrayIndexOf", a.a.A);
            a.b("utils.arrayMap", a.a.Mb);
            a.b("utils.arrayPushAll", a.a.Nb);
            a.b("utils.arrayRemoveItem", a.a.Pa);
            a.b("utils.cloneNodes", a.a.Ca);
            a.b("utils.createSymbolOrString", a.a.Da);
            a.b("utils.extend", a.a.extend);
            a.b("utils.fieldsIncludedWithJsonPost", a.a.Jc);
            a.b("utils.getFormFields", a.a.Lc);
            a.b("utils.objectMap", a.a.Ga);
            a.b("utils.peekObservable", a.a.bc);
            a.b("utils.postJson", a.a.Od);
            a.b("utils.parseJson", a.a.Nd);
            a.b("utils.registerEventHandler", a.a.B);
            a.b("utils.stringifyJson", a.a.hc);
            a.b("utils.range", a.a.Pd);
            a.b("utils.toggleDomNodeCssClass", a.a.Eb);
            a.b("utils.triggerEvent", a.a.Fb);
            a.b("utils.unwrapObservable", a.a.f);
            a.b("utils.objectForEach", a.a.P);
            a.b("utils.addOrRemoveItem", a.a.Na);
            a.b("utils.setTextContent", a.a.Bb);
            a.b("unwrap", a.a.f);
            Function.prototype.bind || (Function.prototype.bind = function(a) {
                var c = this;
                if (1 === arguments.length) return function() {
                    return c.apply(a, arguments);
                };
                var d = Array.prototype.slice.call(arguments, 1);
                return function() {
                    var e = d.slice(0);
                    e.push.apply(e, arguments);
                    return c.apply(a, e);
                };
            });
            a.a.g = new function() {
                var b = 0, c = "__ko__" + (new Date).getTime(), d = {}, e, f;
                a.a.W ? (e = function(a, e) {
                    var f = a[c];
                    if (!f || "null" === f || !d[f]) {
                        if (!e) return n;
                        f = a[c] = "ko" + b++;
                        d[f] = {};
                    }
                    return d[f];
                }, f = function(a) {
                    var b = a[c];
                    return b ? (delete d[b], a[c] = null, !0) : !1;
                }) : (e = function(a, b) {
                    var d = a[c];
                    !d && b && (d = a[c] = {});
                    return d;
                }, f = function(a) {
                    return a[c] ? (delete a[c], !0) : !1;
                });
                return {
                    get: function(a, b) {
                        var c = e(a, !1);
                        return c && c[b];
                    },
                    set: function(a, b, c) {
                        (a = e(a, c !== n)) && (a[b] = c);
                    },
                    Ub: function(a, b, c) {
                        a = e(a, !0);
                        return a[b] || (a[b] = c);
                    },
                    clear: f,
                    Z: function() {
                        return b++ + c;
                    }
                };
            };
            a.b("utils.domData", a.a.g);
            a.b("utils.domData.clear", a.a.g.clear);
            a.a.K = new function() {
                function b(b, c) {
                    var d = a.a.g.get(b, e);
                    d === n && c && (d = [], a.a.g.set(b, e, d));
                    return d;
                }
                function c(c) {
                    var e = b(c, !1);
                    if (e) for(var e = e.slice(0), k = 0; k < e.length; k++)e[k](c);
                    a.a.g.clear(c);
                    a.a.K.cleanExternalData(c);
                    g[c.nodeType] && d(c.childNodes, !0);
                }
                function d(b, d) {
                    for(var e = [], l, f = 0; f < b.length; f++)if (!d || 8 === b[f].nodeType) {
                        if (c(e[e.length] = l = b[f]), b[f] !== l) for(; f-- && -1 == a.a.A(e, b[f]););
                    }
                }
                var e = a.a.g.Z(), f = {
                    1: !0,
                    8: !0,
                    9: !0
                }, g = {
                    1: !0,
                    9: !0
                };
                return {
                    za: function(a, c) {
                        if ("function" != typeof c) throw Error("Callback must be a function");
                        b(a, !0).push(c);
                    },
                    yb: function(c, d) {
                        var f = b(c, !1);
                        f && (a.a.Pa(f, d), 0 == f.length && a.a.g.set(c, e, n));
                    },
                    oa: function(b) {
                        a.u.G(function() {
                            f[b.nodeType] && (c(b), g[b.nodeType] && d(b.getElementsByTagName("*")));
                        });
                        return b;
                    },
                    removeNode: function(b) {
                        a.oa(b);
                        b.parentNode && b.parentNode.removeChild(b);
                    },
                    cleanExternalData: function(a) {
                        v && "function" == typeof v.cleanData && v.cleanData([
                            a
                        ]);
                    }
                };
            };
            a.oa = a.a.K.oa;
            a.removeNode = a.a.K.removeNode;
            a.b("cleanNode", a.oa);
            a.b("removeNode", a.removeNode);
            a.b("utils.domNodeDisposal", a.a.K);
            a.b("utils.domNodeDisposal.addDisposeCallback", a.a.K.za);
            a.b("utils.domNodeDisposal.removeDisposeCallback", a.a.K.yb);
            (function() {
                var b = [
                    0,
                    "",
                    ""
                ], c = [
                    1,
                    "<table>",
                    "</table>"
                ], d = [
                    3,
                    "<table><tbody><tr>",
                    "</tr></tbody></table>"
                ], e = [
                    1,
                    "<select multiple='multiple'>",
                    "</select>"
                ], f = {
                    thead: c,
                    tbody: c,
                    tfoot: c,
                    tr: [
                        2,
                        "<table><tbody>",
                        "</tbody></table>"
                    ],
                    td: d,
                    th: d,
                    option: e,
                    optgroup: e
                }, g = 8 >= a.a.W;
                a.a.ua = function(c, d) {
                    var e;
                    if (v) {
                        if (v.parseHTML) e = v.parseHTML(c, d) || [];
                        else if ((e = v.clean([
                            c
                        ], d)) && e[0]) {
                            for(var l = e[0]; l.parentNode && 11 !== l.parentNode.nodeType;)l = l.parentNode;
                            l.parentNode && l.parentNode.removeChild(l);
                        }
                    } else {
                        (e = d) || (e = w);
                        var l = e.parentWindow || e.defaultView || A, p = a.a.Db(c).toLowerCase(), q = e.createElement("div"), t;
                        t = (p = p.match(/^(?:\x3c!--.*?--\x3e\s*?)*?<([a-z]+)[\s>]/)) && f[p[1]] || b;
                        p = t[0];
                        t = "ignored<div>" + t[1] + c + t[2] + "</div>";
                        "function" == typeof l.innerShiv ? q.appendChild(l.innerShiv(t)) : (g && e.body.appendChild(q), q.innerHTML = t, g && q.parentNode.removeChild(q));
                        for(; p--;)q = q.lastChild;
                        e = a.a.la(q.lastChild.childNodes);
                    }
                    return e;
                };
                a.a.Md = function(b, c) {
                    var d = a.a.ua(b, c);
                    return d.length && d[0].parentElement || a.a.Yb(d);
                };
                a.a.fc = function(b, c) {
                    a.a.Tb(b);
                    c = a.a.f(c);
                    if (null !== c && c !== n) {
                        if ("string" != typeof c && (c = c.toString()), v) v(b).html(c);
                        else for(var d = a.a.ua(c, b.ownerDocument), e = 0; e < d.length; e++)b.appendChild(d[e]);
                    }
                };
            })();
            a.b("utils.parseHtmlFragment", a.a.ua);
            a.b("utils.setHtml", a.a.fc);
            a.aa = function() {
                function b(c, e) {
                    if (c) {
                        if (8 == c.nodeType) {
                            var f = a.aa.Uc(c.nodeValue);
                            null != f && e.push({
                                ud: c,
                                Kd: f
                            });
                        } else if (1 == c.nodeType) for(var f = 0, g = c.childNodes, h = g.length; f < h; f++)b(g[f], e);
                    }
                }
                var c = {};
                return {
                    Xb: function(a) {
                        if ("function" != typeof a) throw Error("You can only pass a function to ko.memoization.memoize()");
                        var b = (4294967296 * (1 + Math.random()) | 0).toString(16).substring(1) + (4294967296 * (1 + Math.random()) | 0).toString(16).substring(1);
                        c[b] = a;
                        return "<!--[ko_memo:" + b + "]-->";
                    },
                    bd: function(a, b) {
                        var f = c[a];
                        if (f === n) throw Error("Couldn't find any memo with ID " + a + ". Perhaps it's already been unmemoized.");
                        try {
                            return f.apply(null, b || []), !0;
                        } finally{
                            delete c[a];
                        }
                    },
                    cd: function(c, e) {
                        var f = [];
                        b(c, f);
                        for(var g = 0, h = f.length; g < h; g++){
                            var m = f[g].ud, k = [
                                m
                            ];
                            e && a.a.Nb(k, e);
                            a.aa.bd(f[g].Kd, k);
                            m.nodeValue = "";
                            m.parentNode && m.parentNode.removeChild(m);
                        }
                    },
                    Uc: function(a) {
                        return (a = a.match(/^\[ko_memo\:(.*?)\]$/)) ? a[1] : null;
                    }
                };
            }();
            a.b("memoization", a.aa);
            a.b("memoization.memoize", a.aa.Xb);
            a.b("memoization.unmemoize", a.aa.bd);
            a.b("memoization.parseMemoText", a.aa.Uc);
            a.b("memoization.unmemoizeDomNodeAndDescendants", a.aa.cd);
            a.na = function() {
                function b() {
                    if (f) {
                        for(var b = f, c = 0, d; h < f;)if (d = e[h++]) {
                            if (h > b) {
                                if (5E3 <= ++c) {
                                    h = f;
                                    a.a.Gc(Error("'Too much recursion' after processing " + c + " task groups."));
                                    break;
                                }
                                b = f;
                            }
                            try {
                                d();
                            } catch (p) {
                                a.a.Gc(p);
                            }
                        }
                    }
                }
                function c() {
                    b();
                    h = f = e.length = 0;
                }
                var d, e = [], f = 0, g = 1, h = 0;
                A.MutationObserver ? d = function(a) {
                    var b = w.createElement("div");
                    new MutationObserver(a).observe(b, {
                        attributes: !0
                    });
                    return function() {
                        b.classList.toggle("foo");
                    };
                }(c) : d = w && "onreadystatechange" in w.createElement("script") ? function(a) {
                    var b = w.createElement("script");
                    b.onreadystatechange = function() {
                        b.onreadystatechange = null;
                        w.documentElement.removeChild(b);
                        b = null;
                        a();
                    };
                    w.documentElement.appendChild(b);
                } : function(a) {
                    setTimeout(a, 0);
                };
                return {
                    scheduler: d,
                    zb: function(b) {
                        f || a.na.scheduler(c);
                        e[f++] = b;
                        return g++;
                    },
                    cancel: function(a) {
                        a = a - (g - f);
                        a >= h && a < f && (e[a] = null);
                    },
                    resetForTesting: function() {
                        var a = f - h;
                        h = f = e.length = 0;
                        return a;
                    },
                    Sd: b
                };
            }();
            a.b("tasks", a.na);
            a.b("tasks.schedule", a.na.zb);
            a.b("tasks.runEarly", a.na.Sd);
            a.Ta = {
                throttle: function(b, c) {
                    b.throttleEvaluation = c;
                    var d = null;
                    return a.$({
                        read: b,
                        write: function(e) {
                            clearTimeout(d);
                            d = a.a.setTimeout(function() {
                                b(e);
                            }, c);
                        }
                    });
                },
                rateLimit: function(a, c) {
                    var d, e, f;
                    "number" == typeof c ? d = c : (d = c.timeout, e = c.method);
                    a.Hb = !1;
                    f = "function" == typeof e ? e : "notifyWhenChangesStop" == e ? Y : X;
                    a.ub(function(a) {
                        return f(a, d, c);
                    });
                },
                deferred: function(b, c) {
                    if (!0 !== c) throw Error("The 'deferred' extender only accepts the value 'true', because it is not supported to turn deferral off once enabled.");
                    b.Hb || (b.Hb = !0, b.ub(function(c) {
                        var e, f = !1;
                        return function() {
                            if (!f) {
                                a.na.cancel(e);
                                e = a.na.zb(c);
                                try {
                                    f = !0, b.notifySubscribers(n, "dirty");
                                } finally{
                                    f = !1;
                                }
                            }
                        };
                    }));
                },
                notify: function(a, c) {
                    a.equalityComparer = "always" == c ? null : K;
                }
            };
            var W = {
                undefined: 1,
                "boolean": 1,
                number: 1,
                string: 1
            };
            a.b("extenders", a.Ta);
            a.ic = function(b, c, d) {
                this.da = b;
                this.lc = c;
                this.mc = d;
                this.Ib = !1;
                this.fb = this.Jb = null;
                a.L(this, "dispose", this.s);
                a.L(this, "disposeWhenNodeIsRemoved", this.l);
            };
            a.ic.prototype.s = function() {
                this.Ib || (this.fb && a.a.K.yb(this.Jb, this.fb), this.Ib = !0, this.mc(), this.da = this.lc = this.mc = this.Jb = this.fb = null);
            };
            a.ic.prototype.l = function(b) {
                this.Jb = b;
                a.a.K.za(b, this.fb = this.s.bind(this));
            };
            a.T = function() {
                a.a.Ab(this, D);
                D.qb(this);
            };
            var D = {
                qb: function(a) {
                    a.U = {
                        change: []
                    };
                    a.sc = 1;
                },
                subscribe: function(b, c, d) {
                    var e = this;
                    d = d || "change";
                    var f = new a.ic(e, c ? b.bind(c) : b, function() {
                        a.a.Pa(e.U[d], f);
                        e.hb && e.hb(d);
                    });
                    e.Qa && e.Qa(d);
                    e.U[d] || (e.U[d] = []);
                    e.U[d].push(f);
                    return f;
                },
                notifySubscribers: function(b, c) {
                    c = c || "change";
                    "change" === c && this.Gb();
                    if (this.Wa(c)) {
                        var d = "change" === c && this.ed || this.U[c].slice(0);
                        try {
                            a.u.xc();
                            for(var e = 0, f; f = d[e]; ++e)f.Ib || f.lc(b);
                        } finally{
                            a.u.end();
                        }
                    }
                },
                ob: function() {
                    return this.sc;
                },
                Dd: function(a) {
                    return this.ob() !== a;
                },
                Gb: function() {
                    ++this.sc;
                },
                ub: function(b) {
                    var c = this, d = a.O(c), e, f, g, h, m;
                    c.gb || (c.gb = c.notifySubscribers, c.notifySubscribers = Z);
                    var k = b(function() {
                        c.Ja = !1;
                        d && h === c && (h = c.nc ? c.nc() : c());
                        var a = f || m && c.sb(g, h);
                        m = f = e = !1;
                        a && c.gb(g = h);
                    });
                    c.qc = function(a, b) {
                        b && c.Ja || (m = !b);
                        c.ed = c.U.change.slice(0);
                        c.Ja = e = !0;
                        h = a;
                        k();
                    };
                    c.pc = function(a) {
                        e || (g = a, c.gb(a, "beforeChange"));
                    };
                    c.rc = function() {
                        m = !0;
                    };
                    c.gd = function() {
                        c.sb(g, c.v(!0)) && (f = !0);
                    };
                },
                Wa: function(a) {
                    return this.U[a] && this.U[a].length;
                },
                Bd: function(b) {
                    if (b) return this.U[b] && this.U[b].length || 0;
                    var c = 0;
                    a.a.P(this.U, function(a, b) {
                        "dirty" !== a && (c += b.length);
                    });
                    return c;
                },
                sb: function(a, c) {
                    return !this.equalityComparer || !this.equalityComparer(a, c);
                },
                toString: function() {
                    return "[object Object]";
                },
                extend: function(b) {
                    var c = this;
                    b && a.a.P(b, function(b, e) {
                        var f = a.Ta[b];
                        "function" == typeof f && (c = f(c, e) || c);
                    });
                    return c;
                }
            };
            a.L(D, "init", D.qb);
            a.L(D, "subscribe", D.subscribe);
            a.L(D, "extend", D.extend);
            a.L(D, "getSubscriptionsCount", D.Bd);
            a.a.Ba && a.a.setPrototypeOf(D, Function.prototype);
            a.T.fn = D;
            a.Qc = function(a) {
                return null != a && "function" == typeof a.subscribe && "function" == typeof a.notifySubscribers;
            };
            a.b("subscribable", a.T);
            a.b("isSubscribable", a.Qc);
            a.S = a.u = function() {
                function b(a) {
                    d.push(e);
                    e = a;
                }
                function c() {
                    e = d.pop();
                }
                var d = [], e, f = 0;
                return {
                    xc: b,
                    end: c,
                    cc: function(b) {
                        if (e) {
                            if (!a.Qc(b)) throw Error("Only subscribable things can act as dependencies");
                            e.od.call(e.pd, b, b.fd || (b.fd = ++f));
                        }
                    },
                    G: function(a, d, e) {
                        try {
                            return b(), a.apply(d, e || []);
                        } finally{
                            c();
                        }
                    },
                    qa: function() {
                        if (e) return e.o.qa();
                    },
                    Va: function() {
                        if (e) return e.o.Va();
                    },
                    Ya: function() {
                        if (e) return e.Ya;
                    },
                    o: function() {
                        if (e) return e.o;
                    }
                };
            }();
            a.b("computedContext", a.S);
            a.b("computedContext.getDependenciesCount", a.S.qa);
            a.b("computedContext.getDependencies", a.S.Va);
            a.b("computedContext.isInitial", a.S.Ya);
            a.b("computedContext.registerDependency", a.S.cc);
            a.b("ignoreDependencies", a.Yd = a.u.G);
            var I = a.a.Da("_latestValue");
            a.ta = function(b) {
                function c() {
                    if (0 < arguments.length) return c.sb(c[I], arguments[0]) && (c.ya(), c[I] = arguments[0], c.xa()), this;
                    a.u.cc(c);
                    return c[I];
                }
                c[I] = b;
                a.a.Ba || a.a.extend(c, a.T.fn);
                a.T.fn.qb(c);
                a.a.Ab(c, F);
                a.options.deferUpdates && a.Ta.deferred(c, !0);
                return c;
            };
            var F = {
                equalityComparer: K,
                v: function() {
                    return this[I];
                },
                xa: function() {
                    this.notifySubscribers(this[I], "spectate");
                    this.notifySubscribers(this[I]);
                },
                ya: function() {
                    this.notifySubscribers(this[I], "beforeChange");
                }
            };
            a.a.Ba && a.a.setPrototypeOf(F, a.T.fn);
            var G = a.ta.Ma = "__ko_proto__";
            F[G] = a.ta;
            a.O = function(b) {
                if ((b = "function" == typeof b && b[G]) && b !== F[G] && b !== a.o.fn[G]) throw Error("Invalid object that looks like an observable; possibly from another Knockout instance");
                return !!b;
            };
            a.Za = function(b) {
                return "function" == typeof b && (b[G] === F[G] || b[G] === a.o.fn[G] && b.Nc);
            };
            a.b("observable", a.ta);
            a.b("isObservable", a.O);
            a.b("isWriteableObservable", a.Za);
            a.b("isWritableObservable", a.Za);
            a.b("observable.fn", F);
            a.L(F, "peek", F.v);
            a.L(F, "valueHasMutated", F.xa);
            a.L(F, "valueWillMutate", F.ya);
            a.Ha = function(b) {
                b = b || [];
                if ("object" != typeof b || !("length" in b)) throw Error("The argument passed when initializing an observable array must be an array, or null, or undefined.");
                b = a.ta(b);
                a.a.Ab(b, a.Ha.fn);
                return b.extend({
                    trackArrayChanges: !0
                });
            };
            a.Ha.fn = {
                remove: function(b) {
                    for(var c = this.v(), d = [], e = "function" != typeof b || a.O(b) ? function(a) {
                        return a === b;
                    } : b, f = 0; f < c.length; f++){
                        var g = c[f];
                        if (e(g)) {
                            0 === d.length && this.ya();
                            if (c[f] !== g) throw Error("Array modified during remove; cannot remove item");
                            d.push(g);
                            c.splice(f, 1);
                            f--;
                        }
                    }
                    d.length && this.xa();
                    return d;
                },
                removeAll: function(b) {
                    if (b === n) {
                        var c = this.v(), d = c.slice(0);
                        this.ya();
                        c.splice(0, c.length);
                        this.xa();
                        return d;
                    }
                    return b ? this.remove(function(c) {
                        return 0 <= a.a.A(b, c);
                    }) : [];
                },
                destroy: function(b) {
                    var c = this.v(), d = "function" != typeof b || a.O(b) ? function(a) {
                        return a === b;
                    } : b;
                    this.ya();
                    for(var e = c.length - 1; 0 <= e; e--){
                        var f = c[e];
                        d(f) && (f._destroy = !0);
                    }
                    this.xa();
                },
                destroyAll: function(b) {
                    return b === n ? this.destroy(function() {
                        return !0;
                    }) : b ? this.destroy(function(c) {
                        return 0 <= a.a.A(b, c);
                    }) : [];
                },
                indexOf: function(b) {
                    var c = this();
                    return a.a.A(c, b);
                },
                replace: function(a, c) {
                    var d = this.indexOf(a);
                    0 <= d && (this.ya(), this.v()[d] = c, this.xa());
                },
                sorted: function(a) {
                    var c = this().slice(0);
                    return a ? c.sort(a) : c.sort();
                },
                reversed: function() {
                    return this().slice(0).reverse();
                }
            };
            a.a.Ba && a.a.setPrototypeOf(a.Ha.fn, a.ta.fn);
            a.a.D("pop push reverse shift sort splice unshift".split(" "), function(b) {
                a.Ha.fn[b] = function() {
                    var a = this.v();
                    this.ya();
                    this.zc(a, b, arguments);
                    var d = a[b].apply(a, arguments);
                    this.xa();
                    return d === a ? this : d;
                };
            });
            a.a.D([
                "slice"
            ], function(b) {
                a.Ha.fn[b] = function() {
                    var a = this();
                    return a[b].apply(a, arguments);
                };
            });
            a.Pc = function(b) {
                return a.O(b) && "function" == typeof b.remove && "function" == typeof b.push;
            };
            a.b("observableArray", a.Ha);
            a.b("isObservableArray", a.Pc);
            a.Ta.trackArrayChanges = function(b, c) {
                function d() {
                    function c() {
                        if (m) {
                            var d = [].concat(b.v() || []), e;
                            if (b.Wa("arrayChange")) {
                                if (!f || 1 < m) f = a.a.Pb(k, d, b.Ob);
                                e = f;
                            }
                            k = d;
                            f = null;
                            m = 0;
                            e && e.length && b.notifySubscribers(e, "arrayChange");
                        }
                    }
                    e ? c() : (e = !0, h = b.subscribe(function() {
                        ++m;
                    }, null, "spectate"), k = [].concat(b.v() || []), f = null, g = b.subscribe(c));
                }
                b.Ob = {};
                c && "object" == typeof c && a.a.extend(b.Ob, c);
                b.Ob.sparse = !0;
                if (!b.zc) {
                    var e = !1, f = null, g, h, m = 0, k, l = b.Qa, p = b.hb;
                    b.Qa = function(a) {
                        l && l.call(b, a);
                        "arrayChange" === a && d();
                    };
                    b.hb = function(a) {
                        p && p.call(b, a);
                        "arrayChange" !== a || b.Wa("arrayChange") || (g && g.s(), h && h.s(), h = g = null, e = !1, k = n);
                    };
                    b.zc = function(b, c, d) {
                        function l(a, b, c) {
                            return k[k.length] = {
                                status: a,
                                value: b,
                                index: c
                            };
                        }
                        if (e && !m) {
                            var k = [], p = b.length, g = d.length, h = 0;
                            switch(c){
                                case "push":
                                    h = p;
                                case "unshift":
                                    for(c = 0; c < g; c++)l("added", d[c], h + c);
                                    break;
                                case "pop":
                                    h = p - 1;
                                case "shift":
                                    p && l("deleted", b[h], h);
                                    break;
                                case "splice":
                                    c = Math.min(Math.max(0, 0 > d[0] ? p + d[0] : d[0]), p);
                                    for(var p = 1 === g ? p : Math.min(c + (d[1] || 0), p), g = c + g - 2, h = Math.max(p, g), U = [], L = [], n = 2; c < h; ++c, ++n)c < p && L.push(l("deleted", b[c], c)), c < g && U.push(l("added", d[n], c));
                                    a.a.Kc(L, U);
                                    break;
                                default:
                                    return;
                            }
                            f = k;
                        }
                    };
                }
            };
            var r = a.a.Da("_state");
            a.o = a.$ = function(b, c, d) {
                function e() {
                    if (0 < arguments.length) {
                        if ("function" === typeof f) f.apply(g.nb, arguments);
                        else throw Error("Cannot write a value to a ko.computed unless you specify a 'write' option. If you wish to read the current value, don't pass any parameters.");
                        return this;
                    }
                    g.ra || a.u.cc(e);
                    (g.ka || g.J && e.Xa()) && e.ha();
                    return g.X;
                }
                "object" === typeof b ? d = b : (d = d || {}, b && (d.read = b));
                if ("function" != typeof d.read) throw Error("Pass a function that returns the value of the ko.computed");
                var f = d.write, g = {
                    X: n,
                    sa: !0,
                    ka: !0,
                    rb: !1,
                    jc: !1,
                    ra: !1,
                    wb: !1,
                    J: !1,
                    Wc: d.read,
                    nb: c || d.owner,
                    l: d.disposeWhenNodeIsRemoved || d.l || null,
                    Sa: d.disposeWhen || d.Sa,
                    Rb: null,
                    I: {},
                    V: 0,
                    Ic: null
                };
                e[r] = g;
                e.Nc = "function" === typeof f;
                a.a.Ba || a.a.extend(e, a.T.fn);
                a.T.fn.qb(e);
                a.a.Ab(e, C);
                d.pure ? (g.wb = !0, g.J = !0, a.a.extend(e, da)) : d.deferEvaluation && a.a.extend(e, ea);
                a.options.deferUpdates && a.Ta.deferred(e, !0);
                g.l && (g.jc = !0, g.l.nodeType || (g.l = null));
                g.J || d.deferEvaluation || e.ha();
                g.l && e.ja() && a.a.K.za(g.l, g.Rb = function() {
                    e.s();
                });
                return e;
            };
            var C = {
                equalityComparer: K,
                qa: function() {
                    return this[r].V;
                },
                Va: function() {
                    var b = [];
                    a.a.P(this[r].I, function(a, d) {
                        b[d.Ka] = d.da;
                    });
                    return b;
                },
                Vb: function(b) {
                    if (!this[r].V) return !1;
                    var c = this.Va();
                    return -1 !== a.a.A(c, b) ? !0 : !!a.a.Lb(c, function(a) {
                        return a.Vb && a.Vb(b);
                    });
                },
                uc: function(a, c, d) {
                    if (this[r].wb && c === this) throw Error("A 'pure' computed must not be called recursively");
                    this[r].I[a] = d;
                    d.Ka = this[r].V++;
                    d.La = c.ob();
                },
                Xa: function() {
                    var a, c, d = this[r].I;
                    for(a in d)if (Object.prototype.hasOwnProperty.call(d, a) && (c = d[a], this.Ia && c.da.Ja || c.da.Dd(c.La))) return !0;
                },
                Jd: function() {
                    this.Ia && !this[r].rb && this.Ia(!1);
                },
                ja: function() {
                    var a = this[r];
                    return a.ka || 0 < a.V;
                },
                Rd: function() {
                    this.Ja ? this[r].ka && (this[r].sa = !0) : this.Hc();
                },
                $c: function(a) {
                    if (a.Hb) {
                        var c = a.subscribe(this.Jd, this, "dirty"), d = a.subscribe(this.Rd, this);
                        return {
                            da: a,
                            s: function() {
                                c.s();
                                d.s();
                            }
                        };
                    }
                    return a.subscribe(this.Hc, this);
                },
                Hc: function() {
                    var b = this, c = b.throttleEvaluation;
                    c && 0 <= c ? (clearTimeout(this[r].Ic), this[r].Ic = a.a.setTimeout(function() {
                        b.ha(!0);
                    }, c)) : b.Ia ? b.Ia(!0) : b.ha(!0);
                },
                ha: function(b) {
                    var c = this[r], d = c.Sa, e = !1;
                    if (!c.rb && !c.ra) {
                        if (c.l && !a.a.Sb(c.l) || d && d()) {
                            if (!c.jc) {
                                this.s();
                                return;
                            }
                        } else c.jc = !1;
                        c.rb = !0;
                        try {
                            e = this.zd(b);
                        } finally{
                            c.rb = !1;
                        }
                        return e;
                    }
                },
                zd: function(b) {
                    var c = this[r], d = !1, e = c.wb ? n : !c.V, d = {
                        qd: this,
                        mb: c.I,
                        Qb: c.V
                    };
                    a.u.xc({
                        pd: d,
                        od: ba,
                        o: this,
                        Ya: e
                    });
                    c.I = {};
                    c.V = 0;
                    var f = this.yd(c, d);
                    c.V ? d = this.sb(c.X, f) : (this.s(), d = !0);
                    d && (c.J ? this.Gb() : this.notifySubscribers(c.X, "beforeChange"), c.X = f, this.notifySubscribers(c.X, "spectate"), !c.J && b && this.notifySubscribers(c.X), this.rc && this.rc());
                    e && this.notifySubscribers(c.X, "awake");
                    return d;
                },
                yd: function(b, c) {
                    try {
                        var d = b.Wc;
                        return b.nb ? d.call(b.nb) : d();
                    } finally{
                        a.u.end(), c.Qb && !b.J && a.a.P(c.mb, aa), b.sa = b.ka = !1;
                    }
                },
                v: function(a) {
                    var c = this[r];
                    (c.ka && (a || !c.V) || c.J && this.Xa()) && this.ha();
                    return c.X;
                },
                ub: function(b) {
                    a.T.fn.ub.call(this, b);
                    this.nc = function() {
                        this[r].J || (this[r].sa ? this.ha() : this[r].ka = !1);
                        return this[r].X;
                    };
                    this.Ia = function(a) {
                        this.pc(this[r].X);
                        this[r].ka = !0;
                        a && (this[r].sa = !0);
                        this.qc(this, !a);
                    };
                },
                s: function() {
                    var b = this[r];
                    !b.J && b.I && a.a.P(b.I, function(a, b) {
                        b.s && b.s();
                    });
                    b.l && b.Rb && a.a.K.yb(b.l, b.Rb);
                    b.I = n;
                    b.V = 0;
                    b.ra = !0;
                    b.sa = !1;
                    b.ka = !1;
                    b.J = !1;
                    b.l = n;
                    b.Sa = n;
                    b.Wc = n;
                    this.Nc || (b.nb = n);
                }
            }, da = {
                Qa: function(b) {
                    var c = this, d = c[r];
                    if (!d.ra && d.J && "change" == b) {
                        d.J = !1;
                        if (d.sa || c.Xa()) d.I = null, d.V = 0, c.ha() && c.Gb();
                        else {
                            var e = [];
                            a.a.P(d.I, function(a, b) {
                                e[b.Ka] = a;
                            });
                            a.a.D(e, function(a, b) {
                                var e = d.I[a], m = c.$c(e.da);
                                m.Ka = b;
                                m.La = e.La;
                                d.I[a] = m;
                            });
                            c.Xa() && c.ha() && c.Gb();
                        }
                        d.ra || c.notifySubscribers(d.X, "awake");
                    }
                },
                hb: function(b) {
                    var c = this[r];
                    c.ra || "change" != b || this.Wa("change") || (a.a.P(c.I, function(a, b) {
                        b.s && (c.I[a] = {
                            da: b.da,
                            Ka: b.Ka,
                            La: b.La
                        }, b.s());
                    }), c.J = !0, this.notifySubscribers(n, "asleep"));
                },
                ob: function() {
                    var b = this[r];
                    b.J && (b.sa || this.Xa()) && this.ha();
                    return a.T.fn.ob.call(this);
                }
            }, ea = {
                Qa: function(a) {
                    "change" != a && "beforeChange" != a || this.v();
                }
            };
            a.a.Ba && a.a.setPrototypeOf(C, a.T.fn);
            var N = a.ta.Ma;
            C[N] = a.o;
            a.Oc = function(a) {
                return "function" == typeof a && a[N] === C[N];
            };
            a.Fd = function(b) {
                return a.Oc(b) && b[r] && b[r].wb;
            };
            a.b("computed", a.o);
            a.b("dependentObservable", a.o);
            a.b("isComputed", a.Oc);
            a.b("isPureComputed", a.Fd);
            a.b("computed.fn", C);
            a.L(C, "peek", C.v);
            a.L(C, "dispose", C.s);
            a.L(C, "isActive", C.ja);
            a.L(C, "getDependenciesCount", C.qa);
            a.L(C, "getDependencies", C.Va);
            a.xb = function(b, c) {
                if ("function" === typeof b) return a.o(b, c, {
                    pure: !0
                });
                b = a.a.extend({}, b);
                b.pure = !0;
                return a.o(b, c);
            };
            a.b("pureComputed", a.xb);
            (function() {
                function b(a, f, g) {
                    g = g || new d;
                    a = f(a);
                    if ("object" != typeof a || null === a || a === n || a instanceof RegExp || a instanceof Date || a instanceof String || a instanceof Number || a instanceof Boolean) return a;
                    var h = a instanceof Array ? [] : {};
                    g.save(a, h);
                    c(a, function(c) {
                        var d = f(a[c]);
                        switch(typeof d){
                            case "boolean":
                            case "number":
                            case "string":
                            case "function":
                                h[c] = d;
                                break;
                            case "object":
                            case "undefined":
                                var l = g.get(d);
                                h[c] = l !== n ? l : b(d, f, g);
                        }
                    });
                    return h;
                }
                function c(a, b) {
                    if (a instanceof Array) {
                        for(var c = 0; c < a.length; c++)b(c);
                        "function" == typeof a.toJSON && b("toJSON");
                    } else for(c in a)b(c);
                }
                function d() {
                    this.keys = [];
                    this.values = [];
                }
                a.ad = function(c) {
                    if (0 == arguments.length) throw Error("When calling ko.toJS, pass the object you want to convert.");
                    return b(c, function(b) {
                        for(var c = 0; a.O(b) && 10 > c; c++)b = b();
                        return b;
                    });
                };
                a.toJSON = function(b, c, d) {
                    b = a.ad(b);
                    return a.a.hc(b, c, d);
                };
                d.prototype = {
                    constructor: d,
                    save: function(b, c) {
                        var d = a.a.A(this.keys, b);
                        0 <= d ? this.values[d] = c : (this.keys.push(b), this.values.push(c));
                    },
                    get: function(b) {
                        b = a.a.A(this.keys, b);
                        return 0 <= b ? this.values[b] : n;
                    }
                };
            })();
            a.b("toJS", a.ad);
            a.b("toJSON", a.toJSON);
            a.Wd = function(b, c, d) {
                function e(c) {
                    var e = a.xb(b, d).extend({
                        ma: "always"
                    }), h = e.subscribe(function(a) {
                        a && (h.s(), c(a));
                    });
                    e.notifySubscribers(e.v());
                    return h;
                }
                return "function" !== typeof Promise || c ? e(c.bind(d)) : new Promise(e);
            };
            a.b("when", a.Wd);
            (function() {
                a.w = {
                    M: function(b) {
                        switch(a.a.R(b)){
                            case "option":
                                return !0 === b.__ko__hasDomDataOptionValue__ ? a.a.g.get(b, a.c.options.$b) : 7 >= a.a.W ? b.getAttributeNode("value") && b.getAttributeNode("value").specified ? b.value : b.text : b.value;
                            case "select":
                                return 0 <= b.selectedIndex ? a.w.M(b.options[b.selectedIndex]) : n;
                            default:
                                return b.value;
                        }
                    },
                    cb: function(b, c, d) {
                        switch(a.a.R(b)){
                            case "option":
                                "string" === typeof c ? (a.a.g.set(b, a.c.options.$b, n), "__ko__hasDomDataOptionValue__" in b && delete b.__ko__hasDomDataOptionValue__, b.value = c) : (a.a.g.set(b, a.c.options.$b, c), b.__ko__hasDomDataOptionValue__ = !0, b.value = "number" === typeof c ? c : "");
                                break;
                            case "select":
                                if ("" === c || null === c) c = n;
                                for(var e = -1, f = 0, g = b.options.length, h; f < g; ++f)if (h = a.w.M(b.options[f]), h == c || "" === h && c === n) {
                                    e = f;
                                    break;
                                }
                                if (d || 0 <= e || c === n && 1 < b.size) b.selectedIndex = e, 6 === a.a.W && a.a.setTimeout(function() {
                                    b.selectedIndex = e;
                                }, 0);
                                break;
                            default:
                                if (null === c || c === n) c = "";
                                b.value = c;
                        }
                    }
                };
            })();
            a.b("selectExtensions", a.w);
            a.b("selectExtensions.readValue", a.w.M);
            a.b("selectExtensions.writeValue", a.w.cb);
            a.m = function() {
                function b(b) {
                    b = a.a.Db(b);
                    123 === b.charCodeAt(0) && (b = b.slice(1, -1));
                    b += "\n,";
                    var c = [], d = b.match(e), p, q = [], h = 0;
                    if (1 < d.length) {
                        for(var x = 0, B; B = d[x]; ++x){
                            var u = B.charCodeAt(0);
                            if (44 === u) {
                                if (0 >= h) {
                                    c.push(p && q.length ? {
                                        key: p,
                                        value: q.join("")
                                    } : {
                                        unknown: p || q.join("")
                                    });
                                    p = h = 0;
                                    q = [];
                                    continue;
                                }
                            } else if (58 === u) {
                                if (!h && !p && 1 === q.length) {
                                    p = q.pop();
                                    continue;
                                }
                            } else if (47 === u && 1 < B.length && (47 === B.charCodeAt(1) || 42 === B.charCodeAt(1))) continue;
                            else 47 === u && x && 1 < B.length ? (u = d[x - 1].match(f)) && !g[u[0]] && (b = b.substr(b.indexOf(B) + 1), d = b.match(e), x = -1, B = "/") : 40 === u || 123 === u || 91 === u ? ++h : 41 === u || 125 === u || 93 === u ? --h : p || q.length || 34 !== u && 39 !== u || (B = B.slice(1, -1));
                            q.push(B);
                        }
                        if (0 < h) throw Error("Unbalanced parentheses, braces, or brackets");
                    }
                    return c;
                }
                var c = [
                    "true",
                    "false",
                    "null",
                    "undefined"
                ], d = /^(?:[$_a-z][$\w]*|(.+)(\.\s*[$_a-z][$\w]*|\[.+\]))$/i, e = RegExp("\"(?:\\\\.|[^\"])*\"|'(?:\\\\.|[^'])*'|`(?:\\\\.|[^`])*`|/\\*(?:[^*]|\\*+[^*/])*\\*+/|//.*\n|/(?:\\\\.|[^/])+/w*|[^\\s:,/][^,\"'`{}()/:[\\]]*[^\\s,\"'`{}()/:[\\]]|[^\\s]", "g"), f = /[\])"'A-Za-z0-9_$]+$/, g = {
                    "in": 1,
                    "return": 1,
                    "typeof": 1
                }, h = {};
                return {
                    Ra: [],
                    wa: h,
                    ac: b,
                    vb: function(e, f) {
                        function l(b, e) {
                            var f;
                            if (!x) {
                                var k = a.getBindingHandler(b);
                                if (k && k.preprocess && !(e = k.preprocess(e, b, l))) return;
                                if (k = h[b]) f = e, 0 <= a.a.A(c, f) ? f = !1 : (k = f.match(d), f = null === k ? !1 : k[1] ? "Object(" + k[1] + ")" + k[2] : f), k = f;
                                k && q.push("'" + ("string" == typeof h[b] ? h[b] : b) + "':function(_z){" + f + "=_z}");
                            }
                            g && (e = "function(){return " + e + " }");
                            p.push("'" + b + "':" + e);
                        }
                        f = f || {};
                        var p = [], q = [], g = f.valueAccessors, x = f.bindingParams, B = "string" === typeof e ? b(e) : e;
                        a.a.D(B, function(a) {
                            l(a.key || a.unknown, a.value);
                        });
                        q.length && l("_ko_property_writers", "{" + q.join(",") + " }");
                        return p.join(",");
                    },
                    Id: function(a, b) {
                        for(var c = 0; c < a.length; c++)if (a[c].key == b) return !0;
                        return !1;
                    },
                    eb: function(b, c, d, e, f) {
                        if (b && a.O(b)) !a.Za(b) || f && b.v() === e || b(e);
                        else if ((b = c.get("_ko_property_writers")) && b[d]) b[d](e);
                    }
                };
            }();
            a.b("expressionRewriting", a.m);
            a.b("expressionRewriting.bindingRewriteValidators", a.m.Ra);
            a.b("expressionRewriting.parseObjectLiteral", a.m.ac);
            a.b("expressionRewriting.preProcessBindings", a.m.vb);
            a.b("expressionRewriting._twoWayBindings", a.m.wa);
            a.b("jsonExpressionRewriting", a.m);
            a.b("jsonExpressionRewriting.insertPropertyAccessorsIntoJson", a.m.vb);
            (function() {
                function b(a) {
                    return 8 == a.nodeType && g.test(f ? a.text : a.nodeValue);
                }
                function c(a) {
                    return 8 == a.nodeType && h.test(f ? a.text : a.nodeValue);
                }
                function d(d, e) {
                    for(var f = d, h = 1, g = []; f = f.nextSibling;){
                        if (c(f) && (a.a.g.set(f, k, !0), h--, 0 === h)) return g;
                        g.push(f);
                        b(f) && h++;
                    }
                    if (!e) throw Error("Cannot find closing comment tag to match: " + d.nodeValue);
                    return null;
                }
                function e(a, b) {
                    var c = d(a, b);
                    return c ? 0 < c.length ? c[c.length - 1].nextSibling : a.nextSibling : null;
                }
                var f = w && "<!--test-->" === w.createComment("test").text, g = f ? /^\x3c!--\s*ko(?:\s+([\s\S]+))?\s*--\x3e$/ : /^\s*ko(?:\s+([\s\S]+))?\s*$/, h = f ? /^\x3c!--\s*\/ko\s*--\x3e$/ : /^\s*\/ko\s*$/, m = {
                    ul: !0,
                    ol: !0
                }, k = "__ko_matchedEndComment__";
                a.h = {
                    ea: {},
                    childNodes: function(a) {
                        return b(a) ? d(a) : a.childNodes;
                    },
                    Ea: function(c) {
                        if (b(c)) {
                            c = a.h.childNodes(c);
                            for(var d = 0, e = c.length; d < e; d++)a.removeNode(c[d]);
                        } else a.a.Tb(c);
                    },
                    va: function(c, d) {
                        if (b(c)) {
                            a.h.Ea(c);
                            for(var e = c.nextSibling, f = 0, k = d.length; f < k; f++)e.parentNode.insertBefore(d[f], e);
                        } else a.a.va(c, d);
                    },
                    Vc: function(a, c) {
                        var d;
                        b(a) ? (d = a.nextSibling, a = a.parentNode) : d = a.firstChild;
                        d ? c !== d && a.insertBefore(c, d) : a.appendChild(c);
                    },
                    Wb: function(c, d, e) {
                        e ? (e = e.nextSibling, b(c) && (c = c.parentNode), e ? d !== e && c.insertBefore(d, e) : c.appendChild(d)) : a.h.Vc(c, d);
                    },
                    firstChild: function(a) {
                        if (b(a)) return !a.nextSibling || c(a.nextSibling) ? null : a.nextSibling;
                        if (a.firstChild && c(a.firstChild)) throw Error("Found invalid end comment, as the first child of " + a);
                        return a.firstChild;
                    },
                    nextSibling: function(d) {
                        b(d) && (d = e(d));
                        if (d.nextSibling && c(d.nextSibling)) {
                            var f = d.nextSibling;
                            if (c(f) && !a.a.g.get(f, k)) throw Error("Found end comment without a matching opening comment, as child of " + d);
                            return null;
                        }
                        return d.nextSibling;
                    },
                    Cd: b,
                    Vd: function(a) {
                        return (a = (f ? a.text : a.nodeValue).match(g)) ? a[1] : null;
                    },
                    Sc: function(d) {
                        if (m[a.a.R(d)]) {
                            var f = d.firstChild;
                            if (f) {
                                do if (1 === f.nodeType) {
                                    var k;
                                    k = f.firstChild;
                                    var h = null;
                                    if (k) {
                                        do if (h) h.push(k);
                                        else if (b(k)) {
                                            var g = e(k, !0);
                                            g ? k = g : h = [
                                                k
                                            ];
                                        } else c(k) && (h = [
                                            k
                                        ]);
                                        while (k = k.nextSibling);
                                    }
                                    if (k = h) for(h = f.nextSibling, g = 0; g < k.length; g++)h ? d.insertBefore(k[g], h) : d.appendChild(k[g]);
                                }
                                while (f = f.nextSibling);
                            }
                        }
                    }
                };
            })();
            a.b("virtualElements", a.h);
            a.b("virtualElements.allowedBindings", a.h.ea);
            a.b("virtualElements.emptyNode", a.h.Ea);
            a.b("virtualElements.insertAfter", a.h.Wb);
            a.b("virtualElements.prepend", a.h.Vc);
            a.b("virtualElements.setDomNodeChildren", a.h.va);
            (function() {
                a.ga = function() {
                    this.nd = {};
                };
                a.a.extend(a.ga.prototype, {
                    nodeHasBindings: function(b) {
                        switch(b.nodeType){
                            case 1:
                                return null != b.getAttribute("data-bind") || a.j.getComponentNameForNode(b);
                            case 8:
                                return a.h.Cd(b);
                            default:
                                return !1;
                        }
                    },
                    getBindings: function(b, c) {
                        var d = this.getBindingsString(b, c), d = d ? this.parseBindingsString(d, c, b) : null;
                        return a.j.tc(d, b, c, !1);
                    },
                    getBindingAccessors: function(b, c) {
                        var d = this.getBindingsString(b, c), d = d ? this.parseBindingsString(d, c, b, {
                            valueAccessors: !0
                        }) : null;
                        return a.j.tc(d, b, c, !0);
                    },
                    getBindingsString: function(b) {
                        switch(b.nodeType){
                            case 1:
                                return b.getAttribute("data-bind");
                            case 8:
                                return a.h.Vd(b);
                            default:
                                return null;
                        }
                    },
                    parseBindingsString: function(b, c, d, e) {
                        try {
                            var f = this.nd, g = b + (e && e.valueAccessors || ""), h;
                            if (!(h = f[g])) {
                                var m, k = "with($context){with($data||{}){return{" + a.m.vb(b, e) + "}}}";
                                m = new Function("$context", "$element", k);
                                h = f[g] = m;
                            }
                            return h(c, d);
                        } catch (l) {
                            throw l.message = "Unable to parse bindings.\nBindings value: " + b + "\nMessage: " + l.message, l;
                        }
                    }
                });
                a.ga.instance = new a.ga;
            })();
            a.b("bindingProvider", a.ga);
            (function() {
                function b(b) {
                    var c = (b = a.a.g.get(b, z)) && b.N;
                    c && (b.N = null, c.Tc());
                }
                function c(c, d, e) {
                    this.node = c;
                    this.yc = d;
                    this.kb = [];
                    this.H = !1;
                    d.N || a.a.K.za(c, b);
                    e && e.N && (e.N.kb.push(c), this.Kb = e);
                }
                function d(a) {
                    return function() {
                        return a;
                    };
                }
                function e(a) {
                    return a();
                }
                function f(b) {
                    return a.a.Ga(a.u.G(b), function(a, c) {
                        return function() {
                            return b()[c];
                        };
                    });
                }
                function g(b, c, e) {
                    return "function" === typeof b ? f(b.bind(null, c, e)) : a.a.Ga(b, d);
                }
                function h(a, b) {
                    return f(this.getBindings.bind(this, a, b));
                }
                function m(b, c) {
                    var d = a.h.firstChild(c);
                    if (d) {
                        var e, f = a.ga.instance, l = f.preprocessNode;
                        if (l) {
                            for(; e = d;)d = a.h.nextSibling(e), l.call(f, e);
                            d = a.h.firstChild(c);
                        }
                        for(; e = d;)d = a.h.nextSibling(e), k(b, e);
                    }
                    a.i.ma(c, a.i.H);
                }
                function k(b, c) {
                    var d = b, e = 1 === c.nodeType;
                    e && a.h.Sc(c);
                    if (e || a.ga.instance.nodeHasBindings(c)) d = p(c, null, b).bindingContextForDescendants;
                    d && !u[a.a.R(c)] && m(d, c);
                }
                function l(b) {
                    var c = [], d = {}, e = [];
                    a.a.P(b, function ca(f) {
                        if (!d[f]) {
                            var k = a.getBindingHandler(f);
                            k && (k.after && (e.push(f), a.a.D(k.after, function(c) {
                                if (b[c]) {
                                    if (-1 !== a.a.A(e, c)) throw Error("Cannot combine the following bindings, because they have a cyclic dependency: " + e.join(", "));
                                    ca(c);
                                }
                            }), e.length--), c.push({
                                key: f,
                                Mc: k
                            }));
                            d[f] = !0;
                        }
                    });
                    return c;
                }
                function p(b, c, d) {
                    var f = a.a.g.Ub(b, z, {}), k = f.hd;
                    if (!c) {
                        if (k) throw Error("You cannot apply bindings multiple times to the same element.");
                        f.hd = !0;
                    }
                    k || (f.context = d);
                    f.Zb || (f.Zb = {});
                    var g;
                    if (c && "function" !== typeof c) g = c;
                    else {
                        var p = a.ga.instance, q = p.getBindingAccessors || h, m = a.$(function() {
                            if (g = c ? c(d, b) : q.call(p, b, d)) {
                                if (d[t]) d[t]();
                                if (d[B]) d[B]();
                            }
                            return g;
                        }, null, {
                            l: b
                        });
                        g && m.ja() || (m = null);
                    }
                    var x = d, u;
                    if (g) {
                        var J = function() {
                            return a.a.Ga(m ? m() : g, e);
                        }, r = m ? function(a) {
                            return function() {
                                return e(m()[a]);
                            };
                        } : function(a) {
                            return g[a];
                        };
                        J.get = function(a) {
                            return g[a] && e(r(a));
                        };
                        J.has = function(a) {
                            return a in g;
                        };
                        a.i.H in g && a.i.subscribe(b, a.i.H, function() {
                            var c = (0, g[a.i.H])();
                            if (c) {
                                var d = a.h.childNodes(b);
                                d.length && c(d, a.Ec(d[0]));
                            }
                        });
                        a.i.pa in g && (x = a.i.Cb(b, d), a.i.subscribe(b, a.i.pa, function() {
                            var c = (0, g[a.i.pa])();
                            c && a.h.firstChild(b) && c(b);
                        }));
                        f = l(g);
                        a.a.D(f, function(c) {
                            var d = c.Mc.init, e = c.Mc.update, f = c.key;
                            if (8 === b.nodeType && !a.h.ea[f]) throw Error("The binding '" + f + "' cannot be used with virtual elements");
                            try {
                                "function" == typeof d && a.u.G(function() {
                                    var a = d(b, r(f), J, x.$data, x);
                                    if (a && a.controlsDescendantBindings) {
                                        if (u !== n) throw Error("Multiple bindings (" + u + " and " + f + ") are trying to control descendant bindings of the same element. You cannot use these bindings together on the same element.");
                                        u = f;
                                    }
                                }), "function" == typeof e && a.$(function() {
                                    e(b, r(f), J, x.$data, x);
                                }, null, {
                                    l: b
                                });
                            } catch (k) {
                                throw k.message = 'Unable to process binding "' + f + ": " + g[f] + '"\nMessage: ' + k.message, k;
                            }
                        });
                    }
                    f = u === n;
                    return {
                        shouldBindDescendants: f,
                        bindingContextForDescendants: f && x
                    };
                }
                function q(b, c) {
                    return b && b instanceof a.fa ? b : new a.fa(b, n, n, c);
                }
                var t = a.a.Da("_subscribable"), x = a.a.Da("_ancestorBindingInfo"), B = a.a.Da("_dataDependency");
                a.c = {};
                var u = {
                    script: !0,
                    textarea: !0,
                    template: !0
                };
                a.getBindingHandler = function(b) {
                    return a.c[b];
                };
                var J = {};
                a.fa = function(b, c, d, e, f) {
                    function k() {
                        var b = p ? h() : h, f = a.a.f(b);
                        c ? (a.a.extend(l, c), x in c && (l[x] = c[x])) : (l.$parents = [], l.$root = f, l.ko = a);
                        l[t] = q;
                        g ? f = l.$data : (l.$rawData = b, l.$data = f);
                        d && (l[d] = f);
                        e && e(l, c, f);
                        if (c && c[t] && !a.S.o().Vb(c[t])) c[t]();
                        m && (l[B] = m);
                        return l.$data;
                    }
                    var l = this, g = b === J, h = g ? n : b, p = "function" == typeof h && !a.O(h), q, m = f && f.dataDependency;
                    f && f.exportDependencies ? k() : (q = a.xb(k), q.v(), q.ja() ? q.equalityComparer = null : l[t] = n);
                };
                a.fa.prototype.createChildContext = function(b, c, d, e) {
                    !e && c && "object" == typeof c && (e = c, c = e.as, d = e.extend);
                    if (c && e && e.noChildContext) {
                        var f = "function" == typeof b && !a.O(b);
                        return new a.fa(J, this, null, function(a) {
                            d && d(a);
                            a[c] = f ? b() : b;
                        }, e);
                    }
                    return new a.fa(b, this, c, function(a, b) {
                        a.$parentContext = b;
                        a.$parent = b.$data;
                        a.$parents = (b.$parents || []).slice(0);
                        a.$parents.unshift(a.$parent);
                        d && d(a);
                    }, e);
                };
                a.fa.prototype.extend = function(b, c) {
                    return new a.fa(J, this, null, function(c) {
                        a.a.extend(c, "function" == typeof b ? b(c) : b);
                    }, c);
                };
                var z = a.a.g.Z();
                c.prototype.Tc = function() {
                    this.Kb && this.Kb.N && this.Kb.N.sd(this.node);
                };
                c.prototype.sd = function(b) {
                    a.a.Pa(this.kb, b);
                    !this.kb.length && this.H && this.Cc();
                };
                c.prototype.Cc = function() {
                    this.H = !0;
                    this.yc.N && !this.kb.length && (this.yc.N = null, a.a.K.yb(this.node, b), a.i.ma(this.node, a.i.pa), this.Tc());
                };
                a.i = {
                    H: "childrenComplete",
                    pa: "descendantsComplete",
                    subscribe: function(b, c, d, e, f) {
                        var k = a.a.g.Ub(b, z, {});
                        k.Fa || (k.Fa = new a.T);
                        f && f.notifyImmediately && k.Zb[c] && a.u.G(d, e, [
                            b
                        ]);
                        return k.Fa.subscribe(d, e, c);
                    },
                    ma: function(b, c) {
                        var d = a.a.g.get(b, z);
                        if (d && (d.Zb[c] = !0, d.Fa && d.Fa.notifySubscribers(b, c), c == a.i.H)) {
                            if (d.N) d.N.Cc();
                            else if (d.N === n && d.Fa && d.Fa.Wa(a.i.pa)) throw Error("descendantsComplete event not supported for bindings on this node");
                        }
                    },
                    Cb: function(b, d) {
                        var e = a.a.g.Ub(b, z, {});
                        e.N || (e.N = new c(b, e, d[x]));
                        return d[x] == e ? d : d.extend(function(a) {
                            a[x] = e;
                        });
                    }
                };
                a.Td = function(b) {
                    return (b = a.a.g.get(b, z)) && b.context;
                };
                a.ib = function(b, c, d) {
                    1 === b.nodeType && a.h.Sc(b);
                    return p(b, c, q(d));
                };
                a.ld = function(b, c, d) {
                    d = q(d);
                    return a.ib(b, g(c, d, b), d);
                };
                a.Oa = function(a, b) {
                    1 !== b.nodeType && 8 !== b.nodeType || m(q(a), b);
                };
                a.vc = function(a, b, c) {
                    !v && A.jQuery && (v = A.jQuery);
                    if (2 > arguments.length) {
                        if (b = w.body, !b) throw Error("ko.applyBindings: could not find document.body; has the document been loaded?");
                    } else if (!b || 1 !== b.nodeType && 8 !== b.nodeType) throw Error("ko.applyBindings: first parameter should be your view model; second parameter should be a DOM node");
                    k(q(a, c), b);
                };
                a.Dc = function(b) {
                    return !b || 1 !== b.nodeType && 8 !== b.nodeType ? n : a.Td(b);
                };
                a.Ec = function(b) {
                    return (b = a.Dc(b)) ? b.$data : n;
                };
                a.b("bindingHandlers", a.c);
                a.b("bindingEvent", a.i);
                a.b("bindingEvent.subscribe", a.i.subscribe);
                a.b("bindingEvent.startPossiblyAsyncContentBinding", a.i.Cb);
                a.b("applyBindings", a.vc);
                a.b("applyBindingsToDescendants", a.Oa);
                a.b("applyBindingAccessorsToNode", a.ib);
                a.b("applyBindingsToNode", a.ld);
                a.b("contextFor", a.Dc);
                a.b("dataFor", a.Ec);
            })();
            (function(b) {
                function c(c, e) {
                    var k = Object.prototype.hasOwnProperty.call(f, c) ? f[c] : b, l;
                    k ? k.subscribe(e) : (k = f[c] = new a.T, k.subscribe(e), d(c, function(b, d) {
                        var e = !(!d || !d.synchronous);
                        g[c] = {
                            definition: b,
                            Gd: e
                        };
                        delete f[c];
                        l || e ? k.notifySubscribers(b) : a.na.zb(function() {
                            k.notifySubscribers(b);
                        });
                    }), l = !0);
                }
                function d(a, b) {
                    e("getConfig", [
                        a
                    ], function(c) {
                        c ? e("loadComponent", [
                            a,
                            c
                        ], function(a) {
                            b(a, c);
                        }) : b(null, null);
                    });
                }
                function e(c, d, f, l) {
                    l || (l = a.j.loaders.slice(0));
                    var g = l.shift();
                    if (g) {
                        var q = g[c];
                        if (q) {
                            var t = !1;
                            if (q.apply(g, d.concat(function(a) {
                                t ? f(null) : null !== a ? f(a) : e(c, d, f, l);
                            })) !== b && (t = !0, !g.suppressLoaderExceptions)) throw Error("Component loaders must supply values by invoking the callback, not by returning values synchronously.");
                        } else e(c, d, f, l);
                    } else f(null);
                }
                var f = {}, g = {};
                a.j = {
                    get: function(d, e) {
                        var f = Object.prototype.hasOwnProperty.call(g, d) ? g[d] : b;
                        f ? f.Gd ? a.u.G(function() {
                            e(f.definition);
                        }) : a.na.zb(function() {
                            e(f.definition);
                        }) : c(d, e);
                    },
                    Bc: function(a) {
                        delete g[a];
                    },
                    oc: e
                };
                a.j.loaders = [];
                a.b("components", a.j);
                a.b("components.get", a.j.get);
                a.b("components.clearCachedDefinition", a.j.Bc);
            })();
            (function() {
                function b(b, c, d, e) {
                    function g() {
                        0 === --B && e(h);
                    }
                    var h = {}, B = 2, u = d.template;
                    d = d.viewModel;
                    u ? f(c, u, function(c) {
                        a.j.oc("loadTemplate", [
                            b,
                            c
                        ], function(a) {
                            h.template = a;
                            g();
                        });
                    }) : g();
                    d ? f(c, d, function(c) {
                        a.j.oc("loadViewModel", [
                            b,
                            c
                        ], function(a) {
                            h[m] = a;
                            g();
                        });
                    }) : g();
                }
                function c(a, b, d) {
                    if ("function" === typeof b) d(function(a) {
                        return new b(a);
                    });
                    else if ("function" === typeof b[m]) d(b[m]);
                    else if ("instance" in b) {
                        var e = b.instance;
                        d(function() {
                            return e;
                        });
                    } else "viewModel" in b ? c(a, b.viewModel, d) : a("Unknown viewModel value: " + b);
                }
                function d(b) {
                    switch(a.a.R(b)){
                        case "script":
                            return a.a.ua(b.text);
                        case "textarea":
                            return a.a.ua(b.value);
                        case "template":
                            if (e(b.content)) return a.a.Ca(b.content.childNodes);
                    }
                    return a.a.Ca(b.childNodes);
                }
                function e(a) {
                    return A.DocumentFragment ? a instanceof DocumentFragment : a && 11 === a.nodeType;
                }
                function f(a, b, c) {
                    "string" === typeof b.require ? T || A.require ? (T || A.require)([
                        b.require
                    ], function(a) {
                        a && "object" === typeof a && a.Xd && a["default"] && (a = a["default"]);
                        c(a);
                    }) : a("Uses require, but no AMD loader is present") : c(b);
                }
                function g(a) {
                    return function(b) {
                        throw Error("Component '" + a + "': " + b);
                    };
                }
                var h = {};
                a.j.register = function(b, c) {
                    if (!c) throw Error("Invalid configuration for " + b);
                    if (a.j.tb(b)) throw Error("Component " + b + " is already registered");
                    h[b] = c;
                };
                a.j.tb = function(a) {
                    return Object.prototype.hasOwnProperty.call(h, a);
                };
                a.j.unregister = function(b) {
                    delete h[b];
                    a.j.Bc(b);
                };
                a.j.Fc = {
                    getConfig: function(b, c) {
                        c(a.j.tb(b) ? h[b] : null);
                    },
                    loadComponent: function(a, c, d) {
                        var e = g(a);
                        f(e, c, function(c) {
                            b(a, e, c, d);
                        });
                    },
                    loadTemplate: function(b, c, f) {
                        b = g(b);
                        if ("string" === typeof c) f(a.a.ua(c));
                        else if (c instanceof Array) f(c);
                        else if (e(c)) f(a.a.la(c.childNodes));
                        else if (c.element) {
                            if (c = c.element, A.HTMLElement ? c instanceof HTMLElement : c && c.tagName && 1 === c.nodeType) f(d(c));
                            else if ("string" === typeof c) {
                                var h = w.getElementById(c);
                                h ? f(d(h)) : b("Cannot find element with ID " + c);
                            } else b("Unknown element type: " + c);
                        } else b("Unknown template value: " + c);
                    },
                    loadViewModel: function(a, b, d) {
                        c(g(a), b, d);
                    }
                };
                var m = "createViewModel";
                a.b("components.register", a.j.register);
                a.b("components.isRegistered", a.j.tb);
                a.b("components.unregister", a.j.unregister);
                a.b("components.defaultLoader", a.j.Fc);
                a.j.loaders.push(a.j.Fc);
                a.j.dd = h;
            })();
            (function() {
                function b(b, e) {
                    var f = b.getAttribute("params");
                    if (f) {
                        var f = c.parseBindingsString(f, e, b, {
                            valueAccessors: !0,
                            bindingParams: !0
                        }), f = a.a.Ga(f, function(c) {
                            return a.o(c, null, {
                                l: b
                            });
                        }), g = a.a.Ga(f, function(c) {
                            var e = c.v();
                            return c.ja() ? a.o({
                                read: function() {
                                    return a.a.f(c());
                                },
                                write: a.Za(e) && function(a) {
                                    c()(a);
                                },
                                l: b
                            }) : e;
                        });
                        Object.prototype.hasOwnProperty.call(g, "$raw") || (g.$raw = f);
                        return g;
                    }
                    return {
                        $raw: {}
                    };
                }
                a.j.getComponentNameForNode = function(b) {
                    var c = a.a.R(b);
                    if (a.j.tb(c) && (-1 != c.indexOf("-") || "[object HTMLUnknownElement]" == "" + b || 8 >= a.a.W && b.tagName === c)) return c;
                };
                a.j.tc = function(c, e, f, g) {
                    if (1 === e.nodeType) {
                        var h = a.j.getComponentNameForNode(e);
                        if (h) {
                            c = c || {};
                            if (c.component) throw Error('Cannot use the "component" binding on a custom element matching a component');
                            var m = {
                                name: h,
                                params: b(e, f)
                            };
                            c.component = g ? function() {
                                return m;
                            } : m;
                        }
                    }
                    return c;
                };
                var c = new a.ga;
                9 > a.a.W && (a.j.register = function(a) {
                    return function(b) {
                        return a.apply(this, arguments);
                    };
                }(a.j.register), w.createDocumentFragment = function(b) {
                    return function() {
                        var c = b(), f = a.j.dd, g;
                        for(g in f);
                        return c;
                    };
                }(w.createDocumentFragment));
            })();
            (function() {
                function b(b, c, d) {
                    c = c.template;
                    if (!c) throw Error("Component '" + b + "' has no template");
                    b = a.a.Ca(c);
                    a.h.va(d, b);
                }
                function c(a, b, c) {
                    var d = a.createViewModel;
                    return d ? d.call(a, b, c) : b;
                }
                var d = 0;
                a.c.component = {
                    init: function(e, f, g, h, m) {
                        function k() {
                            var a = l && l.dispose;
                            "function" === typeof a && a.call(l);
                            q && q.s();
                            p = l = q = null;
                        }
                        var l, p, q, t = a.a.la(a.h.childNodes(e));
                        a.h.Ea(e);
                        a.a.K.za(e, k);
                        a.o(function() {
                            var g = a.a.f(f()), h, u;
                            "string" === typeof g ? h = g : (h = a.a.f(g.name), u = a.a.f(g.params));
                            if (!h) throw Error("No component name specified");
                            var n = a.i.Cb(e, m), z = p = ++d;
                            a.j.get(h, function(d) {
                                if (p === z) {
                                    k();
                                    if (!d) throw Error("Unknown component '" + h + "'");
                                    b(h, d, e);
                                    var f = c(d, u, {
                                        element: e,
                                        templateNodes: t
                                    });
                                    d = n.createChildContext(f, {
                                        extend: function(a) {
                                            a.$component = f;
                                            a.$componentTemplateNodes = t;
                                        }
                                    });
                                    f && f.koDescendantsComplete && (q = a.i.subscribe(e, a.i.pa, f.koDescendantsComplete, f));
                                    l = f;
                                    a.Oa(d, e);
                                }
                            });
                        }, null, {
                            l: e
                        });
                        return {
                            controlsDescendantBindings: !0
                        };
                    }
                };
                a.h.ea.component = !0;
            })();
            var V = {
                "class": "className",
                "for": "htmlFor"
            };
            a.c.attr = {
                update: function(b, c) {
                    var d = a.a.f(c()) || {};
                    a.a.P(d, function(c, d) {
                        d = a.a.f(d);
                        var g = c.indexOf(":"), g = "lookupNamespaceURI" in b && 0 < g && b.lookupNamespaceURI(c.substr(0, g)), h = !1 === d || null === d || d === n;
                        h ? g ? b.removeAttributeNS(g, c) : b.removeAttribute(c) : d = d.toString();
                        8 >= a.a.W && c in V ? (c = V[c], h ? b.removeAttribute(c) : b[c] = d) : h || (g ? b.setAttributeNS(g, c, d) : b.setAttribute(c, d));
                        "name" === c && a.a.Yc(b, h ? "" : d);
                    });
                }
            };
            (function() {
                a.c.checked = {
                    after: [
                        "value",
                        "attr"
                    ],
                    init: function(b, c, d) {
                        function e() {
                            var e = b.checked, f = g();
                            if (!a.S.Ya() && (e || !m && !a.S.qa())) {
                                var k = a.u.G(c);
                                if (l) {
                                    var q = p ? k.v() : k, z = t;
                                    t = f;
                                    z !== f ? e && (a.a.Na(q, f, !0), a.a.Na(q, z, !1)) : a.a.Na(q, f, e);
                                    p && a.Za(k) && k(q);
                                } else h && (f === n ? f = e : e || (f = n)), a.m.eb(k, d, "checked", f, !0);
                            }
                        }
                        function f() {
                            var d = a.a.f(c()), e = g();
                            l ? (b.checked = 0 <= a.a.A(d, e), t = e) : b.checked = h && e === n ? !!d : g() === d;
                        }
                        var g = a.xb(function() {
                            if (d.has("checkedValue")) return a.a.f(d.get("checkedValue"));
                            if (q) return d.has("value") ? a.a.f(d.get("value")) : b.value;
                        }), h = "checkbox" == b.type, m = "radio" == b.type;
                        if (h || m) {
                            var k = c(), l = h && a.a.f(k) instanceof Array, p = !(l && k.push && k.splice), q = m || l, t = l ? g() : n;
                            m && !b.name && a.c.uniqueName.init(b, function() {
                                return !0;
                            });
                            a.o(e, null, {
                                l: b
                            });
                            a.a.B(b, "click", e);
                            a.o(f, null, {
                                l: b
                            });
                            k = n;
                        }
                    }
                };
                a.m.wa.checked = !0;
                a.c.checkedValue = {
                    update: function(b, c) {
                        b.value = a.a.f(c());
                    }
                };
            })();
            a.c["class"] = {
                update: function(b, c) {
                    var d = a.a.Db(a.a.f(c()));
                    a.a.Eb(b, b.__ko__cssValue, !1);
                    b.__ko__cssValue = d;
                    a.a.Eb(b, d, !0);
                }
            };
            a.c.css = {
                update: function(b, c) {
                    var d = a.a.f(c());
                    null !== d && "object" == typeof d ? a.a.P(d, function(c, d) {
                        d = a.a.f(d);
                        a.a.Eb(b, c, d);
                    }) : a.c["class"].update(b, c);
                }
            };
            a.c.enable = {
                update: function(b, c) {
                    var d = a.a.f(c());
                    d && b.disabled ? b.removeAttribute("disabled") : d || b.disabled || (b.disabled = !0);
                }
            };
            a.c.disable = {
                update: function(b, c) {
                    a.c.enable.update(b, function() {
                        return !a.a.f(c());
                    });
                }
            };
            a.c.event = {
                init: function(b, c, d, e, f) {
                    var g = c() || {};
                    a.a.P(g, function(g) {
                        "string" == typeof g && a.a.B(b, g, function(b) {
                            var k, l = c()[g];
                            if (l) {
                                try {
                                    var p = a.a.la(arguments);
                                    e = f.$data;
                                    p.unshift(e);
                                    k = l.apply(e, p);
                                } finally{
                                    !0 !== k && (b.preventDefault ? b.preventDefault() : b.returnValue = !1);
                                }
                                !1 === d.get(g + "Bubble") && (b.cancelBubble = !0, b.stopPropagation && b.stopPropagation());
                            }
                        });
                    });
                }
            };
            a.c.foreach = {
                Rc: function(b) {
                    return function() {
                        var c = b(), d = a.a.bc(c);
                        if (!d || "number" == typeof d.length) return {
                            foreach: c,
                            templateEngine: a.ba.Ma
                        };
                        a.a.f(c);
                        return {
                            foreach: d.data,
                            as: d.as,
                            noChildContext: d.noChildContext,
                            includeDestroyed: d.includeDestroyed,
                            afterAdd: d.afterAdd,
                            beforeRemove: d.beforeRemove,
                            afterRender: d.afterRender,
                            beforeMove: d.beforeMove,
                            afterMove: d.afterMove,
                            templateEngine: a.ba.Ma
                        };
                    };
                },
                init: function(b, c) {
                    return a.c.template.init(b, a.c.foreach.Rc(c));
                },
                update: function(b, c, d, e, f) {
                    return a.c.template.update(b, a.c.foreach.Rc(c), d, e, f);
                }
            };
            a.m.Ra.foreach = !1;
            a.h.ea.foreach = !0;
            a.c.hasfocus = {
                init: function(b, c, d) {
                    function e(e) {
                        b.__ko_hasfocusUpdating = !0;
                        var f = b.ownerDocument;
                        if ("activeElement" in f) {
                            var g;
                            try {
                                g = f.activeElement;
                            } catch (l) {
                                g = f.body;
                            }
                            e = g === b;
                        }
                        f = c();
                        a.m.eb(f, d, "hasfocus", e, !0);
                        b.__ko_hasfocusLastValue = e;
                        b.__ko_hasfocusUpdating = !1;
                    }
                    var f = e.bind(null, !0), g = e.bind(null, !1);
                    a.a.B(b, "focus", f);
                    a.a.B(b, "focusin", f);
                    a.a.B(b, "blur", g);
                    a.a.B(b, "focusout", g);
                    b.__ko_hasfocusLastValue = !1;
                },
                update: function(b, c) {
                    var d = !!a.a.f(c());
                    b.__ko_hasfocusUpdating || b.__ko_hasfocusLastValue === d || (d ? b.focus() : b.blur(), !d && b.__ko_hasfocusLastValue && b.ownerDocument.body.focus(), a.u.G(a.a.Fb, null, [
                        b,
                        d ? "focusin" : "focusout"
                    ]));
                }
            };
            a.m.wa.hasfocus = !0;
            a.c.hasFocus = a.c.hasfocus;
            a.m.wa.hasFocus = "hasfocus";
            a.c.html = {
                init: function() {
                    return {
                        controlsDescendantBindings: !0
                    };
                },
                update: function(b, c) {
                    a.a.fc(b, c());
                }
            };
            (function() {
                function b(b, d, e) {
                    a.c[b] = {
                        init: function(b, c, h, m, k) {
                            var l, p, q = {}, t, x, n;
                            if (d) {
                                m = h.get("as");
                                var u = h.get("noChildContext");
                                n = !(m && u);
                                q = {
                                    as: m,
                                    noChildContext: u,
                                    exportDependencies: n
                                };
                            }
                            x = (t = "render" == h.get("completeOn")) || h.has(a.i.pa);
                            a.o(function() {
                                var h = a.a.f(c()), m = !e !== !h, u = !p, r;
                                if (n || m !== l) {
                                    x && (k = a.i.Cb(b, k));
                                    if (m) {
                                        if (!d || n) q.dataDependency = a.S.o();
                                        r = d ? k.createChildContext("function" == typeof h ? h : c, q) : a.S.qa() ? k.extend(null, q) : k;
                                    }
                                    u && a.S.qa() && (p = a.a.Ca(a.h.childNodes(b), !0));
                                    m ? (u || a.h.va(b, a.a.Ca(p)), a.Oa(r, b)) : (a.h.Ea(b), t || a.i.ma(b, a.i.H));
                                    l = m;
                                }
                            }, null, {
                                l: b
                            });
                            return {
                                controlsDescendantBindings: !0
                            };
                        }
                    };
                    a.m.Ra[b] = !1;
                    a.h.ea[b] = !0;
                }
                b("if");
                b("ifnot", !1, !0);
                b("with", !0);
            })();
            a.c.let = {
                init: function(b, c, d, e, f) {
                    c = f.extend(c);
                    a.Oa(c, b);
                    return {
                        controlsDescendantBindings: !0
                    };
                }
            };
            a.h.ea.let = !0;
            var Q = {};
            a.c.options = {
                init: function(b) {
                    if ("select" !== a.a.R(b)) throw Error("options binding applies only to SELECT elements");
                    for(; 0 < b.length;)b.remove(0);
                    return {
                        controlsDescendantBindings: !0
                    };
                },
                update: function(b, c, d) {
                    function e() {
                        return a.a.jb(b.options, function(a) {
                            return a.selected;
                        });
                    }
                    function f(a, b, c) {
                        var d = typeof b;
                        return "function" == d ? b(a) : "string" == d ? a[b] : c;
                    }
                    function g(c, d) {
                        if (x && l) a.i.ma(b, a.i.H);
                        else if (t.length) {
                            var e = 0 <= a.a.A(t, a.w.M(d[0]));
                            a.a.Zc(d[0], e);
                            x && !e && a.u.G(a.a.Fb, null, [
                                b,
                                "change"
                            ]);
                        }
                    }
                    var h = b.multiple, m = 0 != b.length && h ? b.scrollTop : null, k = a.a.f(c()), l = d.get("valueAllowUnset") && d.has("value"), p = d.get("optionsIncludeDestroyed");
                    c = {};
                    var q, t = [];
                    l || (h ? t = a.a.Mb(e(), a.w.M) : 0 <= b.selectedIndex && t.push(a.w.M(b.options[b.selectedIndex])));
                    k && ("undefined" == typeof k.length && (k = [
                        k
                    ]), q = a.a.jb(k, function(b) {
                        return p || b === n || null === b || !a.a.f(b._destroy);
                    }), d.has("optionsCaption") && (k = a.a.f(d.get("optionsCaption")), null !== k && k !== n && q.unshift(Q)));
                    var x = !1;
                    c.beforeRemove = function(a) {
                        b.removeChild(a);
                    };
                    k = g;
                    d.has("optionsAfterRender") && "function" == typeof d.get("optionsAfterRender") && (k = function(b, c) {
                        g(0, c);
                        a.u.G(d.get("optionsAfterRender"), null, [
                            c[0],
                            b !== Q ? b : n
                        ]);
                    });
                    a.a.ec(b, q, function(c, e, g) {
                        g.length && (t = !l && g[0].selected ? [
                            a.w.M(g[0])
                        ] : [], x = !0);
                        e = b.ownerDocument.createElement("option");
                        c === Q ? (a.a.Bb(e, d.get("optionsCaption")), a.w.cb(e, n)) : (g = f(c, d.get("optionsValue"), c), a.w.cb(e, a.a.f(g)), c = f(c, d.get("optionsText"), g), a.a.Bb(e, c));
                        return [
                            e
                        ];
                    }, c, k);
                    if (!l) {
                        var B;
                        h ? B = t.length && e().length < t.length : B = t.length && 0 <= b.selectedIndex ? a.w.M(b.options[b.selectedIndex]) !== t[0] : t.length || 0 <= b.selectedIndex;
                        B && a.u.G(a.a.Fb, null, [
                            b,
                            "change"
                        ]);
                    }
                    (l || a.S.Ya()) && a.i.ma(b, a.i.H);
                    a.a.wd(b);
                    m && 20 < Math.abs(m - b.scrollTop) && (b.scrollTop = m);
                }
            };
            a.c.options.$b = a.a.g.Z();
            a.c.selectedOptions = {
                init: function(b, c, d) {
                    function e() {
                        var e = c(), f = [];
                        a.a.D(b.getElementsByTagName("option"), function(b) {
                            b.selected && f.push(a.w.M(b));
                        });
                        a.m.eb(e, d, "selectedOptions", f);
                    }
                    function f() {
                        var d = a.a.f(c()), e = b.scrollTop;
                        d && "number" == typeof d.length && a.a.D(b.getElementsByTagName("option"), function(b) {
                            var c = 0 <= a.a.A(d, a.w.M(b));
                            b.selected != c && a.a.Zc(b, c);
                        });
                        b.scrollTop = e;
                    }
                    if ("select" != a.a.R(b)) throw Error("selectedOptions binding applies only to SELECT elements");
                    var g;
                    a.i.subscribe(b, a.i.H, function() {
                        g ? e() : (a.a.B(b, "change", e), g = a.o(f, null, {
                            l: b
                        }));
                    }, null, {
                        notifyImmediately: !0
                    });
                },
                update: function() {}
            };
            a.m.wa.selectedOptions = !0;
            a.c.style = {
                update: function(b, c) {
                    var d = a.a.f(c() || {});
                    a.a.P(d, function(c, d) {
                        d = a.a.f(d);
                        if (null === d || d === n || !1 === d) d = "";
                        if (v) v(b).css(c, d);
                        else if (/^--/.test(c)) b.style.setProperty(c, d);
                        else {
                            c = c.replace(/-(\w)/g, function(a, b) {
                                return b.toUpperCase();
                            });
                            var g = b.style[c];
                            b.style[c] = d;
                            d === g || b.style[c] != g || isNaN(d) || (b.style[c] = d + "px");
                        }
                    });
                }
            };
            a.c.submit = {
                init: function(b, c, d, e, f) {
                    if ("function" != typeof c()) throw Error("The value for a submit binding must be a function");
                    a.a.B(b, "submit", function(a) {
                        var d, e = c();
                        try {
                            d = e.call(f.$data, b);
                        } finally{
                            !0 !== d && (a.preventDefault ? a.preventDefault() : a.returnValue = !1);
                        }
                    });
                }
            };
            a.c.text = {
                init: function() {
                    return {
                        controlsDescendantBindings: !0
                    };
                },
                update: function(b, c) {
                    a.a.Bb(b, c());
                }
            };
            a.h.ea.text = !0;
            (function() {
                if (A && A.navigator) {
                    var b = function(a) {
                        if (a) return parseFloat(a[1]);
                    }, c = A.navigator.userAgent, d, e, f, g, h;
                    (d = A.opera && A.opera.version && parseInt(A.opera.version())) || (h = b(c.match(/Edge\/([^ ]+)$/))) || b(c.match(/Chrome\/([^ ]+)/)) || (e = b(c.match(/Version\/([^ ]+) Safari/))) || (f = b(c.match(/Firefox\/([^ ]+)/))) || (g = a.a.W || b(c.match(/MSIE ([^ ]+)/))) || (g = b(c.match(/rv:([^ )]+)/)));
                }
                if (8 <= g && 10 > g) var m = a.a.g.Z(), k = a.a.g.Z(), l = function(b) {
                    var c = this.activeElement;
                    (c = c && a.a.g.get(c, k)) && c(b);
                }, p = function(b, c) {
                    var d = b.ownerDocument;
                    a.a.g.get(d, m) || (a.a.g.set(d, m, !0), a.a.B(d, "selectionchange", l));
                    a.a.g.set(b, k, c);
                };
                a.c.textInput = {
                    init: function(b, c, k) {
                        function l(c, d) {
                            a.a.B(b, c, d);
                        }
                        function m() {
                            var d = a.a.f(c());
                            if (null === d || d === n) d = "";
                            L !== n && d === L ? a.a.setTimeout(m, 4) : b.value !== d && (y = !0, b.value = d, y = !1, v = b.value);
                        }
                        function r() {
                            w || (L = b.value, w = a.a.setTimeout(z, 4));
                        }
                        function z() {
                            clearTimeout(w);
                            L = w = n;
                            var d = b.value;
                            v !== d && (v = d, a.m.eb(c(), k, "textInput", d));
                        }
                        var v = b.value, w, L, A = 9 == a.a.W ? r : z, y = !1;
                        g && l("keypress", z);
                        11 > g && l("propertychange", function(a) {
                            y || "value" !== a.propertyName || A(a);
                        });
                        8 == g && (l("keyup", z), l("keydown", z));
                        p && (p(b, A), l("dragend", r));
                        (!g || 9 <= g) && l("input", A);
                        5 > e && "textarea" === a.a.R(b) ? (l("keydown", r), l("paste", r), l("cut", r)) : 11 > d ? l("keydown", r) : 4 > f ? (l("DOMAutoComplete", z), l("dragdrop", z), l("drop", z)) : h && "number" === b.type && l("keydown", r);
                        l("change", z);
                        l("blur", z);
                        a.o(m, null, {
                            l: b
                        });
                    }
                };
                a.m.wa.textInput = !0;
                a.c.textinput = {
                    preprocess: function(a, b, c) {
                        c("textInput", a);
                    }
                };
            })();
            a.c.uniqueName = {
                init: function(b, c) {
                    if (c()) {
                        var d = "ko_unique_" + ++a.c.uniqueName.rd;
                        a.a.Yc(b, d);
                    }
                }
            };
            a.c.uniqueName.rd = 0;
            a.c.using = {
                init: function(b, c, d, e, f) {
                    var g;
                    d.has("as") && (g = {
                        as: d.get("as"),
                        noChildContext: d.get("noChildContext")
                    });
                    c = f.createChildContext(c, g);
                    a.Oa(c, b);
                    return {
                        controlsDescendantBindings: !0
                    };
                }
            };
            a.h.ea.using = !0;
            a.c.value = {
                init: function(b, c, d) {
                    var e = a.a.R(b), f = "input" == e;
                    if (!f || "checkbox" != b.type && "radio" != b.type) {
                        var g = [], h = d.get("valueUpdate"), m = !1, k = null;
                        h && ("string" == typeof h ? g = [
                            h
                        ] : g = a.a.wc(h), a.a.Pa(g, "change"));
                        var l = function() {
                            k = null;
                            m = !1;
                            var e = c(), f = a.w.M(b);
                            a.m.eb(e, d, "value", f);
                        };
                        !a.a.W || !f || "text" != b.type || "off" == b.autocomplete || b.form && "off" == b.form.autocomplete || -1 != a.a.A(g, "propertychange") || (a.a.B(b, "propertychange", function() {
                            m = !0;
                        }), a.a.B(b, "focus", function() {
                            m = !1;
                        }), a.a.B(b, "blur", function() {
                            m && l();
                        }));
                        a.a.D(g, function(c) {
                            var d = l;
                            a.a.Ud(c, "after") && (d = function() {
                                k = a.w.M(b);
                                a.a.setTimeout(l, 0);
                            }, c = c.substring(5));
                            a.a.B(b, c, d);
                        });
                        var p;
                        p = f && "file" == b.type ? function() {
                            var d = a.a.f(c());
                            null === d || d === n || "" === d ? b.value = "" : a.u.G(l);
                        } : function() {
                            var f = a.a.f(c()), g = a.w.M(b);
                            if (null !== k && f === k) a.a.setTimeout(p, 0);
                            else if (f !== g || g === n) "select" === e ? (g = d.get("valueAllowUnset"), a.w.cb(b, f, g), g || f === a.w.M(b) || a.u.G(l)) : a.w.cb(b, f);
                        };
                        if ("select" === e) {
                            var q;
                            a.i.subscribe(b, a.i.H, function() {
                                q ? d.get("valueAllowUnset") ? p() : l() : (a.a.B(b, "change", l), q = a.o(p, null, {
                                    l: b
                                }));
                            }, null, {
                                notifyImmediately: !0
                            });
                        } else a.a.B(b, "change", l), a.o(p, null, {
                            l: b
                        });
                    } else a.ib(b, {
                        checkedValue: c
                    });
                },
                update: function() {}
            };
            a.m.wa.value = !0;
            a.c.visible = {
                update: function(b, c) {
                    var d = a.a.f(c()), e = "none" != b.style.display;
                    d && !e ? b.style.display = "" : !d && e && (b.style.display = "none");
                }
            };
            a.c.hidden = {
                update: function(b, c) {
                    a.c.visible.update(b, function() {
                        return !a.a.f(c());
                    });
                }
            };
            (function(b) {
                a.c[b] = {
                    init: function(c, d, e, f, g) {
                        return a.c.event.init.call(this, c, function() {
                            var a = {};
                            a[b] = d();
                            return a;
                        }, e, f, g);
                    }
                };
            })("click");
            a.ca = function() {};
            a.ca.prototype.renderTemplateSource = function() {
                throw Error("Override renderTemplateSource");
            };
            a.ca.prototype.createJavaScriptEvaluatorBlock = function() {
                throw Error("Override createJavaScriptEvaluatorBlock");
            };
            a.ca.prototype.makeTemplateSource = function(b, c) {
                if ("string" == typeof b) {
                    c = c || w;
                    var d = c.getElementById(b);
                    if (!d) throw Error("Cannot find template with ID " + b);
                    return new a.C.F(d);
                }
                if (1 == b.nodeType || 8 == b.nodeType) return new a.C.ia(b);
                throw Error("Unknown template type: " + b);
            };
            a.ca.prototype.renderTemplate = function(a, c, d, e) {
                a = this.makeTemplateSource(a, e);
                return this.renderTemplateSource(a, c, d, e);
            };
            a.ca.prototype.isTemplateRewritten = function(a, c) {
                return !1 === this.allowTemplateRewriting ? !0 : this.makeTemplateSource(a, c).data("isRewritten");
            };
            a.ca.prototype.rewriteTemplate = function(a, c, d) {
                a = this.makeTemplateSource(a, d);
                c = c(a.text());
                a.text(c);
                a.data("isRewritten", !0);
            };
            a.b("templateEngine", a.ca);
            a.kc = function() {
                function b(b, c, d, h) {
                    b = a.m.ac(b);
                    for(var m = a.m.Ra, k = 0; k < b.length; k++){
                        var l = b[k].key;
                        if (Object.prototype.hasOwnProperty.call(m, l)) {
                            var p = m[l];
                            if ("function" === typeof p) {
                                if (l = p(b[k].value)) throw Error(l);
                            } else if (!p) throw Error("This template engine does not support the '" + l + "' binding within its templates");
                        }
                    }
                    d = "ko.__tr_ambtns(function($context,$element){return(function(){return{ " + a.m.vb(b, {
                        valueAccessors: !0
                    }) + " } })()},'" + d.toLowerCase() + "')";
                    return h.createJavaScriptEvaluatorBlock(d) + c;
                }
                var c = /(<([a-z]+\d*)(?:\s+(?!data-bind\s*=\s*)[a-z0-9\-]+(?:=(?:\"[^\"]*\"|\'[^\']*\'|[^>]*))?)*\s+)data-bind\s*=\s*(["'])([\s\S]*?)\3/gi, d = /\x3c!--\s*ko\b\s*([\s\S]*?)\s*--\x3e/g;
                return {
                    xd: function(b, c, d) {
                        c.isTemplateRewritten(b, d) || c.rewriteTemplate(b, function(b) {
                            return a.kc.Ld(b, c);
                        }, d);
                    },
                    Ld: function(a, f) {
                        return a.replace(c, function(a, c, d, e, l) {
                            return b(l, c, d, f);
                        }).replace(d, function(a, c) {
                            return b(c, "<!-- ko -->", "#comment", f);
                        });
                    },
                    md: function(b, c) {
                        return a.aa.Xb(function(d, h) {
                            var m = d.nextSibling;
                            m && m.nodeName.toLowerCase() === c && a.ib(m, b, h);
                        });
                    }
                };
            }();
            a.b("__tr_ambtns", a.kc.md);
            (function() {
                a.C = {};
                a.C.F = function(b) {
                    if (this.F = b) {
                        var c = a.a.R(b);
                        this.ab = "script" === c ? 1 : "textarea" === c ? 2 : "template" == c && b.content && 11 === b.content.nodeType ? 3 : 4;
                    }
                };
                a.C.F.prototype.text = function() {
                    var b = 1 === this.ab ? "text" : 2 === this.ab ? "value" : "innerHTML";
                    if (0 == arguments.length) return this.F[b];
                    var c = arguments[0];
                    "innerHTML" === b ? a.a.fc(this.F, c) : this.F[b] = c;
                };
                var b = a.a.g.Z() + "_";
                a.C.F.prototype.data = function(c) {
                    if (1 === arguments.length) return a.a.g.get(this.F, b + c);
                    a.a.g.set(this.F, b + c, arguments[1]);
                };
                var c = a.a.g.Z();
                a.C.F.prototype.nodes = function() {
                    var b = this.F;
                    if (0 == arguments.length) {
                        var e = a.a.g.get(b, c) || {}, f = e.lb || (3 === this.ab ? b.content : 4 === this.ab ? b : n);
                        if (!f || e.jd) {
                            var g = this.text();
                            g && g !== e.bb && (f = a.a.Md(g, b.ownerDocument), a.a.g.set(b, c, {
                                lb: f,
                                bb: g,
                                jd: !0
                            }));
                        }
                        return f;
                    }
                    e = arguments[0];
                    this.ab !== n && this.text("");
                    a.a.g.set(b, c, {
                        lb: e
                    });
                };
                a.C.ia = function(a) {
                    this.F = a;
                };
                a.C.ia.prototype = new a.C.F;
                a.C.ia.prototype.constructor = a.C.ia;
                a.C.ia.prototype.text = function() {
                    if (0 == arguments.length) {
                        var b = a.a.g.get(this.F, c) || {};
                        b.bb === n && b.lb && (b.bb = b.lb.innerHTML);
                        return b.bb;
                    }
                    a.a.g.set(this.F, c, {
                        bb: arguments[0]
                    });
                };
                a.b("templateSources", a.C);
                a.b("templateSources.domElement", a.C.F);
                a.b("templateSources.anonymousTemplate", a.C.ia);
            })();
            (function() {
                function b(b, c, d) {
                    var e;
                    for(c = a.h.nextSibling(c); b && (e = b) !== c;)b = a.h.nextSibling(e), d(e, b);
                }
                function c(c, d) {
                    if (c.length) {
                        var e = c[0], f = c[c.length - 1], g = e.parentNode, h = a.ga.instance, m = h.preprocessNode;
                        if (m) {
                            b(e, f, function(a, b) {
                                var c = a.previousSibling, d = m.call(h, a);
                                d && (a === e && (e = d[0] || b), a === f && (f = d[d.length - 1] || c));
                            });
                            c.length = 0;
                            if (!e) return;
                            e === f ? c.push(e) : (c.push(e, f), a.a.Ua(c, g));
                        }
                        b(e, f, function(b) {
                            1 !== b.nodeType && 8 !== b.nodeType || a.vc(d, b);
                        });
                        b(e, f, function(b) {
                            1 !== b.nodeType && 8 !== b.nodeType || a.aa.cd(b, [
                                d
                            ]);
                        });
                        a.a.Ua(c, g);
                    }
                }
                function d(a) {
                    return a.nodeType ? a : 0 < a.length ? a[0] : null;
                }
                function e(b, e, f, h, m) {
                    m = m || {};
                    var n = (b && d(b) || f || {}).ownerDocument, B = m.templateEngine || g;
                    a.kc.xd(f, B, n);
                    f = B.renderTemplate(f, h, m, n);
                    if ("number" != typeof f.length || 0 < f.length && "number" != typeof f[0].nodeType) throw Error("Template engine must return an array of DOM nodes");
                    n = !1;
                    switch(e){
                        case "replaceChildren":
                            a.h.va(b, f);
                            n = !0;
                            break;
                        case "replaceNode":
                            a.a.Xc(b, f);
                            n = !0;
                            break;
                        case "ignoreTargetNode":
                            break;
                        default:
                            throw Error("Unknown renderMode: " + e);
                    }
                    n && (c(f, h), m.afterRender && a.u.G(m.afterRender, null, [
                        f,
                        h[m.as || "$data"]
                    ]), "replaceChildren" == e && a.i.ma(b, a.i.H));
                    return f;
                }
                function f(b, c, d) {
                    return a.O(b) ? b() : "function" === typeof b ? b(c, d) : b;
                }
                var g;
                a.gc = function(b) {
                    if (b != n && !(b instanceof a.ca)) throw Error("templateEngine must inherit from ko.templateEngine");
                    g = b;
                };
                a.dc = function(b, c, h, m, t) {
                    h = h || {};
                    if ((h.templateEngine || g) == n) throw Error("Set a template engine before calling renderTemplate");
                    t = t || "replaceChildren";
                    if (m) {
                        var x = d(m);
                        return a.$(function() {
                            var g = c && c instanceof a.fa ? c : new a.fa(c, null, null, null, {
                                exportDependencies: !0
                            }), n = f(b, g.$data, g), g = e(m, t, n, g, h);
                            "replaceNode" == t && (m = g, x = d(m));
                        }, null, {
                            Sa: function() {
                                return !x || !a.a.Sb(x);
                            },
                            l: x && "replaceNode" == t ? x.parentNode : x
                        });
                    }
                    return a.aa.Xb(function(d) {
                        a.dc(b, c, h, d, "replaceNode");
                    });
                };
                a.Qd = function(b, d, g, h, m) {
                    function x(b, c) {
                        a.u.G(a.a.ec, null, [
                            h,
                            b,
                            u,
                            g,
                            r,
                            c
                        ]);
                        a.i.ma(h, a.i.H);
                    }
                    function r(a, b) {
                        c(b, v);
                        g.afterRender && g.afterRender(b, a);
                        v = null;
                    }
                    function u(a, c) {
                        v = m.createChildContext(a, {
                            as: z,
                            noChildContext: g.noChildContext,
                            extend: function(a) {
                                a.$index = c;
                                z && (a[z + "Index"] = c);
                            }
                        });
                        var d = f(b, a, v);
                        return e(h, "ignoreTargetNode", d, v, g);
                    }
                    var v, z = g.as, w = !1 === g.includeDestroyed || a.options.foreachHidesDestroyed && !g.includeDestroyed;
                    if (w || g.beforeRemove || !a.Pc(d)) return a.$(function() {
                        var b = a.a.f(d) || [];
                        "undefined" == typeof b.length && (b = [
                            b
                        ]);
                        w && (b = a.a.jb(b, function(b) {
                            return b === n || null === b || !a.a.f(b._destroy);
                        }));
                        x(b);
                    }, null, {
                        l: h
                    });
                    x(d.v());
                    var A = d.subscribe(function(a) {
                        x(d(), a);
                    }, null, "arrayChange");
                    A.l(h);
                    return A;
                };
                var h = a.a.g.Z(), m = a.a.g.Z();
                a.c.template = {
                    init: function(b, c) {
                        var d = a.a.f(c());
                        if ("string" == typeof d || "name" in d) a.h.Ea(b);
                        else if ("nodes" in d) {
                            d = d.nodes || [];
                            if (a.O(d)) throw Error('The "nodes" option must be a plain, non-observable array.');
                            var e = d[0] && d[0].parentNode;
                            e && a.a.g.get(e, m) || (e = a.a.Yb(d), a.a.g.set(e, m, !0));
                            new a.C.ia(b).nodes(e);
                        } else if (d = a.h.childNodes(b), 0 < d.length) e = a.a.Yb(d), new a.C.ia(b).nodes(e);
                        else throw Error("Anonymous template defined, but no template content was provided");
                        return {
                            controlsDescendantBindings: !0
                        };
                    },
                    update: function(b, c, d, e, f) {
                        var g = c();
                        c = a.a.f(g);
                        d = !0;
                        e = null;
                        "string" == typeof c ? c = {} : (g = "name" in c ? c.name : b, "if" in c && (d = a.a.f(c["if"])), d && "ifnot" in c && (d = !a.a.f(c.ifnot)), d && !g && (d = !1));
                        "foreach" in c ? e = a.Qd(g, d && c.foreach || [], c, b, f) : d ? (d = f, "data" in c && (d = f.createChildContext(c.data, {
                            as: c.as,
                            noChildContext: c.noChildContext,
                            exportDependencies: !0
                        })), e = a.dc(g, d, c, b)) : a.h.Ea(b);
                        f = e;
                        (c = a.a.g.get(b, h)) && "function" == typeof c.s && c.s();
                        a.a.g.set(b, h, !f || f.ja && !f.ja() ? n : f);
                    }
                };
                a.m.Ra.template = function(b) {
                    b = a.m.ac(b);
                    return 1 == b.length && b[0].unknown || a.m.Id(b, "name") ? null : "This template engine does not support anonymous templates nested within its templates";
                };
                a.h.ea.template = !0;
            })();
            a.b("setTemplateEngine", a.gc);
            a.b("renderTemplate", a.dc);
            a.a.Kc = function(a, c, d) {
                if (a.length && c.length) {
                    var e, f, g, h, m;
                    for(e = f = 0; (!d || e < d) && (h = a[f]); ++f){
                        for(g = 0; m = c[g]; ++g)if (h.value === m.value) {
                            h.moved = m.index;
                            m.moved = h.index;
                            c.splice(g, 1);
                            e = g = 0;
                            break;
                        }
                        e += g;
                    }
                }
            };
            a.a.Pb = function() {
                function b(b, d, e, f, g) {
                    var h = Math.min, m = Math.max, k = [], l, p = b.length, q, n = d.length, r = n - p || 1, v = p + n + 1, u, w, z;
                    for(l = 0; l <= p; l++)for(w = u, k.push(u = []), z = h(n, l + r), q = m(0, l - 1); q <= z; q++)u[q] = q ? l ? b[l - 1] === d[q - 1] ? w[q - 1] : h(w[q] || v, u[q - 1] || v) + 1 : q + 1 : l + 1;
                    h = [];
                    m = [];
                    r = [];
                    l = p;
                    for(q = n; l || q;)n = k[l][q] - 1, q && n === k[l][q - 1] ? m.push(h[h.length] = {
                        status: e,
                        value: d[--q],
                        index: q
                    }) : l && n === k[l - 1][q] ? r.push(h[h.length] = {
                        status: f,
                        value: b[--l],
                        index: l
                    }) : (--q, --l, g.sparse || h.push({
                        status: "retained",
                        value: d[q]
                    }));
                    a.a.Kc(r, m, !g.dontLimitMoves && 10 * p);
                    return h.reverse();
                }
                return function(a, d, e) {
                    e = "boolean" === typeof e ? {
                        dontLimitMoves: e
                    } : e || {};
                    a = a || [];
                    d = d || [];
                    return a.length < d.length ? b(a, d, "added", "deleted", e) : b(d, a, "deleted", "added", e);
                };
            }();
            a.b("utils.compareArrays", a.a.Pb);
            (function() {
                function b(b, c, d, h, m) {
                    var k = [], l = a.$(function() {
                        var l = c(d, m, a.a.Ua(k, b)) || [];
                        0 < k.length && (a.a.Xc(k, l), h && a.u.G(h, null, [
                            d,
                            l,
                            m
                        ]));
                        k.length = 0;
                        a.a.Nb(k, l);
                    }, null, {
                        l: b,
                        Sa: function() {
                            return !a.a.kd(k);
                        }
                    });
                    return {
                        Y: k,
                        $: l.ja() ? l : n
                    };
                }
                var c = a.a.g.Z(), d = a.a.g.Z();
                a.a.ec = function(e, f, g, h, m, k) {
                    function l(b) {
                        y = {
                            Aa: b,
                            pb: a.ta(w++)
                        };
                        v.push(y);
                        r || F.push(y);
                    }
                    function p(b) {
                        y = t[b];
                        w !== y.pb.v() && D.push(y);
                        y.pb(w++);
                        a.a.Ua(y.Y, e);
                        v.push(y);
                    }
                    function q(b, c) {
                        if (b) for(var d = 0, e = c.length; d < e; d++)a.a.D(c[d].Y, function(a) {
                            b(a, d, c[d].Aa);
                        });
                    }
                    f = f || [];
                    "undefined" == typeof f.length && (f = [
                        f
                    ]);
                    h = h || {};
                    var t = a.a.g.get(e, c), r = !t, v = [], u = 0, w = 0, z = [], A = [], C = [], D = [], F = [], y, I = 0;
                    if (r) a.a.D(f, l);
                    else {
                        if (!k || t && t._countWaitingForRemove) {
                            var E = a.a.Mb(t, function(a) {
                                return a.Aa;
                            });
                            k = a.a.Pb(E, f, {
                                dontLimitMoves: h.dontLimitMoves,
                                sparse: !0
                            });
                        }
                        for(var E = 0, G, H, K; G = k[E]; E++)switch(H = G.moved, K = G.index, G.status){
                            case "deleted":
                                for(; u < K;)p(u++);
                                H === n && (y = t[u], y.$ && (y.$.s(), y.$ = n), a.a.Ua(y.Y, e).length && (h.beforeRemove && (v.push(y), I++, y.Aa === d ? y = null : C.push(y)), y && z.push.apply(z, y.Y)));
                                u++;
                                break;
                            case "added":
                                for(; w < K;)p(u++);
                                H !== n ? (A.push(v.length), p(H)) : l(G.value);
                        }
                        for(; w < f.length;)p(u++);
                        v._countWaitingForRemove = I;
                    }
                    a.a.g.set(e, c, v);
                    q(h.beforeMove, D);
                    a.a.D(z, h.beforeRemove ? a.oa : a.removeNode);
                    var M, O, P;
                    try {
                        P = e.ownerDocument.activeElement;
                    } catch (N) {}
                    if (A.length) for(; (E = A.shift()) != n;){
                        y = v[E];
                        for(M = n; E;)if ((O = v[--E].Y) && O.length) {
                            M = O[O.length - 1];
                            break;
                        }
                        for(f = 0; u = y.Y[f]; M = u, f++)a.h.Wb(e, u, M);
                    }
                    for(E = 0; y = v[E]; E++){
                        y.Y || a.a.extend(y, b(e, g, y.Aa, m, y.pb));
                        for(f = 0; u = y.Y[f]; M = u, f++)a.h.Wb(e, u, M);
                        !y.Ed && m && (m(y.Aa, y.Y, y.pb), y.Ed = !0, M = y.Y[y.Y.length - 1]);
                    }
                    P && e.ownerDocument.activeElement != P && P.focus();
                    q(h.beforeRemove, C);
                    for(E = 0; E < C.length; ++E)C[E].Aa = d;
                    q(h.afterMove, D);
                    q(h.afterAdd, F);
                };
            })();
            a.b("utils.setDomNodeChildrenFromArrayMapping", a.a.ec);
            a.ba = function() {
                this.allowTemplateRewriting = !1;
            };
            a.ba.prototype = new a.ca;
            a.ba.prototype.constructor = a.ba;
            a.ba.prototype.renderTemplateSource = function(b, c, d, e) {
                if (c = (9 > a.a.W ? 0 : b.nodes) ? b.nodes() : null) return a.a.la(c.cloneNode(!0).childNodes);
                b = b.text();
                return a.a.ua(b, e);
            };
            a.ba.Ma = new a.ba;
            a.gc(a.ba.Ma);
            a.b("nativeTemplateEngine", a.ba);
            (function() {
                a.$a = function() {
                    var a = this.Hd = function() {
                        if (!v || !v.tmpl) return 0;
                        try {
                            if (0 <= v.tmpl.tag.tmpl.open.toString().indexOf("__")) return 2;
                        } catch (a) {}
                        return 1;
                    }();
                    this.renderTemplateSource = function(b, e, f, g) {
                        g = g || w;
                        f = f || {};
                        if (2 > a) throw Error("Your version of jQuery.tmpl is too old. Please upgrade to jQuery.tmpl 1.0.0pre or later.");
                        var h = b.data("precompiled");
                        h || (h = b.text() || "", h = v.template(null, "{{ko_with $item.koBindingContext}}" + h + "{{/ko_with}}"), b.data("precompiled", h));
                        b = [
                            e.$data
                        ];
                        e = v.extend({
                            koBindingContext: e
                        }, f.templateOptions);
                        e = v.tmpl(h, b, e);
                        e.appendTo(g.createElement("div"));
                        v.fragments = {};
                        return e;
                    };
                    this.createJavaScriptEvaluatorBlock = function(a) {
                        return "{{ko_code ((function() { return " + a + " })()) }}";
                    };
                    this.addTemplate = function(a, b) {
                        w.write("<script type='text/html' id='" + a + "'>" + b + "</script>");
                    };
                    0 < a && (v.tmpl.tag.ko_code = {
                        open: "__.push($1 || '');"
                    }, v.tmpl.tag.ko_with = {
                        open: "with($1) {",
                        close: "} "
                    });
                };
                a.$a.prototype = new a.ca;
                a.$a.prototype.constructor = a.$a;
                var b = new a.$a;
                0 < b.Hd && a.gc(b);
                a.b("jqueryTmplTemplateEngine", a.$a);
            })();
        });
    })();
})();

});

parcelRegister("fO0lp", function(module, exports) {
var $b81bcae697b1ffd3$var$_ = {};

$b81bcae697b1ffd3$var$_.every = (parcelRequire("kV2SD"));
module.exports = function(ko) {
    ko.validation.rules.phone_number = {
        validator: function(val, validate) {
            return validate ? String(val).replace(/\D/g, "").length > 7 : true;
        },
        message: "Phone numbers have got to have numbers in them."
    };
    ko.validation.rules.array_members_valid = {
        validator: function(array, validate) {
            return validate ? $b81bcae697b1ffd3$var$_.every(array, function(val) {
                return val.isValid();
            }) : true;
        },
        message: "Please fill out every field"
    };
    // https://github.com/Knockout-Contrib/Knockout-Validation/wiki/User-Contributed-Rules
    ko.validation.rules.same_as = {
        validator: function(val, other_value) {
            return val === ko.unwrap(other_value);
        },
        message: "The fields must have the same value"
    };
    ko.validation.registerExtenders();
};

});
parcelRegister("kV2SD", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function arrayEvery(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function baseEvery(collection, predicate) {
    var result = true;
    baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function every(collection, predicate, guard) {
    var func = isArray(collection) ? arrayEvery : baseEvery;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = every;

});


parcelRegister("7mGb1", function(module, exports) {
"use strict";
var $55cb4ded09f684a4$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

module.exports = function print_r(array, returnVal) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/print_r/
    // original by: Michael White (https://getsprink.com)
    // improved by: Ben Bryan
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    //    input by: Brett Zamir (https://brett-zamir.me)
    //   example 1: print_r(1, true)
    //   returns 1: '1'
    var echo = (parcelRequire("6d5Yv"));
    var output = "";
    var padChar = " ";
    var padVal = 4;
    var _repeatChar = function _repeatChar(len, padChar) {
        var str = "";
        for(var i = 0; i < len; i++)str += padChar;
        return str;
    };
    var _formatArray = function _formatArray(obj, curDepth, padVal, padChar) {
        if (curDepth > 0) curDepth++;
        var basePad = _repeatChar(padVal * curDepth, padChar);
        var thickPad = _repeatChar(padVal * (curDepth + 1), padChar);
        var str = "";
        if ((typeof obj === "undefined" ? "undefined" : $55cb4ded09f684a4$var$_typeof(obj)) === "object" && obj !== null && obj.constructor) {
            str += "Array\n" + basePad + "(\n";
            for(var key in obj)if (Object.prototype.toString.call(obj[key]) === "[object Array]") {
                str += thickPad;
                str += "[";
                str += key;
                str += "] => ";
                str += _formatArray(obj[key], curDepth + 1, padVal, padChar);
            } else {
                str += thickPad;
                str += "[";
                str += key;
                str += "] => ";
                str += obj[key];
                str += "\n";
            }
            str += basePad + ")\n";
        } else if (obj === null || obj === undefined) str = "";
        else // for our "resource" class
        str = obj.toString();
        return str;
    };
    output = _formatArray(array, 0, padVal, padChar);
    if (returnVal !== true) {
        echo(output);
        return true;
    }
    return output;
};

});
parcelRegister("6d5Yv", function(module, exports) {
"use strict";
module.exports = function echo() {
    //  discuss at: https://locutus.io/php/echo/
    // original by: Philip Peterson
    // improved by: echo is bad
    // improved by: Nate
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: Brett Zamir (https://brett-zamir.me)
    //  revised by: Der Simon (https://innerdom.sourceforge.net/)
    // bugfixed by: Eugene Bulkin (https://doubleaw.com/)
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    // bugfixed by: EdorFaus
    //      note 1: In 1.3.2 and earlier, this function wrote to the body of the document when it
    //      note 1: was called in webbrowsers, in addition to supporting XUL.
    //      note 1: This involved >100 lines of boilerplate to do this in a safe way.
    //      note 1: Since I can't imageine a complelling use-case for this, and XUL is deprecated
    //      note 1: I have removed this behavior in favor of just calling `console.log`
    //      note 2: You'll see functions depends on `echo` instead of `console.log` as we'll want
    //      note 2: to have 1 contact point to interface with the outside world, so that it's easy
    //      note 2: to support other ways of printing output.
    //  revised by: Kevin van Zonneveld (https://kvz.io)
    //    input by: JB
    //   example 1: echo('Hello world')
    //   returns 1: undefined
    var args = Array.prototype.slice.call(arguments);
    return console.log(args.join(" "));
};

});


parcelRegister("aULbU", function(module, exports) {
"use strict";
module.exports = function sprintf() {
    //  discuss at: https://locutus.io/php/sprintf/
    // original by: Ash Searle (https://hexmen.com/blog/)
    // improved by: Michael White (https://getsprink.com)
    // improved by: Jack
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Dj
    // improved by: Allidylls
    //    input by: Paulo Freitas
    //    input by: Brett Zamir (https://brett-zamir.me)
    // improved by: Rafał Kukawski (https://kukawski.pl)
    //   example 1: sprintf("%01.2f", 123.1)
    //   returns 1: '123.10'
    //   example 2: sprintf("[%10s]", 'monkey')
    //   returns 2: '[    monkey]'
    //   example 3: sprintf("[%'#10s]", 'monkey')
    //   returns 3: '[####monkey]'
    //   example 4: sprintf("%d", 123456789012345)
    //   returns 4: '123456789012345'
    //   example 5: sprintf('%-03s', 'E')
    //   returns 5: 'E00'
    //   example 6: sprintf('%+010d', 9)
    //   returns 6: '+000000009'
    //   example 7: sprintf('%+0\'@10d', 9)
    //   returns 7: '@@@@@@@@+9'
    //   example 8: sprintf('%.f', 3.14)
    //   returns 8: '3.140000'
    //   example 9: sprintf('%% %2$d', 1, 2)
    //   returns 9: '% 2'
    var regex = /%%|%(?:(\d+)\$)?((?:[-+#0 ]|'[\s\S])*)(\d+)?(?:\.(\d*))?([\s\S])/g;
    var args = arguments;
    var i = 0;
    var format = args[i++];
    var _pad = function _pad(str, len, chr, leftJustify) {
        if (!chr) chr = " ";
        var padding = str.length >= len ? "" : new Array(1 + len - str.length >>> 0).join(chr);
        return leftJustify ? str + padding : padding + str;
    };
    var justify = function justify(value, prefix, leftJustify, minWidth, padChar) {
        var diff = minWidth - value.length;
        if (diff > 0) {
            // when padding with zeros
            // on the left side
            // keep sign (+ or -) in front
            if (!leftJustify && padChar === "0") value = [
                value.slice(0, prefix.length),
                _pad("", diff, "0", true),
                value.slice(prefix.length)
            ].join("");
            else value = _pad(value, minWidth, padChar, leftJustify);
        }
        return value;
    };
    var _formatBaseX = function _formatBaseX(value, base, leftJustify, minWidth, precision, padChar) {
        // Note: casts negative numbers to positive ones
        var number = value >>> 0;
        value = _pad(number.toString(base), precision || 0, "0", false);
        return justify(value, "", leftJustify, minWidth, padChar);
    };
    // _formatString()
    var _formatString = function _formatString(value, leftJustify, minWidth, precision, customPadChar) {
        if (precision !== null && precision !== undefined) value = value.slice(0, precision);
        return justify(value, "", leftJustify, minWidth, customPadChar);
    };
    // doFormat()
    var doFormat = function doFormat(substring, argIndex, modifiers, minWidth, precision, specifier) {
        var number = void 0, prefix = void 0, method = void 0, textTransform = void 0, value = void 0;
        if (substring === "%%") return "%";
        // parse modifiers
        var padChar = " "; // pad with spaces by default
        var leftJustify = false;
        var positiveNumberPrefix = "";
        var j = void 0, l = void 0;
        for(j = 0, l = modifiers.length; j < l; j++)switch(modifiers.charAt(j)){
            case " ":
            case "0":
                padChar = modifiers.charAt(j);
                break;
            case "+":
                positiveNumberPrefix = "+";
                break;
            case "-":
                leftJustify = true;
                break;
            case "'":
                if (j + 1 < l) {
                    padChar = modifiers.charAt(j + 1);
                    j++;
                }
                break;
        }
        if (!minWidth) minWidth = 0;
        else minWidth = +minWidth;
        if (!isFinite(minWidth)) throw new Error("Width must be finite");
        if (!precision) precision = specifier === "d" ? 0 : "fFeE".indexOf(specifier) > -1 ? 6 : undefined;
        else precision = +precision;
        if (argIndex && +argIndex === 0) throw new Error("Argument number must be greater than zero");
        if (argIndex && +argIndex >= args.length) throw new Error("Too few arguments");
        value = argIndex ? args[+argIndex] : args[i++];
        switch(specifier){
            case "%":
                return "%";
            case "s":
                return _formatString(value + "", leftJustify, minWidth, precision, padChar);
            case "c":
                return _formatString(String.fromCharCode(+value), leftJustify, minWidth, precision, padChar);
            case "b":
                return _formatBaseX(value, 2, leftJustify, minWidth, precision, padChar);
            case "o":
                return _formatBaseX(value, 8, leftJustify, minWidth, precision, padChar);
            case "x":
                return _formatBaseX(value, 16, leftJustify, minWidth, precision, padChar);
            case "X":
                return _formatBaseX(value, 16, leftJustify, minWidth, precision, padChar).toUpperCase();
            case "u":
                return _formatBaseX(value, 10, leftJustify, minWidth, precision, padChar);
            case "i":
            case "d":
                number = +value || 0;
                // Plain Math.round doesn't just truncate
                number = Math.round(number - number % 1);
                prefix = number < 0 ? "-" : positiveNumberPrefix;
                value = prefix + _pad(String(Math.abs(number)), precision, "0", false);
                if (leftJustify && padChar === "0") // can't right-pad 0s on integers
                padChar = " ";
                return justify(value, prefix, leftJustify, minWidth, padChar);
            case "e":
            case "E":
            case "f":
            case "F":
            case "g":
            case "G":
                number = +value;
                prefix = number < 0 ? "-" : positiveNumberPrefix;
                method = [
                    "toExponential",
                    "toFixed",
                    "toPrecision"
                ]["efg".indexOf(specifier.toLowerCase())];
                textTransform = [
                    "toString",
                    "toUpperCase"
                ]["eEfFgG".indexOf(specifier) % 2];
                value = prefix + Math.abs(number)[method](precision);
                return justify(value, prefix, leftJustify, minWidth, padChar)[textTransform]();
            default:
                // unknown specifier, consume that char and return empty
                return "";
        }
    };
    try {
        return format.replace(regex, doFormat);
    } catch (err) {
        return false;
    }
};

});

parcelRegister("gDfUQ", function(module, exports) {
"use strict";
module.exports = function number_format(number, decimals, decPoint, thousandsSep) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/number_format/
    // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // improved by: davook
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: Theriault (https://github.com/Theriault)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // bugfixed by: Michael White (https://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (https://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
    //  revised by: Luke Smith (https://lucassmith.name)
    //    input by: Kheang Hok Chin (https://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (https://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56)
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ')
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '')
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.')
    //   returns 4: '67,00'
    //   example 5: number_format(1000)
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2)
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1)
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.')
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0)
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2)
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4)
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3)
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ')
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '')
    //  returns 14: '0.00000001'
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number;
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    var sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
    var dec = typeof decPoint === "undefined" ? "." : decPoint;
    var s = "";
    var toFixedFix = function toFixedFix(n, prec) {
        if (("" + n).indexOf("e") === -1) return +(Math.round(n + "e+" + prec) + "e-" + prec);
        else {
            var arr = ("" + n).split("e");
            var sig = "";
            if (+arr[1] + prec > 0) sig = "+";
            return (+(Math.round(+arr[0] + "e" + sig + (+arr[1] + prec)) + "e-" + prec)).toFixed(prec);
        }
    };
    // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec).toString() : "" + Math.round(n)).split(".");
    if (s[0].length > 3) s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    if ((s[1] || "").length < prec) {
        s[1] = s[1] || "";
        s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
};

});

parcelRegister("il6dQ", function(module, exports) {
// DEFINE SOME TYPES
/**
 * @typedef {object} ProductDict
 * @property {string} slug
 * @property {string} name
 * @property {float} price
 * @property {[SKUDict]} skus
 */ /**
 * @typedef {object} SKUDict
 * @property {string} name
 * @property {string} description
 */ /**
 * @typedef {object} OrderSubmitResponse
 * @property {string} redirect
 * @property {string} payment_error
 * @property {string} order_update_url
 * @property {string} order_review_html
 * @property {string} is_error
 * @property {string} error_html
 */ // IMPORT SOME UTILITY FUNCTIONS








$parcel$global._ = {
    pickBy: (parcelRequire("7jnVe")),
    filter: (parcelRequire("ctHpU")),
    values: (parcelRequire("1rT3o")),
    map: (parcelRequire("3wqMl")),
    reduce: (parcelRequire("jddyX")),
    flatten: (parcelRequire("chGpG")),
    isUndefined: (parcelRequire("609n5")),
    countBy: (parcelRequire("tCGJs"))
};
parcelRequire("iBTM9");
parcelRequire("4UGpM");

var $aHbDH = parcelRequire("aHbDH");

var $cx4Dz = parcelRequire("cx4Dz");


/**
 * @param {object}  order_form_selector
 * @param {object} products_dictionary
 * @param {ProductDict}  products_dictionary.regular_membership
 * @param {ProductDict}  products_dictionary.super_membership
 * @param {ProductDict}  products_dictionary.medallion_membership
 * @param {ProductDict}  products_dictionary.regular_shirt
 * @param {ProductDict}  products_dictionary.regular_shirt_addon
 * @param {ProductDict}  products_dictionary.super_shirt
 * @param {ProductDict}  products_dictionary.medallion_hoodie
 * @param {ProductDict}  products_dictionary.blue_canary_light
 * @param {ProductDict}  products_dictionary.mug
 * @param {ProductDict}  products_dictionary.new_album_cd
 * @param {ProductDict}  products_dictionary.new_album_vinyl
 * @param {ProductDict}  products_dictionary.beast_cd
 * @param {ProductDict}  products_dictionary.beast_vinyl
 * @param {ProductDict}  products_dictionary.first_album_art_puzzle
 * @param {ProductDict}  products_dictionary.intl_shipping
 * @param {ProductDict}  products_dictionary.addon_shipping
 * @param {string}  fetch_client_token_url
 * @param {string}  ajax_order_create_url
 * @param {string}  paypal_env
 * @param {string}  customer_support_email
 * @param {object}  hosted_fields_styles_object
 * @param {object}  hosted_fields_styles_object
 * @param {string}  hosted_fields_number_selector
 * @param {string}  hosted_fields_cvv_selector
 * @param {string}  hosted_fields_exp_selector
 * @param {string}  hosted_fields_post_code_selector
 * @param {string}  paypal_button_selector
 * @param {object}  paypal_button_styles_object
 * @param {string}  pppin4_selector

  */ function $d59f03c6583b48dd$var$OrderViewModel(order_form_selector, products_dictionary, customer_support_email, fetch_client_token_url, ajax_order_create_url, paypal_env, hosted_fields_styles_object, hosted_fields_number_selector, hosted_fields_cvv_selector, hosted_fields_exp_selector, hosted_fields_post_code_selector, paypal_button_selector, paypal_button_styles_object, pppin4_selector) {
    // helper variables (before view model definitions)
    var product_skus_to_price = _.reduce(products_dictionary, function(carry, product_dict) {
        /** @param {ProductDict} product_dict  */ product_dict.skus.forEach(function(sku_dict) {
            carry[sku_dict.skuid] = product_dict.price;
        });
        return carry;
    }, {});
    var self = this;
    self.order_type = ko.observable().extend({
        required: true
    });
    /** @returns {ProductDict} */ self.membership_product = ko.pureComputed(function() {
        return products_dictionary[self.order_type()];
    });
    // MEMBERSHIP SHIRTS
    self.regular_shirt = ko.observable().extend({
        required: true
    });
    // remember that these products must also be added to the dict submitted to the server...
    self.super_shirt_required = ko.pureComputed(function() {
        return self.membership_product() === products_dictionary.super_membership || self.membership_product() == products_dictionary.medallion_membership;
    });
    self.super_shirt = ko.observable().extend({
        required: self.super_shirt_required
    });
    self.medallion_hoodie_required = ko.pureComputed(function() {
        return self.membership_product() == products_dictionary.medallion_membership;
    });
    self.medallion_hoodie = ko.observable().extend({
        required: self.medallion_hoodie_required
    });
    self.is_gift = ko.observable();
    self.include_gift_message = ko.observable(false);
    self.gift_message = ko.observable().extend({
        maxLength: 900
    });
    self.is_gift.subscribe(function(value) {
        // don't submit anything if there is no gift
        if (value === false) {
            self.include_gift_message(false);
            self.gift_message("");
        }
    });
    self.name_pronunciation = ko.observable().extend({
        maxLength: 900,
        required: self.medallion_hoodie_required
    });
    self.name_pronunciation_url = ko.observable();
    self.medallion_hoodie_required.subscribe(function(value) {
        if (value === false) {
            self.name_pronunciation("");
            self.name_pronunciation_url("");
        }
    });
    // EXTRA PRODUCTS with VIRTUAL TOGGLES
    // Virtual toggles are boolean writable computeds
    // which read based on another property, and alter that property on write
    self.extra_ifc_shirts = ko.observableArray().extend({
        array_members_valid: true
    });
    self.add_shirt = function() {
        self.extra_ifc_shirts.push(ko.observable().extend({
            required: true
        }));
    };
    self.n_extra_ifc_shirts = ko.computed(function() {
        return self.extra_ifc_shirts().length;
    });
    self.extra_ifc_shirts_toggle = ko.computed({
        read: function() {
            return self.n_extra_ifc_shirts() > 0;
        },
        write: function(value) {
            if (value === true) self.add_shirt();
            else self.extra_ifc_shirts.removeAll();
        }
    });
    self.n_new_album_cd = ko.observable(0);
    self.n_new_album_vinyl = ko.observable(0);
    self.n_blue_canary_light = ko.observable(0);
    self.n_beast_cd = ko.observable(0);
    self.n_beast_vinyl = ko.observable(0);
    self.n_mug = ko.observable(0);
    self.n_first_album_art_puzzle = ko.observable(0);
    self.has_addons = ko.pureComputed(function() {
        return self.extra_ifc_shirts_toggle() || self.n_new_album_cd() > 0 || self.n_new_album_vinyl() > 0 || self.n_blue_canary_light() > 0 || self.n_beast_cd() > 0 || self.n_beast_vinyl() > 0 || self.n_mug() > 0 || self.n_first_album_art_puzzle() > 0;
    });
    // SUB MODELS
    self.purchaser = new $d59f03c6583b48dd$var$CustomerViewModel(true, ko.pureComputed(function() {
        return !self.is_gift();
    }));
    self.recipient = new $d59f03c6583b48dd$var$CustomerViewModel(self.is_gift, self.is_gift);
    self.destination_is_intl = ko.pureComputed(function() {
        return self.is_gift() ? self.recipient.is_intl() : self.purchaser.is_intl();
    });
    self.selected_skus_js = ko.pureComputed(function() {
        skuToCount = _.reduce({
            // ALL THE SINGLE SKU PRODUCTS WE ACCOUNT FOR WITH BASIC COUNT OBSERVABLES
            "new_album_cd": self.n_new_album_cd,
            "new_album_vinyl": self.n_new_album_vinyl,
            "blue_canary_light": self.n_blue_canary_light,
            "beast_cd": self.n_beast_cd,
            "beast_vinyl": self.n_beast_vinyl,
            "mug": self.n_mug,
            "first_album_art_puzzle": self.n_first_album_art_puzzle
        }, function(accumulator, value, key, collection) {
            var qty = parseInt(value());
            if (qty > 0) // don't add nothins into the dict...
            accumulator[products_dictionary[key].skus[0].skuid] = qty;
            return accumulator;
        }, _.countBy(_.filter(// start with the accumulator set to a count of the occurrence of the multi sku prods
        // dump the extra ifc shirts into a js array as it's an obserable array with obs members...
        [
            self.regular_shirt(),
            self.super_shirt(),
            self.medallion_hoodie()
        ].concat(ko.toJS(self.extra_ifc_shirts)))));
        // add in the sku for the membership product!
        if (self.membership_product()) // but only if it's not undefined (it starts as undefined)
        skuToCount[self.membership_product().skus[0].skuid] = 1;
        if (self.destination_is_intl()) skuToCount[products_dictionary.intl_shipping.skus[0].skuid] = 1;
        if (self.has_addons()) skuToCount[products_dictionary.addon_shipping.skus[0].skuid] = 1;
        return skuToCount;
    });
    // IMPLEMENTATION FIELDS
    self.selected_skus = ko.pureComputed({
        read: function() {
            // get all the non null properties from this list
            return ko.toJSON(self.selected_skus_js());
        },
        write: function() {}
    });
    self.total_price = ko.pureComputed(function() {
        return _.reduce(self.selected_skus_js(), function(carry, qty, skuid) {
            return carry + product_skus_to_price[skuid] * qty;
        }, 0);
    });
    self.order_update_url = ko.observable();
    self.ajax_url = ko.pureComputed(function() {
        return self.order_update_url() ? self.order_update_url() : ajax_order_create_url;
    });
    // CLIENT SIDE VALIDATION
    // anything that has this property can be validated
    // we want all of them... and i can't get them all together
    // naturally??
    validateable_dict = function(obj, prefix) {
        return _.reduce(_.filter(Object.keys(obj), function(propname) {
            return !!obj[propname].isValid;
        }), function(carry, el) {
            carry[prefix ? prefix + el : el] = obj[el];
            return carry;
        }, {});
    };
    self.validateable_properties = validateable_dict(self);
    $.extend(self.validateable_properties, validateable_dict(self.purchaser, "purchaser."), validateable_dict(self.recipient, "recipient."));
    self.invalid_properties = ko.pureComputed(function() {
        return $aHbDH(_.pickBy(self.validateable_properties, function(prop, key) {
            if (!prop.isValid()) return key;
        }));
    });
    self.n_invalid_properties = ko.pureComputed(function() {
        return self.invalid_properties().length;
    });
    self.order_form_valid = ko.pureComputed(function() {
        return self.n_invalid_properties() === 0;
    });
    self.validateable_property_nice_name = function(mean_name) {
        var nice_names = {
            "extra_ifc_shirts": "IFC Add-on Shirts",
            "gift_message": "Message to gift recipient",
            "name_pronunciation": "Phonetic name spelling",
            "purchaser.city": "Purchaser City",
            "purchaser.confirm_email": "Purchaser Email Confirmation",
            "purchaser.country": "Purchaser Country",
            "purchaser.email": "Purchaser Email",
            "purchaser.first_name": "Purchaser First Name",
            "purchaser.last_name": "Purchaser Last Name",
            "purchaser.phone": "Purchaser Phone",
            "purchaser.postal_code": "Purchaser Postal Code",
            "purchaser.state_province": "Purchaser State/Province",
            "purchaser.street1": "Purchaser Street Address",
            "recipient.city": "Gift Recipient City",
            "recipient.confirm_email": "Gift Recipient Email Confirmation",
            "recipient.country": "Gift Recipient Country",
            "recipient.email": "Gift Recipient Email",
            "recipient.first_name": "Gift Recipient First Name",
            "recipient.last_name": "Gift Recipient Last Name",
            "recipient.phone": "Gift Recipient Phone",
            "recipient.postal_code": "Gift Recipient Postal Code",
            "recipient.state_province": "Gift Recipient State/Province",
            "recipient.street1": "Gift Recipient Street Address",
            "regular_shirt": "IFC Premiere Level Shirt",
            "super_shirt": "Executive Super-Boss Shirt",
            "medallion_hoodie": "Medallion Level Zip Hoodie"
        };
        if (nice_names.hasOwnProperty(mean_name)) return nice_names[mean_name];
        return mean_name;
    };
    // FORM SUBMISSION AND UPDATES
    var ifc_ajax_retry = (parcelRequire("aCIbB"));
    // this will change when the form changes
    // by ensnaring ko.toJson in our closure we get updates on teh whole
    // hierarchy
    // then we reach out of ko for the old school form submission data
    // we throttle notifications as this data can be very volatile
    // we cannot make it part of the view model or it will be serialized itself
    // and it will be very circular and bad
    var serialized_form_data = ko.computed(function() {
        if (ko.toJSON(self)) return $(order_form_selector).serialize();
    }).extend({
        rateLimit: {
            method: "notifyWhenChangesStop",
            timeout: 1000
        },
        deferred: true
    });
    // track whatever we sent in before
    self.previous_submission = "";
    // can we even do a submit? by making this an observable this will trigger
    // a form change and a resubmit if we were locked out of a previously valid submission
    self.submission_lockout = ko.observable(false);
    serialized_form_data.subscribe(function(current_submission) {
        // we only submit valid order forms
        // while not locked out
        // that differ from what we previously submitted
        console.log("subscribed update");
        console.log(current_submission);
        console.log("valid: " + self.order_form_valid());
        if (self.order_form_valid() && !self.submission_lockout() && current_submission !== self.previous_submission) {
            // we lockout if we are gonna start
            self.submission_lockout(true);
            // if we have something new to say, say it
            ifc_ajax_retry("POST", "json", self.ajax_url, 5, serialized_form_data, recoverable_payment_error_callback, function() {
                // it submitted something that wasn't valid just now... 
                if (self.order_form_valid()) $(order_form_selector).submit();
            }, /** @param {OrderSubmitResponse} response  */ function(response) {
                if (response.redirect) {
                    window.location.href = response.redirect;
                    return;
                }
                if (response.payment_error) {
                    self.unblock_ui();
                    self.submission_lockout(false);
                    var generic_alt = "There was an error processing your payment method. Please check your payment method details and try again.";
                    self.payment_error_message(generic_alt);
                    alert(generic_alt);
                    return;
                }
                // we keep updating this viewmodel here
                self.order_update_url(response.order_update_url);
                self.order_review_html(response.order_review_html);
                // we can post again now
                self.submission_lockout(false);
            });
            // we record what we said
            self.previous_submission = current_submission;
        }
    });
    // PAYMENT SETUP
    self.block_ui_with_message = function(message_header, message_body, showloading) {
        var loading = '<span class="loading"></span>';
        var html_message = sprintf('<div style="padding:17px;"><h1>%s</h1><p>%s</p>%s</div>', message_header, message_body ? $cx4Dz(message_body) : "", !_.isUndefined(showloading) && !showloading ? "" : loading);
        var mobile_px_breakpoint = 1000;
        var width = $(window).width() > mobile_px_breakpoint ? "44" : 67;
        var left = (100 - width) / 2;
        $.blockUI({
            message: html_message,
            css: {
                width: sprintf("%s%%", width),
                left: sprintf("%s%%", left),
                margin: "auto"
            }
        });
    };
    self.unblock_ui = function() {
        $.unblockUI();
    };
    self.order_review_html = ko.observable();
    self.payment_error_message = ko.observable();
    self.payments_are_ready = ko.observable(false);
    self.should_show_ppin4_stuff_callback = ko.observable(false);
    self.payment_is_out_for_processing = ko.observable(false);
    self.payment_is_out_for_processing.subscribe(function(is_out) {
        if (is_out) self.block_ui_with_message("Processing your payment details");
        else self.unblock_ui();
    });
    // form field -- we must submit this to our server
    self.payment_method_nonce = ko.observable();
    self.payment_method_nonce.subscribe(function(nonce) {
        ko.tasks.runEarly();
        if (nonce) self.block_ui_with_message("Finalizing your order! Buckle up!");
    });
    var recoverable_payment_error_callback = function(recoverable_message) {
        self.payment_error_message(recoverable_message);
        console.log(arguments);
    };
    var unrecoverable_alert_callback = function(unrecoverable_message) {
        self.block_ui_with_message("Fatal error", sprintf("Our sincerest apologies: there has been a fatal javascript error. Please reload this page to try again. The error follows. \n\n%s\n\n\nIf you are having trouble completing your order please contact us by emailing at %s.\n\n", unrecoverable_message, customer_support_email));
        console.error(Array.prototype.slice.call(arguments, 1));
    };
    self.cc_submit_event_name = "ifc_cc::submit";
    self.cc_submit = function() {
        $(document).trigger(self.cc_submit_event_name);
    };
    var ifc_braintree = (parcelRequire("d9huX"));
    var payment_initialization_begun = false;
    ko.pureComputed(function() {
        return !!self.purchaser.first_name();
    }).subscribe(function(should_initialize) {
        if (should_initialize && !payment_initialization_begun) {
            payment_initialization_begun = true;
            ifc_braintree.braintree_init(fetch_client_token_url, paypal_env, hosted_fields_styles_object, hosted_fields_number_selector, hosted_fields_cvv_selector, hosted_fields_exp_selector, hosted_fields_post_code_selector, paypal_button_selector, paypal_button_styles_object, self.total_price, recoverable_payment_error_callback, unrecoverable_alert_callback, self.payments_are_ready, self.payment_is_out_for_processing, self.payment_method_nonce, self.cc_submit_event_name, pppin4_selector, self.should_show_ppin4_stuff_callback);
        }
    });
}
function $d59f03c6583b48dd$var$CustomerViewModel(require_essentials, require_shipping) {
    var self = this;
    // initialize with the value they get from the server
    self.first_name = ko.observable("").extend({
        required: require_essentials
    });
    self.last_name = ko.observable("").extend({
        required: require_essentials
    });
    self.phone = ko.observable("").extend({
        required: require_essentials,
        phone_number: require_essentials
    });
    self.email = ko.observable("").extend({
        required: require_essentials,
        email: true
    });
    self.confirm_email = ko.observable("").extend({
        same_as: self.email
    });
    self.street1 = ko.observable("").extend({
        required: require_shipping
    });
    self.street2 = ko.observable("").extend({
        required: false
    });
    self.city = ko.observable("").extend({
        required: require_shipping
    });
    self.state_province = ko.observable("").extend({
        required: require_shipping
    });
    self.postal_code = ko.observable("").extend({
        required: require_shipping
    });
    self.country = ko.observable().extend({
        required: require_shipping
    });
    self.is_intl = ko.pureComputed(function() {
        // if not blank and not US true else false
        return self.country() && self.country() !== "US";
    });
}
module.exports = {
    OrderViewModel: $d59f03c6583b48dd$var$OrderViewModel,
    CustomerViewModel: $d59f03c6583b48dd$var$CustomerViewModel
};

});
parcelRegister("7jnVe", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, props, predicate) {
    var index = -1, length = props.length, result = {};
    while(++index < length){
        var key = props[index], value = object[key];
        if (predicate(value, key)) result[key] = value;
    }
    return result;
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function pickBy(object, predicate) {
    return object == null ? {} : basePickBy(object, getAllKeysIn(object), baseIteratee(predicate));
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = pickBy;

});

parcelRegister("ctHpU", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array ? array.length : 0, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function baseFilter(collection, predicate) {
    var result = [];
    baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */ function filter(collection, predicate) {
    var func = isArray(collection) ? arrayFilter : baseFilter;
    return func(collection, baseIteratee(predicate, 3));
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = filter;

});

parcelRegister("1rT3o", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $10e3049437b7f7d8$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $10e3049437b7f7d8$var$argsTag = "[object Arguments]", $10e3049437b7f7d8$var$funcTag = "[object Function]", $10e3049437b7f7d8$var$genTag = "[object GeneratorFunction]";
/** Used to detect unsigned integer values. */ var $10e3049437b7f7d8$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $10e3049437b7f7d8$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $10e3049437b7f7d8$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $10e3049437b7f7d8$var$baseValues(object, props) {
    return $10e3049437b7f7d8$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $10e3049437b7f7d8$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $10e3049437b7f7d8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $10e3049437b7f7d8$var$hasOwnProperty = $10e3049437b7f7d8$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $10e3049437b7f7d8$var$objectToString = $10e3049437b7f7d8$var$objectProto.toString;
/** Built-in value references. */ var $10e3049437b7f7d8$var$propertyIsEnumerable = $10e3049437b7f7d8$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $10e3049437b7f7d8$var$nativeKeys = $10e3049437b7f7d8$var$overArg(Object.keys, Object);
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $10e3049437b7f7d8$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $10e3049437b7f7d8$var$isArray(value) || $10e3049437b7f7d8$var$isArguments(value) ? $10e3049437b7f7d8$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $10e3049437b7f7d8$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || $10e3049437b7f7d8$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $10e3049437b7f7d8$var$baseKeys(object) {
    if (!$10e3049437b7f7d8$var$isPrototype(object)) return $10e3049437b7f7d8$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($10e3049437b7f7d8$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $10e3049437b7f7d8$var$isIndex(value, length) {
    length = length == null ? $10e3049437b7f7d8$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || $10e3049437b7f7d8$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $10e3049437b7f7d8$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $10e3049437b7f7d8$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $10e3049437b7f7d8$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $10e3049437b7f7d8$var$isArrayLikeObject(value) && $10e3049437b7f7d8$var$hasOwnProperty.call(value, "callee") && (!$10e3049437b7f7d8$var$propertyIsEnumerable.call(value, "callee") || $10e3049437b7f7d8$var$objectToString.call(value) == $10e3049437b7f7d8$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $10e3049437b7f7d8$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $10e3049437b7f7d8$var$isArrayLike(value) {
    return value != null && $10e3049437b7f7d8$var$isLength(value.length) && !$10e3049437b7f7d8$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $10e3049437b7f7d8$var$isArrayLikeObject(value) {
    return $10e3049437b7f7d8$var$isObjectLike(value) && $10e3049437b7f7d8$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $10e3049437b7f7d8$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $10e3049437b7f7d8$var$isObject(value) ? $10e3049437b7f7d8$var$objectToString.call(value) : "";
    return tag == $10e3049437b7f7d8$var$funcTag || tag == $10e3049437b7f7d8$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $10e3049437b7f7d8$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $10e3049437b7f7d8$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $10e3049437b7f7d8$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $10e3049437b7f7d8$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $10e3049437b7f7d8$var$keys(object) {
    return $10e3049437b7f7d8$var$isArrayLike(object) ? $10e3049437b7f7d8$var$arrayLikeKeys(object) : $10e3049437b7f7d8$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $10e3049437b7f7d8$var$values(object) {
    return object ? $10e3049437b7f7d8$var$baseValues(object, $10e3049437b7f7d8$var$keys(object)) : [];
}
module.exports = $10e3049437b7f7d8$var$values;

});

parcelRegister("3wqMl", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = map;

});

parcelRegister("jddyX", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function reduce(collection, iteratee, accumulator) {
    var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
    return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = reduce;

});

parcelRegister("chGpG", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $8f17f8f0636254af$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $8f17f8f0636254af$var$argsTag = "[object Arguments]", $8f17f8f0636254af$var$funcTag = "[object Function]", $8f17f8f0636254af$var$genTag = "[object GeneratorFunction]";
/** Detect free variable `global` from Node.js. */ var $8f17f8f0636254af$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $8f17f8f0636254af$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8f17f8f0636254af$var$root = $8f17f8f0636254af$var$freeGlobal || $8f17f8f0636254af$var$freeSelf || Function("return this")();
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8f17f8f0636254af$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/** Used for built-in method references. */ var $8f17f8f0636254af$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8f17f8f0636254af$var$hasOwnProperty = $8f17f8f0636254af$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8f17f8f0636254af$var$objectToString = $8f17f8f0636254af$var$objectProto.toString;
/** Built-in value references. */ var $8f17f8f0636254af$var$Symbol = $8f17f8f0636254af$var$root.Symbol, $8f17f8f0636254af$var$propertyIsEnumerable = $8f17f8f0636254af$var$objectProto.propertyIsEnumerable, $8f17f8f0636254af$var$spreadableSymbol = $8f17f8f0636254af$var$Symbol ? $8f17f8f0636254af$var$Symbol.isConcatSpreadable : undefined;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $8f17f8f0636254af$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $8f17f8f0636254af$var$isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $8f17f8f0636254af$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8f17f8f0636254af$var$arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $8f17f8f0636254af$var$isFlattenable(value) {
    return $8f17f8f0636254af$var$isArray(value) || $8f17f8f0636254af$var$isArguments(value) || !!($8f17f8f0636254af$var$spreadableSymbol && value && value[$8f17f8f0636254af$var$spreadableSymbol]);
}
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $8f17f8f0636254af$var$flatten(array) {
    var length = array ? array.length : 0;
    return length ? $8f17f8f0636254af$var$baseFlatten(array, 1) : [];
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $8f17f8f0636254af$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $8f17f8f0636254af$var$isArrayLikeObject(value) && $8f17f8f0636254af$var$hasOwnProperty.call(value, "callee") && (!$8f17f8f0636254af$var$propertyIsEnumerable.call(value, "callee") || $8f17f8f0636254af$var$objectToString.call(value) == $8f17f8f0636254af$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $8f17f8f0636254af$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $8f17f8f0636254af$var$isArrayLike(value) {
    return value != null && $8f17f8f0636254af$var$isLength(value.length) && !$8f17f8f0636254af$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $8f17f8f0636254af$var$isArrayLikeObject(value) {
    return $8f17f8f0636254af$var$isObjectLike(value) && $8f17f8f0636254af$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $8f17f8f0636254af$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $8f17f8f0636254af$var$isObject(value) ? $8f17f8f0636254af$var$objectToString.call(value) : "";
    return tag == $8f17f8f0636254af$var$funcTag || tag == $8f17f8f0636254af$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $8f17f8f0636254af$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $8f17f8f0636254af$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $8f17f8f0636254af$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8f17f8f0636254af$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
module.exports = $8f17f8f0636254af$var$flatten;

});

parcelRegister("609n5", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $45ea032376943b70$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $45ea032376943b70$var$isUndefined;

});

parcelRegister("tCGJs", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var countBy = createAggregator(function(result, value, key) {
    hasOwnProperty.call(result, key) ? ++result[key] : result[key] = 1;
});
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = countBy;

});

parcelRegister("iBTM9", function(module, exports) {
"use strict";
module.exports = function array_fill(startIndex, num, mixedVal) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/array_fill/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Waldo Malqui Silva (https://waldo.malqui.info)
    //   example 1: array_fill(5, 6, 'banana')
    //   returns 1: { 5: 'banana', 6: 'banana', 7: 'banana', 8: 'banana', 9: 'banana', 10: 'banana' }
    var key = void 0;
    var tmpArr = {};
    if (!isNaN(startIndex) && !isNaN(num)) for(key = 0; key < num; key++)tmpArr[key + startIndex] = mixedVal;
    return tmpArr;
};

});

parcelRegister("4UGpM", function(module, exports) {
"use strict";
module.exports = function array_values(input) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/array_values/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Brett Zamir (https://brett-zamir.me)
    //   example 1: array_values( {firstname: 'Kevin', surname: 'van Zonneveld'} )
    //   returns 1: [ 'Kevin', 'van Zonneveld' ]
    var tmpArr = [];
    var key = "";
    for(key in input)tmpArr[tmpArr.length] = input[key];
    return tmpArr;
};

});

parcelRegister("aHbDH", function(module, exports) {
"use strict";
module.exports = function array_keys(input, searchValue, argStrict) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/array_keys/
    // original by: Kevin van Zonneveld (https://kvz.io)
    //    input by: Brett Zamir (https://brett-zamir.me)
    //    input by: P
    // bugfixed by: Kevin van Zonneveld (https://kvz.io)
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    // improved by: jd
    // improved by: Brett Zamir (https://brett-zamir.me)
    //   example 1: array_keys( {firstname: 'Kevin', surname: 'van Zonneveld'} )
    //   returns 1: [ 'firstname', 'surname' ]
    var search = typeof searchValue !== "undefined";
    var tmpArr = [];
    var strict = !!argStrict;
    var include = true;
    var key = "";
    for(key in input)if (input.hasOwnProperty(key)) {
        include = true;
        if (search) {
            if (strict && input[key] !== searchValue) include = false;
            else if (input[key] !== searchValue) include = false;
        }
        if (include) tmpArr[tmpArr.length] = key;
    }
    return tmpArr;
};

});

parcelRegister("cx4Dz", function(module, exports) {
"use strict";
module.exports = function nl2br(str, isXhtml) {
    //  discuss at: https://locutus.io/php/nl2br/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Philip Peterson
    // improved by: Onno Marsman (https://twitter.com/onnomarsman)
    // improved by: Atli Þór
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: Maximusya
    // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
    // bugfixed by: Kevin van Zonneveld (https://kvz.io)
    // bugfixed by: Reynier de la Rosa (https://scriptinside.blogspot.com.es/)
    //    input by: Brett Zamir (https://brett-zamir.me)
    //   example 1: nl2br('Kevin\nvan\nZonneveld')
    //   returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
    //   example 2: nl2br("\nOne\nTwo\n\nThree\n", false)
    //   returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
    //   example 3: nl2br("\nOne\nTwo\n\nThree\n", true)
    //   returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'
    //   example 4: nl2br(null)
    //   returns 4: ''
    // Some latest browsers when str is null return and unexpected null value
    if (typeof str === "undefined" || str === null) return "";
    // Adjust comment to avoid issue on locutus.io display
    var breakTag = isXhtml || typeof isXhtml === "undefined" ? "<br />" : "<br>";
    return (str + "").replace(/(\r\n|\n\r|\r|\n)/g, breakTag + "$1");
};

});

parcelRegister("aCIbB", function(module, exports) {
//https://stackoverflow.com/questions/4959975/generate-random-number-between-two-numbers-in-javascript
function $7bbfba727abd3e7d$var$randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
module.exports = function ajax_with_retries(http_verb, data_type, get_url_function, retry_n_times, get_request_data_function, client_recoverable_error_callback, client_unrecoverable_error_callback, did_succeed_with_data_callback) {
    console.log("ajax");
    var url = get_url_function();
    var request_data = get_request_data_function ? get_request_data_function() : null;
    $.ajax({
        url: url,
        type: http_verb,
        dataType: data_type,
        data: request_data,
        tryCount: 0,
        retryLimit: retry_n_times,
        success: function(data) {
            console.log(sprintf("[%s][%s] success", this.url, this.data));
            console.log(data);
            did_succeed_with_data_callback(data);
        },
        error: function(xhr, textStatus, errorThrown) {
            console.log(arguments);
            if (textStatus === "timeout") {
                console.log(sprintf("retry #[%d] for [%s]", this.tryCount, this.type));
                client_recoverable_error_callback("We are having some trouble making outgoing network connections. Can you check your internet connection?");
                this.tryCount++;
                if (this.tryCount <= this.retryLimit) {
                    setTimeout(function() {
                        $.ajax(this);
                    }, self.randomIntFromInterval(100, 750));
                    return;
                }
                return;
            }
            console.error(arguments);
            console.error(this.data);
            // out of tries
            client_unrecoverable_error_callback(sprintf("We can't connect to the internet--or some other kind of error has occured. Please check your internet connection and try again.\n\n[%s]", textStatus));
        }
    });
};

});

parcelRegister("d9huX", function(module, exports) {

var $aCIbB = parcelRequire("aCIbB");

var $ctGv0 = parcelRequire("ctGv0");
var $9929b06a4a9b814f$require$floatval = $ctGv0.floatval;



function $9929b06a4a9b814f$var$braintree_init(fetch_client_token_url, paypal_env, hosted_fields_styles_object, hosted_fields_number_selector, hosted_fields_cvv_selector, hosted_fields_exp_selector, hosted_fields_post_code_selector, paypal_button_selector, paypal_button_styles_object, // callbacks
knockout_subscribable_total_price_function, client_recoverable_error_callback, client_unrecoverable_error_callback, payments_are_ready_callback, payment_is_currently_processing_true_false_callback, nonce_received_callback, credit_card_submit_event, pppin4_selector, should_show_ppin4_stuff_callback) {
    var self = this;
    // payment requirements
    self.braintree = {};
    self.braintree.client = (parcelRequire("aP8PO"));
    self.braintree.hostedFields = (parcelRequire("5m3t5"));
    self.braintree.paypalCheckout = (parcelRequire("ip4ex"));
    self.n_payment_methods = 2;
    self.n_payment_methods_initialized = 0;
    self.payment_method_initialization_complete_callback = function() {
        self.n_payment_methods_initialized++;
        console.log(sprintf("%d payment methods now initialized", self.n_payment_methods_initialized));
        if (self.n_payment_methods === self.n_payment_methods_initialized) {
            console.log("payment methods are ready");
            payments_are_ready_callback(true);
        }
    };
    self.hosted_fields_instance = null;
    // LEVEL 0
    // LEVEL 0
    // LEVEL 0
    // Get token URL from client
    $aCIbB("GET", "text", function() {
        return fetch_client_token_url;
    }, 5, null, client_recoverable_error_callback, client_unrecoverable_error_callback, function(braintree_client_token) {
        console.log(sprintf("Braintree token fetch success: %s", braintree_client_token));
        self.braintree.client.create({
            authorization: braintree_client_token,
            locale: "en_US"
        }, // LEVEL 1
        // LEVEL 1
        // LEVEL 1
        // Braintree Overarching Client Init
        function(clientErr, clientInstance) {
            if (clientErr) {
                client_unrecoverable_error_callback(clientErr);
                return;
            }
            console.log("braintree client create success");
            console.log(clientInstance);
            // Braintree Client is Created
            // LEVEL 2
            // LEVEL 2
            // LEVEL 2
            // Hosted Fields Init
            self.braintree.hostedFields.create({
                client: clientInstance,
                styles: hosted_fields_styles_object,
                fields: {
                    number: {
                        selector: hosted_fields_number_selector
                    },
                    cvv: {
                        selector: hosted_fields_cvv_selector,
                        placeholder: "\u2022\u2022\u2022"
                    },
                    expirationDate: {
                        selector: hosted_fields_exp_selector
                    },
                    postalCode: {
                        selector: hosted_fields_post_code_selector
                    }
                }
            }, // LEVEL 3
            // LEVEL 3
            // LEVEL 3
            // Hosted Fields Creation Success Callback
            function(hostedFieldsErr, hostedFieldsInstance) {
                if (hostedFieldsErr) {
                    client_unrecoverable_error_callback(hostedFieldsErr);
                    return;
                }
                console.log("hosted fields creation success");
                console.log(hostedFieldsInstance);
                self.payment_method_initialization_complete_callback(hostedFieldsInstance);
                self.hosted_fields_instance = hostedFieldsInstance;
            });
            // LEVEL 2
            // LEVEL 2
            // LEVEL 2
            // Paypal Checkout Init
            self.braintree.paypalCheckout.create({
                client: clientInstance
            }, function(paypalCheckoutError, paypalCheckoutInstance) {
                if (paypalCheckoutError) {
                    client_unrecoverable_error_callback(paypalCheckoutError);
                    return;
                }
                console.log("braintree paypalCheckout object is created");
                console.log(paypalCheckoutInstance);
                // LEVEL 3
                // LEVEL 3
                // LEVEL 3
                let prettyAmount = function() {
                    let amt = number_format(knockout_subscribable_total_price_function(), 2, ".", "");
                    console.log("calling prettyAmount", amt);
                    return amt;
                };
                let ppSDKOpts = {
                    components: "buttons,messages",
                    intent: "capture",
                    currency: "USD",
                    "enable-funding": "paylater",
                    dataAttributes: {
                        amount: prettyAmount()
                    },
                    commit: true,
                    vault: false
                };
                let getPpPaymentOpts = function() {
                    return {
                        flow: "checkout",
                        amount: prettyAmount(),
                        currency: "USD",
                        intent: "capture",
                        enableShippingAddress: false
                    };
                };
                /**
                         * This will update the paypal component to reflect the correct amount when the
                         * price changes. This relies on the fact (which was previously an implementation
                         * detail) that I am passing down a knockout object here.
                         */ knockout_subscribable_total_price_function.subscribe(function(tp) {
                    paypalCheckoutInstance.updatePayment(getPpPaymentOpts());
                });
                //console.log(ppSDKOpts);
                paypalCheckoutInstance.loadPayPalSDK(ppSDKOpts, function(loadPayPalSDKErr) {
                    // Adds https://www.paypal.com/sdk/js script to the page and
                    // adds the paypal object to the window
                    // LEVEL 4
                    // LEVEL 4
                    // LEVEL 4
                    // Paypal SDK is now initialized
                    if (loadPayPalSDKErr) {
                        client_unrecoverable_error_callback(loadPayPalSDKErr);
                        return;
                    }
                    let onApprove = function(data, actions) {
                        return paypalCheckoutInstance.tokenizePayment(data).then(function(payload) {
                            console.log(sprintf("paypal braintree nonce received [%s]", payload.nonce));
                            nonce_received_callback(payload.nonce);
                        });
                    };
                    let onCancel = function(data) {
                        console.log("client canceled payment");
                        client_recoverable_error_callback("You cancelled your payment.");
                    };
                    let createPayment = function() {
                        return paypalCheckoutInstance.createPayment(getPpPaymentOpts());
                    };
                    let onError = function(err) {
                        client_recoverable_error_callback(sprintf("There was an error processing your payment. <pre>%s</pre>", print_r(err, true)));
                        console.error("checkout.js error", err);
                    };
                    // Paypal Configuration and Button Creation
                    let standardBtn = paypal.Buttons({
                        fundingSource: paypal.FUNDING.PAYPAL,
                        style: paypal_button_styles_object,
                        env: paypal_env,
                        createOrder: createPayment,
                        onApprove: onApprove,
                        onCancel: onCancel,
                        onError: onError
                    });
                    if (standardBtn.isEligible()) standardBtn.render(paypal_button_selector).then(function() {
                        // The PayPal button will be rendered in an html element with the id
                        // paypal_button_selector. This function will be called when the PayPal button
                        // is set up and ready to be used.
                        console.log("Paypal checkout button created");
                        self.payment_method_initialization_complete_callback(paypalCheckoutInstance);
                    });
                    let payLaterBtn = paypal.Buttons({
                        fundingSource: paypal.FUNDING.PAYLATER,
                        env: paypal_env,
                        createOrder: createPayment,
                        onApprove: onApprove,
                        onCancel: onCancel,
                        onError: onError
                    });
                    if (payLaterBtn.isEligible()) {
                        // Skip rendering if not eligible
                        payLaterBtn.render(pppin4_selector);
                        should_show_ppin4_stuff_callback(true);
                    } else {
                        console.log("pppin4 is ineligible");
                        should_show_ppin4_stuff_callback(false);
                    }
                });
            });
        });
    });
    $(document).bind(credit_card_submit_event, function() {
        $9929b06a4a9b814f$var$braintree_credit_card_submit(self.hosted_fields_instance, client_recoverable_error_callback, payment_is_currently_processing_true_false_callback, nonce_received_callback);
    });
}
function $9929b06a4a9b814f$var$braintree_credit_card_submit(hosted_fields_instance, client_recoverable_error_function, payment_is_currently_processing_true_false_callback, card_submit_did_succeed_with_nonce_callback) {
    console.log("braintree credit payment out for processing");
    payment_is_currently_processing_true_false_callback(true);
    hosted_fields_instance.tokenize(function(tokenizeErr, payload) {
        // from https://braintree.github.io/braintree-web/3.22.2/HostedFields.html#tokenize
        if (tokenizeErr) {
            console.log("braintree tokenization error");
            console.log(tokenizeErr.code);
            console.log(tokenizeErr);
            switch(tokenizeErr.code){
                case "HOSTED_FIELDS_FIELDS_EMPTY":
                    // occurs when none of the fields are filled in
                    client_recoverable_error_function("All credit card fields are empty! Please fill out the form.");
                    break;
                case "HOSTED_FIELDS_FIELDS_INVALID":
                    // occurs when certain fields do not pass client side validation
                    client_recoverable_error_function(sprintf("Some credit card fields are invalid: [%s]. Please fill them out before continuing.", tokenizeErr.details.invalidFieldKeys));
                    break;
                case "HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE":
                    // occurs when:
                    //   * the client token used for client authorization was generated
                    //     with a customer ID and the fail on duplicate payment method
                    //     option is set to true
                    //   * the card being tokenized has previously been vaulted (with any customer)
                    // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.fail_on_duplicate_payment_method
                    client_recoverable_error_function("This payment method is in use elsewhere. Please try another payment method.");
                    break;
                case "HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED":
                    // occurs when:
                    //   * the client token used for client authorization was generated
                    //     with a customer ID and the verify card option is set to true
                    //     and you have credit card verification turned on in the Braintree
                    //     control panel
                    //   * the cvv does not pass verfication (https://developers.braintreepayments.com/reference/general/testing/#avs-and-cvv/cid-responses)
                    // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.verify_card
                    client_recoverable_error_function("Credit Card CVV code did not pass verification");
                    break;
                case "HOSTED_FIELDS_FAILED_TOKENIZATION":
                    // occurs for any other tokenization error on the server
                    client_recoverable_error_function("We could not verify your card. Would you please check your data and try again?");
                    break;
                case "HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR":
                    // occurs when the Braintree gateway cannot be contacted
                    client_recoverable_error_function("There was a network error while trying to verify your card. Would you please check your network connection and try again? ");
                    break;
                default:
                    client_recoverable_error_function(sprintf('An unidentified error occurred while processing your card. Please verify your data and try again. ["%s": "%s"]', tokenizeErr.code, tokenizeErr.message));
            }
            payment_is_currently_processing_true_false_callback(false);
            return;
        }
        console.log(sprintf("braintree credit card nonce received [%s]", payload.nonce));
        payment_is_currently_processing_true_false_callback(false);
        card_submit_did_succeed_with_nonce_callback(payload.nonce);
    });
}
module.exports = {
    braintree_init: $9929b06a4a9b814f$var$braintree_init
};

});
parcelRegister("ctGv0", function(module, exports) {

$parcel$export(module.exports, "floatval", () => $915928e7f56614d9$export$f79b966f6513a4a4, (v) => $915928e7f56614d9$export$f79b966f6513a4a4 = v);
var $915928e7f56614d9$export$f92e24520169952c;
var $915928e7f56614d9$export$7b508c7d682f38c2;
var $915928e7f56614d9$export$6e22c362a0406a2c;
var $915928e7f56614d9$export$f79b966f6513a4a4;
var $915928e7f56614d9$export$c534b7aaec9c6541;
var $915928e7f56614d9$export$518f5a7be6be2bfb;
var $915928e7f56614d9$export$e11d765514e26475;
var $915928e7f56614d9$export$b9e620dcd263416a;
var $915928e7f56614d9$export$1b9bc6d6416d4aed;
var $915928e7f56614d9$export$d557c59a3457063;
var $915928e7f56614d9$export$ccde71a52e7c94a;
var $915928e7f56614d9$export$73a63460674e8192;
var $915928e7f56614d9$export$25686719dd720715;
var $915928e7f56614d9$export$50950dbe6175720b;
var $915928e7f56614d9$export$5a809a9f8c508d53;
var $915928e7f56614d9$export$a7350a83df6cbf8c;
var $915928e7f56614d9$export$6eb3e1aff281a120;
var $915928e7f56614d9$export$5fe1d4742c8a41e2;
var $915928e7f56614d9$export$167528a9b5133c2f;
var $915928e7f56614d9$export$2881e3f0bcfe3fcd;
var $915928e7f56614d9$export$5703b497ec3a710b;
var $915928e7f56614d9$export$2a124c24c597fe41;
var $915928e7f56614d9$export$8cf8222cef2855b6;
var $915928e7f56614d9$export$99b9a4368c7161b7;
var $915928e7f56614d9$export$b64ed8bd77067805;
var $915928e7f56614d9$export$dfdc1655ccc5b9cb;
var $915928e7f56614d9$export$e78e04b6df40a09a;
var $915928e7f56614d9$export$768ab73e7bdda567;
var $915928e7f56614d9$export$f1524ad7cc450ab;
var $915928e7f56614d9$export$c539df27d2e5b467;
"use strict";

$915928e7f56614d9$export$f92e24520169952c = (parcelRequire("e78os"));

$915928e7f56614d9$export$7b508c7d682f38c2 = (parcelRequire("llNHy"));

$915928e7f56614d9$export$6e22c362a0406a2c = (parcelRequire("Xd8TS"));

$915928e7f56614d9$export$f79b966f6513a4a4 = (parcelRequire("fKser"));

$915928e7f56614d9$export$c534b7aaec9c6541 = (parcelRequire("1GhY3"));

$915928e7f56614d9$export$518f5a7be6be2bfb = (parcelRequire("jYpB7"));

$915928e7f56614d9$export$e11d765514e26475 = (parcelRequire("53Ffj"));

$915928e7f56614d9$export$b9e620dcd263416a = (parcelRequire("jMdXQ"));

$915928e7f56614d9$export$1b9bc6d6416d4aed = (parcelRequire("7gqxi"));

$915928e7f56614d9$export$d557c59a3457063 = (parcelRequire("6kuJk"));

$915928e7f56614d9$export$ccde71a52e7c94a = (parcelRequire("fgOX1"));

$915928e7f56614d9$export$73a63460674e8192 = (parcelRequire("kKVde"));

$915928e7f56614d9$export$25686719dd720715 = (parcelRequire("ceNa0"));

$915928e7f56614d9$export$50950dbe6175720b = (parcelRequire("3p9AE"));

$915928e7f56614d9$export$5a809a9f8c508d53 = (parcelRequire("jdYSH"));

$915928e7f56614d9$export$a7350a83df6cbf8c = (parcelRequire("aSvCw"));

$915928e7f56614d9$export$6eb3e1aff281a120 = (parcelRequire("gvmcr"));

$915928e7f56614d9$export$5fe1d4742c8a41e2 = (parcelRequire("6oGpV"));

$915928e7f56614d9$export$167528a9b5133c2f = (parcelRequire("gYAwq"));

$915928e7f56614d9$export$2881e3f0bcfe3fcd = (parcelRequire("2j14x"));

$915928e7f56614d9$export$5703b497ec3a710b = (parcelRequire("aeHIR"));

$915928e7f56614d9$export$2a124c24c597fe41 = (parcelRequire("9tJeG"));

$915928e7f56614d9$export$8cf8222cef2855b6 = (parcelRequire("iKEYB"));

$915928e7f56614d9$export$99b9a4368c7161b7 = (parcelRequire("9YDnd"));

$915928e7f56614d9$export$b64ed8bd77067805 = (parcelRequire("7mGb1"));

$915928e7f56614d9$export$dfdc1655ccc5b9cb = (parcelRequire("7dpPV"));

$915928e7f56614d9$export$e78e04b6df40a09a = (parcelRequire("8W2tk"));

$915928e7f56614d9$export$768ab73e7bdda567 = (parcelRequire("8LSUB"));

$915928e7f56614d9$export$f1524ad7cc450ab = (parcelRequire("jVEUG"));

$915928e7f56614d9$export$c539df27d2e5b467 = (parcelRequire("3y3zi"));

});
parcelRegister("e78os", function(module, exports) {
"use strict";
module.exports = function boolval(mixedVar) {
    // original by: Will Rowe
    //   example 1: boolval(true)
    //   returns 1: true
    //   example 2: boolval(false)
    //   returns 2: false
    //   example 3: boolval(0)
    //   returns 3: false
    //   example 4: boolval(0.0)
    //   returns 4: false
    //   example 5: boolval('')
    //   returns 5: false
    //   example 6: boolval('0')
    //   returns 6: false
    //   example 7: boolval([])
    //   returns 7: false
    //   example 8: boolval('')
    //   returns 8: false
    //   example 9: boolval(null)
    //   returns 9: false
    //   example 10: boolval(undefined)
    //   returns 10: false
    //   example 11: boolval('true')
    //   returns 11: true
    if (mixedVar === false) return false;
    if (mixedVar === 0 || mixedVar === 0.0) return false;
    if (mixedVar === "" || mixedVar === "0") return false;
    if (Array.isArray(mixedVar) && mixedVar.length === 0) return false;
    if (mixedVar === null || mixedVar === undefined) return false;
    return true;
};

});

parcelRegister("llNHy", function(module, exports) {
"use strict";

module.exports = function doubleval(mixedVar) {
    //  discuss at: https://locutus.io/php/doubleval/
    // original by: Brett Zamir (https://brett-zamir.me)
    //      note 1: 1.0 is simplified to 1 before it can be accessed by the function, this makes
    //      note 1: it different from the PHP implementation. We can't fix this unfortunately.
    //   example 1: doubleval(186)
    //   returns 1: 186.00
    var floatval = (parcelRequire("fKser"));
    return floatval(mixedVar);
};

});
parcelRegister("fKser", function(module, exports) {
"use strict";
module.exports = function floatval(mixedVar) {
    //  discuss at: https://locutus.io/php/floatval/
    // original by: Michael White (https://getsprink.com)
    //      note 1: The native parseFloat() method of JavaScript returns NaN
    //      note 1: when it encounters a string before an int or float value.
    //   example 1: floatval('150.03_page-section')
    //   returns 1: 150.03
    //   example 2: floatval('page: 3')
    //   example 2: floatval('-50 + 8')
    //   returns 2: 0
    //   returns 2: -50
    return parseFloat(mixedVar) || 0;
};

});


parcelRegister("Xd8TS", function(module, exports) {
"use strict";
var $0b1fb4a3bb3e00d9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
module.exports = function empty(mixedVar) {
    //  discuss at: https://locutus.io/php/empty/
    // original by: Philippe Baumann
    //    input by: Onno Marsman (https://twitter.com/onnomarsman)
    //    input by: LH
    //    input by: Stoyan Kyosev (https://www.svest.org/)
    // bugfixed by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Onno Marsman (https://twitter.com/onnomarsman)
    // improved by: Francesco
    // improved by: Marc Jansen
    // improved by: Rafał Kukawski (https://blog.kukawski.pl)
    //   example 1: empty(null)
    //   returns 1: true
    //   example 2: empty(undefined)
    //   returns 2: true
    //   example 3: empty([])
    //   returns 3: true
    //   example 4: empty({})
    //   returns 4: true
    //   example 5: empty({'aFunc' : function () { alert('humpty'); } })
    //   returns 5: false
    var undef = void 0;
    var key = void 0;
    var i = void 0;
    var len = void 0;
    var emptyValues = [
        undef,
        null,
        false,
        0,
        "",
        "0"
    ];
    for(i = 0, len = emptyValues.length; i < len; i++){
        if (mixedVar === emptyValues[i]) return true;
    }
    if ((typeof mixedVar === "undefined" ? "undefined" : $0b1fb4a3bb3e00d9$var$_typeof(mixedVar)) === "object") {
        for(key in mixedVar){
            if (mixedVar.hasOwnProperty(key)) return false;
        }
        return true;
    }
    return false;
};

});

parcelRegister("1GhY3", function(module, exports) {
"use strict";
var $1397a6ab7bbe5fc4$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

module.exports = function gettype(mixedVar) {
    //  discuss at: https://locutus.io/php/gettype/
    // original by: Paulo Freitas
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Douglas Crockford (https://javascript.crockford.com)
    // improved by: Brett Zamir (https://brett-zamir.me)
    //    input by: KELAN
    //      note 1: 1.0 is simplified to 1 before it can be accessed by the function, this makes
    //      note 1: it different from the PHP implementation. We can't fix this unfortunately.
    //   example 1: gettype(1)
    //   returns 1: 'integer'
    //   example 2: gettype(undefined)
    //   returns 2: 'undefined'
    //   example 3: gettype({0: 'Kevin van Zonneveld'})
    //   returns 3: 'object'
    //   example 4: gettype('foo')
    //   returns 4: 'string'
    //   example 5: gettype({0: function () {return false;}})
    //   returns 5: 'object'
    //   example 6: gettype({0: 'test', length: 1, splice: function () {}})
    //   returns 6: 'object'
    //   example 7: gettype(['test'])
    //   returns 7: 'array'
    var isFloat = (parcelRequire("ceNa0"));
    var s = typeof mixedVar === "undefined" ? "undefined" : $1397a6ab7bbe5fc4$var$_typeof(mixedVar);
    var name = void 0;
    var _getFuncName = function _getFuncName(fn) {
        var name = /\W*function\s+([\w$]+)\s*\(/.exec(fn);
        if (!name) return "(Anonymous)";
        return name[1];
    };
    if (s === "object") {
        if (mixedVar !== null) {
            // From: https://javascript.crockford.com/remedial.html
            // @todo: Break up this lengthy if statement
            if (typeof mixedVar.length === "number" && !mixedVar.propertyIsEnumerable("length") && typeof mixedVar.splice === "function") s = "array";
            else if (mixedVar.constructor && _getFuncName(mixedVar.constructor)) {
                name = _getFuncName(mixedVar.constructor);
                if (name === "Date") // not in PHP
                s = "date";
                else if (name === "RegExp") // not in PHP
                s = "regexp";
                else if (name === "LOCUTUS_Resource") // Check against our own resource constructor
                s = "resource";
            }
        } else s = "null";
    } else if (s === "number") s = isFloat(mixedVar) ? "double" : "integer";
    return s;
};

});
parcelRegister("ceNa0", function(module, exports) {
"use strict";
module.exports = function is_float(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_float/
    // original by: Paulo Freitas
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    // improved by: WebDevHobo (https://webdevhobo.blogspot.com/)
    // improved by: Rafał Kukawski (https://blog.kukawski.pl)
    //      note 1: 1.0 is simplified to 1 before it can be accessed by the function, this makes
    //      note 1: it different from the PHP implementation. We can't fix this unfortunately.
    //   example 1: is_float(186.31)
    //   returns 1: true
    return +mixedVar === mixedVar && (!isFinite(mixedVar) || !!(mixedVar % 1));
};

});


parcelRegister("jYpB7", function(module, exports) {
"use strict";
var $e8a77a14875343b5$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
module.exports = function intval(mixedVar, base) {
    //  discuss at: https://locutus.io/php/intval/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: stensi
    // bugfixed by: Kevin van Zonneveld (https://kvz.io)
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    // bugfixed by: Rafał Kukawski (https://blog.kukawski.pl)
    //    input by: Matteo
    //   example 1: intval('Kevin van Zonneveld')
    //   returns 1: 0
    //   example 2: intval(4.2)
    //   returns 2: 4
    //   example 3: intval(42, 8)
    //   returns 3: 42
    //   example 4: intval('09')
    //   returns 4: 9
    //   example 5: intval('1e', 16)
    //   returns 5: 30
    //   example 6: intval(0x200000001)
    //   returns 6: 8589934593
    //   example 7: intval('0xff', 0)
    //   returns 7: 255
    //   example 8: intval('010', 0)
    //   returns 8: 8
    var tmp = void 0, match = void 0;
    var type = typeof mixedVar === "undefined" ? "undefined" : $e8a77a14875343b5$var$_typeof(mixedVar);
    if (type === "boolean") return +mixedVar;
    else if (type === "string") {
        if (base === 0) {
            match = mixedVar.match(/^\s*0(x?)/i);
            base = match ? match[1] ? 16 : 8 : 10;
        }
        tmp = parseInt(mixedVar, base || 10);
        return isNaN(tmp) || !isFinite(tmp) ? 0 : tmp;
    } else if (type === "number" && isFinite(mixedVar)) return mixedVar < 0 ? Math.ceil(mixedVar) : Math.floor(mixedVar);
    else return 0;
};

});

parcelRegister("53Ffj", function(module, exports) {
"use strict";
var $3aed3a232a65d17e$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

module.exports = function is_array(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_array/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Legaev Andrey
    // improved by: Onno Marsman (https://twitter.com/onnomarsman)
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: Nathan Sepulveda
    // improved by: Brett Zamir (https://brett-zamir.me)
    // bugfixed by: Cord
    // bugfixed by: Manish
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    //      note 1: In Locutus, javascript objects are like php associative arrays,
    //      note 1: thus JavaScript objects will also
    //      note 1: return true in this function (except for objects which inherit properties,
    //      note 1: being thus used as objects),
    //      note 1: unless you do ini_set('locutus.objectsAsArrays', 0),
    //      note 1: in which case only genuine JavaScript arrays
    //      note 1: will return true
    //   example 1: is_array(['Kevin', 'van', 'Zonneveld'])
    //   returns 1: true
    //   example 2: is_array('Kevin van Zonneveld')
    //   returns 2: false
    //   example 3: is_array({0: 'Kevin', 1: 'van', 2: 'Zonneveld'})
    //   returns 3: true
    //   example 4: ini_set('locutus.objectsAsArrays', 0)
    //   example 4: is_array({0: 'Kevin', 1: 'van', 2: 'Zonneveld'})
    //   returns 4: false
    //   example 5: is_array(function tmp_a (){ this.name = 'Kevin' })
    //   returns 5: false
    var _getFuncName = function _getFuncName(fn) {
        var name = /\W*function\s+([\w$]+)\s*\(/.exec(fn);
        if (!name) return "(Anonymous)";
        return name[1];
    };
    var _isArray = function _isArray(mixedVar) {
        // return Object.prototype.toString.call(mixedVar) === '[object Array]';
        // The above works, but let's do the even more stringent approach:
        // (since Object.prototype.toString could be overridden)
        // Null, Not an object, no length property so couldn't be an Array (or String)
        if (!mixedVar || (typeof mixedVar === "undefined" ? "undefined" : $3aed3a232a65d17e$var$_typeof(mixedVar)) !== "object" || typeof mixedVar.length !== "number") return false;
        var len = mixedVar.length;
        mixedVar[mixedVar.length] = "bogus";
        // The only way I can think of to get around this (or where there would be trouble)
        // would be to have an object defined
        // with a custom "length" getter which changed behavior on each call
        // (or a setter to mess up the following below) or a custom
        // setter for numeric properties, but even that would need to listen for
        // specific indexes; but there should be no false negatives
        // and such a false positive would need to rely on later JavaScript
        // innovations like __defineSetter__
        if (len !== mixedVar.length) {
            // We know it's an array since length auto-changed with the addition of a
            // numeric property at its length end, so safely get rid of our bogus element
            mixedVar.length -= 1;
            return true;
        }
        // Get rid of the property we added onto a non-array object; only possible
        // side-effect is if the user adds back the property later, it will iterate
        // this property in the older order placement in IE (an order which should not
        // be depended on anyways)
        delete mixedVar[mixedVar.length];
        return false;
    };
    if (!mixedVar || (typeof mixedVar === "undefined" ? "undefined" : $3aed3a232a65d17e$var$_typeof(mixedVar)) !== "object") return false;
    var isArray = _isArray(mixedVar);
    if (isArray) return true;
    var iniVal = (parcelRequire("afmQR"))("locutus.objectsAsArrays") || "on";
    if (iniVal === "on") {
        var asString = Object.prototype.toString.call(mixedVar);
        var asFunc = _getFuncName(mixedVar.constructor);
        if (asString === "[object Object]" && asFunc === "Object") // Most likely a literal and intended as assoc. array
        return true;
    }
    return false;
};

});
parcelRegister("afmQR", function(module, exports) {
"use strict";
module.exports = function ini_get(varname) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/ini_get/
    // original by: Brett Zamir (https://brett-zamir.me)
    //      note 1: The ini values must be set by ini_set or manually within an ini file
    //   example 1: ini_set('date.timezone', 'Asia/Hong_Kong')
    //   example 1: ini_get('date.timezone')
    //   returns 1: 'Asia/Hong_Kong'
    var $global = typeof window !== "undefined" ? window : $parcel$global;
    $global.$locutus = $global.$locutus || {};
    var $locutus = $global.$locutus;
    $locutus.php = $locutus.php || {};
    $locutus.php.ini = $locutus.php.ini || {};
    if ($locutus.php.ini[varname] && $locutus.php.ini[varname].local_value !== undefined) {
        if ($locutus.php.ini[varname].local_value === null) return "";
        return $locutus.php.ini[varname].local_value;
    }
    return "";
};

});


parcelRegister("jMdXQ", function(module, exports) {
"use strict";
module.exports = function is_binary(vr) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_binary/
    // original by: Brett Zamir (https://brett-zamir.me)
    //   example 1: is_binary('This could be binary as far as JavaScript knows...')
    //   returns 1: true
    return typeof vr === "string"; // If it is a string of any kind, it could be binary
};

});

parcelRegister("7gqxi", function(module, exports) {
"use strict";
module.exports = function is_bool(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_bool/
    // original by: Onno Marsman (https://twitter.com/onnomarsman)
    // improved by: CoursesWeb (https://www.coursesweb.net/)
    //   example 1: is_bool(false)
    //   returns 1: true
    //   example 2: is_bool(0)
    //   returns 2: false
    return mixedVar === true || mixedVar === false; // Faster (in FF) than type checking
};

});

parcelRegister("6kuJk", function(module, exports) {
"use strict";
module.exports = function is_buffer(vr) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_buffer/
    // original by: Brett Zamir (https://brett-zamir.me)
    //   example 1: is_buffer('This could be binary or a regular string...')
    //   returns 1: true
    return typeof vr === "string";
};

});

parcelRegister("fgOX1", function(module, exports) {
"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
module.exports = function is_callable(mixedVar, syntaxOnly, callableName) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_callable/
    // original by: Brett Zamir (https://brett-zamir.me)
    //    input by: François
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: KnightYoshi
    // improved by: Waldo Malqui Silva (https://fayr.us/waldo/)
    //      note 1: The variable callableName cannot work as a string variable passed by
    //      note 1: reference as in PHP (since JavaScript does not support passing
    //      note 1: strings by reference), but instead will take the name of
    //      note 1: a global variable and set that instead.
    //      note 1: When used on an object, depends on a constructor property
    //      note 1: being kept on the object prototype
    //      note 2: Depending on the `callableName` that is passed, this function can use eval.
    //      note 2: The eval input is however checked to only allow valid function names,
    //      note 2: So it should not be unsafer than uses without eval (seeing as you can)
    //      note 2: already pass any function to be executed here.
    //   example 1: is_callable('is_callable')
    //   returns 1: true
    //   example 2: is_callable('bogusFunction', true)
    //   returns 2: true // gives true because does not do strict checking
    //   example 3: function SomeClass () {}
    //   example 3: SomeClass.prototype.someMethod = function (){}
    //   example 3: var testObj = new SomeClass()
    //   example 3: is_callable([testObj, 'someMethod'], true, 'myVar')
    //   example 3: var $result = myVar
    //   returns 3: 'SomeClass::someMethod'
    //   example 4: is_callable(function () {})
    //   returns 4: true
    //   example 5: is_callable(class MyClass {})
    //   returns 5: false
    var $global = typeof window !== "undefined" ? window : $parcel$global;
    var validJSFunctionNamePattern = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
    var name = "";
    var obj = {};
    var method = "";
    var validFunctionName = false;
    var getFuncName = function getFuncName(fn) {
        var name = /\W*function\s+([\w$]+)\s*\(/.exec(fn);
        if (!name) return "(Anonymous)";
        return name[1];
    };
    // eslint-disable-next-line no-useless-escape
    if (/(^class|\(this\,)/.test(mixedVar.toString())) return false;
    if (typeof mixedVar === "string") {
        obj = $global;
        method = mixedVar;
        name = mixedVar;
        validFunctionName = !!name.match(validJSFunctionNamePattern);
    } else if (typeof mixedVar === "function") return true;
    else if (Object.prototype.toString.call(mixedVar) === "[object Array]" && mixedVar.length === 2 && _typeof(mixedVar[0]) === "object" && typeof mixedVar[1] === "string") {
        obj = mixedVar[0];
        method = mixedVar[1];
        name = (obj.constructor && getFuncName(obj.constructor)) + "::" + method;
    }
    if (syntaxOnly || typeof obj[method] === "function") {
        if (callableName) $global[callableName] = name;
        return true;
    }
    // validFunctionName avoids exploits
    if (validFunctionName && typeof eval(method) === "function") {
        // eslint-disable-line no-eval
        if (callableName) $global[callableName] = name;
        return true;
    }
    return false;
};

});

parcelRegister("kKVde", function(module, exports) {
"use strict";

module.exports = function is_double(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_double/
    // original by: Paulo Freitas
    //      note 1: 1.0 is simplified to 1 before it can be accessed by the function, this makes
    //      note 1: it different from the PHP implementation. We can't fix this unfortunately.
    //   example 1: is_double(186.31)
    //   returns 1: true
    var _isFloat = (parcelRequire("ceNa0"));
    return _isFloat(mixedVar);
};

});

parcelRegister("3p9AE", function(module, exports) {
"use strict";
module.exports = function is_int(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_int/
    // original by: Alex
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // improved by: WebDevHobo (https://webdevhobo.blogspot.com/)
    // improved by: Rafał Kukawski (https://blog.kukawski.pl)
    //  revised by: Matt Bradley
    // bugfixed by: Kevin van Zonneveld (https://kvz.io)
    //      note 1: 1.0 is simplified to 1 before it can be accessed by the function, this makes
    //      note 1: it different from the PHP implementation. We can't fix this unfortunately.
    //   example 1: is_int(23)
    //   returns 1: true
    //   example 2: is_int('23')
    //   returns 2: false
    //   example 3: is_int(23.5)
    //   returns 3: false
    //   example 4: is_int(true)
    //   returns 4: false
    return mixedVar === +mixedVar && isFinite(mixedVar) && !(mixedVar % 1);
};

});

parcelRegister("jdYSH", function(module, exports) {
"use strict";

module.exports = function is_integer(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_integer/
    // original by: Paulo Freitas
    //      note 1: 1.0 is simplified to 1 before it can be accessed by the function, this makes
    //      note 1: it different from the PHP implementation. We can't fix this unfortunately.
    //   example 1: is_integer(186.31)
    //   returns 1: false
    //   example 2: is_integer(12)
    //   returns 2: true
    var _isInt = (parcelRequire("3p9AE"));
    return _isInt(mixedVar);
};

});

parcelRegister("aSvCw", function(module, exports) {
"use strict";

module.exports = function is_long(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_long/
    // original by: Paulo Freitas
    //      note 1: 1.0 is simplified to 1 before it can be accessed by the function, this makes
    //      note 1: it different from the PHP implementation. We can't fix this unfortunately.
    //   example 1: is_long(186.31)
    //   returns 1: true
    var _isFloat = (parcelRequire("ceNa0"));
    return _isFloat(mixedVar);
};

});

parcelRegister("gvmcr", function(module, exports) {
"use strict";
module.exports = function is_null(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_null/
    // original by: Kevin van Zonneveld (https://kvz.io)
    //   example 1: is_null('23')
    //   returns 1: false
    //   example 2: is_null(null)
    //   returns 2: true
    return mixedVar === null;
};

});

parcelRegister("6oGpV", function(module, exports) {
"use strict";
module.exports = function is_numeric(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_numeric/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: David
    // improved by: taith
    // bugfixed by: Tim de Koning
    // bugfixed by: WebDevHobo (https://webdevhobo.blogspot.com/)
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    // bugfixed by: Denis Chenu (https://shnoulle.net)
    //   example 1: is_numeric(186.31)
    //   returns 1: true
    //   example 2: is_numeric('Kevin van Zonneveld')
    //   returns 2: false
    //   example 3: is_numeric(' +186.31e2')
    //   returns 3: true
    //   example 4: is_numeric('')
    //   returns 4: false
    //   example 5: is_numeric([])
    //   returns 5: false
    //   example 6: is_numeric('1 ')
    //   returns 6: false
    var whitespace = [
        " ",
        "\n",
        "\r",
        "	",
        "\f",
        "\v",
        "\xa0",
        "\u2000",
        "\u2001",
        "\u2002",
        "\u2003",
        "\u2004",
        "\u2005",
        "\u2006",
        "\u2007",
        "\u2008",
        "\u2009",
        "\u200A",
        "\u200B",
        "\u2028",
        "\u2029",
        "\u3000"
    ].join("");
    // @todo: Break this up using many single conditions with early returns
    return (typeof mixedVar === "number" || typeof mixedVar === "string" && whitespace.indexOf(mixedVar.slice(-1)) === -1) && mixedVar !== "" && !isNaN(mixedVar);
};

});

parcelRegister("gYAwq", function(module, exports) {
"use strict";
var $c5be947270840c0e$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
module.exports = function is_object(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_object/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Legaev Andrey
    // improved by: Michael White (https://getsprink.com)
    //   example 1: is_object('23')
    //   returns 1: false
    //   example 2: is_object({foo: 'bar'})
    //   returns 2: true
    //   example 3: is_object(null)
    //   returns 3: false
    if (Object.prototype.toString.call(mixedVar) === "[object Array]") return false;
    return mixedVar !== null && (typeof mixedVar === "undefined" ? "undefined" : $c5be947270840c0e$var$_typeof(mixedVar)) === "object";
};

});

parcelRegister("2j14x", function(module, exports) {
"use strict";

module.exports = function is_real(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_real/
    // original by: Brett Zamir (https://brett-zamir.me)
    //      note 1: 1.0 is simplified to 1 before it can be accessed by the function, this makes
    //      note 1: it different from the PHP implementation. We can't fix this unfortunately.
    //   example 1: is_real(186.31)
    //   returns 1: true
    var _isFloat = (parcelRequire("ceNa0"));
    return _isFloat(mixedVar);
};

});

parcelRegister("aeHIR", function(module, exports) {
"use strict";
var $773d208ec7f2b4cf$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
module.exports = function is_scalar(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_scalar/
    // original by: Paulo Freitas
    //   example 1: is_scalar(186.31)
    //   returns 1: true
    //   example 2: is_scalar({0: 'Kevin van Zonneveld'})
    //   returns 2: false
    return /boolean|number|string/.test(typeof mixedVar === "undefined" ? "undefined" : $773d208ec7f2b4cf$var$_typeof(mixedVar));
};

});

parcelRegister("9tJeG", function(module, exports) {
"use strict";
module.exports = function is_string(mixedVar) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_string/
    // original by: Kevin van Zonneveld (https://kvz.io)
    //   example 1: is_string('23')
    //   returns 1: true
    //   example 2: is_string(23.5)
    //   returns 2: false
    return typeof mixedVar === "string";
};

});

parcelRegister("iKEYB", function(module, exports) {
"use strict";
module.exports = function is_unicode(vr) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/is_unicode/
    // original by: Brett Zamir (https://brett-zamir.me)
    //      note 1: Almost all strings in JavaScript should be Unicode
    //   example 1: is_unicode('We the peoples of the United Nations...!')
    //   returns 1: true
    if (typeof vr !== "string") return false;
    // If surrogates occur outside of high-low pairs, then this is not Unicode
    var arr = [];
    var highSurrogate = "[\uD800-\uDBFF]";
    var lowSurrogate = "[\uDC00-\uDFFF]";
    var highSurrogateBeforeAny = new RegExp(highSurrogate + "([\\s\\S])", "g");
    var lowSurrogateAfterAny = new RegExp("([\\s\\S])" + lowSurrogate, "g");
    var singleLowSurrogate = new RegExp("^" + lowSurrogate + "$");
    var singleHighSurrogate = new RegExp("^" + highSurrogate + "$");
    while((arr = highSurrogateBeforeAny.exec(vr)) !== null){
        if (!arr[1] || !arr[1].match(singleLowSurrogate)) // If high not followed by low surrogate
        return false;
    }
    while((arr = lowSurrogateAfterAny.exec(vr)) !== null){
        if (!arr[1] || !arr[1].match(singleHighSurrogate)) // If low not preceded by high surrogate
        return false;
    }
    return true;
};

});

parcelRegister("9YDnd", function(module, exports) {
"use strict";
module.exports = function isset() {
    //  discuss at: https://locutus.io/php/isset/
    // original by: Kevin van Zonneveld (https://kvz.io)
    // improved by: FremyCompany
    // improved by: Onno Marsman (https://twitter.com/onnomarsman)
    // improved by: Rafał Kukawski (https://blog.kukawski.pl)
    //   example 1: isset( undefined, true)
    //   returns 1: false
    //   example 2: isset( 'Kevin van Zonneveld' )
    //   returns 2: true
    var a = arguments;
    var l = a.length;
    var i = 0;
    var undef = void 0;
    if (l === 0) throw new Error("Empty isset");
    while(i !== l){
        if (a[i] === undef || a[i] === null) return false;
        i++;
    }
    return true;
};

});

parcelRegister("7dpPV", function(module, exports) {
"use strict";
var $540dc9e844e87d26$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
module.exports = function serialize(mixedValue) {
    //  discuss at: https://locutus.io/php/serialize/
    // original by: Arpad Ray (mailto:arpad@php.net)
    // improved by: Dino
    // improved by: Le Torbi (https://www.letorbi.de/)
    // improved by: Kevin van Zonneveld (https://kvz.io/)
    // bugfixed by: Andrej Pavlovic
    // bugfixed by: Garagoth
    // bugfixed by: Russell Walker (https://www.nbill.co.uk/)
    // bugfixed by: Jamie Beck (https://www.terabit.ca/)
    // bugfixed by: Kevin van Zonneveld (https://kvz.io/)
    // bugfixed by: Ben (https://benblume.co.uk/)
    // bugfixed by: Codestar (https://codestarlive.com/)
    // bugfixed by: idjem (https://github.com/idjem)
    //    input by: DtTvB (https://dt.in.th/2008-09-16.string-length-in-bytes.html)
    //    input by: Martin (https://www.erlenwiese.de/)
    //      note 1: We feel the main purpose of this function should be to ease
    //      note 1: the transport of data between php & js
    //      note 1: Aiming for PHP-compatibility, we have to translate objects to arrays
    //   example 1: serialize(['Kevin', 'van', 'Zonneveld'])
    //   returns 1: 'a:3:{i:0;s:5:"Kevin";i:1;s:3:"van";i:2;s:9:"Zonneveld";}'
    //   example 2: serialize({firstName: 'Kevin', midName: 'van'})
    //   returns 2: 'a:2:{s:9:"firstName";s:5:"Kevin";s:7:"midName";s:3:"van";}'
    //   example 3: serialize( {'ü': 'ü', '四': '四', '𠜎': '𠜎'})
    //   returns 3: 'a:3:{s:2:"ü";s:2:"ü";s:3:"四";s:3:"四";s:4:"𠜎";s:4:"𠜎";}'
    var val = void 0, key = void 0, okey = void 0;
    var ktype = "";
    var vals = "";
    var count = 0;
    var _utf8Size = function _utf8Size(str) {
        return ~-encodeURI(str).split(/%..|./).length;
    };
    var _getType = function _getType(inp) {
        var match = void 0;
        var key = void 0;
        var cons = void 0;
        var types = void 0;
        var type = typeof inp === "undefined" ? "undefined" : $540dc9e844e87d26$var$_typeof(inp);
        if (type === "object" && !inp) return "null";
        if (type === "object") {
            if (!inp.constructor) return "object";
            cons = inp.constructor.toString();
            match = cons.match(/(\w+)\(/);
            if (match) cons = match[1].toLowerCase();
            types = [
                "boolean",
                "number",
                "string",
                "array"
            ];
            for(key in types)if (cons === types[key]) {
                type = types[key];
                break;
            }
        }
        return type;
    };
    var type = _getType(mixedValue);
    switch(type){
        case "function":
            val = "";
            break;
        case "boolean":
            val = "b:" + (mixedValue ? "1" : "0");
            break;
        case "number":
            val = (Math.round(mixedValue) === mixedValue ? "i" : "d") + ":" + mixedValue;
            break;
        case "string":
            val = "s:" + _utf8Size(mixedValue) + ':"' + mixedValue + '"';
            break;
        case "array":
        case "object":
            val = "a";
            /*
      if (type === 'object') {
        var objname = mixedValue.constructor.toString().match(/(\w+)\(\)/);
        if (objname === undefined) {
          return;
        }
        objname[1] = serialize(objname[1]);
        val = 'O' + objname[1].substring(1, objname[1].length - 1);
      }
      */ for(key in mixedValue)if (mixedValue.hasOwnProperty(key)) {
                ktype = _getType(mixedValue[key]);
                if (ktype === "function") continue;
                okey = key.match(/^[0-9]+$/) ? parseInt(key, 10) : key;
                vals += serialize(okey) + serialize(mixedValue[key]);
                count++;
            }
            val += ":" + count + ":{" + vals + "}";
            break;
        case "undefined":
        default:
            // Fall-through
            // if the JS object has a property which contains a null value,
            // the string cannot be unserialized by PHP
            val = "N";
            break;
    }
    if (type !== "object" && type !== "array") val += ";";
    return val;
};

});

parcelRegister("8W2tk", function(module, exports) {
"use strict";

module.exports = function strval(str) {
    //  discuss at: https://locutus.io/php/strval/
    // original by: Brett Zamir (https://brett-zamir.me)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    //   example 1: strval({red: 1, green: 2, blue: 3, white: 4})
    //   returns 1: 'Object'
    var gettype = (parcelRequire("1GhY3"));
    var type = "";
    if (str === null) return "";
    type = gettype(str);
    // Comment out the entire switch if you want JS-like
    // behavior instead of PHP behavior
    switch(type){
        case "boolean":
            if (str === true) return "1";
            return "";
        case "array":
            return "Array";
        case "object":
            return "Object";
    }
    return str;
};

});

parcelRegister("8LSUB", function(module, exports) {
"use strict";
var $662d4edddc8d86b4$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
function $662d4edddc8d86b4$var$initCache() {
    var store = [];
    // cache only first element, second is length to jump ahead for the parser
    var cache = function cache(value) {
        store.push(value[0]);
        return value;
    };
    cache.get = function(index) {
        if (index >= store.length) throw RangeError("Can't resolve reference " + (index + 1));
        return store[index];
    };
    return cache;
}
function $662d4edddc8d86b4$var$expectType(str, cache) {
    var types = /^(?:N(?=;)|[bidsSaOCrR](?=:)|[^:]+(?=:))/g;
    var type = (types.exec(str) || [])[0];
    if (!type) throw SyntaxError("Invalid input: " + str);
    switch(type){
        case "N":
            return cache([
                null,
                2
            ]);
        case "b":
            return cache($662d4edddc8d86b4$var$expectBool(str));
        case "i":
            return cache($662d4edddc8d86b4$var$expectInt(str));
        case "d":
            return cache($662d4edddc8d86b4$var$expectFloat(str));
        case "s":
            return cache($662d4edddc8d86b4$var$expectString(str));
        case "S":
            return cache($662d4edddc8d86b4$var$expectEscapedString(str));
        case "a":
            return $662d4edddc8d86b4$var$expectArray(str, cache);
        case "O":
            return $662d4edddc8d86b4$var$expectObject(str, cache);
        case "C":
            return $662d4edddc8d86b4$var$expectClass(str, cache);
        case "r":
        case "R":
            return $662d4edddc8d86b4$var$expectReference(str, cache);
        default:
            throw SyntaxError("Invalid or unsupported data type: " + type);
    }
}
function $662d4edddc8d86b4$var$expectBool(str) {
    var reBool = /^b:([01]);/;
    var _ref = reBool.exec(str) || [], _ref2 = $662d4edddc8d86b4$var$_slicedToArray(_ref, 2), match = _ref2[0], boolMatch = _ref2[1];
    if (!boolMatch) throw SyntaxError("Invalid bool value, expected 0 or 1");
    return [
        boolMatch === "1",
        match.length
    ];
}
function $662d4edddc8d86b4$var$expectInt(str) {
    var reInt = /^i:([+-]?\d+);/;
    var _ref3 = reInt.exec(str) || [], _ref4 = $662d4edddc8d86b4$var$_slicedToArray(_ref3, 2), match = _ref4[0], intMatch = _ref4[1];
    if (!intMatch) throw SyntaxError("Expected an integer value");
    return [
        parseInt(intMatch, 10),
        match.length
    ];
}
function $662d4edddc8d86b4$var$expectFloat(str) {
    var reFloat = /^d:(NAN|-?INF|(?:\d+\.\d*|\d*\.\d+|\d+)(?:[eE][+-]\d+)?);/;
    var _ref5 = reFloat.exec(str) || [], _ref6 = $662d4edddc8d86b4$var$_slicedToArray(_ref5, 2), match = _ref6[0], floatMatch = _ref6[1];
    if (!floatMatch) throw SyntaxError("Expected a float value");
    var floatValue = void 0;
    switch(floatMatch){
        case "NAN":
            floatValue = Number.NaN;
            break;
        case "-INF":
            floatValue = Number.NEGATIVE_INFINITY;
            break;
        case "INF":
            floatValue = Number.POSITIVE_INFINITY;
            break;
        default:
            floatValue = parseFloat(floatMatch);
            break;
    }
    return [
        floatValue,
        match.length
    ];
}
function $662d4edddc8d86b4$var$readBytes(str, len) {
    var escapedString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var bytes = 0;
    var out = "";
    var c = 0;
    var strLen = str.length;
    var wasHighSurrogate = false;
    var escapedChars = 0;
    while(bytes < len && c < strLen){
        var chr = str.charAt(c);
        var code = chr.charCodeAt(0);
        var isHighSurrogate = code >= 0xd800 && code <= 0xdbff;
        var isLowSurrogate = code >= 0xdc00 && code <= 0xdfff;
        if (escapedString && chr === "\\") {
            chr = String.fromCharCode(parseInt(str.substr(c + 1, 2), 16));
            escapedChars++;
            // each escaped sequence is 3 characters. Go 2 chars ahead.
            // third character will be jumped over a few lines later
            c += 2;
        }
        c++;
        bytes += isHighSurrogate || isLowSurrogate && wasHighSurrogate ? 2 : code > 0x7ff ? 3 : code > 0x7f ? 2 : 1;
        // if high surrogate is not followed by low surrogate, add 1 more byte
        bytes += wasHighSurrogate && !isLowSurrogate ? 1 : 0;
        out += chr;
        wasHighSurrogate = isHighSurrogate;
    }
    return [
        out,
        bytes,
        escapedChars
    ];
}
function $662d4edddc8d86b4$var$expectString(str) {
    // PHP strings consist of one-byte characters.
    // JS uses 2 bytes with possible surrogate pairs.
    // Serialized length of 2 is still 1 JS string character
    var reStrLength = /^s:(\d+):"/g; // also match the opening " char
    var _ref7 = reStrLength.exec(str) || [], _ref8 = $662d4edddc8d86b4$var$_slicedToArray(_ref7, 2), match = _ref8[0], byteLenMatch = _ref8[1];
    if (!match) throw SyntaxError("Expected a string value");
    var len = parseInt(byteLenMatch, 10);
    str = str.substr(match.length);
    var _readBytes = $662d4edddc8d86b4$var$readBytes(str, len), _readBytes2 = $662d4edddc8d86b4$var$_slicedToArray(_readBytes, 2), strMatch = _readBytes2[0], bytes = _readBytes2[1];
    if (bytes !== len) throw SyntaxError("Expected string of " + len + " bytes, but got " + bytes);
    str = str.substr(strMatch.length);
    // strict parsing, match closing "; chars
    if (!str.startsWith('";')) throw SyntaxError('Expected ";');
    return [
        strMatch,
        match.length + strMatch.length + 2
    ]; // skip last ";
}
function $662d4edddc8d86b4$var$expectEscapedString(str) {
    var reStrLength = /^S:(\d+):"/g; // also match the opening " char
    var _ref9 = reStrLength.exec(str) || [], _ref10 = $662d4edddc8d86b4$var$_slicedToArray(_ref9, 2), match = _ref10[0], strLenMatch = _ref10[1];
    if (!match) throw SyntaxError("Expected an escaped string value");
    var len = parseInt(strLenMatch, 10);
    str = str.substr(match.length);
    var _readBytes3 = $662d4edddc8d86b4$var$readBytes(str, len, true), _readBytes4 = $662d4edddc8d86b4$var$_slicedToArray(_readBytes3, 3), strMatch = _readBytes4[0], bytes = _readBytes4[1], escapedChars = _readBytes4[2];
    if (bytes !== len) throw SyntaxError("Expected escaped string of " + len + " bytes, but got " + bytes);
    str = str.substr(strMatch.length + escapedChars * 2);
    // strict parsing, match closing "; chars
    if (!str.startsWith('";')) throw SyntaxError('Expected ";');
    return [
        strMatch,
        match.length + strMatch.length + 2
    ]; // skip last ";
}
function $662d4edddc8d86b4$var$expectKeyOrIndex(str) {
    try {
        return $662d4edddc8d86b4$var$expectString(str);
    } catch (err) {}
    try {
        return $662d4edddc8d86b4$var$expectEscapedString(str);
    } catch (err) {}
    try {
        return $662d4edddc8d86b4$var$expectInt(str);
    } catch (err) {
        throw SyntaxError("Expected key or index");
    }
}
function $662d4edddc8d86b4$var$expectObject(str, cache) {
    // O:<class name length>:"class name":<prop count>:{<props and values>}
    // O:8:"stdClass":2:{s:3:"foo";s:3:"bar";s:3:"bar";s:3:"baz";}
    var reObjectLiteral = /^O:(\d+):"([^"]+)":(\d+):\{/;
    var _ref11 = reObjectLiteral.exec(str) || [], _ref12 = $662d4edddc8d86b4$var$_slicedToArray(_ref11, 4), objectLiteralBeginMatch = _ref12[0], /* classNameLengthMatch */ className = _ref12[2], propCountMatch = _ref12[3];
    if (!objectLiteralBeginMatch) throw SyntaxError("Invalid input");
    if (className !== "stdClass") throw SyntaxError("Unsupported object type: " + className);
    var totalOffset = objectLiteralBeginMatch.length;
    var propCount = parseInt(propCountMatch, 10);
    var obj = {};
    cache([
        obj
    ]);
    str = str.substr(totalOffset);
    for(var i = 0; i < propCount; i++){
        var prop = $662d4edddc8d86b4$var$expectKeyOrIndex(str);
        str = str.substr(prop[1]);
        totalOffset += prop[1];
        var value = $662d4edddc8d86b4$var$expectType(str, cache);
        str = str.substr(value[1]);
        totalOffset += value[1];
        obj[prop[0]] = value[0];
    }
    // strict parsing, expect } after object literal
    if (str.charAt(0) !== "}") throw SyntaxError("Expected }");
    return [
        obj,
        totalOffset + 1
    ]; // skip final }
}
function $662d4edddc8d86b4$var$expectClass(str, cache) {
    // can't be well supported, because requires calling eval (or similar)
    // in order to call serialized constructor name
    // which is unsafe
    // or assume that constructor is defined in global scope
    // but this is too much limiting
    throw Error("Not yet implemented");
}
function $662d4edddc8d86b4$var$expectReference(str, cache) {
    var reRef = /^[rR]:([1-9]\d*);/;
    var _ref13 = reRef.exec(str) || [], _ref14 = $662d4edddc8d86b4$var$_slicedToArray(_ref13, 2), match = _ref14[0], refIndex = _ref14[1];
    if (!match) throw SyntaxError("Expected reference value");
    return [
        cache.get(parseInt(refIndex, 10) - 1),
        match.length
    ];
}
function $662d4edddc8d86b4$var$expectArray(str, cache) {
    var reArrayLength = /^a:(\d+):{/;
    var _ref15 = reArrayLength.exec(str) || [], _ref16 = $662d4edddc8d86b4$var$_slicedToArray(_ref15, 2), arrayLiteralBeginMatch = _ref16[0], arrayLengthMatch = _ref16[1];
    if (!arrayLengthMatch) throw SyntaxError("Expected array length annotation");
    str = str.substr(arrayLiteralBeginMatch.length);
    var array = $662d4edddc8d86b4$var$expectArrayItems(str, parseInt(arrayLengthMatch, 10), cache);
    // strict parsing, expect closing } brace after array literal
    if (str.charAt(array[1]) !== "}") throw SyntaxError("Expected }");
    return [
        array[0],
        arrayLiteralBeginMatch.length + array[1] + 1
    ]; // jump over }
}
function $662d4edddc8d86b4$var$expectArrayItems(str) {
    var expectedItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var cache = arguments[2];
    var key = void 0;
    var hasStringKeys = false;
    var item = void 0;
    var totalOffset = 0;
    var items = [];
    cache([
        items
    ]);
    for(var i = 0; i < expectedItems; i++){
        key = $662d4edddc8d86b4$var$expectKeyOrIndex(str);
        // this is for backward compatibility with previous implementation
        if (!hasStringKeys) hasStringKeys = typeof key[0] === "string";
        str = str.substr(key[1]);
        totalOffset += key[1];
        // references are resolved immediately, so if duplicate key overwrites previous array index
        // the old value is anyway resolved
        // fixme: but next time the same reference should point to the new value
        item = $662d4edddc8d86b4$var$expectType(str, cache);
        str = str.substr(item[1]);
        totalOffset += item[1];
        items[key[0]] = item[0];
    }
    // this is for backward compatibility with previous implementation
    if (hasStringKeys) items = Object.assign({}, items);
    return [
        items,
        totalOffset
    ];
}
module.exports = function unserialize(str) {
    //       discuss at: https://locutus.io/php/unserialize/
    //      original by: Arpad Ray (mailto:arpad@php.net)
    //      improved by: Pedro Tainha (https://www.pedrotainha.com)
    //      improved by: Kevin van Zonneveld (https://kvz.io)
    //      improved by: Kevin van Zonneveld (https://kvz.io)
    //      improved by: Chris
    //      improved by: James
    //      improved by: Le Torbi
    //      improved by: Eli Skeggs
    //      bugfixed by: dptr1988
    //      bugfixed by: Kevin van Zonneveld (https://kvz.io)
    //      bugfixed by: Brett Zamir (https://brett-zamir.me)
    //      bugfixed by: philippsimon (https://github.com/philippsimon/)
    //       revised by: d3x
    //         input by: Brett Zamir (https://brett-zamir.me)
    //         input by: Martin (https://www.erlenwiese.de/)
    //         input by: kilops
    //         input by: Jaroslaw Czarniak
    //         input by: lovasoa (https://github.com/lovasoa/)
    //      improved by: Rafał Kukawski
    // reimplemented by: Rafał Kukawski
    //           note 1: We feel the main purpose of this function should be
    //           note 1: to ease the transport of data between php & js
    //           note 1: Aiming for PHP-compatibility, we have to translate objects to arrays
    //        example 1: unserialize('a:3:{i:0;s:5:"Kevin";i:1;s:3:"van";i:2;s:9:"Zonneveld";}')
    //        returns 1: ['Kevin', 'van', 'Zonneveld']
    //        example 2: unserialize('a:2:{s:9:"firstName";s:5:"Kevin";s:7:"midName";s:3:"van";}')
    //        returns 2: {firstName: 'Kevin', midName: 'van'}
    //        example 3: unserialize('a:3:{s:2:"ü";s:2:"ü";s:3:"四";s:3:"四";s:4:"𠜎";s:4:"𠜎";}')
    //        returns 3: {'ü': 'ü', '四': '四', '𠜎': '𠜎'}
    //        example 4: unserialize(undefined)
    //        returns 4: false
    //        example 5: unserialize('O:8:"stdClass":1:{s:3:"foo";b:1;}')
    //        returns 5: { foo: true }
    //        example 6: unserialize('a:2:{i:0;N;i:1;s:0:"";}')
    //        returns 6: [null, ""]
    //        example 7: unserialize('S:7:"\\65\\73\\63\\61\\70\\65\\64";')
    //        returns 7: 'escaped'
    try {
        if (typeof str !== "string") return false;
        return $662d4edddc8d86b4$var$expectType(str, $662d4edddc8d86b4$var$initCache())[0];
    } catch (err) {
        console.error(err);
        return false;
    }
};

});

parcelRegister("jVEUG", function(module, exports) {
"use strict";
var $e82313b89bd59139$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

module.exports = function var_dump() {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/var_dump/
    // original by: Brett Zamir (https://brett-zamir.me)
    // improved by: Zahlii
    // improved by: Brett Zamir (https://brett-zamir.me)
    //      note 1: For returning a string, use var_export() with the second argument set to true
    //        test: skip-all
    //   example 1: var_dump(1)
    //   returns 1: 'int(1)'
    var echo = (parcelRequire("6d5Yv"));
    var output = "";
    var padChar = " ";
    var padVal = 4;
    var lgth = 0;
    var i = 0;
    var _getFuncName = function _getFuncName(fn) {
        var name = /\W*function\s+([\w$]+)\s*\(/.exec(fn);
        if (!name) return "(Anonymous)";
        return name[1];
    };
    var _repeatChar = function _repeatChar(len, padChar) {
        var str = "";
        for(var _i = 0; _i < len; _i++)str += padChar;
        return str;
    };
    var _getInnerVal = function _getInnerVal(val, thickPad) {
        var ret = "";
        if (val === null) ret = "NULL";
        else if (typeof val === "boolean") ret = "bool(" + val + ")";
        else if (typeof val === "string") ret = "string(" + val.length + ') "' + val + '"';
        else if (typeof val === "number") {
            if (parseFloat(val) === parseInt(val, 10)) ret = "int(" + val + ")";
            else ret = "float(" + val + ")";
        } else if (typeof val === "undefined") // The remaining are not PHP behavior because these values
        // only exist in this exact form in JavaScript
        ret = "undefined";
        else if (typeof val === "function") {
            var funcLines = val.toString().split("\n");
            ret = "";
            for(var _i2 = 0, fll = funcLines.length; _i2 < fll; _i2++)ret += (_i2 !== 0 ? "\n" + thickPad : "") + funcLines[_i2];
        } else if (val instanceof Date) ret = "Date(" + val + ")";
        else if (val instanceof RegExp) ret = "RegExp(" + val + ")";
        else if (val.nodeName) // Different than PHP's DOMElement
        switch(val.nodeType){
            case 1:
                if (typeof val.namespaceURI === "undefined" || val.namespaceURI === "https://www.w3.org/1999/xhtml") // Undefined namespace could be plain XML, but namespaceURI not widely supported
                ret = 'HTMLElement("' + val.nodeName + '")';
                else ret = 'XML Element("' + val.nodeName + '")';
                break;
            case 2:
                ret = "ATTRIBUTE_NODE(" + val.nodeName + ")";
                break;
            case 3:
                ret = "TEXT_NODE(" + val.nodeValue + ")";
                break;
            case 4:
                ret = "CDATA_SECTION_NODE(" + val.nodeValue + ")";
                break;
            case 5:
                ret = "ENTITY_REFERENCE_NODE";
                break;
            case 6:
                ret = "ENTITY_NODE";
                break;
            case 7:
                ret = "PROCESSING_INSTRUCTION_NODE(" + val.nodeName + ":" + val.nodeValue + ")";
                break;
            case 8:
                ret = "COMMENT_NODE(" + val.nodeValue + ")";
                break;
            case 9:
                ret = "DOCUMENT_NODE";
                break;
            case 10:
                ret = "DOCUMENT_TYPE_NODE";
                break;
            case 11:
                ret = "DOCUMENT_FRAGMENT_NODE";
                break;
            case 12:
                ret = "NOTATION_NODE";
                break;
        }
        return ret;
    };
    var _formatArray = function _formatArray(obj, curDepth, padVal, padChar) {
        if (curDepth > 0) curDepth++;
        var basePad = _repeatChar(padVal * (curDepth - 1), padChar);
        var thickPad = _repeatChar(padVal * (curDepth + 1), padChar);
        var str = "";
        var val = "";
        if ((typeof obj === "undefined" ? "undefined" : $e82313b89bd59139$var$_typeof(obj)) === "object" && obj !== null) {
            if (obj.constructor && _getFuncName(obj.constructor) === "LOCUTUS_Resource") return obj.var_dump();
            lgth = 0;
            for(var someProp in obj)if (obj.hasOwnProperty(someProp)) lgth++;
            str += "array(" + lgth + ") {\n";
            for(var key in obj){
                var objVal = obj[key];
                if ((typeof objVal === "undefined" ? "undefined" : $e82313b89bd59139$var$_typeof(objVal)) === "object" && objVal !== null && !(objVal instanceof Date) && !(objVal instanceof RegExp) && !objVal.nodeName) {
                    str += thickPad;
                    str += "[";
                    str += key;
                    str += "] =>\n";
                    str += thickPad;
                    str += _formatArray(objVal, curDepth + 1, padVal, padChar);
                } else {
                    val = _getInnerVal(objVal, thickPad);
                    str += thickPad;
                    str += "[";
                    str += key;
                    str += "] =>\n";
                    str += thickPad;
                    str += val;
                    str += "\n";
                }
            }
            str += basePad + "}\n";
        } else str = _getInnerVal(obj, thickPad);
        return str;
    };
    output = _formatArray(arguments[0], 0, padVal, padChar);
    for(i = 1; i < arguments.length; i++)output += "\n" + _formatArray(arguments[i], 0, padVal, padChar);
    echo(output);
    // Not how PHP does it, but helps us test:
    return output;
};

});

parcelRegister("3y3zi", function(module, exports) {
"use strict";
var $295750a64b742247$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

module.exports = function var_export(mixedExpression, boolReturn) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/var_export/
    // original by: Philip Peterson
    // improved by: johnrembo
    // improved by: Brett Zamir (https://brett-zamir.me)
    //    input by: Brian Tafoya (https://www.premasolutions.com/)
    //    input by: Hans Henrik (https://hanshenrik.tk/)
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    // bugfixed by: simivar (https://github.com/simivar)
    // bugfixed by: simivar (https://github.com/simivar)
    // bugfixed by: simivar (https://github.com/simivar)
    //   example 1: var_export(null)
    //   returns 1: null
    //   example 2: var_export({0: 'Kevin', 1: 'van', 2: 'Zonneveld'}, true)
    //   returns 2: "array (\n  0 => 'Kevin',\n  1 => 'van',\n  2 => 'Zonneveld',\n)"
    //   example 3: var data = 'Kevin'
    //   example 3: var_export(data, true)
    //   returns 3: "'Kevin'"
    //   example 4: var_export({0: 'Kevin', 1: 'van', 'lastName': 'Zonneveld'}, true)
    //   returns 4: "array (\n  0 => 'Kevin',\n  1 => 'van',\n  'lastName' => 'Zonneveld',\n)"
    //   example 5: var_export([], true)
    //   returns 5: "array (\n)"
    //   example 6: var_export({ test: [ 'a', 'b' ] }, true)
    //   returns 6: "array (\n  'test' =>\n  array (\n    0 => 'a',\n    1 => 'b',\n  ),\n)"
    var echo = (parcelRequire("6d5Yv"));
    var retstr = "";
    var iret = "";
    var value = void 0;
    var cnt = 0;
    var x = [];
    var i = 0;
    var funcParts = [];
    // We use the last argument (not part of PHP) to pass in
    // our indentation level
    var idtLevel = arguments[2] || 2;
    var innerIndent = "";
    var outerIndent = "";
    var getFuncName = function getFuncName(fn) {
        var name = /\W*function\s+([\w$]+)\s*\(/.exec(fn);
        if (!name) return "(Anonymous)";
        return name[1];
    };
    var _isNormalInteger = function _isNormalInteger(string) {
        var number = Math.floor(Number(string));
        return number !== Infinity && String(number) === string && number >= 0;
    };
    var _makeIndent = function _makeIndent(idtLevel) {
        return new Array(idtLevel + 1).join(" ");
    };
    var __getType = function __getType(inp) {
        var i = 0;
        var match = void 0;
        var types = void 0;
        var cons = void 0;
        var type = typeof inp === "undefined" ? "undefined" : $295750a64b742247$var$_typeof(inp);
        if (type === "object" && inp && inp.constructor && getFuncName(inp.constructor) === "LOCUTUS_Resource") return "resource";
        if (type === "function") return "function";
        if (type === "object" && !inp) // Should this be just null?
        return "null";
        if (type === "object") {
            if (!inp.constructor) return "object";
            cons = inp.constructor.toString();
            match = cons.match(/(\w+)\(/);
            if (match) cons = match[1].toLowerCase();
            types = [
                "boolean",
                "number",
                "string",
                "array"
            ];
            for(i = 0; i < types.length; i++)if (cons === types[i]) {
                type = types[i];
                break;
            }
        }
        return type;
    };
    var type = __getType(mixedExpression);
    if (type === null) retstr = "NULL";
    else if (type === "array" || type === "object") {
        outerIndent = _makeIndent(idtLevel - 2);
        innerIndent = _makeIndent(idtLevel);
        for(i in mixedExpression){
            value = " ";
            var subtype = __getType(mixedExpression[i]);
            if (subtype === "array" || subtype === "object") value = "\n";
            value += var_export(mixedExpression[i], 1, idtLevel + 2);
            i = _isNormalInteger(i) ? i : "'" + i + "'";
            x[cnt++] = innerIndent + i + " =>" + value;
        }
        if (x.length > 0) iret = x.join(",\n") + ",\n";
        retstr = outerIndent + "array (\n" + iret + outerIndent + ")";
    } else if (type === "function") {
        funcParts = mixedExpression.toString().match(/function .*?\((.*?)\) \{([\s\S]*)\}/);
        // For lambda functions, var_export() outputs such as the following:
        // '\000lambda_1'. Since it will probably not be a common use to
        // expect this (unhelpful) form, we'll use another PHP-exportable
        // construct, create_function() (though dollar signs must be on the
        // variables in JavaScript); if using instead in JavaScript and you
        // are using the namespaced version, note that create_function() will
        // not be available as a global
        retstr = "create_function ('" + funcParts[1] + "', '" + funcParts[2].replace(/'/g, "\\'") + "')";
    } else if (type === "resource") // Resources treated as null for var_export
    retstr = "NULL";
    else retstr = typeof mixedExpression !== "string" ? mixedExpression : "'" + mixedExpression.replace(/(["'])/g, "\\$1").replace(/\0/g, "\\0") + "'";
    if (!boolReturn) {
        echo(retstr);
        return null;
    }
    return retstr;
};

});


parcelRegister("aP8PO", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");

var $6qkAA = parcelRequire("6qkAA");
var $7e1585337a1acae2$var$VERSION = "3.100.0";

var $7GGVg = parcelRequire("7GGVg");

var $b3ukb = parcelRequire("b3ukb");
/** @module braintree-web/client */ /**
 * @function create
 * @description This function is the entry point for the <code>braintree.client</code> module. It is used for creating {@link Client} instances that service communication to Braintree servers.
 * @param {object} options Object containing all {@link Client} options:
 * @param {string} options.authorization A tokenizationKey or clientToken.
 * @param {callback} [callback] The second argument, <code>data</code>, is the {@link Client} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   if (createErr) {
 *     if (createErr.code === 'CLIENT_AUTHORIZATION_INVALID') {
 *       // either the client token has expired, and a new one should be generated
 *       // or the tokenization key was deactivated or deleted
 *     } else {
 *       console.log('something went wrong creating the client instance', createErr);
 *     }
 *     return;
 *   }
 *
 *  // set up other components
 * });
 * @static
 */ function $7e1585337a1acae2$var$create(options) {
    if (!options.authorization) return Promise.reject(new $dcafC({
        type: $b3ukb.INSTANTIATION_OPTION_REQUIRED.type,
        code: $b3ukb.INSTANTIATION_OPTION_REQUIRED.code,
        message: "options.authorization is required when instantiating a client."
    }));
    return $6qkAA.initialize(options);
}
module.exports = {
    create: $7GGVg($7e1585337a1acae2$var$create),
    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: $7e1585337a1acae2$var$VERSION
};

});
parcelRegister("dcafC", function(module, exports) {
"use strict";

var $7GGem = parcelRequire("7GGem");
/**
 * @class
 * @global
 * @param {object} options Construction options
 * @classdesc This class is used to report error conditions, frequently as the first parameter to callbacks throughout the Braintree SDK.
 * @description <strong>You cannot use this constructor directly. Interact with instances of this class through {@link callback callbacks}.</strong>
 */ function $99b458f39a84c14f$var$BraintreeError(options) {
    if (!$99b458f39a84c14f$var$BraintreeError.types.hasOwnProperty(options.type)) throw new Error(options.type + " is not a valid type.");
    if (!options.code) throw new Error("Error code required.");
    if (!options.message) throw new Error("Error message required.");
    this.name = "BraintreeError";
    /**
   * @type {string}
   * @description A code that corresponds to specific errors.
   */ this.code = options.code;
    /**
   * @type {string}
   * @description A short description of the error.
   */ this.message = options.message;
    /**
   * @type {BraintreeError.types}
   * @description The type of error.
   */ this.type = options.type;
    /**
   * @type {object=}
   * @description Additional information about the error, such as an underlying network error response.
   */ this.details = options.details;
}
$99b458f39a84c14f$var$BraintreeError.prototype = Object.create(Error.prototype);
$99b458f39a84c14f$var$BraintreeError.prototype.constructor = $99b458f39a84c14f$var$BraintreeError;
/**
 * Enum for {@link BraintreeError} types.
 * @name BraintreeError.types
 * @enum
 * @readonly
 * @memberof BraintreeError
 * @property {string} CUSTOMER An error caused by the customer.
 * @property {string} MERCHANT An error that is actionable by the merchant.
 * @property {string} NETWORK An error due to a network problem.
 * @property {string} INTERNAL An error caused by Braintree code.
 * @property {string} UNKNOWN An error where the origin is unknown.
 */ $99b458f39a84c14f$var$BraintreeError.types = $7GGem([
    "CUSTOMER",
    "MERCHANT",
    "NETWORK",
    "INTERNAL",
    "UNKNOWN"
]);
$99b458f39a84c14f$var$BraintreeError.findRootError = function(err) {
    if (err instanceof $99b458f39a84c14f$var$BraintreeError && err.details && err.details.originalError) return $99b458f39a84c14f$var$BraintreeError.findRootError(err.details.originalError);
    return err;
};
module.exports = $99b458f39a84c14f$var$BraintreeError;

});
parcelRegister("7GGem", function(module, exports) {
"use strict";
function $598d36ca4f306d30$var$enumerate(values, prefix) {
    prefix = prefix == null ? "" : prefix;
    return values.reduce(function(enumeration, value) {
        enumeration[value] = prefix + value;
        return enumeration;
    }, {});
}
module.exports = $598d36ca4f306d30$var$enumerate;

});


parcelRegister("6qkAA", function(module, exports) {
"use strict";

var $iArVC = parcelRequire("iArVC");
var $4ad524605fcc959b$require$BRAINTREE_VERSION = $iArVC.BRAINTREE_VERSION;

var $1J6kX = parcelRequire("1J6kX");

var $d9RJ4 = parcelRequire("d9RJ4");

var $9CXDY = parcelRequire("9CXDY");

var $dcafC = parcelRequire("dcafC");

var $45Qfj = parcelRequire("45Qfj");

var $koqZI = parcelRequire("koqZI");
var $4ad524605fcc959b$require$getGatewayConfiguration = $koqZI.getConfiguration;

var $3vts9 = parcelRequire("3vts9");

var $jIdSA = parcelRequire("jIdSA");

var $7GGVg = parcelRequire("7GGVg");

var $3f8Xq = parcelRequire("3f8Xq");

var $fuE0r = parcelRequire("fuE0r");

var $8mxc9 = parcelRequire("8mxc9");
var $4ad524605fcc959b$require$assign = $8mxc9.assign;

var $cIYHN = parcelRequire("cIYHN");

var $0Fx8B = parcelRequire("0Fx8B");

var $3h7RY = parcelRequire("3h7RY");
var $4ad524605fcc959b$require$VERSION = $3h7RY.VERSION;

var $3h7RY = parcelRequire("3h7RY");
var $4ad524605fcc959b$require$GRAPHQL_URLS = $3h7RY.GRAPHQL_URLS;

var $jXxvS = parcelRequire("jXxvS");

var $fbCls = parcelRequire("fbCls");

var $6rXUw = parcelRequire("6rXUw");

var $3h7RY = parcelRequire("3h7RY");
var $4ad524605fcc959b$require$FRAUDNET_FNCLS = $3h7RY.FRAUDNET_FNCLS;

var $3h7RY = parcelRequire("3h7RY");
var $4ad524605fcc959b$require$FRAUDNET_SOURCE = $3h7RY.FRAUDNET_SOURCE;

var $3h7RY = parcelRequire("3h7RY");
var $4ad524605fcc959b$require$FRAUDNET_URL = $3h7RY.FRAUDNET_URL;
var $4ad524605fcc959b$var$cachedClients = {};
/**
 * This object is returned by {@link Client#getConfiguration|getConfiguration}. This information is used extensively by other Braintree modules to properly configure themselves.
 * @typedef {object} Client~configuration
 * @property {object} client The braintree-web/client parameters.
 * @property {string} client.authorization A tokenizationKey or clientToken.
 * @property {object} gatewayConfiguration Gateway-supplied configuration.
 * @property {object} analyticsMetadata Analytics-specific data.
 * @property {string} analyticsMetadata.sessionId Uniquely identifies a browsing session.
 * @property {string} analyticsMetadata.sdkVersion The braintree.js version.
 * @property {string} analyticsMetadata.merchantAppId Identifies the merchant's web app.
 */ /**
 * @class
 * @param {Client~configuration} configuration Options
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/client.create|braintree.client.create} instead.</strong>
 * @classdesc This class is required by many other Braintree components. It serves as the base API layer that communicates with our servers. It is also capable of being used to formulate direct calls to our servers, such as direct credit card tokenization. See {@link Client#request}.
 */ function $4ad524605fcc959b$var$Client(configuration) {
    var configurationJSON, gatewayConfiguration;
    configuration = configuration || {};
    configurationJSON = JSON.stringify(configuration);
    gatewayConfiguration = configuration.gatewayConfiguration;
    if (!gatewayConfiguration) throw new $dcafC($0Fx8B.CLIENT_MISSING_GATEWAY_CONFIGURATION);
    [
        "assetsUrl",
        "clientApiUrl",
        "configUrl"
    ].forEach(function(property) {
        if (property in gatewayConfiguration && !$9CXDY(gatewayConfiguration[property])) throw new $dcafC({
            type: $0Fx8B.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
            code: $0Fx8B.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
            message: property + " property is on an invalid domain."
        });
    });
    /**
   * Returns a copy of the configuration values.
   * @public
   * @returns {Client~configuration} configuration
   */ this.getConfiguration = function() {
        return JSON.parse(configurationJSON);
    };
    this._request = $d9RJ4;
    this._configuration = this.getConfiguration();
    this._clientApiBaseUrl = gatewayConfiguration.clientApiUrl + "/v1/";
    if (gatewayConfiguration.graphQL) {
        if (!$9CXDY(gatewayConfiguration.graphQL.url)) throw new $dcafC({
            type: $0Fx8B.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
            code: $0Fx8B.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
            message: "graphQL.url property is on an invalid domain."
        });
        this._graphQL = new $1J6kX({
            graphQL: gatewayConfiguration.graphQL
        });
    }
}
$4ad524605fcc959b$var$Client.initialize = function(options) {
    var clientInstance, authData;
    var promise = $4ad524605fcc959b$var$cachedClients[options.authorization];
    if (promise) {
        $cIYHN.sendEvent(promise, "custom.client.load.cached");
        return promise;
    }
    try {
        authData = $3vts9(options.authorization);
    } catch (err) {
        return Promise.reject(new $dcafC($0Fx8B.CLIENT_INVALID_AUTHORIZATION));
    }
    promise = $4ad524605fcc959b$require$getGatewayConfiguration(authData).then(function(configuration) {
        if (options.debug) configuration.isDebug = true;
        configuration.authorization = options.authorization;
        clientInstance = new $4ad524605fcc959b$var$Client(configuration);
        return clientInstance;
    });
    $4ad524605fcc959b$var$cachedClients[options.authorization] = promise;
    $cIYHN.sendEvent(promise, "custom.client.load.initialized");
    return promise.then(function(client) {
        $cIYHN.sendEvent(clientInstance, "custom.client.load.succeeded");
        return client;
    }).catch(function(err) {
        delete $4ad524605fcc959b$var$cachedClients[options.authorization];
        return Promise.reject(err);
    });
};
// Primarily used for testing the client initalization call
$4ad524605fcc959b$var$Client.clearCache = function() {
    $4ad524605fcc959b$var$cachedClients = {};
};
$4ad524605fcc959b$var$Client.prototype._findOrCreateFraudnetJSON = function(clientMetadataId) {
    var el = document.querySelector('script[fncls="' + $4ad524605fcc959b$require$FRAUDNET_FNCLS + '"]');
    var config, additionalData, authorizationFingerprint, parameters;
    if (!el) {
        el = document.body.appendChild(document.createElement("script"));
        el.type = "application/json";
        el.setAttribute("fncls", $4ad524605fcc959b$require$FRAUDNET_FNCLS);
    }
    config = this.getConfiguration();
    additionalData = {
        rda_tenant: "bt_card",
        mid: config.gatewayConfiguration.merchantId
    };
    authorizationFingerprint = config.authorizationFingerprint;
    if (authorizationFingerprint) authorizationFingerprint.split("&").forEach(function(pieces) {
        var component = pieces.split("=");
        if (component[0] === "customer_id" && component.length > 1) additionalData.cid = component[1];
    });
    parameters = {
        f: clientMetadataId.substr(0, 32),
        fp: additionalData,
        bu: false,
        s: $4ad524605fcc959b$require$FRAUDNET_SOURCE
    };
    el.text = JSON.stringify(parameters);
};
/**
 * Used by other modules to formulate all network requests to the Braintree gateway. It is also capable of being used directly from your own form to tokenize credit card information. However, be sure to satisfy PCI compliance if you use direct card tokenization.
 * @public
 * @param {object} options Request options:
 * @param {string} options.method HTTP method, e.g. "get" or "post".
 * @param {string} options.endpoint Endpoint path, e.g. "payment_methods".
 * @param {object} options.data Data to send with the request.
 * @param {number} [options.timeout=60000] Set a timeout (in milliseconds) for the request.
 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data.
 * @example
 * <caption>Direct Credit Card Tokenization</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-expiration-date'].value,
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @example
 * <caption>Tokenizing Fields for AVS Checks</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-date'].value,
 *       // The billing address can be checked with AVS rules.
 *       // See: https://articles.braintreepayments.com/support/guides/fraud-tools/basic/avs-cvv-rules
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value,
 *         streetAddress: form['cc-street-address'].value,
 *         countryName: form['cc-country-name'].value,
 *         countryCodeAlpha2: form['cc-country-alpha2'].value,
 *         countryCodeAlpha3: form['cc-country-alpha3'].value,
 *         countryCodeNumeric: form['cc-country-numeric'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $4ad524605fcc959b$var$Client.prototype.request = function(options, callback) {
    var self = this; // eslint-disable-line no-invalid-this
    var requestPromise = new Promise(function(resolve, reject) {
        var optionName, api, baseUrl, requestOptions;
        var shouldCollectData = Boolean(options.endpoint === "payment_methods/credit_cards" && self.getConfiguration().gatewayConfiguration.creditCards.collectDeviceData);
        if (options.api !== "graphQLApi") {
            if (!options.method) optionName = "options.method";
            else if (!options.endpoint) optionName = "options.endpoint";
        }
        if (optionName) throw new $dcafC({
            type: $0Fx8B.CLIENT_OPTION_REQUIRED.type,
            code: $0Fx8B.CLIENT_OPTION_REQUIRED.code,
            message: optionName + " is required when making a request."
        });
        if ("api" in options) api = options.api;
        else api = "clientApi";
        requestOptions = {
            method: options.method,
            graphQL: self._graphQL,
            timeout: options.timeout,
            metadata: self._configuration.analyticsMetadata
        };
        if (api === "clientApi") {
            baseUrl = self._clientApiBaseUrl;
            requestOptions.data = $jIdSA(self._configuration, options.data);
        } else if (api === "graphQLApi") {
            baseUrl = $4ad524605fcc959b$require$GRAPHQL_URLS[self._configuration.gatewayConfiguration.environment];
            options.endpoint = "";
            requestOptions.method = "post";
            requestOptions.data = $4ad524605fcc959b$require$assign({
                clientSdkMetadata: {
                    platform: self._configuration.analyticsMetadata.platform,
                    source: self._configuration.analyticsMetadata.source,
                    integration: self._configuration.analyticsMetadata.integration,
                    sessionId: self._configuration.analyticsMetadata.sessionId,
                    version: $4ad524605fcc959b$require$VERSION
                }
            }, options.data);
            requestOptions.headers = $4ad524605fcc959b$var$getAuthorizationHeadersForGraphQL(self._configuration);
        } else throw new $dcafC({
            type: $0Fx8B.CLIENT_OPTION_INVALID.type,
            code: $0Fx8B.CLIENT_OPTION_INVALID.code,
            message: "options.api is invalid."
        });
        requestOptions.url = baseUrl + options.endpoint;
        requestOptions.sendAnalyticsEvent = function(kind) {
            $cIYHN.sendEvent(self, kind);
        };
        self._request(requestOptions, function(err, data, status) {
            var resolvedData, requestError;
            requestError = $4ad524605fcc959b$var$formatRequestError(status, err);
            if (requestError) {
                reject(requestError);
                return;
            }
            if (api === "graphQLApi" && data.errors) {
                reject($45Qfj(data.errors, {
                    type: $0Fx8B.CLIENT_GRAPHQL_REQUEST_ERROR.type,
                    code: $0Fx8B.CLIENT_GRAPHQL_REQUEST_ERROR.code,
                    message: $0Fx8B.CLIENT_GRAPHQL_REQUEST_ERROR.message
                }));
                return;
            }
            resolvedData = $4ad524605fcc959b$require$assign({
                _httpStatus: status
            }, data);
            if (shouldCollectData && resolvedData.creditCards && resolvedData.creditCards.length > 0) {
                self._findOrCreateFraudnetJSON(resolvedData.creditCards[0].nonce);
                $6rXUw.loadScript({
                    src: $4ad524605fcc959b$require$FRAUDNET_URL,
                    forceScriptReload: true
                });
            }
            resolve(resolvedData);
        });
    });
    if (typeof callback === "function") {
        callback = $3f8Xq($fuE0r(callback));
        requestPromise.then(function(response) {
            callback(null, response, response._httpStatus);
        }).catch(function(err) {
            var status = err && err.details && err.details.httpStatus;
            callback(err, null, status);
        });
        return;
    }
    return requestPromise; // eslint-disable-line consistent-return
};
// eslint-disable-next-line consistent-return
function $4ad524605fcc959b$var$formatRequestError(status, err) {
    var requestError;
    if (status === -1) requestError = new $dcafC($0Fx8B.CLIENT_REQUEST_TIMEOUT);
    else if (status === 401) requestError = new $dcafC($0Fx8B.CLIENT_AUTHORIZATION_INVALID);
    else if (status === 403) requestError = new $dcafC($0Fx8B.CLIENT_AUTHORIZATION_INSUFFICIENT);
    else if (status === 429) requestError = new $dcafC($0Fx8B.CLIENT_RATE_LIMITED);
    else if (status >= 500) requestError = new $dcafC($0Fx8B.CLIENT_GATEWAY_NETWORK);
    else if (status < 200 || status >= 400) requestError = $45Qfj(err, {
        type: $0Fx8B.CLIENT_REQUEST_ERROR.type,
        code: $0Fx8B.CLIENT_REQUEST_ERROR.code,
        message: $0Fx8B.CLIENT_REQUEST_ERROR.message
    });
    if (requestError) {
        requestError.details = requestError.details || {};
        requestError.details.httpStatus = status;
        return requestError;
    }
}
$4ad524605fcc959b$var$Client.prototype.toJSON = function() {
    return this.getConfiguration();
};
/**
 * Returns the Client version.
 * @public
 * @returns {String} The created client's version.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   console.log(clientInstance.getVersion()); // Ex: 1.0.0
 * });
 * @returns {void}
 */ $4ad524605fcc959b$var$Client.prototype.getVersion = function() {
    return $4ad524605fcc959b$require$VERSION;
};
/**
 * Cleanly tear down anything set up by {@link module:braintree-web/client.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * clientInstance.teardown();
 * @example <caption>With callback</caption>
 * clientInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $4ad524605fcc959b$var$Client.prototype.teardown = $7GGVg(function() {
    var self = this; // eslint-disable-line no-invalid-this
    delete $4ad524605fcc959b$var$cachedClients[self.getConfiguration().authorization];
    $fbCls(self, $jXxvS($4ad524605fcc959b$var$Client.prototype));
    return Promise.resolve();
});
function $4ad524605fcc959b$var$getAuthorizationHeadersForGraphQL(configuration) {
    var token = configuration.authorizationFingerprint || configuration.authorization;
    return {
        Authorization: "Bearer " + token,
        "Braintree-Version": $4ad524605fcc959b$require$BRAINTREE_VERSION
    };
}
module.exports = $4ad524605fcc959b$var$Client;

});
parcelRegister("iArVC", function(module, exports) {
"use strict";
module.exports = {
    BRAINTREE_VERSION: "2018-05-10"
};

});

parcelRegister("1J6kX", function(module, exports) {
"use strict";
var $141ee8d2675bef26$var$features = {
    tokenize_credit_cards: "payment_methods/credit_cards",
    configuration: "configuration"
};
var $141ee8d2675bef26$var$disallowedInputPaths = [
    "creditCard.options.unionPayEnrollment"
];
function $141ee8d2675bef26$var$GraphQL(config) {
    this._config = config.graphQL;
}
$141ee8d2675bef26$var$GraphQL.prototype.getGraphQLEndpoint = function() {
    return this._config.url;
};
$141ee8d2675bef26$var$GraphQL.prototype.isGraphQLRequest = function(url, body) {
    var featureEnabled;
    var path = this.getClientApiPath(url);
    if (!this._isGraphQLEnabled() || !path) return false;
    featureEnabled = this._config.features.some(function(feature) {
        return $141ee8d2675bef26$var$features[feature] === path;
    });
    if ($141ee8d2675bef26$var$containsDisallowedlistedKeys(body)) return false;
    return featureEnabled;
};
$141ee8d2675bef26$var$GraphQL.prototype.getClientApiPath = function(url) {
    var path;
    var clientApiPrefix = "/client_api/v1/";
    var pathParts = url.split(clientApiPrefix);
    if (pathParts.length > 1) path = pathParts[1].split("?")[0];
    return path;
};
$141ee8d2675bef26$var$GraphQL.prototype._isGraphQLEnabled = function() {
    return Boolean(this._config);
};
function $141ee8d2675bef26$var$containsDisallowedlistedKeys(body) {
    return $141ee8d2675bef26$var$disallowedInputPaths.some(function(keys) {
        var value = keys.split(".").reduce(function(accumulator, key) {
            return accumulator && accumulator[key];
        }, body);
        return value !== undefined; // eslint-disable-line no-undefined
    });
}
module.exports = $141ee8d2675bef26$var$GraphQL;

});

parcelRegister("d9RJ4", function(module, exports) {
"use strict";

var $3f8Xq = parcelRequire("3f8Xq");

var $iR7D9 = parcelRequire("iR7D9");
module.exports = function(options, cb) {
    cb = $3f8Xq(cb || Function.prototype);
    options.method = (options.method || "GET").toUpperCase();
    options.timeout = options.timeout == null ? 60000 : options.timeout;
    options.data = options.data || {};
    $iR7D9.request(options, cb);
};

});
parcelRegister("3f8Xq", function(module, exports) {
"use strict";
function $25c9b8917b027995$var$once(fn) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            fn.apply(null, arguments);
        }
    };
}
module.exports = $25c9b8917b027995$var$once;

});

parcelRegister("iR7D9", function(module, exports) {
"use strict";

var $2rlYa = parcelRequire("2rlYa");

var $8mxc9 = parcelRequire("8mxc9");
var $dba3187b0be4ae0d$require$assign = $8mxc9.assign;

var $8VUtv = parcelRequire("8VUtv");

var $a0iBk = parcelRequire("a0iBk");

var $gJFku = parcelRequire("gJFku");
var $dba3187b0be4ae0d$var$isXHRAvailable = $gJFku.isAvailable;

var $8s09P = parcelRequire("8s09P");

var $0sTUe = parcelRequire("0sTUe");
var $dba3187b0be4ae0d$var$MAX_TCP_RETRYCOUNT = 1;
var $dba3187b0be4ae0d$var$TCP_PRECONNECT_BUG_STATUS_CODE = 408;
function $dba3187b0be4ae0d$var$requestShouldRetry(status) {
    return !status || status === $dba3187b0be4ae0d$var$TCP_PRECONNECT_BUG_STATUS_CODE;
}
function $dba3187b0be4ae0d$var$graphQLRequestShouldRetryWithClientApi(body) {
    var errorClass = !body.data && body.errors && body.errors[0] && body.errors[0].extensions && body.errors[0].extensions.errorClass;
    return errorClass === "UNKNOWN" || errorClass === "INTERNAL";
}
function $dba3187b0be4ae0d$var$_requestWithRetry(options, tcpRetryCount, cb) {
    var status, resBody, ajaxRequest, body, method, headers, parsedBody;
    var url = options.url;
    var graphQL = options.graphQL;
    var timeout = options.timeout;
    var req = $gJFku.getRequestObject();
    var callback = cb;
    var isGraphQLRequest = Boolean(graphQL && graphQL.isGraphQLRequest(url, options.data));
    options.headers = $dba3187b0be4ae0d$require$assign({
        "Content-Type": "application/json"
    }, options.headers);
    if (isGraphQLRequest) ajaxRequest = new $8s09P(options);
    else ajaxRequest = new $0sTUe(options);
    url = ajaxRequest.getUrl();
    body = ajaxRequest.getBody();
    method = ajaxRequest.getMethod();
    headers = ajaxRequest.getHeaders();
    if (method === "GET") {
        url = $2rlYa.queryify(url, body);
        body = null;
    }
    if ($dba3187b0be4ae0d$var$isXHRAvailable) req.onreadystatechange = function() {
        if (req.readyState !== 4) return;
        if (req.status === 0 && isGraphQLRequest) {
            // If a merchant experiences a connection
            // issue to the GraphQL endpoint (possibly
            // due to a Content Security Policy), retry
            // the request against the old client API.
            delete options.graphQL;
            $dba3187b0be4ae0d$var$_requestWithRetry(options, tcpRetryCount, cb);
            return;
        }
        parsedBody = $a0iBk(req.responseText);
        resBody = ajaxRequest.adaptResponseBody(parsedBody);
        status = ajaxRequest.determineStatus(req.status, parsedBody);
        if (status >= 400 || status < 200) {
            if (isGraphQLRequest && $dba3187b0be4ae0d$var$graphQLRequestShouldRetryWithClientApi(parsedBody)) {
                delete options.graphQL;
                $dba3187b0be4ae0d$var$_requestWithRetry(options, tcpRetryCount, cb);
                return;
            }
            if (tcpRetryCount < $dba3187b0be4ae0d$var$MAX_TCP_RETRYCOUNT && $dba3187b0be4ae0d$var$requestShouldRetry(status)) {
                tcpRetryCount++;
                $dba3187b0be4ae0d$var$_requestWithRetry(options, tcpRetryCount, cb);
                return;
            }
            callback(resBody || "error", null, status || 500);
        } else callback(null, resBody, status);
    };
    else {
        if (options.headers) url = $2rlYa.queryify(url, headers);
        req.onload = function() {
            callback(null, $a0iBk(req.responseText), req.status);
        };
        req.onerror = function() {
            // XDomainRequest does not report a body or status for errors, so
            // hardcode to 'error' and 500, respectively
            callback("error", null, 500);
        };
        // This must remain for IE9 to work
        req.onprogress = function() {};
        req.ontimeout = function() {
            callback("timeout", null, -1);
        };
    }
    try {
        req.open(method, url, true);
    } catch (requestOpenError) {
        // If a merchant has a Content Security Policy and they have
        // not allowed our endpoints, some browsers may
        // synchronously throw an error. If it is not a GraphQL
        // request, we throw the error. If it is a GraphQL request
        // we remove the GraphQL option and try the request against
        // the old client API.
        if (!isGraphQLRequest) throw requestOpenError;
        delete options.graphQL;
        $dba3187b0be4ae0d$var$_requestWithRetry(options, tcpRetryCount, cb);
        return;
    }
    req.timeout = timeout;
    if ($dba3187b0be4ae0d$var$isXHRAvailable) Object.keys(headers).forEach(function(headerKey) {
        req.setRequestHeader(headerKey, headers[headerKey]);
    });
    try {
        req.send($8VUtv(method, body));
    } catch (e) {
    /* ignored */ }
}
function $dba3187b0be4ae0d$var$request(options, cb) {
    $dba3187b0be4ae0d$var$_requestWithRetry(options, 0, cb);
}
module.exports = {
    request: $dba3187b0be4ae0d$var$request
};

});
parcelRegister("2rlYa", function(module, exports) {
"use strict";
function $1c6f250a4b4e2c16$var$_notEmpty(obj) {
    var key;
    for(key in obj){
        if (obj.hasOwnProperty(key)) return true;
    }
    return false;
}
/* eslint-disable no-mixed-operators */ function $1c6f250a4b4e2c16$var$_isArray(value) {
    return value && typeof value === "object" && typeof value.length === "number" && Object.prototype.toString.call(value) === "[object Array]" || false;
}
/* eslint-enable no-mixed-operators */ function $1c6f250a4b4e2c16$var$hasQueryParams(url) {
    url = url || window.location.href;
    return /\?/.test(url);
}
function $1c6f250a4b4e2c16$var$parse(url) {
    var query, params;
    url = url || window.location.href;
    if (!$1c6f250a4b4e2c16$var$hasQueryParams(url)) return {};
    query = url.split("?")[1] || "";
    query = query.replace(/#.*$/, "").split("&");
    params = query.reduce(function(toReturn, keyValue) {
        var parts = keyValue.split("=");
        var key = decodeURIComponent(parts[0]);
        var value = decodeURIComponent(parts[1]);
        toReturn[key] = value;
        return toReturn;
    }, {});
    return params;
}
function $1c6f250a4b4e2c16$var$stringify(params, namespace) {
    var k, v, p;
    var query = [];
    for(p in params){
        if (!params.hasOwnProperty(p)) continue;
        v = params[p];
        if (namespace) {
            if ($1c6f250a4b4e2c16$var$_isArray(params)) k = namespace + "[]";
            else k = namespace + "[" + p + "]";
        } else k = p;
        if (typeof v === "object") query.push($1c6f250a4b4e2c16$var$stringify(v, k));
        else query.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
    return query.join("&");
}
function $1c6f250a4b4e2c16$var$queryify(url, params) {
    url = url || "";
    if (params != null && typeof params === "object" && $1c6f250a4b4e2c16$var$_notEmpty(params)) {
        url += url.indexOf("?") === -1 ? "?" : "";
        url += url.indexOf("=") !== -1 ? "&" : "";
        url += $1c6f250a4b4e2c16$var$stringify(params);
    }
    return url;
}
module.exports = {
    parse: $1c6f250a4b4e2c16$var$parse,
    stringify: $1c6f250a4b4e2c16$var$stringify,
    queryify: $1c6f250a4b4e2c16$var$queryify,
    hasQueryParams: $1c6f250a4b4e2c16$var$hasQueryParams
};

});

parcelRegister("8mxc9", function(module, exports) {
"use strict";
var $616a20a6b7a72087$var$assignNormalized = typeof Object.assign === "function" ? Object.assign : $616a20a6b7a72087$var$assignPolyfill;
function $616a20a6b7a72087$var$assignPolyfill(destination) {
    var i, source, key;
    for(i = 1; i < arguments.length; i++){
        source = arguments[i];
        for(key in source)if (source.hasOwnProperty(key)) destination[key] = source[key];
    }
    return destination;
}
module.exports = {
    assign: $616a20a6b7a72087$var$assignNormalized,
    _assign: $616a20a6b7a72087$var$assignPolyfill
};

});

parcelRegister("8VUtv", function(module, exports) {
"use strict";
module.exports = function(method, body) {
    if (typeof method !== "string") throw new Error("Method must be a string");
    if (method.toLowerCase() !== "get" && body != null) body = typeof body === "string" ? body : JSON.stringify(body);
    return body;
};

});

parcelRegister("a0iBk", function(module, exports) {
"use strict";
module.exports = function(body) {
    try {
        body = JSON.parse(body);
    } catch (e) {
    /* ignored */ }
    return body;
};

});

parcelRegister("gJFku", function(module, exports) {
"use strict";
var $c2f0e875eeb75688$var$isXHRAvailable = typeof window !== "undefined" && window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest();
function $c2f0e875eeb75688$var$getRequestObject() {
    return $c2f0e875eeb75688$var$isXHRAvailable ? new window.XMLHttpRequest() : new window.XDomainRequest();
}
module.exports = {
    isAvailable: $c2f0e875eeb75688$var$isXHRAvailable,
    getRequestObject: $c2f0e875eeb75688$var$getRequestObject
};

});

parcelRegister("8s09P", function(module, exports) {
"use strict";

var $iArVC = parcelRequire("iArVC");
var $62710f844fd27def$require$BRAINTREE_VERSION = $iArVC.BRAINTREE_VERSION;

var $8mxc9 = parcelRequire("8mxc9");
var $62710f844fd27def$require$assign = $8mxc9.assign;

var $3xv0O = parcelRequire("3xv0O");

var $jzwFi = parcelRequire("jzwFi");

var $cKAcc = parcelRequire("cKAcc");

var $gz4EW = parcelRequire("gz4EW");

var $h46NU = parcelRequire("h46NU");
var $62710f844fd27def$var$generators = {
    "payment_methods/credit_cards": $jzwFi,
    configuration: $gz4EW
};
var $62710f844fd27def$var$adapters = {
    "payment_methods/credit_cards": $cKAcc,
    configuration: $h46NU
};
function $62710f844fd27def$var$GraphQLRequest(options) {
    var clientApiPath = options.graphQL.getClientApiPath(options.url);
    this._graphQL = options.graphQL;
    this._data = options.data;
    this._method = options.method;
    this._headers = options.headers;
    this._clientSdkMetadata = {
        source: options.metadata.source,
        integration: options.metadata.integration,
        sessionId: options.metadata.sessionId
    };
    this._sendAnalyticsEvent = options.sendAnalyticsEvent || Function.prototype;
    this._generator = $62710f844fd27def$var$generators[clientApiPath];
    this._adapter = $62710f844fd27def$var$adapters[clientApiPath];
    this._sendAnalyticsEvent("graphql.init");
}
$62710f844fd27def$var$GraphQLRequest.prototype.getUrl = function() {
    return this._graphQL.getGraphQLEndpoint();
};
$62710f844fd27def$var$GraphQLRequest.prototype.getBody = function() {
    var formattedBody = $62710f844fd27def$var$formatBodyKeys(this._data);
    var generatedBody = this._generator(formattedBody);
    var body = $62710f844fd27def$require$assign({
        clientSdkMetadata: this._clientSdkMetadata
    }, generatedBody);
    return JSON.stringify(body);
};
$62710f844fd27def$var$GraphQLRequest.prototype.getMethod = function() {
    return "POST";
};
$62710f844fd27def$var$GraphQLRequest.prototype.getHeaders = function() {
    var authorization, headers;
    if (this._data.authorizationFingerprint) {
        this._sendAnalyticsEvent("graphql.authorization-fingerprint");
        authorization = this._data.authorizationFingerprint;
    } else {
        this._sendAnalyticsEvent("graphql.tokenization-key");
        authorization = this._data.tokenizationKey;
    }
    headers = {
        Authorization: "Bearer " + authorization,
        "Braintree-Version": $62710f844fd27def$require$BRAINTREE_VERSION
    };
    return $62710f844fd27def$require$assign({}, this._headers, headers);
};
$62710f844fd27def$var$GraphQLRequest.prototype.adaptResponseBody = function(parsedBody) {
    return this._adapter(parsedBody, this);
};
$62710f844fd27def$var$GraphQLRequest.prototype.determineStatus = function(httpStatus, parsedResponse) {
    var status, errorClass;
    if (httpStatus === 200) {
        errorClass = parsedResponse.errors && parsedResponse.errors[0] && parsedResponse.errors[0].extensions && parsedResponse.errors[0].extensions.errorClass;
        if (parsedResponse.data && !parsedResponse.errors) status = 200;
        else if (errorClass === "VALIDATION") status = 422;
        else if (errorClass === "AUTHORIZATION") status = 403;
        else if (errorClass === "AUTHENTICATION") status = 401;
        else if ($62710f844fd27def$var$isGraphQLError(errorClass, parsedResponse)) status = 403;
        else status = 500;
    } else if (!httpStatus) status = 500;
    else status = httpStatus;
    this._sendAnalyticsEvent("graphql.status." + httpStatus);
    this._sendAnalyticsEvent("graphql.determinedStatus." + status);
    return status;
};
function $62710f844fd27def$var$isGraphQLError(errorClass, parsedResponse) {
    return !errorClass && parsedResponse.errors[0].message;
}
function $62710f844fd27def$var$formatBodyKeys(originalBody) {
    var body = {};
    Object.keys(originalBody).forEach(function(key) {
        var camelCaseKey = $3xv0O(key);
        if (typeof originalBody[key] === "object") body[camelCaseKey] = $62710f844fd27def$var$formatBodyKeys(originalBody[key]);
        else if (typeof originalBody[key] === "number") body[camelCaseKey] = String(originalBody[key]);
        else body[camelCaseKey] = originalBody[key];
    });
    return body;
}
module.exports = $62710f844fd27def$var$GraphQLRequest;

});
parcelRegister("3xv0O", function(module, exports) {
"use strict";
module.exports = function(snakeString) {
    if (snakeString.indexOf("_") === -1) return snakeString;
    return snakeString.toLowerCase().replace(/(\_\w)/g, function(match) {
        return match[1].toUpperCase();
    });
};

});

parcelRegister("jzwFi", function(module, exports) {
"use strict";

var $8mxc9 = parcelRequire("8mxc9");
var $e3fa9fd285579631$require$assign = $8mxc9.assign;
function $e3fa9fd285579631$var$createMutation(config) {
    var hasAuthenticationInsight = config.hasAuthenticationInsight;
    var mutation = "mutation TokenizeCreditCard($input: TokenizeCreditCardInput!";
    if (hasAuthenticationInsight) mutation += ", $authenticationInsightInput: AuthenticationInsightInput!";
    mutation += ") {   tokenizeCreditCard(input: $input) {     token     creditCard {       bin       brandCode       last4       cardholderName       expirationMonth      expirationYear      binData {         prepaid         healthcare         debit         durbinRegulated         commercial         payroll         issuingBank         countryOfIssuance         productId       }     } ";
    if (hasAuthenticationInsight) mutation += "    authenticationInsight(input: $authenticationInsightInput) {      customerAuthenticationRegulationEnvironment    }";
    mutation += "  } }";
    return mutation;
}
function $e3fa9fd285579631$var$createCreditCardTokenizationBody(body, options) {
    var cc = body.creditCard;
    var billingAddress = cc && cc.billingAddress;
    var expDate = cc && cc.expirationDate;
    var expirationMonth = cc && (cc.expirationMonth || expDate && expDate.split("/")[0].trim());
    var expirationYear = cc && (cc.expirationYear || expDate && expDate.split("/")[1].trim());
    var variables = {
        input: {
            creditCard: {
                number: cc && cc.number,
                expirationMonth: expirationMonth,
                expirationYear: expirationYear,
                cvv: cc && cc.cvv,
                cardholderName: cc && cc.cardholderName
            },
            options: {}
        }
    };
    if (options.hasAuthenticationInsight) variables.authenticationInsightInput = {
        merchantAccountId: body.merchantAccountId
    };
    if (billingAddress) variables.input.creditCard.billingAddress = billingAddress;
    variables.input = $e3fa9fd285579631$var$addValidationRule(body, variables.input);
    return variables;
}
function $e3fa9fd285579631$var$addValidationRule(body, input) {
    var validate;
    if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === "boolean") validate = body.creditCard.options.validate;
    else if (body.authorizationFingerprint && body.tokenizationKey || body.authorizationFingerprint) validate = true;
    else if (body.tokenizationKey) validate = false;
    if (typeof validate === "boolean") input.options = $e3fa9fd285579631$require$assign({
        validate: validate
    }, input.options);
    return input;
}
function $e3fa9fd285579631$var$creditCardTokenization(body) {
    var options = {
        hasAuthenticationInsight: Boolean(body.authenticationInsight && body.merchantAccountId)
    };
    return {
        query: $e3fa9fd285579631$var$createMutation(options),
        variables: $e3fa9fd285579631$var$createCreditCardTokenizationBody(body, options),
        operationName: "TokenizeCreditCard"
    };
}
module.exports = $e3fa9fd285579631$var$creditCardTokenization;

});

parcelRegister("cKAcc", function(module, exports) {
"use strict";

var $7Z1u7 = parcelRequire("7Z1u7");
var $9485dba33d57e7f6$var$CARD_BRAND_MAP = {
    /* eslint-disable camelcase */ AMERICAN_EXPRESS: "American Express",
    DINERS: "Discover",
    DISCOVER: "Discover",
    ELO: "Elo",
    HIPER: "Hiper",
    HIPERCARD: "Hipercard",
    INTERNATIONAL_MAESTRO: "Maestro",
    JCB: "JCB",
    MASTERCARD: "MasterCard",
    UK_MAESTRO: "Maestro",
    UNION_PAY: "UnionPay",
    VISA: "Visa"
};
var $9485dba33d57e7f6$var$BIN_DATA_MAP = {
    YES: "Yes",
    NO: "No",
    UNKNOWN: "Unknown"
};
var $9485dba33d57e7f6$var$AUTHENTICATION_INSIGHT_MAP = {
    PSDTWO: "psd2"
};
function $9485dba33d57e7f6$var$creditCardTokenizationResponseAdapter(responseBody) {
    var adaptedResponse;
    if (responseBody.data && !responseBody.errors) adaptedResponse = $9485dba33d57e7f6$var$adaptTokenizeCreditCardResponseBody(responseBody);
    else adaptedResponse = $7Z1u7(responseBody);
    return adaptedResponse;
}
function $9485dba33d57e7f6$var$adaptTokenizeCreditCardResponseBody(body) {
    var data = body.data.tokenizeCreditCard;
    var creditCard = data.creditCard;
    var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : "";
    var binData = creditCard.binData;
    var response, regulationEnvironment;
    if (binData) {
        [
            "commercial",
            "debit",
            "durbinRegulated",
            "healthcare",
            "payroll",
            "prepaid"
        ].forEach(function(key) {
            if (binData[key]) binData[key] = $9485dba33d57e7f6$var$BIN_DATA_MAP[binData[key]];
            else binData[key] = "Unknown";
        });
        [
            "issuingBank",
            "countryOfIssuance",
            "productId"
        ].forEach(function(key) {
            if (!binData[key]) binData[key] = "Unknown";
        });
    }
    response = {
        creditCards: [
            {
                binData: binData,
                consumed: false,
                description: lastTwo ? "ending in " + lastTwo : "",
                nonce: data.token,
                details: {
                    cardholderName: creditCard.cardholderName,
                    expirationMonth: creditCard.expirationMonth,
                    expirationYear: creditCard.expirationYear,
                    bin: creditCard.bin || "",
                    cardType: $9485dba33d57e7f6$var$CARD_BRAND_MAP[creditCard.brandCode] || "Unknown",
                    lastFour: creditCard.last4 || "",
                    lastTwo: lastTwo
                },
                type: "CreditCard",
                threeDSecureInfo: null
            }
        ]
    };
    if (data.authenticationInsight) {
        regulationEnvironment = data.authenticationInsight.customerAuthenticationRegulationEnvironment;
        response.creditCards[0].authenticationInsight = {
            regulationEnvironment: $9485dba33d57e7f6$var$AUTHENTICATION_INSIGHT_MAP[regulationEnvironment] || regulationEnvironment.toLowerCase()
        };
    }
    return response;
}
module.exports = $9485dba33d57e7f6$var$creditCardTokenizationResponseAdapter;

});
parcelRegister("7Z1u7", function(module, exports) {
"use strict";
function $5cff61bb51440d84$var$errorResponseAdapter(responseBody) {
    var response;
    var errorClass = responseBody.errors && responseBody.errors[0] && responseBody.errors[0].extensions && responseBody.errors[0].extensions.errorClass;
    if (errorClass === "VALIDATION") response = $5cff61bb51440d84$var$userErrorResponseAdapter(responseBody);
    else if (errorClass) response = $5cff61bb51440d84$var$errorWithClassResponseAdapter(responseBody);
    else response = {
        error: {
            message: "There was a problem serving your request"
        },
        fieldErrors: []
    };
    return response;
}
function $5cff61bb51440d84$var$errorWithClassResponseAdapter(responseBody) {
    return {
        error: {
            message: responseBody.errors[0].message
        },
        fieldErrors: []
    };
}
function $5cff61bb51440d84$var$userErrorResponseAdapter(responseBody) {
    var fieldErrors = $5cff61bb51440d84$var$buildFieldErrors(responseBody.errors);
    if (fieldErrors.length === 0) return {
        error: {
            message: responseBody.errors[0].message
        }
    };
    return {
        error: {
            message: $5cff61bb51440d84$var$getLegacyMessage(fieldErrors)
        },
        fieldErrors: fieldErrors
    };
}
function $5cff61bb51440d84$var$buildFieldErrors(errors) {
    var fieldErrors = [];
    errors.forEach(function(error) {
        if (!(error.extensions && error.extensions.inputPath)) return;
        $5cff61bb51440d84$var$addFieldError(error.extensions.inputPath.slice(1), error, fieldErrors);
    });
    return fieldErrors;
}
function $5cff61bb51440d84$var$addFieldError(inputPath, errorDetail, fieldErrors) {
    var fieldError;
    var legacyCode = errorDetail.extensions.legacyCode;
    var inputField = inputPath[0];
    if (inputPath.length === 1) {
        fieldErrors.push({
            code: legacyCode,
            field: inputField,
            message: errorDetail.message
        });
        return;
    }
    fieldErrors.forEach(function(candidate) {
        if (candidate.field === inputField) fieldError = candidate;
    });
    if (!fieldError) {
        fieldError = {
            field: inputField,
            fieldErrors: []
        };
        fieldErrors.push(fieldError);
    }
    $5cff61bb51440d84$var$addFieldError(inputPath.slice(1), errorDetail, fieldError.fieldErrors);
}
function $5cff61bb51440d84$var$getLegacyMessage(errors) {
    var legacyMessages = {
        creditCard: "Credit card is invalid"
    };
    var field = errors[0].field;
    return legacyMessages[field];
}
module.exports = $5cff61bb51440d84$var$errorResponseAdapter;

});


parcelRegister("gz4EW", function(module, exports) {
"use strict";
var $c0f38779016d3ba9$var$CONFIGURATION_QUERY = "query ClientConfiguration {   clientConfiguration {     analyticsUrl     environment     merchantId     assetsUrl     clientApiUrl     creditCard {       supportedCardBrands       challenges       threeDSecureEnabled       threeDSecure {         cardinalAuthenticationJWT       }     }     applePayWeb {       countryCode       currencyCode       merchantIdentifier       supportedCardBrands     }     googlePay {       displayName       supportedCardBrands       environment       googleAuthorization       paypalClientId     }     ideal {       routeId       assetsUrl     }     kount {       merchantId     }     masterpass {       merchantCheckoutId       supportedCardBrands     }     paypal {       displayName       clientId       assetsUrl       environment       environmentNoNetwork       unvettedMerchant       braintreeClientId       billingAgreementsEnabled       merchantAccountId       currencyCode       payeeEmail     }     unionPay {       merchantAccountId     }     usBankAccount {       routeId       plaidPublicKey     }     venmo {       merchantId       accessToken       environment       enrichedCustomerDataEnabled    }     visaCheckout {       apiKey       externalClientId       supportedCardBrands     }     braintreeApi {       accessToken       url     }     supportedFeatures   } }";
function $c0f38779016d3ba9$var$configuration() {
    return {
        query: $c0f38779016d3ba9$var$CONFIGURATION_QUERY,
        operationName: "ClientConfiguration"
    };
}
module.exports = $c0f38779016d3ba9$var$configuration;

});

parcelRegister("h46NU", function(module, exports) {
"use strict";

var $7Z1u7 = parcelRequire("7Z1u7");

var $8mxc9 = parcelRequire("8mxc9");
var $c6c8167ea946ab25$require$assign = $8mxc9.assign;
/* eslint-disable camelcase */ var $c6c8167ea946ab25$var$cardTypeTransforms = {
    creditCard: {
        AMERICAN_EXPRESS: "American Express",
        DISCOVER: "Discover",
        INTERNATIONAL_MAESTRO: "Maestro",
        JCB: "JCB",
        MASTERCARD: "MasterCard",
        SOLO: "Solo",
        UK_MAESTRO: "UK Maestro",
        UNION_PAY: "UnionPay",
        VISA: "Visa",
        ELO: "Elo",
        HIPER: "Hiper",
        HIPERCARD: "Hipercard"
    },
    applePayWeb: {
        VISA: "visa",
        MASTERCARD: "mastercard",
        DISCOVER: "discover",
        AMERICAN_EXPRESS: "amex",
        INTERNATIONAL_MAESTRO: "maestro",
        ELO: "elo"
    },
    visaCheckout: {
        VISA: "Visa",
        MASTERCARD: "MasterCard",
        DISCOVER: "Discover",
        AMERICAN_EXPRESS: "American Express"
    },
    googlePay: {
        VISA: "visa",
        MASTERCARD: "mastercard",
        DISCOVER: "discover",
        AMERICAN_EXPRESS: "amex",
        INTERNATIONAL_MAESTRO: "maestro",
        ELO: "elo"
    },
    masterpass: {
        VISA: "visa",
        MASTERCARD: "master",
        DISCOVER: "discover",
        AMERICAN_EXPRESS: "amex",
        DINERS: "diners",
        INTERNATIONAL_MAESTRO: "maestro",
        JCB: "jcb"
    }
};
/* eslint-enable camelcase */ function $c6c8167ea946ab25$var$configurationResponseAdapter(responseBody, ctx) {
    var adaptedResponse;
    if (responseBody.data && !responseBody.errors) adaptedResponse = $c6c8167ea946ab25$var$adaptConfigurationResponseBody(responseBody, ctx);
    else adaptedResponse = $7Z1u7(responseBody);
    return adaptedResponse;
}
function $c6c8167ea946ab25$var$adaptConfigurationResponseBody(body, ctx) {
    var configuration = body.data.clientConfiguration;
    var response;
    response = {
        environment: configuration.environment.toLowerCase(),
        clientApiUrl: configuration.clientApiUrl,
        assetsUrl: configuration.assetsUrl,
        analytics: {
            url: configuration.analyticsUrl
        },
        merchantId: configuration.merchantId,
        venmo: "off"
    };
    if (configuration.supportedFeatures) response.graphQL = {
        url: ctx._graphQL._config.url,
        features: configuration.supportedFeatures.map(function(feature) {
            return feature.toLowerCase();
        })
    };
    if (configuration.braintreeApi) response.braintreeApi = configuration.braintreeApi;
    if (configuration.applePayWeb) {
        response.applePayWeb = configuration.applePayWeb;
        response.applePayWeb.supportedNetworks = $c6c8167ea946ab25$var$mapCardTypes(configuration.applePayWeb.supportedCardBrands, $c6c8167ea946ab25$var$cardTypeTransforms.applePayWeb);
        delete response.applePayWeb.supportedCardBrands;
    }
    if (configuration.ideal) response.ideal = configuration.ideal;
    if (configuration.kount) response.kount = {
        kountMerchantId: configuration.kount.merchantId
    };
    if (configuration.creditCard) {
        response.challenges = configuration.creditCard.challenges.map(function(challenge) {
            return challenge.toLowerCase();
        });
        response.creditCards = {
            supportedCardTypes: $c6c8167ea946ab25$var$mapCardTypes(configuration.creditCard.supportedCardBrands, $c6c8167ea946ab25$var$cardTypeTransforms.creditCard)
        };
        response.threeDSecureEnabled = configuration.creditCard.threeDSecureEnabled;
        response.threeDSecure = configuration.creditCard.threeDSecure;
    } else {
        response.challenges = [];
        response.creditCards = {
            supportedCardTypes: []
        };
        response.threeDSecureEnabled = false;
    }
    if (configuration.googlePay) response.androidPay = {
        displayName: configuration.googlePay.displayName,
        enabled: true,
        environment: configuration.googlePay.environment.toLowerCase(),
        googleAuthorizationFingerprint: configuration.googlePay.googleAuthorization,
        paypalClientId: configuration.googlePay.paypalClientId,
        supportedNetworks: $c6c8167ea946ab25$var$mapCardTypes(configuration.googlePay.supportedCardBrands, $c6c8167ea946ab25$var$cardTypeTransforms.googlePay)
    };
    if (configuration.venmo) response.payWithVenmo = {
        merchantId: configuration.venmo.merchantId,
        accessToken: configuration.venmo.accessToken,
        environment: configuration.venmo.environment.toLowerCase(),
        enrichedCustomerDataEnabled: configuration.venmo.enrichedCustomerDataEnabled
    };
    if (configuration.paypal) {
        response.paypalEnabled = true;
        response.paypal = $c6c8167ea946ab25$require$assign({}, configuration.paypal);
        response.paypal.currencyIsoCode = response.paypal.currencyCode;
        response.paypal.environment = response.paypal.environment.toLowerCase();
        delete response.paypal.currencyCode;
    } else response.paypalEnabled = false;
    if (configuration.unionPay) response.unionPay = {
        enabled: true,
        merchantAccountId: configuration.unionPay.merchantAccountId
    };
    if (configuration.visaCheckout) response.visaCheckout = {
        apikey: configuration.visaCheckout.apiKey,
        encryptionKey: configuration.visaCheckout.encryptionKey,
        externalClientId: configuration.visaCheckout.externalClientId,
        supportedCardTypes: $c6c8167ea946ab25$var$mapCardTypes(configuration.visaCheckout.supportedCardBrands, $c6c8167ea946ab25$var$cardTypeTransforms.visaCheckout)
    };
    if (configuration.masterpass) response.masterpass = {
        merchantCheckoutId: configuration.masterpass.merchantCheckoutId,
        supportedNetworks: $c6c8167ea946ab25$var$mapCardTypes(configuration.masterpass.supportedCardBrands, $c6c8167ea946ab25$var$cardTypeTransforms.masterpass)
    };
    if (configuration.usBankAccount) response.usBankAccount = {
        routeId: configuration.usBankAccount.routeId,
        plaid: {
            publicKey: configuration.usBankAccount.plaidPublicKey
        }
    };
    return response;
}
function $c6c8167ea946ab25$var$mapCardTypes(cardTypes, cardTypeTransformMap) {
    return cardTypes.reduce(function(acc, type) {
        if (cardTypeTransformMap.hasOwnProperty(type)) return acc.concat(cardTypeTransformMap[type]);
        return acc;
    }, []);
}
module.exports = $c6c8167ea946ab25$var$configurationResponseAdapter;

});


parcelRegister("0sTUe", function(module, exports) {
"use strict";
function $00166b47cb44c633$var$DefaultRequest(options) {
    this._url = options.url;
    this._data = options.data;
    this._method = options.method;
    this._headers = options.headers;
}
$00166b47cb44c633$var$DefaultRequest.prototype.getUrl = function() {
    return this._url;
};
$00166b47cb44c633$var$DefaultRequest.prototype.getBody = function() {
    return this._data;
};
$00166b47cb44c633$var$DefaultRequest.prototype.getMethod = function() {
    return this._method;
};
$00166b47cb44c633$var$DefaultRequest.prototype.getHeaders = function() {
    return this._headers;
};
$00166b47cb44c633$var$DefaultRequest.prototype.adaptResponseBody = function(parsedBody) {
    return parsedBody;
};
$00166b47cb44c633$var$DefaultRequest.prototype.determineStatus = function(status) {
    return status;
};
module.exports = $00166b47cb44c633$var$DefaultRequest;

});



parcelRegister("9CXDY", function(module, exports) {
"use strict";
var $7025edaac23bf54c$var$parser;
var $7025edaac23bf54c$var$legalHosts = {
    "paypal.com": 1,
    "braintreepayments.com": 1,
    "braintreegateway.com": 1,
    "braintree-api.com": 1
};
function $7025edaac23bf54c$var$stripSubdomains(domain) {
    return domain.split(".").slice(-2).join(".");
}
function $7025edaac23bf54c$var$isVerifiedDomain(url) {
    var mainDomain;
    url = url.toLowerCase();
    if (!/^https:/.test(url)) return false;
    $7025edaac23bf54c$var$parser = $7025edaac23bf54c$var$parser || document.createElement("a");
    $7025edaac23bf54c$var$parser.href = url;
    mainDomain = $7025edaac23bf54c$var$stripSubdomains($7025edaac23bf54c$var$parser.hostname);
    return $7025edaac23bf54c$var$legalHosts.hasOwnProperty(mainDomain);
}
module.exports = $7025edaac23bf54c$var$isVerifiedDomain;

});

parcelRegister("45Qfj", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");
function $2fb027fd76ced1f1$var$convertToBraintreeError(originalErr, btErrorObject) {
    if (originalErr instanceof $dcafC) return originalErr;
    return new $dcafC({
        type: btErrorObject.type,
        code: btErrorObject.code,
        message: btErrorObject.message,
        details: {
            originalError: originalErr
        }
    });
}
module.exports = $2fb027fd76ced1f1$var$convertToBraintreeError;

});

parcelRegister("koqZI", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");

var $7GGVg = parcelRequire("7GGVg");

var $d9RJ4 = parcelRequire("d9RJ4");

var $eC4sQ = parcelRequire("eC4sQ");

var $3h7RY = parcelRequire("3h7RY");

var $0Fx8B = parcelRequire("0Fx8B");

var $1J6kX = parcelRequire("1J6kX");

var $3h7RY = parcelRequire("3h7RY");
var $ed8afd0c0753ac98$require$GRAPHQL_URLS = $3h7RY.GRAPHQL_URLS;

var $6BPMX = parcelRequire("6BPMX");

var $iArVC = parcelRequire("iArVC");
var $ed8afd0c0753ac98$require$BRAINTREE_VERSION = $iArVC.BRAINTREE_VERSION;
function $ed8afd0c0753ac98$var$getConfiguration(authData) {
    return new Promise(function(resolve, reject) {
        var configuration, attrs, configUrl, reqOptions;
        var sessionId = $eC4sQ();
        var analyticsMetadata = {
            merchantAppId: window.location.host,
            platform: $3h7RY.PLATFORM,
            sdkVersion: $3h7RY.VERSION,
            source: $3h7RY.SOURCE,
            // NEXT_MAJOR_VERSION remove one of these to not duplicate data. Target parity with mobile platforms approach.
            integration: $3h7RY.INTEGRATION,
            integrationType: $3h7RY.INTEGRATION,
            sessionId: sessionId
        };
        attrs = authData.attrs;
        configUrl = authData.configUrl;
        attrs._meta = analyticsMetadata;
        attrs.braintreeLibraryVersion = $3h7RY.BRAINTREE_LIBRARY_VERSION;
        attrs.configVersion = "3";
        reqOptions = {
            url: configUrl,
            method: "GET",
            data: attrs
        };
        if (attrs.authorizationFingerprint && authData.graphQL) {
            if ($6BPMX(authData.graphQL.date, $ed8afd0c0753ac98$require$BRAINTREE_VERSION)) reqOptions.graphQL = new $1J6kX({
                graphQL: {
                    url: authData.graphQL.url,
                    features: [
                        "configuration"
                    ]
                }
            });
            reqOptions.metadata = analyticsMetadata;
        } else if (attrs.tokenizationKey) {
            reqOptions.graphQL = new $1J6kX({
                graphQL: {
                    url: $ed8afd0c0753ac98$require$GRAPHQL_URLS[authData.environment],
                    features: [
                        "configuration"
                    ]
                }
            });
            reqOptions.metadata = analyticsMetadata;
        }
        // NEXT_MAJOR_VERSION
        // there are various issues with the config endpoint where the values returned
        // do not match the values from the merchant account id passed into a client token
        // we need to update the configuration request endpoint to be able to pass the
        // correct values. The following ones are incorrect
        // * applePayWeb - definitely supportedNetworks, which compiles all the card
        //    networks from all the merchant accounts instead of providing just the
        //    ones from the specified one. The same is probably true for ios apple pay
        //    Also the merchantidentifier
        // NEXT_MAJOR_VERSION Allow passing in merchant account id when creating the component
        // to fetch the config for that merchant account id (particularly helpful when using
        // a tokenization key for authorization)
        $d9RJ4(reqOptions, function(err, response, status) {
            var errorTemplate;
            if (err) {
                if (status === 403) errorTemplate = $0Fx8B.CLIENT_AUTHORIZATION_INSUFFICIENT;
                else if (status === 401) errorTemplate = $0Fx8B.CLIENT_AUTHORIZATION_INVALID;
                else errorTemplate = $0Fx8B.CLIENT_GATEWAY_NETWORK;
                reject(new $dcafC({
                    type: errorTemplate.type,
                    code: errorTemplate.code,
                    message: errorTemplate.message,
                    details: {
                        originalError: err
                    }
                }));
                return;
            }
            configuration = {
                authorizationType: attrs.tokenizationKey ? "TOKENIZATION_KEY" : "CLIENT_TOKEN",
                authorizationFingerprint: attrs.authorizationFingerprint,
                analyticsMetadata: analyticsMetadata,
                gatewayConfiguration: response
            };
            resolve(configuration);
        });
    });
}
module.exports = {
    getConfiguration: $7GGVg($ed8afd0c0753ac98$var$getConfiguration)
};

});
parcelRegister("7GGVg", function(module, exports) {
"use strict";

var $hBn91 = parcelRequire("hBn91");

var $jhmIp = parcelRequire("jhmIp");

var $ggtc9 = parcelRequire("ggtc9");
function $598dc029fb39d287$var$wrapPromise(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var callback;
        var lastArg = args[args.length - 1];
        if (typeof lastArg === "function") {
            callback = args.pop();
            callback = $jhmIp.once($hBn91.deferred(callback));
        }
        // I know, I know, this looks bad. But it's a quirk of the library that
        // we need to allow passing the this context to the original function
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore: this has an implicit any
        return $ggtc9.promiseOrCallback(fn.apply(this, args), callback); // eslint-disable-line no-invalid-this
    };
}
$598dc029fb39d287$var$wrapPromise.wrapPrototype = function(target, options) {
    if (options === void 0) options = {};
    var ignoreMethods = options.ignoreMethods || [];
    var includePrivateMethods = options.transformPrivateMethods === true;
    var methods = Object.getOwnPropertyNames(target.prototype).filter(function(method) {
        var isNotPrivateMethod;
        var isNonConstructorFunction = method !== "constructor" && typeof target.prototype[method] === "function";
        var isNotAnIgnoredMethod = ignoreMethods.indexOf(method) === -1;
        if (includePrivateMethods) isNotPrivateMethod = true;
        else isNotPrivateMethod = method.charAt(0) !== "_";
        return isNonConstructorFunction && isNotPrivateMethod && isNotAnIgnoredMethod;
    });
    methods.forEach(function(method) {
        var original = target.prototype[method];
        target.prototype[method] = $598dc029fb39d287$var$wrapPromise(original);
    });
    return target;
};
module.exports = $598dc029fb39d287$var$wrapPromise;

});
parcelRegister("hBn91", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $cd07d85f0ce296d3$var$deferred(fn) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        setTimeout(function() {
            try {
                fn.apply(void 0, args);
            } catch (err) {
                /* eslint-disable no-console */ console.log("Error in callback function");
                console.log(err);
            /* eslint-enable no-console */ }
        }, 1);
    };
}
module.exports.deferred = $cd07d85f0ce296d3$var$deferred;

});

parcelRegister("jhmIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $e09139a1b7856eea$var$once(fn) {
    var called = false;
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!called) {
            called = true;
            fn.apply(void 0, args);
        }
    };
}
module.exports.once = $e09139a1b7856eea$var$once;

});

parcelRegister("ggtc9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/* eslint-disable consistent-return */ function $bd74c98050b6952d$var$promiseOrCallback(promise, callback) {
    if (!callback) return promise;
    promise.then(function(data) {
        return callback(null, data);
    }).catch(function(err) {
        return callback(err);
    });
}
module.exports.promiseOrCallback = $bd74c98050b6952d$var$promiseOrCallback;

});


parcelRegister("eC4sQ", function(module, exports) {
"use strict";
function $aa3813c900c7823c$var$uuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
module.exports = $aa3813c900c7823c$var$uuid;

});

parcelRegister("3h7RY", function(module, exports) {
"use strict";
var $2629105a3b339bdf$var$VERSION = "3.100.0";
var $2629105a3b339bdf$var$PLATFORM = "web";
var $2629105a3b339bdf$var$CLIENT_API_URLS = {
    production: "https://api.braintreegateway.com:443",
    sandbox: "https://api.sandbox.braintreegateway.com:443"
};
var $2629105a3b339bdf$var$ASSETS_URLS = {
    production: "https://assets.braintreegateway.com",
    sandbox: "https://assets.braintreegateway.com"
};
var $2629105a3b339bdf$var$GRAPHQL_URLS = {
    production: "https://payments.braintree-api.com/graphql",
    sandbox: "https://payments.sandbox.braintree-api.com/graphql"
};
module.exports = {
    ANALYTICS_PREFIX: $2629105a3b339bdf$var$PLATFORM + ".",
    ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
    ASSETS_URLS: $2629105a3b339bdf$var$ASSETS_URLS,
    CLIENT_API_URLS: $2629105a3b339bdf$var$CLIENT_API_URLS,
    FRAUDNET_SOURCE: "BRAINTREE_SIGNIN",
    FRAUDNET_FNCLS: "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99",
    FRAUDNET_URL: "https://c.paypal.com/da/r/fb.js",
    BUS_CONFIGURATION_REQUEST_EVENT: "BUS_CONFIGURATION_REQUEST",
    GRAPHQL_URLS: $2629105a3b339bdf$var$GRAPHQL_URLS,
    INTEGRATION_TIMEOUT_MS: 60000,
    VERSION: $2629105a3b339bdf$var$VERSION,
    INTEGRATION: "custom",
    SOURCE: "client",
    PLATFORM: $2629105a3b339bdf$var$PLATFORM,
    BRAINTREE_LIBRARY_VERSION: "braintree/" + $2629105a3b339bdf$var$PLATFORM + "/" + $2629105a3b339bdf$var$VERSION
};

});

parcelRegister("0Fx8B", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");
module.exports = {
    CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN: {
        type: $dcafC.types.MERCHANT,
        code: "CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN"
    },
    CLIENT_OPTION_REQUIRED: {
        type: $dcafC.types.MERCHANT,
        code: "CLIENT_OPTION_REQUIRED"
    },
    CLIENT_OPTION_INVALID: {
        type: $dcafC.types.MERCHANT,
        code: "CLIENT_OPTION_INVALID"
    },
    CLIENT_MISSING_GATEWAY_CONFIGURATION: {
        type: $dcafC.types.INTERNAL,
        code: "CLIENT_MISSING_GATEWAY_CONFIGURATION",
        message: "Missing gatewayConfiguration."
    },
    CLIENT_INVALID_AUTHORIZATION: {
        type: $dcafC.types.MERCHANT,
        code: "CLIENT_INVALID_AUTHORIZATION",
        message: "Authorization is invalid. Make sure your client token or tokenization key is valid."
    },
    CLIENT_GATEWAY_NETWORK: {
        type: $dcafC.types.NETWORK,
        code: "CLIENT_GATEWAY_NETWORK",
        message: "Cannot contact the gateway at this time."
    },
    CLIENT_REQUEST_TIMEOUT: {
        type: $dcafC.types.NETWORK,
        code: "CLIENT_REQUEST_TIMEOUT",
        message: "Request timed out waiting for a reply."
    },
    CLIENT_REQUEST_ERROR: {
        type: $dcafC.types.NETWORK,
        code: "CLIENT_REQUEST_ERROR",
        message: "There was a problem with your request."
    },
    CLIENT_GRAPHQL_REQUEST_ERROR: {
        type: $dcafC.types.NETWORK,
        code: "CLIENT_GRAPHQL_REQUEST_ERROR",
        message: "There was a problem with your request."
    },
    CLIENT_RATE_LIMITED: {
        type: $dcafC.types.MERCHANT,
        code: "CLIENT_RATE_LIMITED",
        message: "You are being rate-limited; please try again in a few minutes."
    },
    CLIENT_AUTHORIZATION_INSUFFICIENT: {
        type: $dcafC.types.MERCHANT,
        code: "CLIENT_AUTHORIZATION_INSUFFICIENT",
        message: "The authorization used has insufficient privileges."
    },
    CLIENT_AUTHORIZATION_INVALID: {
        type: $dcafC.types.MERCHANT,
        code: "CLIENT_AUTHORIZATION_INVALID",
        message: "Either the client token has expired and a new one should be generated or the tokenization key has been deactivated or deleted."
    }
};

});

parcelRegister("6BPMX", function(module, exports) {
"use strict";
function $4cfe5eebe8474d68$var$convertDateStringToDate(dateString) {
    var splitDate = dateString.split("-");
    return new Date(splitDate[0], splitDate[1], splitDate[2]);
}
function $4cfe5eebe8474d68$var$isDateStringBeforeOrOn(firstDate, secondDate) {
    return $4cfe5eebe8474d68$var$convertDateStringToDate(firstDate) <= $4cfe5eebe8474d68$var$convertDateStringToDate(secondDate);
}
module.exports = $4cfe5eebe8474d68$var$isDateStringBeforeOrOn;

});


parcelRegister("3vts9", function(module, exports) {
"use strict";

var $2oOwl = parcelRequire("2oOwl");
var $28db1d18775f1d61$require$atob = $2oOwl.atob;

var $3h7RY = parcelRequire("3h7RY");
var $28db1d18775f1d61$require$CLIENT_API_URLS = $3h7RY.CLIENT_API_URLS;
function $28db1d18775f1d61$var$_isTokenizationKey(str) {
    return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(str);
}
function $28db1d18775f1d61$var$_parseTokenizationKey(tokenizationKey) {
    var tokens = tokenizationKey.split("_");
    var environment = tokens[0];
    var merchantId = tokens.slice(2).join("_");
    return {
        merchantId: merchantId,
        environment: environment
    };
}
function $28db1d18775f1d61$var$createAuthorizationData(authorization) {
    var parsedClientToken, parsedTokenizationKey;
    var data = {
        attrs: {},
        configUrl: ""
    };
    if ($28db1d18775f1d61$var$_isTokenizationKey(authorization)) {
        parsedTokenizationKey = $28db1d18775f1d61$var$_parseTokenizationKey(authorization);
        data.environment = parsedTokenizationKey.environment;
        data.attrs.tokenizationKey = authorization;
        data.configUrl = $28db1d18775f1d61$require$CLIENT_API_URLS[parsedTokenizationKey.environment] + "/merchants/" + parsedTokenizationKey.merchantId + "/client_api/v1/configuration";
    } else {
        parsedClientToken = JSON.parse($28db1d18775f1d61$require$atob(authorization));
        data.environment = parsedClientToken.environment;
        data.attrs.authorizationFingerprint = parsedClientToken.authorizationFingerprint;
        data.configUrl = parsedClientToken.configUrl;
        data.graphQL = parsedClientToken.graphQL;
    }
    return data;
}
module.exports = $28db1d18775f1d61$var$createAuthorizationData;

});
parcelRegister("2oOwl", function(module, exports) {
"use strict";
// NEXT_MAJOR_VERSION old versions of IE don't have atob, in the
// next major version, we're dropping support for those versions
// so we can eliminate the need to have this atob polyfill
var $1bf503045a356ee2$var$atobNormalized = typeof atob === "function" ? atob : $1bf503045a356ee2$var$atobPolyfill;
function $1bf503045a356ee2$var$atobPolyfill(base64String) {
    var a, b, c, b1, b2, b3, b4, i;
    var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$");
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var result = "";
    if (!base64Matcher.test(base64String)) throw new Error("Non base64 encoded input passed to window.atob polyfill");
    i = 0;
    do {
        b1 = characters.indexOf(base64String.charAt(i++));
        b2 = characters.indexOf(base64String.charAt(i++));
        b3 = characters.indexOf(base64String.charAt(i++));
        b4 = characters.indexOf(base64String.charAt(i++));
        a = (b1 & 0x3f) << 2 | b2 >> 4 & 0x3;
        b = (b2 & 0xf) << 4 | b3 >> 2 & 0xf;
        c = (b3 & 0x3) << 6 | b4 & 0x3f;
        result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : "") + (c ? String.fromCharCode(c) : "");
    }while (i < base64String.length);
    return result;
}
module.exports = {
    atob: function(base64String) {
        return $1bf503045a356ee2$var$atobNormalized.call(window, base64String);
    },
    _atob: $1bf503045a356ee2$var$atobPolyfill
};

});


parcelRegister("jIdSA", function(module, exports) {
"use strict";

var $3vts9 = parcelRequire("3vts9");

var $4eQvu = parcelRequire("4eQvu");

var $3h7RY = parcelRequire("3h7RY");
function $e59ce48de18f00f0$var$addMetadata(configuration, data) {
    var key;
    var attrs = data ? $4eQvu(data) : {};
    var authAttrs = $3vts9(configuration.authorization).attrs;
    var _meta = $4eQvu(configuration.analyticsMetadata);
    attrs.braintreeLibraryVersion = $3h7RY.BRAINTREE_LIBRARY_VERSION;
    for(key in attrs._meta)if (attrs._meta.hasOwnProperty(key)) _meta[key] = attrs._meta[key];
    attrs._meta = _meta;
    if (authAttrs.tokenizationKey) attrs.tokenizationKey = authAttrs.tokenizationKey;
    else attrs.authorizationFingerprint = authAttrs.authorizationFingerprint;
    return attrs;
}
module.exports = $e59ce48de18f00f0$var$addMetadata;

});
parcelRegister("4eQvu", function(module, exports) {
"use strict";
module.exports = function(value) {
    return JSON.parse(JSON.stringify(value));
};

});


parcelRegister("fuE0r", function(module, exports) {
"use strict";
module.exports = function(fn) {
    return function() {
        // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
        var args = arguments;
        setTimeout(function() {
            fn.apply(null, args);
        }, 1);
    };
};

});

parcelRegister("cIYHN", function(module, exports) {
"use strict";

var $3h7RY = parcelRequire("3h7RY");

var $jIdSA = parcelRequire("jIdSA");
function $9438aee6a6243524$var$sendAnalyticsEvent(clientInstanceOrPromise, kind, callback) {
    var timestamp = Date.now(); // milliseconds
    return Promise.resolve(clientInstanceOrPromise).then(function(client) {
        var timestampInPromise = Date.now();
        var configuration = client.getConfiguration();
        var request = client._request;
        var url = configuration.gatewayConfiguration.analytics.url;
        var data = {
            analytics: [
                {
                    kind: $3h7RY.ANALYTICS_PREFIX + kind,
                    isAsync: Math.floor(timestampInPromise / 1000) !== Math.floor(timestamp / 1000),
                    timestamp: timestamp
                }
            ]
        };
        request({
            url: url,
            method: "post",
            data: $jIdSA(configuration, data),
            timeout: $3h7RY.ANALYTICS_REQUEST_TIMEOUT_MS
        }, callback);
    }).catch(function(err) {
        // for all non-test cases, we don't provide a callback,
        // so this error will always be swallowed. In this case,
        // that's fine, it should only error when the deferred
        // client fails to set up, in which case we don't want
        // that error to report over and over again via these
        // deferred analytics events
        if (callback) callback(err);
    });
}
module.exports = {
    sendEvent: $9438aee6a6243524$var$sendAnalyticsEvent
};

});

parcelRegister("jXxvS", function(module, exports) {
"use strict";
module.exports = function(obj) {
    return Object.keys(obj).filter(function(key) {
        return typeof obj[key] === "function";
    });
};

});

parcelRegister("fbCls", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");

var $b3ukb = parcelRequire("b3ukb");
module.exports = function(instance, methodNames) {
    methodNames.forEach(function(methodName) {
        instance[methodName] = function() {
            throw new $dcafC({
                type: $b3ukb.METHOD_CALLED_AFTER_TEARDOWN.type,
                code: $b3ukb.METHOD_CALLED_AFTER_TEARDOWN.code,
                message: methodName + " cannot be called after teardown."
            });
        };
    });
};

});
parcelRegister("b3ukb", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");
module.exports = {
    INVALID_USE_OF_INTERNAL_FUNCTION: {
        type: $dcafC.types.INTERNAL,
        code: "INVALID_USE_OF_INTERNAL_FUNCTION"
    },
    INSTANTIATION_OPTION_REQUIRED: {
        type: $dcafC.types.MERCHANT,
        code: "INSTANTIATION_OPTION_REQUIRED"
    },
    INCOMPATIBLE_VERSIONS: {
        type: $dcafC.types.MERCHANT,
        code: "INCOMPATIBLE_VERSIONS"
    },
    CLIENT_SCRIPT_FAILED_TO_LOAD: {
        type: $dcafC.types.NETWORK,
        code: "CLIENT_SCRIPT_FAILED_TO_LOAD",
        message: "Braintree client script could not be loaded."
    },
    METHOD_CALLED_AFTER_TEARDOWN: {
        type: $dcafC.types.MERCHANT,
        code: "METHOD_CALLED_AFTER_TEARDOWN"
    }
};

});


parcelRegister("6rXUw", function(module, exports) {
"use strict";

var $iyoYq = parcelRequire("iyoYq");
module.exports = {
    loadScript: $iyoYq
};

});
parcelRegister("iyoYq", function(module, exports) {

module.exports = (parcelRequire("lu8Sr"));

});
parcelRegister("lu8Sr", function(module, exports) {
"use strict";

var $272TT = parcelRequire("272TT");
var $fa43491ea0a6d1b2$var$scriptPromiseCache = {};
function $fa43491ea0a6d1b2$var$loadScript(options) {
    var scriptLoadPromise;
    var stringifiedOptions = JSON.stringify(options);
    if (!options.forceScriptReload) {
        scriptLoadPromise = $fa43491ea0a6d1b2$var$scriptPromiseCache[stringifiedOptions];
        if (scriptLoadPromise) return scriptLoadPromise;
    }
    var script = document.createElement("script");
    var attrs = options.dataAttributes || {};
    var container = options.container || document.head;
    script.src = options.src;
    script.id = options.id || "";
    script.async = true;
    if (options.crossorigin) script.setAttribute("crossorigin", "" + options.crossorigin);
    Object.keys(attrs).forEach(function(key) {
        script.setAttribute("data-" + key, "" + attrs[key]);
    });
    scriptLoadPromise = new $272TT.PromiseGlobal(function(resolve, reject) {
        script.addEventListener("load", function() {
            resolve(script);
        });
        script.addEventListener("error", function() {
            reject(new Error(options.src + " failed to load."));
        });
        script.addEventListener("abort", function() {
            reject(new Error(options.src + " has aborted."));
        });
        container.appendChild(script);
    });
    $fa43491ea0a6d1b2$var$scriptPromiseCache[stringifiedOptions] = scriptLoadPromise;
    return scriptLoadPromise;
}
$fa43491ea0a6d1b2$var$loadScript.clearCache = function() {
    $fa43491ea0a6d1b2$var$scriptPromiseCache = {};
};
module.exports = $fa43491ea0a6d1b2$var$loadScript;

});
parcelRegister("272TT", function(module, exports) {
"use strict";
var $189e7c38d4cb846b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PromiseGlobal = void 0;

var $189e7c38d4cb846b$var$promise_polyfill_1 = $189e7c38d4cb846b$var$__importDefault((parcelRequire("gEZsP")));
var $189e7c38d4cb846b$var$PromiseGlobal = // eslint-disable-next-line no-undef
typeof Promise !== "undefined" ? Promise : $189e7c38d4cb846b$var$promise_polyfill_1.default;
module.exports.PromiseGlobal = $189e7c38d4cb846b$var$PromiseGlobal;

});
parcelRegister("gEZsP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c2100f3a9690faaf$export$2e2bcd8739ae039);

var $be6Fr = parcelRequire("be6Fr");

var $4kONi = parcelRequire("4kONi");

var $9ZNPw = parcelRequire("9ZNPw");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $c2100f3a9690faaf$var$setTimeoutFunc = setTimeout;
function $c2100f3a9690faaf$var$isArray(x) {
    return Boolean(x && typeof x.length !== "undefined");
}
function $c2100f3a9690faaf$var$noop() {}
// Polyfill for Function.prototype.bind
function $c2100f3a9690faaf$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $c2100f3a9690faaf$var$Promise(fn) {
    if (!(this instanceof $c2100f3a9690faaf$var$Promise)) throw new TypeError("Promises must be constructed via new");
    if (typeof fn !== "function") throw new TypeError("not a function");
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $c2100f3a9690faaf$var$doResolve(fn, this);
}
function $c2100f3a9690faaf$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $c2100f3a9690faaf$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $c2100f3a9690faaf$var$resolve : $c2100f3a9690faaf$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $c2100f3a9690faaf$var$reject(deferred.promise, e);
            return;
        }
        $c2100f3a9690faaf$var$resolve(deferred.promise, ret);
    });
}
function $c2100f3a9690faaf$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError("A promise cannot be resolved with itself.");
        if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
            var then = newValue.then;
            if (newValue instanceof $c2100f3a9690faaf$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $c2100f3a9690faaf$var$finale(self);
                return;
            } else if (typeof then === "function") {
                $c2100f3a9690faaf$var$doResolve($c2100f3a9690faaf$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $c2100f3a9690faaf$var$finale(self);
    } catch (e) {
        $c2100f3a9690faaf$var$reject(self, e);
    }
}
function $c2100f3a9690faaf$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $c2100f3a9690faaf$var$finale(self);
}
function $c2100f3a9690faaf$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $c2100f3a9690faaf$var$Promise._immediateFn(function() {
        if (!self._handled) $c2100f3a9690faaf$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$c2100f3a9690faaf$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $c2100f3a9690faaf$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $c2100f3a9690faaf$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $c2100f3a9690faaf$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $c2100f3a9690faaf$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $c2100f3a9690faaf$var$reject(self, ex);
    }
}
$c2100f3a9690faaf$var$Promise.prototype["catch"] = function(onRejected) {
    return this.then(null, onRejected);
};
$c2100f3a9690faaf$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($c2100f3a9690faaf$var$noop);
    $c2100f3a9690faaf$var$handle(this, new $c2100f3a9690faaf$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$c2100f3a9690faaf$var$Promise.prototype["finally"] = (0, $be6Fr.default);
$c2100f3a9690faaf$var$Promise.all = function(arr) {
    return new $c2100f3a9690faaf$var$Promise(function(resolve, reject) {
        if (!$c2100f3a9690faaf$var$isArray(arr)) return reject(new TypeError("Promise.all accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === "object" || typeof val === "function")) {
                    var then = val.then;
                    if (typeof then === "function") {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$c2100f3a9690faaf$var$Promise.any = (0, $9ZNPw.default);
$c2100f3a9690faaf$var$Promise.allSettled = (0, $4kONi.default);
$c2100f3a9690faaf$var$Promise.resolve = function(value) {
    if (value && typeof value === "object" && value.constructor === $c2100f3a9690faaf$var$Promise) return value;
    return new $c2100f3a9690faaf$var$Promise(function(resolve) {
        resolve(value);
    });
};
$c2100f3a9690faaf$var$Promise.reject = function(value) {
    return new $c2100f3a9690faaf$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$c2100f3a9690faaf$var$Promise.race = function(arr) {
    return new $c2100f3a9690faaf$var$Promise(function(resolve, reject) {
        if (!$c2100f3a9690faaf$var$isArray(arr)) return reject(new TypeError("Promise.race accepts an array"));
        for(var i = 0, len = arr.length; i < len; i++)$c2100f3a9690faaf$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$c2100f3a9690faaf$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === "function" && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $c2100f3a9690faaf$var$setTimeoutFunc(fn, 0);
};
$c2100f3a9690faaf$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== "undefined" && console) console.warn("Possible Unhandled Promise Rejection:", err); // eslint-disable-line no-console
};
var $c2100f3a9690faaf$export$2e2bcd8739ae039 = $c2100f3a9690faaf$var$Promise;

});
parcelRegister("be6Fr", function(module, exports) {

$parcel$export(module.exports, "default", () => $82c62c82a1594745$export$2e2bcd8739ae039);
/**
 * @this {Promise}
 */ function $82c62c82a1594745$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $82c62c82a1594745$export$2e2bcd8739ae039 = $82c62c82a1594745$var$finallyConstructor;

});

parcelRegister("4kONi", function(module, exports) {

$parcel$export(module.exports, "default", () => $32806e5453e5889b$export$2e2bcd8739ae039);
function $32806e5453e5889b$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError(typeof arr + " " + arr + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === "object" || typeof val === "function")) {
                var then = val.then;
                if (typeof then === "function") {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: "rejected",
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: "fulfilled",
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $32806e5453e5889b$export$2e2bcd8739ae039 = $32806e5453e5889b$var$allSettled;

});

parcelRegister("9ZNPw", function(module, exports) {

$parcel$export(module.exports, "default", () => $747076c264e6fe77$export$2e2bcd8739ae039);
/**
 * @constructor
 */ function $747076c264e6fe77$var$AggregateError(errors, message) {
    this.name = "AggregateError", this.errors = errors;
    this.message = message || "";
}
$747076c264e6fe77$var$AggregateError.prototype = Error.prototype;
function $747076c264e6fe77$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError("Promise.any accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $747076c264e6fe77$var$AggregateError(rejectionReasons, "All promises were rejected"));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $747076c264e6fe77$export$2e2bcd8739ae039 = $747076c264e6fe77$var$any;

});








parcelRegister("5m3t5", function(module, exports) {
"use strict";

var $1MHGH = parcelRequire("1MHGH");

var $41yK6 = parcelRequire("41yK6");

var $1bDti = parcelRequire("1bDti");

var $kHc8n = parcelRequire("kHc8n");

var $7GGVg = parcelRequire("7GGVg");

var $dcafC = parcelRequire("dcafC");
var $3e61b286245f7c79$var$VERSION = "3.100.0";
/**
 * Fields used in {@link module:braintree-web/hosted-fields~fieldOptions fields options}
 * @typedef {object} field
 * @property {string} selector Deprecated: Now an alias for `options.container`.
 * @property {(string|HTMLElement)} container A DOM node or CSS selector to find the container where the hosted field will be inserted.
 * @property {string} [placeholder] Will be used as the `placeholder` attribute of the input. If `placeholder` is not natively supported by the browser, it will be polyfilled.
 * @property {string} [type] Will be used as the `type` attribute of the input. To mask `cvv` input, for instance, `type: "password"` can be used.
 * @property {string} [iframeTitle] The title used for the iframe containing the credit card input. By default, this will be `Secure Credit Card Frame - <the name of the specific field>`.
 * @property {string} [internalLabel] Each Hosted Field iframe has a hidden label that is used by screen readers to identify the input. The `internalLabel` property can be used to customize the field for localization purposes. The default values are:
 * * number: Credit Card Number
 * * cvv: CVV
 * * expirationDate: Expiration Date
 * * expirationMonth: Expiration Month
 * * expirationYear: Expiration Year
 * * postalCode: Postal Code
 * * cardholderName: Cardholder Name
 * @property {boolean} [formatInput=true] Enable or disable automatic formatting on this field.
 * @property {(object|boolean)} [maskInput=false] Enable or disable input masking when input is not focused. If set to `true` instead of an object, the defaults for the `maskInput` parameters will be used.
 * @property {string} [maskInput.character=•] The character to use when masking the input. The default character ('•') uses a unicode symbol, so the webpage must support UTF-8 characters when using the default.
 * @property {Boolean} [maskInput.showLastFour=false] Only applicable for the credit card field. Whether or not to show the last 4 digits of the card when masking.
 * @property {(object|boolean)} [select] If truthy, this field becomes a `<select>` dropdown list. This can only be used for `expirationMonth` and `expirationYear` fields. If you do not use a `placeholder` property for the field, the current month/year will be the default selected value.
 * @property {string[]} [select.options] An array of 12 strings, one per month. This can only be used for the `expirationMonth` field. For example, the array can look like `['01 - January', '02 - February', ...]`.
 * @property {number} [maxCardLength] This option applies only to the number field. Allows a limit to the length of the card number, even if the card brand may support numbers of a greater length. If the value passed is greater than the max length for a card brand, the smaller number of the 2 values will be used. For example, is `maxCardLength` is set to 16, but an American Express card is entered (which has a max card length of 15), a max card length of 15 will be used.
 * @property {number} [maxlength] This option applies only to the CVV and postal code fields. Will be used as the `maxlength` attribute of the input. The primary use cases for the `maxlength` option are: limiting the length of the CVV input for CVV-only verifications when the card type is known and setting the length of the postal code input when cards are coming from a known region. The default `maxlength` for the postal code input is `10`.
 * @property {number} [minlength=3] This option applies only to the cvv and postal code fields. Will be used as the `minlength` attribute of the input.
 * For postal code fields, the default value is 3, representing the Icelandic postal code length. This option's primary use case is to increase the `minlength`, e.g. for US customers, the postal code `minlength` can be set to 5.
 * For cvv fields, the default value is 3. The `minlength` attribute only applies to integrations capturing a cvv without a number field.
 * @property {string} [prefill] A value to prefill the field with. For example, when creating an update card form, you can prefill the expiration date fields with the old expiration date data.
 * @property {boolean} [rejectUnsupportedCards=false] Deprecated since version 3.46.0, use `supportedCardBrands` instead. Only allow card types that your merchant account is able to process. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering a American Express card would get an invalid card field. This can only be used for the `number` field.
 * @property {object} [supportedCardBrands] Override card brands that are supported by the card form. Pass `'card-brand-id': true` to override the default in the merchant configuration and enable a card brand. Pass `'card-brand-id': false` to disable a card brand. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering an American Express card would get an invalid card field. This can only be used for the  `number` field. (Note: only allow card types that your merchant account is actually able to process.)
 *
 * Valid card brand ids are:
 * * visa
 * * mastercard
 * * american-express
 * * diners-club
 * * discover
 * * jcb
 * * union-pay
 * * maestro
 * * elo
 * * mir
 * * hiper
 * * hipercard
 */ /**
 * An object that has {@link module:braintree-web/hosted-fields~field field objects} for each field. Used in {@link module:braintree-web/hosted-fields~create create}.
 * @typedef {object} fieldOptions
 * @property {field} [number] A field for card number.
 * @property {field} [expirationDate] A field for expiration date in `MM/YYYY` or `MM/YY` format. This should not be used with the `expirationMonth` and `expirationYear` properties.
 * @property {field} [expirationMonth] A field for expiration month in `MM` format. This should be used with the `expirationYear` property.
 * @property {field} [expirationYear] A field for expiration year in `YYYY` or `YY` format. This should be used with the `expirationMonth` property.
 * @property {field} [cvv] A field for 3 or 4 digit card verification code (like CVV or CID). If you wish to create a CVV-only payment method nonce to verify a card already stored in your Vault, omit all other fields to only collect CVV.
 * @property {field} [postalCode] A field for postal or region code.
 * @property {field} [cardholderName] A field for the cardholder name on the customer's credit card.
 */ /**
 * An object that represents CSS that will be applied in each hosted field. This object looks similar to CSS. Typically, these styles involve fonts (such as `font-family` or `color`).
 *
 * You may also pass the name of a class on your site that contains the styles you would like to apply. The style properties will be automatically pulled off the class and applied to the Hosted Fields inputs. Note: this is recommended for `input` elements only. If using a `select` for the expiration date, unexpected styling may occur.
 *
 * These are the CSS properties that Hosted Fields supports. Any other CSS should be specified on your page and outside of any Braintree configuration. Trying to set unsupported properties will fail and put a warning in the console.
 *
 * Supported CSS properties are:
 * `appearance`
 * `box-shadow`
 * `color`
 * `direction`
 * `font-family`
 * `font-size-adjust`
 * `font-size`
 * `font-stretch`
 * `font-style`
 * `font-variant-alternates`
 * `font-variant-caps`
 * `font-variant-east-asian`
 * `font-variant-ligatures`
 * `font-variant-numeric`
 * `font-variant`
 * `font-weight`
 * `font`
 * `letter-spacing`
 * `line-height`
 * `opacity`
 * `outline`
 * `margin`
 * `margin-top`
 * `margin-right`
 * `margin-bottom`
 * `margin-left`
 * `padding`
 * `padding-top`
 * `padding-right`
 * `padding-bottom`
 * `padding-left`
 * `text-align`
 * `text-shadow`
 * `transition`
 * `-moz-appearance`
 * `-moz-box-shadow`
 * `-moz-osx-font-smoothing`
 * `-moz-tap-highlight-color`
 * `-moz-transition`
 * `-webkit-appearance`
 * `-webkit-box-shadow`
 * `-webkit-font-smoothing`
 * `-webkit-tap-highlight-color`
 * `-webkit-transition`
 * @typedef {object} styleOptions
 */ /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {fieldOptions} options.fields A {@link module:braintree-web/hosted-fields~fieldOptions set of options for each field}.
 * @param {styleOptions} [options.styles] {@link module:braintree-web/hosted-fields~styleOptions Styles} applied to each field.
 * @param {boolean} [options.preventAutofill=false] When true, browsers will not try to prompt the customer to autofill their credit card information.
 * @param {callback} [callback] The second argument, `data`, is the {@link HostedFields} instance. If no callback is provided, `create` returns a promise that resolves with the {@link HostedFields} instance.
 * @returns {void}
 * @example
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       'font-size': '16pt',
 *       'color': '#3A3A3A'
 *     },
 *     '.number': {
 *       'font-family': 'monospace'
 *     },
 *     '.valid': {
 *       'color': 'green'
 *     }
 *   },
 *   fields: {
 *     number: {
 *       container: '#card-number'
 *     },
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       container: '#expiration-date'
 *     }
 *   }
 * }, callback);
 * @example <caption>With cardholder name</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     number: {
 *       container: '#card-number'
 *     },
 *     cardholderName: {
 *       container: '#cardholder-name'
 *     },
 *     cvv: {
 *       container: '#cvv',
 *     },
 *     expirationDate: {
 *       container: '#expiration-date'
 *     }
 *   }
 * }, callback);
 * @example <caption>Applying styles with a class name</caption>
 * // in document head
 * <style>
 *   .braintree-input-class {
 *     color: black;
 *   }
 *   .braintree-valid-class {
 *     color: green;
 *   }
 *   .braintree-invalid-class {
 *     color: red;
 *   }
 * </style>
 * // in a script tag
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': 'braintree-input-class',
 *     '.invalid': 'braintree-invalid-class',
 *     '.valid': {
 *       // you can also use the object syntax alongside
 *       // the class name syntax
 *       color: green;
 *     }
 *   },
 *   fields: {
 *     number: {
 *       container: '#card-number'
 *     },
 *     // etc...
 *   }
 * }, callback);
 * @example <caption>Right to Left Language Support</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       // other styles
 *       direction: 'rtl'
 *     },
 *   },
 *   fields: {
 *     number: {
 *       container: '#card-number',
 *       // Credit card formatting is not currently supported
 *       // with RTL languages, so we need to turn it off for the number input
 *       formatInput: false
 *     },
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       container: '#expiration-date',
 *       type: 'month'
 *     }
 *   }
 * }, callback);
 * @example <caption>Setting up Hosted Fields to tokenize CVV only</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     // Only add the `cvv` option.
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     }
 *   }
 * }, callback);
 * @example <caption>Creating an expiration date update form with prefilled data</caption>
 * var storedCreditCardInformation = {
 *   // get this info from your server
 *   // with a payment method lookup
 *   month: '09',
 *   year: '2017'
 * };
 *
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     expirationMonth: {
 *       container: '#expiration-month',
 *       prefill: storedCreditCardInformation.month
 *     },
 *     expirationYear: {
 *       container: '#expiration-year',
 *       prefill: storedCreditCardInformation.year
 *     }
 *   }
 * }, callback);
 * @example <caption>Validate the card form for supported card types</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     number: {
 *       container: '#card-number',
 *       supportedCardBrands: {
 *         visa: false, // prevents Visas from showing up as valid even when the Braintree control panel is configured to allow them
 *         'diners-club': true // allow Diners Club cards to be valid (processed as Discover cards on the Braintree backend)
 *       }
 *     },
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       container: '#expiration-date',
 *       type: 'month'
 *     }
 *   },
 * }, callback);
 */ function $3e61b286245f7c79$var$create(options) {
    return $41yK6.verify({
        name: "Hosted Fields",
        authorization: options.authorization,
        client: options.client
    }).then(function() {
        var integration = new $1MHGH(options);
        return new Promise(function(resolve, reject) {
            integration.on("ready", function() {
                resolve(integration);
            });
            integration.on("timeout", function() {
                reject(new $dcafC($1bDti.HOSTED_FIELDS_TIMEOUT));
            });
        });
    });
}
module.exports = {
    /**
   * @static
   * @function supportsInputFormatting
   * @description Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true. For a list of unsupported browsers, [go here](https://github.com/braintree/restricted-input/blob/main/README.md#browsers-where-formatting-is-turned-off-automatically).
   * @returns {Boolean} Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true.
   * @example
   * <caption>Conditionally choosing split expiration date inputs if formatting is unavailable</caption>
   * var canFormat = braintree.hostedFields.supportsInputFormatting();
   * var fields = {
   *   number: {
   *     container: '#card-number'
   *   },
   *   cvv: {
   *     container: '#cvv'
   *   }
   * };
   *
   * if (canFormat) {
   *   fields.expirationDate = {
   *     selection: '#expiration-date'
   *   };
   *   functionToCreateAndInsertExpirationDateDivToForm();
   * } else {
   *   fields.expirationMonth = {
   *     selection: '#expiration-month'
   *   };
   *   fields.expirationYear = {
   *     selection: '#expiration-year'
   *   };
   *   functionToCreateAndInsertExpirationMonthAndYearDivsToForm();
   * }
   *
   * braintree.hostedFields.create({
   *   client: clientInstance,
   *   styles: {
   *     // Styles
   *   },
   *   fields: fields
   * }, callback);
   */ supportsInputFormatting: $kHc8n,
    create: $7GGVg($3e61b286245f7c79$var$create),
    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: $3e61b286245f7c79$var$VERSION
};

});
parcelRegister("1MHGH", function(module, exports) {
"use strict";

var $8mxc9 = parcelRequire("8mxc9");
var $14cc299fe4911bbd$require$assign = $8mxc9.assign;

var $ePN3B = parcelRequire("ePN3B");

var $9CXDY = parcelRequire("9CXDY");

var $eXDl5 = parcelRequire("eXDl5");

var $2DRDC = parcelRequire("2DRDC");

var $efA95 = parcelRequire("efA95");

var $b6BSv = parcelRequire("b6BSv");

var $dcafC = parcelRequire("dcafC");

var $aTgXt = parcelRequire("aTgXt");

var $9ooKM = parcelRequire("9ooKM");

var $hYQeJ = parcelRequire("hYQeJ");

var $1bDti = parcelRequire("1bDti");

var $3h7RY = parcelRequire("3h7RY");
var $14cc299fe4911bbd$require$INTEGRATION_TIMEOUT_MS = $3h7RY.INTEGRATION_TIMEOUT_MS;

var $eC4sQ = parcelRequire("eC4sQ");

var $5E25m = parcelRequire("5E25m");

var $hOQOA = parcelRequire("hOQOA");
var $14cc299fe4911bbd$var$events = $hYQeJ.events;

var $6aiin = parcelRequire("6aiin");

var $gaafx = parcelRequire("gaafx");

var $cIYHN = parcelRequire("cIYHN");
var $14cc299fe4911bbd$var$allowedFields = $hYQeJ.allowedFields;

var $jXxvS = parcelRequire("jXxvS");

var $iENnV = parcelRequire("iENnV");

var $cgVjh = parcelRequire("cgVjh");

var $fbCls = parcelRequire("fbCls");

var $b3ukb = parcelRequire("b3ukb");

var $3L5ZD = parcelRequire("3L5ZD");

var $27Y9u = parcelRequire("27Y9u");

var $7GGVg = parcelRequire("7GGVg");

var $9ypus = parcelRequire("9ypus");

var $7S4Hg = parcelRequire("7S4Hg");
var $14cc299fe4911bbd$require$destroyFocusIntercept = $7S4Hg.destroy;
var $14cc299fe4911bbd$var$SAFARI_FOCUS_TIMEOUT = 5;
/**
 * @typedef {object} HostedFields~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} authenticationInsight Info about the [regulatory environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) of the tokenized card. Only available if `authenticationInsight.merchantAccountId` is passed in the `tokenize` method options.
 * @property {string} authenticationInsight.regulationEnvironment The [regulation environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) for the tokenized card.
 * @property {object} details Additional account details.
 * @property {string} details.bin The BIN number of the card.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.expirationMonth The expiration month of the card.
 * @property {string} details.expirationYear The expiration year of the card.
 * @property {string} details.cardholderName The cardholder name tokenized with the card.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, always `CreditCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */ /**
 * @typedef {object} HostedFields~stateObject
 * @description The event payload sent from {@link HostedFields#on|on} or {@link HostedFields#getState|getState}.
 * @property {HostedFields~hostedFieldsCard[]} cards
 * This will return an array of potential {@link HostedFields~hostedFieldsCard|cards}. If the card type has been determined, the array will contain only one card.
 * Internally, Hosted Fields uses <a href="https://github.com/braintree/credit-card-type">credit-card-type</a>,
 * an open-source card detection library.
 * @property {string} emittedBy
 * The name of the field associated with an event. This will not be included if returned by {@link HostedFields#getState|getState}. It will be one of the following strings:<br>
 * - `"number"`
 * - `"cvv"`
 * - `"expirationDate"`
 * - `"expirationMonth"`
 * - `"expirationYear"`
 * - `"postalCode"`
 * - `"cardholderName"`
 * @property {object} fields
 * @property {?HostedFields~hostedFieldsFieldData} fields.number {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the number field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.cvv {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the CVV field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationDate {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration date field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationMonth {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration month field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationYear {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration year field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.postalCode {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the postal code field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.cardholderName {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the cardholder name field, if it is present.
 */ /**
 * @typedef {object} HostedFields~binPayload
 * @description The event payload sent from {@link HostedFields#on|on} when the {@link HostedFields#event:binAvailable|binAvailable} event is emitted.
 * @property {string} bin The first 6 digits of the card number.
 */ /**
 * @typedef {object} HostedFields~hostedFieldsFieldData
 * @description Data about Hosted Fields fields, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {HTMLElement} container Reference to the container DOM element on your page associated with the current event.
 * @property {boolean} isFocused Whether or not the input is currently focused.
 * @property {boolean} isEmpty Whether or not the user has entered a value in the input.
 * @property {boolean} isPotentiallyValid
 * A determination based on the future validity of the input value.
 * This is helpful when a user is entering a card number and types <code>"41"</code>.
 * While that value is not valid for submission, it is still possible for
 * it to become a fully qualified entry. However, if the user enters <code>"4x"</code>
 * it is clear that the card number can never become valid and isPotentiallyValid will
 * return false.
 * @property {boolean} isValid Whether or not the value of the associated input is <i>fully</i> qualified for submission.
 */ /**
 * @typedef {object} HostedFields~hostedFieldsCard
 * @description Information about the card type, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {string} type The code-friendly representation of the card type. It will be one of the following strings:
 * - `american-express`
 * - `diners-club`
 * - `discover`
 * - `jcb`
 * - `maestro`
 * - `master-card`
 * - `unionpay`
 * - `visa`
 * @property {string} niceType The pretty-printed card type. It will be one of the following strings:
 * - `American Express`
 * - `Diners Club`
 * - `Discover`
 * - `JCB`
 * - `Maestro`
 * - `MasterCard`
 * - `UnionPay`
 * - `Visa`
 * @property {object} code
 * This object contains data relevant to the security code requirements of the card brand.
 * For example, on a Visa card there will be a <code>CVV</code> of 3 digits, whereas an
 * American Express card requires a 4-digit <code>CID</code>.
 * @property {string} code.name <code>"CVV"</code> <code>"CID"</code> <code>"CVC"</code>
 * @property {number} code.size The expected length of the security code. Typically, this is 3 or 4.
 */ /**
 * @name HostedFields#on
 * @function
 * @param {string} event The name of the event to which you are subscribing.
 * @param {function} handler A callback to handle the event.
 * @description Subscribes a handler function to a named event.
 *
 * **Events that emit a {@link HostedFields~stateObject|stateObject}.**
 * * {@link HostedFields#event:blur|blur}
 * * {@link HostedFields#event:focus|focus}
 * * {@link HostedFields#event:empty|empty}
 * * {@link HostedFields#event:notEmpty|notEmpty}
 * * {@link HostedFields#event:cardTypeChange|cardTypeChange}
 * * {@link HostedFields#event:validityChange|validityChange}
 * * {@link HostedFields#event:inputSubmitRequest|inputSubmitRequest}
 *
 * **Other Events**
 * * {@link HostedFields#event:binAvailable|binAvailable} - emits a {@link HostedFields~binPayload|bin payload}. Note: If you are using a [Referrer-Policy](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Referrer-Policy) header that prevents the origin from being sent, this event will not fire.
 * @example
 * <caption>Listening to a Hosted Field event, in this case 'focus'</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'has been focused');
 *   });
 * });
 * @returns {void}
 */ /**
 * @name HostedFields#off
 * @function
 * @param {string} event The name of the event to which you are unsubscribing.
 * @param {function} handler The callback for the event you are unsubscribing from.
 * @description Unsubscribes the handler function to a named event.
 * @example
 * <caption>Subscribing and then unsubscribing from a Hosted Field event, in this case 'focus'</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   var callback = function (event) {
 *     console.log(event.emittedBy, 'has been focused');
 *   };
 *   hostedFieldsInstance.on('focus', callback);
 *
 *   // later on
 *   hostedFieldsInstance.off('focus', callback);
 * });
 * @returns {void}
 */ /**
 * This event is emitted when the user requests submission of an input field, such as by pressing the Enter or Return key on their keyboard, or mobile equivalent.
 * @event HostedFields#inputSubmitRequest
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Clicking a submit button upon hitting Enter (or equivalent) within a Hosted Field</caption>
 * var hostedFields = require('braintree-web/hosted-fields');
 * var submitButton = document.querySelector('input[type="submit"]');
 *
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('inputSubmitRequest', function () {
 *     // User requested submission, e.g. by pressing Enter or equivalent
 *     submitButton.click();
 *   });
 * });
 */ /**
 * This event is emitted when a field transitions from having data to being empty.
 * @event HostedFields#empty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an empty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('empty', function (event) {
 *     console.log(event.emittedBy, 'is now empty');
 *   });
 * });
 */ /**
 * This event is emitted when a field transitions from being empty to having data.
 * @event HostedFields#notEmpty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an notEmpty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('notEmpty', function (event) {
 *     console.log(event.emittedBy, 'is now not empty');
 *   });
 * });
 */ /**
 * This event is emitted when a field loses focus.
 * @event HostedFields#blur
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a blur event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('blur', function (event) {
 *     console.log(event.emittedBy, 'lost focus');
 *   });
 * });
 */ /**
 * This event is emitted when a field gains focus.
 * @event HostedFields#focus
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a focus event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'gained focus');
 *   });
 * });
 */ /**
 * This event is emitted when activity within the number field has changed such that the possible card type has changed.
 * @event HostedFields#cardTypeChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a cardTypeChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('cardTypeChange', function (event) {
 *     if (event.cards.length === 1) {
 *       console.log(event.cards[0].type);
 *     } else {
 *       console.log('Type of card not yet known');
 *     }
 *   });
 * });
 */ /**
 * This event is emitted when the validity of a field has changed. Validity is represented in the {@link HostedFields~stateObject|stateObject} as two booleans: `isValid` and `isPotentiallyValid`.
 * @event HostedFields#validityChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a validityChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('validityChange', function (event) {
 *     var field = event.fields[event.emittedBy];
 *
 *     if (field.isValid) {
 *       console.log(event.emittedBy, 'is fully valid');
 *     } else if (field.isPotentiallyValid) {
 *       console.log(event.emittedBy, 'is potentially valid');
 *     } else {
 *       console.log(event.emittedBy, 'is not valid');
 *     }
 *   });
 * });
 */ /**
 * This event is emitted when the first 6 digits of the card number have been entered by the customer.
 * @event HostedFields#binAvailable
 * @type {string}
 * @example
 * <caption>Listening to a `binAvailable` event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('binAvailable', function (event) {
 *     event.bin // send bin to 3rd party bin service
 *   });
 * });
 */ function $14cc299fe4911bbd$var$createInputEventHandler(fields) {
    return function(eventData) {
        var field;
        var merchantPayload = eventData.merchantPayload;
        var emittedBy = merchantPayload.emittedBy;
        var container = fields[emittedBy].containerElement;
        Object.keys(merchantPayload.fields).forEach(function(key) {
            merchantPayload.fields[key].container = fields[key].containerElement;
        });
        field = merchantPayload.fields[emittedBy];
        container.classList.toggle($hYQeJ.externalClasses.FOCUSED, field.isFocused);
        container.classList.toggle($hYQeJ.externalClasses.VALID, field.isValid);
        container.classList.toggle($hYQeJ.externalClasses.INVALID, !field.isPotentiallyValid);
        // eslint-disable-next-line no-invalid-this
        this._state = {
            cards: merchantPayload.cards,
            fields: merchantPayload.fields
        };
        this._emit(eventData.type, merchantPayload); // eslint-disable-line no-invalid-this
    };
}
function $14cc299fe4911bbd$var$isVisibleEnough(node) {
    var boundingBox = node.getBoundingClientRect();
    var verticalMidpoint = Math.floor(boundingBox.height / 2);
    var horizontalMidpoint = Math.floor(boundingBox.width / 2);
    return boundingBox.top < (window.innerHeight - verticalMidpoint || document.documentElement.clientHeight - verticalMidpoint) && boundingBox.right > horizontalMidpoint && boundingBox.bottom > verticalMidpoint && boundingBox.left < (window.innerWidth - horizontalMidpoint || document.documentElement.clientWidth - horizontalMidpoint);
}
/**
 * @class HostedFields
 * @param {object} options The Hosted Fields {@link module:braintree-web/hosted-fields.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/hosted-fields.create|braintree-web.hosted-fields.create} instead.</strong>
 * @classdesc This class represents a Hosted Fields component produced by {@link module:braintree-web/hosted-fields.create|braintree-web/hosted-fields.create}. Instances of this class have methods for interacting with the input fields within Hosted Fields' iframes.
 */ function $14cc299fe4911bbd$var$HostedFields(options) {
    var failureTimeout, clientConfig, assetsUrl, isDebug, hostedFieldsUrl;
    var self = this;
    var fields = {};
    var frameReadyPromiseResolveFunctions = {};
    var frameReadyPromises = [];
    var componentId = $eC4sQ();
    this._merchantConfigurationOptions = $14cc299fe4911bbd$require$assign({}, options);
    if (options.client) {
        clientConfig = options.client.getConfiguration();
        assetsUrl = clientConfig.gatewayConfiguration.assetsUrl;
        isDebug = clientConfig.isDebug;
    } else {
        assetsUrl = $ePN3B.create(options.authorization);
        isDebug = Boolean(options.isDebug);
    }
    this._clientPromise = $b6BSv.create({
        client: options.client,
        authorization: options.authorization,
        debug: isDebug,
        assetsUrl: assetsUrl,
        name: "Hosted Fields"
    });
    hostedFieldsUrl = $aTgXt(assetsUrl, componentId, isDebug);
    if (!options.fields || Object.keys(options.fields).length === 0) throw new $dcafC({
        type: $b3ukb.INSTANTIATION_OPTION_REQUIRED.type,
        code: $b3ukb.INSTANTIATION_OPTION_REQUIRED.code,
        message: "options.fields is required when instantiating Hosted Fields."
    });
    $6aiin.call(this);
    this._injectedNodes = [];
    this._destructor = new $eXDl5();
    this._fields = fields;
    this._state = {
        fields: {},
        cards: $3L5ZD("")
    };
    this._bus = new $efA95({
        channel: componentId,
        verifyDomain: $9CXDY,
        targetFrames: [
            window
        ]
    });
    this._destructor.registerFunctionForTeardown(function() {
        self._bus.teardown();
    });
    // NEXT_MAJOR_VERSION analytics events should have present tense verbs
    if (!options.client) $cIYHN.sendEvent(this._clientPromise, "custom.hosted-fields.initialized.deferred-client");
    else $cIYHN.sendEvent(this._clientPromise, "custom.hosted-fields.initialized");
    Object.keys(options.fields).forEach((function(key) {
        var field, externalContainer, internalContainer, frame, frameReadyPromise;
        if (!$hYQeJ.allowedFields.hasOwnProperty(key)) throw new $dcafC({
            type: $1bDti.HOSTED_FIELDS_INVALID_FIELD_KEY.type,
            code: $1bDti.HOSTED_FIELDS_INVALID_FIELD_KEY.code,
            message: '"' + key + '" is not a valid field.'
        });
        field = options.fields[key];
        // NEXT_MAJOR_VERSION remove selector as an option
        // and simply make the API take a container
        externalContainer = field.container || field.selector;
        if (typeof externalContainer === "string") externalContainer = document.querySelector(externalContainer);
        if (!externalContainer || externalContainer.nodeType !== 1) throw new $dcafC({
            type: $1bDti.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.type,
            code: $1bDti.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.code,
            message: $1bDti.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.message,
            details: {
                fieldSelector: field.selector,
                fieldContainer: field.container,
                fieldKey: key
            }
        });
        else if (externalContainer.querySelector('iframe[name^="braintree-"]')) throw new $dcafC({
            type: $1bDti.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.type,
            code: $1bDti.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.code,
            message: $1bDti.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.message,
            details: {
                fieldSelector: field.selector,
                fieldContainer: field.container,
                fieldKey: key
            }
        });
        internalContainer = externalContainer;
        if ($iENnV.isShadowElement(internalContainer)) internalContainer = $iENnV.transformToSlot(internalContainer, "height: 100%");
        if (field.maxlength && typeof field.maxlength !== "number") throw new $dcafC({
            type: $1bDti.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
            code: $1bDti.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
            message: "The value for maxlength must be a number.",
            details: {
                fieldKey: key
            }
        });
        if (field.minlength && typeof field.minlength !== "number") throw new $dcafC({
            type: $1bDti.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
            code: $1bDti.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
            message: "The value for minlength must be a number.",
            details: {
                fieldKey: key
            }
        });
        frame = $2DRDC({
            type: key,
            name: "braintree-hosted-field-" + key,
            style: $hYQeJ.defaultIFrameStyle,
            title: field.iframeTitle || "Secure Credit Card Frame - " + $hYQeJ.allowedFields[key].label
        });
        this._bus.addTargetFrame(frame);
        this._injectedNodes.push.apply(this._injectedNodes, $gaafx(componentId, frame, internalContainer, function() {
            self.focus(key);
        }));
        this._setupLabelFocus(key, externalContainer);
        fields[key] = {
            frameElement: frame,
            containerElement: externalContainer
        };
        frameReadyPromise = new Promise(function(resolve) {
            frameReadyPromiseResolveFunctions[key] = resolve;
        });
        frameReadyPromises.push(frameReadyPromise);
        this._state.fields[key] = {
            isEmpty: true,
            isValid: false,
            isPotentiallyValid: true,
            isFocused: false,
            container: externalContainer
        };
        // prevents loading the iframe from blocking the code
        setTimeout(function() {
            frame.src = hostedFieldsUrl;
        }, 0);
    }).bind(this));
    if (this._merchantConfigurationOptions.styles) Object.keys(this._merchantConfigurationOptions.styles).forEach(function(selector) {
        var className = self._merchantConfigurationOptions.styles[selector];
        if (typeof className === "string") self._merchantConfigurationOptions.styles[selector] = $9ooKM(className);
    });
    this._bus.on($14cc299fe4911bbd$var$events.REMOVE_FOCUS_INTERCEPTS, function(data) {
        $14cc299fe4911bbd$require$destroyFocusIntercept(data && data.id);
    });
    this._bus.on($14cc299fe4911bbd$var$events.TRIGGER_FOCUS_CHANGE, $9ypus.createFocusChangeHandler(componentId, {
        onRemoveFocusIntercepts: function(element) {
            self._bus.emit($14cc299fe4911bbd$var$events.REMOVE_FOCUS_INTERCEPTS, {
                id: element
            });
        },
        onTriggerInputFocus: function(targetType) {
            self.focus(targetType);
        }
    }));
    this._bus.on($14cc299fe4911bbd$var$events.READY_FOR_CLIENT, function(reply) {
        self._clientPromise.then(function(client) {
            reply(client);
        });
    });
    this._bus.on($14cc299fe4911bbd$var$events.CARD_FORM_ENTRY_HAS_BEGUN, function() {
        $cIYHN.sendEvent(self._clientPromise, "hosted-fields.input.started");
    });
    this._bus.on($14cc299fe4911bbd$var$events.BIN_AVAILABLE, function(bin) {
        self._emit("binAvailable", {
            bin: bin
        });
    });
    failureTimeout = setTimeout(function() {
        $cIYHN.sendEvent(self._clientPromise, "custom.hosted-fields.load.timed-out");
        self._emit("timeout");
    }, $14cc299fe4911bbd$require$INTEGRATION_TIMEOUT_MS);
    Promise.all(frameReadyPromises).then(function(results) {
        var reply = results[0];
        clearTimeout(failureTimeout);
        reply($14cc299fe4911bbd$var$formatMerchantConfigurationForIframes(self._merchantConfigurationOptions));
        self._cleanUpFocusIntercepts();
        self._emit("ready");
    });
    this._bus.on($14cc299fe4911bbd$var$events.FRAME_READY, function(data, reply) {
        frameReadyPromiseResolveFunctions[data.field](reply);
    });
    this._bus.on($14cc299fe4911bbd$var$events.INPUT_EVENT, $14cc299fe4911bbd$var$createInputEventHandler(fields).bind(this));
    this._destructor.registerFunctionForTeardown(function() {
        var j, node, parent;
        for(j = 0; j < self._injectedNodes.length; j++){
            node = self._injectedNodes[j];
            parent = node.parentNode;
            parent.removeChild(node);
            parent.classList.remove($hYQeJ.externalClasses.FOCUSED, $hYQeJ.externalClasses.INVALID, $hYQeJ.externalClasses.VALID);
        }
    });
    this._destructor.registerFunctionForTeardown(function() {
        $14cc299fe4911bbd$require$destroyFocusIntercept();
    });
    this._destructor.registerFunctionForTeardown(function() {
        var methodNames = $jXxvS($14cc299fe4911bbd$var$HostedFields.prototype).concat($jXxvS($6aiin.prototype));
        $fbCls(self, methodNames);
    });
}
$6aiin.createChild($14cc299fe4911bbd$var$HostedFields);
$14cc299fe4911bbd$var$HostedFields.prototype._setupLabelFocus = function(type, container) {
    var labels, i;
    var self = this;
    var rootNode = $cgVjh(container);
    if (container.id == null) return;
    function triggerFocus() {
        self.focus(type);
    }
    // find any labels in the normal DOM
    labels = Array.prototype.slice.call(document.querySelectorAll('label[for="' + container.id + '"]'));
    if (rootNode !== document) // find any labels within the shadow dom
    labels = labels.concat(Array.prototype.slice.call(rootNode.querySelectorAll('label[for="' + container.id + '"]')));
    // find any labels surrounding the container that don't also have the `for` attribute
    labels = labels.concat($5E25m(container, "label"));
    // filter out any accidental duplicates
    labels = labels.filter(function(label, index, arr) {
        return arr.indexOf(label) === index;
    });
    for(i = 0; i < labels.length; i++)labels[i].addEventListener("click", triggerFocus, false);
    this._destructor.registerFunctionForTeardown(function() {
        for(i = 0; i < labels.length; i++)labels[i].removeEventListener("click", triggerFocus, false);
    });
};
$14cc299fe4911bbd$var$HostedFields.prototype._getAnyFieldContainer = function() {
    var self = this;
    return Object.keys(this._fields).reduce(function(found, field) {
        return found || self._fields[field].containerElement;
    }, null);
};
$14cc299fe4911bbd$var$HostedFields.prototype._cleanUpFocusIntercepts = function() {
    var iframeContainer, checkoutForm;
    if (document.forms.length < 1) this._bus.emit($14cc299fe4911bbd$var$events.REMOVE_FOCUS_INTERCEPTS);
    else {
        iframeContainer = this._getAnyFieldContainer();
        checkoutForm = $5E25m(iframeContainer, "form")[0];
        if (checkoutForm) $9ypus.removeExtraFocusElements(checkoutForm, (function(id) {
            this._bus.emit($14cc299fe4911bbd$var$events.REMOVE_FOCUS_INTERCEPTS, {
                id: id
            });
        }).bind(this));
        else this._bus.emit($14cc299fe4911bbd$var$events.REMOVE_FOCUS_INTERCEPTS);
    }
};
$14cc299fe4911bbd$var$HostedFields.prototype._attachInvalidFieldContainersToError = function(err) {
    if (!(err.details && err.details.invalidFieldKeys && err.details.invalidFieldKeys.length > 0)) return;
    err.details.invalidFields = {};
    err.details.invalidFieldKeys.forEach((function(field) {
        err.details.invalidFields[field] = this._fields[field].containerElement;
    }).bind(this));
};
/**
 * Get card verification challenges, such as requirements for cvv and postal code.
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. If no callback is provided, `getChallenges` returns a promise.
 * @example
 * hostedFieldsInstance.getChallenges().then(function (challenges) {
 *   challenges // ['cvv', 'postal_code']
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.getChallenges = function() {
    return this._clientPromise.then(function(client) {
        return client.getConfiguration().gatewayConfiguration.challenges;
    });
};
/**
 * Get supported card types configured in the Braintree Control Panel
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. If no callback is provided, `getSupportedCardTypes` returns a promise.
 * @example
 * hostedFieldsInstance.getSupportedCardTypes().then(function (cardTypes) {
 *   cardTypes // ['Visa', 'American Express', 'Mastercard']
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.getSupportedCardTypes = function() {
    return this._clientPromise.then(function(client) {
        var cards = client.getConfiguration().gatewayConfiguration.creditCards.supportedCardTypes.map(function(cardType) {
            if (cardType === "MasterCard") // Mastercard changed their branding. We can't update our
            // config without creating a breaking change, so we just
            // hard code the change here
            return "Mastercard";
            return cardType;
        });
        return cards;
    });
};
/**
 * Cleanly remove anything set up by {@link module:braintree-web/hosted-fields.create|create}.
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. No data is returned if teardown completes successfully. If no callback is provided, `teardown` returns a promise.
 * @example
 * hostedFieldsInstance.teardown(function (teardownErr) {
 *   if (teardownErr) {
 *     console.error('Could not tear down Hosted Fields!');
 *   } else {
 *     console.info('Hosted Fields has been torn down!');
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.teardown = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self._destructor.teardown(function(err) {
            $cIYHN.sendEvent(self._clientPromise, "custom.hosted-fields.teardown-completed");
            if (err) reject(err);
            else resolve();
        });
    });
};
/**
 * Tokenizes fields and returns a nonce payload.
 * @public
 * @param {object} [options] All tokenization options for the Hosted Fields component.
 * @param {boolean} [options.vault=false] When true, will vault the tokenized card. Cards will only be vaulted when using a client created with a client token that includes a customer ID. Note: merchants using Advanced Fraud Tools should not use this option, as device data will not be included.
 * @param {object} [options.authenticationInsight] Options for checking authentication insight - the [regulatory environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) of the tokenized card.
 * @param {string} options.authenticationInsight.merchantAccountId The Braintree merchant account id to use to look up the authentication insight information.
 * @param {array} [options.fieldsToTokenize] By default, all fields will be tokenized. You may specify which fields specifically you wish to tokenize with this property. Valid options are `'number'`, `'cvv'`, `'expirationDate'`, `'expirationMonth'`, `'expirationYear'`, `'postalCode'`, `'cardholderName'`.
 * @param {string} [options.cardholderName] When supplied, the cardholder name to be tokenized with the contents of the fields.
 * @param {string} [options.billingAddress.postalCode] When supplied, this postal code will be tokenized along with the contents of the fields. If a postal code is provided as part of the Hosted Fields configuration, the value of the field will be tokenized and this value will be ignored.
 * @param {string} [options.billingAddress.firstName] When supplied, this customer first name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.lastName] When supplied, this customer last name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.company] When supplied, this company name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.streetAddress] When supplied, this street address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.extendedAddress] When supplied, this extended address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.locality] When supplied, this locality (the city) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.region] When supplied, this region (the state) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeNumeric] When supplied, this numeric country code will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha2] When supplied, this alpha 2 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha3] When supplied, this alpha 3 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryName] When supplied, this country name will be tokenized along with the contents of the fields.
 *
 * @param {callback} [callback] May be used as the only parameter of the function if no options are passed in. The second argument, <code>data</code>, is a {@link HostedFields~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link HostedFields~tokenizePayload|tokenizePayload}.
 * @example <caption>Tokenize a card</caption>
 * hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     switch (tokenizeErr.code) {
 *       case 'HOSTED_FIELDS_FIELDS_EMPTY':
 *         // occurs when none of the fields are filled in
 *         console.error('All fields are empty! Please fill out the form.');
 *         break;
 *       case 'HOSTED_FIELDS_FIELDS_INVALID':
 *         // occurs when certain fields do not pass client side validation
 *         console.error('Some fields are invalid:', tokenizeErr.details.invalidFieldKeys);
 *
 *         // you can also programmatically access the field containers for the invalid fields
 *         tokenizeErr.details.invalidFields.forEach(function (fieldContainer) {
 *           fieldContainer.className = 'invalid';
 *         });
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the fail on duplicate payment method
 *         //     option is set to true
 *         //   * the card being tokenized has previously been vaulted (with any customer)
 *         // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.fail_on_duplicate_payment_method
 *         console.error('This payment method already exists in your vault.');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the verify card option is set to true
 *         //     and you have credit card verification turned on in the Braintree
 *         //     control panel
 *         //   * the cvv does not pass verification (https://developer.paypal.com/braintree/docs/reference/general/testing#avs-and-cvv/cid-responses)
 *         // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.verify_card
 *         console.error('CVV did not pass verification');
 *         break;
 *       case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
 *         // occurs for any other tokenization error on the server
 *         console.error('Tokenization failed server side. Is the card valid?');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
 *         // occurs when the Braintree gateway cannot be contacted
 *         console.error('Network error occurred when tokenizing.');
 *         break;
 *       default:
 *         console.error('Something bad happened!', tokenizeErr);
 *     }
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize and vault a card</caption>
 * hostedFieldsInstance.tokenize({
 *   vault: true
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with non-Hosted Fields cardholder name</caption>
 * hostedFieldsInstance.tokenize({
 *   cardholderName: 'First Last'
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with non-Hosted Fields postal code option</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     postalCode: '11111'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with additional billing address options</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     firstName: 'First',
 *     lastName: 'Last',
 *     company: 'Company',
 *     streetAddress: '123 Street',
 *     extendedAddress: 'Unit 1',
 *     // passing just one of the country options is sufficient to
 *     // associate the card details with a particular country
 *     // valid country names and codes can be found here:
 *     // https://developer.paypal.com/braintree/docs/reference/general/countries/ruby#list-of-countries
 *     countryName: 'United States',
 *     countryCodeAlpha2: 'US',
 *     countryCodeAlpha3: 'USA',
 *     countryCodeNumeric: '840'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Allow tokenization with empty cardholder name field</caption>
 * var state = hostedFieldsInstance.getState();
 * var fields = Object.keys(state.fields);
 *
 * // normally, if you tried to tokenize an empty cardholder name field
 * // you would get an error, to allow making this field optional,
 * // tokenize all the fields except for the cardholder name field
 * // when the cardholder name field is empty. Otherwise, tokenize
 * // all the fields
 * if (state.fields.cardholderName.isEmpty) {
 *  fields = fields.filter(function (field) {
 *    return field !== 'cardholderName';
 *  });
 * }
 *
 * hostedFieldsInstance.tokenize({
 *  fieldsToTokenize: fields
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.tokenize = function(options) {
    var self = this;
    if (!options) options = {};
    return new Promise(function(resolve, reject) {
        self._bus.emit($14cc299fe4911bbd$var$events.TOKENIZATION_REQUEST, options, function(response) {
            var err = response[0];
            var payload = response[1];
            if (err) {
                self._attachInvalidFieldContainersToError(err);
                reject(new $dcafC(err));
            } else resolve(payload);
        });
    });
};
/**
 * Add a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to add a class to. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be added.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is added successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.addClass = function(field, classname) {
    var err;
    if (!$14cc299fe4911bbd$var$allowedFields.hasOwnProperty(field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_INVALID.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_INVALID.code,
        message: '"' + field + '" is not a valid field. You must use a valid field option when adding a class.'
    });
    else if (!this._fields.hasOwnProperty(field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
        message: 'Cannot add class to "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
    else this._bus.emit($14cc299fe4911bbd$var$events.ADD_CLASS, {
        field: field,
        classname: classname
    });
    if (err) return Promise.reject(err);
    return Promise.resolve();
};
/**
 * Removes a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to remove a class from. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be removed.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is removed successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *     return;
 *   }
 *
 *   // some time later...
 *   hostedFieldsInstance.removeClass('number', 'custom-class');
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.removeClass = function(field, classname) {
    var err;
    if (!$14cc299fe4911bbd$var$allowedFields.hasOwnProperty(field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_INVALID.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_INVALID.code,
        message: '"' + field + '" is not a valid field. You must use a valid field option when removing a class.'
    });
    else if (!this._fields.hasOwnProperty(field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
        message: 'Cannot remove class from "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
    else this._bus.emit($14cc299fe4911bbd$var$events.REMOVE_CLASS, {
        field: field,
        classname: classname
    });
    if (err) return Promise.reject(err);
    return Promise.resolve();
};
/**
 * Sets an attribute of a {@link module:braintree-web/hosted-fields~field field}.
 * Supported attributes are `aria-invalid`, `aria-required`, `disabled`, and `placeholder`.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to add to the field.
 * @param {string} options.value The value for the attribute.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is set successfully.
 *
 * @example <caption>Set the placeholder attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'placeholder',
 *   value: '1111 1111 1111 1111'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @example <caption>Set the aria-required attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'aria-required',
 *   value: true
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.setAttribute = function(options) {
    var attributeErr, err;
    if (!$14cc299fe4911bbd$var$allowedFields.hasOwnProperty(options.field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_INVALID.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_INVALID.code,
        message: '"' + options.field + '" is not a valid field. You must use a valid field option when setting an attribute.'
    });
    else if (!this._fields.hasOwnProperty(options.field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
        message: 'Cannot set attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
    });
    else {
        attributeErr = $27Y9u(options.attribute, options.value);
        if (attributeErr) err = attributeErr;
        else this._bus.emit($14cc299fe4911bbd$var$events.SET_ATTRIBUTE, {
            field: options.field,
            attribute: options.attribute,
            value: options.value
        });
    }
    if (err) return Promise.reject(err);
    return Promise.resolve();
};
/**
 * Sets the month options for the expiration month field when presented as a select element.
 *
 * @public
 * @param {array} options An array of 12 entries corresponding to the 12 months.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the options are updated successfully. Errors if expirationMonth is not configured on the Hosted Fields instance or if the expirationMonth field is not configured to be a select input.
 *
 * @example <caption>Update the month options to spanish</caption>
 * hostedFieldsInstance.setMonthOptions([
 *   '01 - enero',
 *   '02 - febrero',
 *   '03 - marzo',
 *   '04 - abril',
 *   '05 - mayo',
 *   '06 - junio',
 *   '07 - julio',
 *   '08 - agosto',
 *   '09 - septiembre',
 *   '10 - octubre',
 *   '11 - noviembre',
 *   '12 - diciembre'
 * ]);
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.setMonthOptions = function(options) {
    var self = this;
    var merchantOptions = this._merchantConfigurationOptions.fields;
    var errorMessage;
    if (!merchantOptions.expirationMonth) errorMessage = "Expiration month field must exist to use setMonthOptions.";
    else if (!merchantOptions.expirationMonth.select) errorMessage = "Expiration month field must be a select element.";
    if (errorMessage) return Promise.reject(new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
        message: errorMessage
    }));
    return new Promise(function(resolve) {
        self._bus.emit($14cc299fe4911bbd$var$events.SET_MONTH_OPTIONS, options, resolve);
    });
};
/**
 * Sets a visually hidden message (for screen readers) on a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~field field}.
 * @param {string} options.message The message to set.
 *
 * @example <caption>Set an error message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: 'Invalid card number'
 * });
 *
 * @example <caption>Remove the message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: ''
 * });
 *
 * @returns {void}
 */ $14cc299fe4911bbd$var$HostedFields.prototype.setMessage = function(options) {
    this._bus.emit($14cc299fe4911bbd$var$events.SET_MESSAGE, {
        field: options.field,
        message: options.message
    });
};
/**
 * Removes a supported attribute from a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to remove.
 * @param {string} options.field The field from which you wish to remove an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to remove from the field.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is removed successfully.
 *
 * @example <caption>Remove the placeholder attribute of a field</caption>
 * hostedFieldsInstance.removeAttribute({
 *   field: 'number',
 *   attribute: 'placeholder'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.removeAttribute = function(options) {
    var attributeErr, err;
    if (!$14cc299fe4911bbd$var$allowedFields.hasOwnProperty(options.field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_INVALID.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_INVALID.code,
        message: '"' + options.field + '" is not a valid field. You must use a valid field option when removing an attribute.'
    });
    else if (!this._fields.hasOwnProperty(options.field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
        message: 'Cannot remove attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
    });
    else {
        attributeErr = $27Y9u(options.attribute);
        if (attributeErr) err = attributeErr;
        else this._bus.emit($14cc299fe4911bbd$var$events.REMOVE_ATTRIBUTE, {
            field: options.field,
            attribute: options.attribute
        });
    }
    if (err) return Promise.reject(err);
    return Promise.resolve();
};
/**
 * @deprecated since version 3.8.0. Use {@link HostedFields#setAttribute|setAttribute} instead.
 *
 * @public
 * @param {string} field The field whose placeholder you wish to change. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} placeholder Will be used as the `placeholder` attribute of the input.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the placeholder updated successfully.
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $14cc299fe4911bbd$var$HostedFields.prototype.setPlaceholder = function(field, placeholder) {
    return this.setAttribute({
        field: field,
        attribute: "placeholder",
        value: placeholder
    });
};
/**
 * Clear the value of a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you wish to clear. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field cleared successfully.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * hostedFieldsInstance.clear('number', function (clearErr) {
 *   if (clearErr) {
 *     console.error(clearErr);
 *   }
 * });
 *
 * @example <caption>Clear several fields</caption>
 * hostedFieldsInstance.clear('number');
 * hostedFieldsInstance.clear('cvv');
 * hostedFieldsInstance.clear('expirationDate');
 */ $14cc299fe4911bbd$var$HostedFields.prototype.clear = function(field) {
    var err;
    if (!$14cc299fe4911bbd$var$allowedFields.hasOwnProperty(field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_INVALID.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_INVALID.code,
        message: '"' + field + '" is not a valid field. You must use a valid field option when clearing a field.'
    });
    else if (!this._fields.hasOwnProperty(field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
        message: 'Cannot clear "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
    else this._bus.emit($14cc299fe4911bbd$var$events.CLEAR_FIELD, {
        field: field
    });
    if (err) return Promise.reject(err);
    return Promise.resolve();
};
/**
 * Programmatically focus a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you want to focus. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field focused successfully.
 * @returns {void}
 * @example
 * hostedFieldsInstance.focus('number', function (focusErr) {
 *   if (focusErr) {
 *     console.error(focusErr);
 *   }
 * });
 * @example <caption>Using an event listener</caption>
 * myElement.addEventListener('click', function (e) {
 *   // In Firefox, the focus method can be suppressed
 *   //   if the element has a tabindex property or the element
 *   //   is an anchor link with an href property.
 *   e.preventDefault();
 *   hostedFieldsInstance.focus('number');
 * });
 */ $14cc299fe4911bbd$var$HostedFields.prototype.focus = function(field) {
    var err;
    var fieldConfig = this._fields[field];
    if (!$14cc299fe4911bbd$var$allowedFields.hasOwnProperty(field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_INVALID.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_INVALID.code,
        message: '"' + field + '" is not a valid field. You must use a valid field option when focusing a field.'
    });
    else if (!this._fields.hasOwnProperty(field)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
        code: $1bDti.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
        message: 'Cannot focus "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
    else {
        fieldConfig.frameElement.focus();
        this._bus.emit($14cc299fe4911bbd$var$events.TRIGGER_INPUT_FOCUS, {
            field: field
        });
        if ($hOQOA.isIos()) // Inputs outside of the viewport don't always scroll into view on
        // focus in iOS Safari. 5ms timeout gives the browser a chance to
        // do the right thing and prevents stuttering.
        setTimeout(function() {
            if (!$14cc299fe4911bbd$var$isVisibleEnough(fieldConfig.containerElement)) fieldConfig.containerElement.scrollIntoView();
        }, $14cc299fe4911bbd$var$SAFARI_FOCUS_TIMEOUT);
    }
    if (err) return Promise.reject(err);
    return Promise.resolve();
};
/**
 * Returns an {@link HostedFields~stateObject|object} that includes the state of all fields and possible card types.
 * @public
 * @returns {object} {@link HostedFields~stateObject|stateObject}
 * @example <caption>Check if all fields are valid</caption>
 * var state = hostedFieldsInstance.getState();
 *
 * var formValid = Object.keys(state.fields).every(function (key) {
 *   return state.fields[key].isValid;
 * });
 */ $14cc299fe4911bbd$var$HostedFields.prototype.getState = function() {
    return this._state;
};
// React adds decorations to DOM nodes that cause
// circular dependencies, so we remove them from the
// config before sending it to the iframes. However,
// we don't want to mutate the original object that
// was passed in, so we create fresh objects via assign
function $14cc299fe4911bbd$var$formatMerchantConfigurationForIframes(config) {
    var formattedConfig = $14cc299fe4911bbd$require$assign({}, config);
    formattedConfig.fields = $14cc299fe4911bbd$require$assign({}, formattedConfig.fields);
    Object.keys(formattedConfig.fields).forEach(function(field) {
        formattedConfig.fields[field] = $14cc299fe4911bbd$require$assign({}, formattedConfig.fields[field]);
        delete formattedConfig.fields[field].container;
    });
    return formattedConfig;
}
module.exports = $7GGVg.wrapPrototype($14cc299fe4911bbd$var$HostedFields);

});
parcelRegister("ePN3B", function(module, exports) {
"use strict";

var $3h7RY = parcelRequire("3h7RY");
var $accbe1da9dbfb934$require$ASSETS_URLS = $3h7RY.ASSETS_URLS;
function $accbe1da9dbfb934$var$createAssetsUrl(authorization) {
    return $accbe1da9dbfb934$require$ASSETS_URLS.production;
}
/* eslint-enable */ module.exports = {
    create: $accbe1da9dbfb934$var$createAssetsUrl
};

});

parcelRegister("eXDl5", function(module, exports) {
"use strict";

var $3e8Do = parcelRequire("3e8Do");
function $ae45175350c454bc$var$Destructor() {
    this._teardownRegistry = [];
    this._isTearingDown = false;
}
$ae45175350c454bc$var$Destructor.prototype.registerFunctionForTeardown = function(fn) {
    if (typeof fn === "function") this._teardownRegistry.push(fn);
};
$ae45175350c454bc$var$Destructor.prototype.teardown = function(callback) {
    if (this._isTearingDown) {
        callback(new Error("Destructor is already tearing down"));
        return;
    }
    this._isTearingDown = true;
    $3e8Do(this._teardownRegistry, (function(err) {
        this._teardownRegistry = [];
        this._isTearingDown = false;
        if (typeof callback === "function") callback(err);
    }).bind(this));
};
module.exports = $ae45175350c454bc$var$Destructor;

});
parcelRegister("3e8Do", function(module, exports) {
"use strict";

var $3f8Xq = parcelRequire("3f8Xq");
function $2599608686d6e02d$var$call(fn, callback) {
    var isSync = fn.length === 0;
    if (isSync) {
        fn();
        callback(null);
    } else fn(callback);
}
module.exports = function(functions, cb) {
    var i;
    var length = functions.length;
    var remaining = length;
    var callback = $3f8Xq(cb);
    if (length === 0) {
        callback(null);
        return;
    }
    function finish(err) {
        if (err) {
            callback(err);
            return;
        }
        remaining -= 1;
        if (remaining === 0) callback(null);
    }
    for(i = 0; i < length; i++)$2599608686d6e02d$var$call(functions[i], finish);
};

});


parcelRegister("2DRDC", function(module, exports) {
"use strict";

var $aPwUY = parcelRequire("aPwUY");

var $8xnXS = parcelRequire("8xnXS");

var $mu1XX = parcelRequire("mu1XX");
module.exports = function createFrame(options) {
    if (options === void 0) options = {};
    var iframe = document.createElement("iframe");
    var config = $mu1XX.assign({}, $8xnXS.defaultAttributes, options);
    if (config.style && typeof config.style !== "string") {
        $mu1XX.assign(iframe.style, config.style);
        delete config.style;
    }
    $aPwUY.setAttributes(iframe, config);
    if (!iframe.getAttribute("id")) iframe.id = iframe.name;
    return iframe;
};

});
parcelRegister("aPwUY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setAttributes = void 0;
function $7e283397b7c3d98e$var$setAttributes(element, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attributes) {
    for(var key in attributes)if (attributes.hasOwnProperty(key)) {
        var value = attributes[key];
        if (value == null) element.removeAttribute(key);
        else element.setAttribute(key, value);
    }
}
module.exports.setAttributes = $7e283397b7c3d98e$var$setAttributes;

});

parcelRegister("8xnXS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultAttributes = void 0;
module.exports.defaultAttributes = {
    src: "about:blank",
    frameBorder: 0,
    allowtransparency: true,
    scrolling: "no"
};

});

parcelRegister("mu1XX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assign = void 0;
function $043959a9832dec56$var$assign(// eslint-disable-next-line @typescript-eslint/no-explicit-any
target) {
    var objs = [];
    for(var _i = 1; _i < arguments.length; _i++)objs[_i - 1] = arguments[_i];
    objs.forEach(function(obj) {
        if (typeof obj !== "object") return;
        Object.keys(obj).forEach(function(key) {
            target[key] = obj[key];
        });
    });
    return target;
}
module.exports.assign = $043959a9832dec56$var$assign;

});


parcelRegister("efA95", function(module, exports) {
"use strict";

var $8C902 = parcelRequire("8C902");

var $k0Ml2 = parcelRequire("k0Ml2");
(0, $8C902.attach)();
module.exports = $k0Ml2.Framebus;

});
parcelRegister("8C902", function(module, exports) {
"use strict";
var $6458da797c0328ee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6458da797c0328ee$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6458da797c0328ee$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6458da797c0328ee$var$__exportStar((parcelRequire("1BSyi")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("koo5p")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("jwnXk")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("32J87")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("84R2K")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("b0Oe3")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("fScni")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("5WcqU")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("hjA1C")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("9mdxn")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("5XIPC")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("3BGg9")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("bwRb1")), module.exports);

$6458da797c0328ee$var$__exportStar((parcelRequire("kw1q4")), module.exports);

});
parcelRegister("1BSyi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.detach = module.exports.attach = void 0;

var $8C902 = parcelRequire("8C902");
var $12c39015a41d357b$var$isAttached = false;
function $12c39015a41d357b$var$attach() {
    if ($12c39015a41d357b$var$isAttached || typeof window === "undefined") return;
    $12c39015a41d357b$var$isAttached = true;
    window.addEventListener("message", $8C902.onMessage, false);
}
module.exports.attach = $12c39015a41d357b$var$attach;
// removeIf(production)
function $12c39015a41d357b$var$detach() {
    $12c39015a41d357b$var$isAttached = false;
    window.removeEventListener("message", $8C902.onMessage, false);
}
module.exports.detach = $12c39015a41d357b$var$detach; // endRemoveIf(production)

});

parcelRegister("koo5p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.broadcastToChildWindows = void 0;

var $8C902 = parcelRequire("8C902");
function $ed88bb8fd49f9fe8$var$broadcastToChildWindows(payload, origin, source) {
    for(var i = $8C902.childWindows.length - 1; i >= 0; i--){
        var childWindow = $8C902.childWindows[i];
        if (childWindow.closed) $8C902.childWindows.splice(i, 1);
        else if (source !== childWindow) (0, $8C902.broadcast)(payload, {
            origin: origin,
            frame: childWindow.top
        });
    }
}
module.exports.broadcastToChildWindows = $ed88bb8fd49f9fe8$var$broadcastToChildWindows;

});

parcelRegister("jwnXk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.broadcast = void 0;

var $8C902 = parcelRequire("8C902");
function $e363969f7b5de61b$var$broadcast(payload, options) {
    var i = 0;
    var frameToBroadcastTo;
    var origin = options.origin, frame = options.frame;
    try {
        frame.postMessage(payload, origin);
        if ((0, $8C902.hasOpener)(frame) && frame.opener.top !== window.top) $e363969f7b5de61b$var$broadcast(payload, {
            origin: origin,
            frame: frame.opener.top
        });
        // previously, our max value was frame.frames.length
        // but frames.length inherits from window.length
        // which can be overwritten if a developer does
        // `var length = value;` outside of a function
        // scope, it'll prevent us from looping through
        // all the frames. With this, we loop through
        // until there are no longer any frames
        // eslint-disable-next-line no-cond-assign
        while(frameToBroadcastTo = frame.frames[i]){
            $e363969f7b5de61b$var$broadcast(payload, {
                origin: origin,
                frame: frameToBroadcastTo
            });
            i++;
        }
    } catch (_) {
    /* ignored */ }
}
module.exports.broadcast = $e363969f7b5de61b$var$broadcast;

});

parcelRegister("32J87", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.subscribers = module.exports.childWindows = module.exports.prefix = void 0;
module.exports.prefix = "/*framebus*/";
module.exports.childWindows = [];
module.exports.subscribers = {};

});

parcelRegister("84R2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dispatch = void 0;

var $8C902 = parcelRequire("8C902");
function $5e17d7b963a8ea06$var$dispatch(origin, event, data, reply, e) {
    if (!$8C902.subscribers[origin]) return;
    if (!$8C902.subscribers[origin][event]) return;
    var args = [];
    if (data) args.push(data);
    if (reply) args.push(reply);
    for(var i = 0; i < $8C902.subscribers[origin][event].length; i++)$8C902.subscribers[origin][event][i].apply(e, args);
}
module.exports.dispatch = $5e17d7b963a8ea06$var$dispatch;

});

parcelRegister("b0Oe3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasOpener = void 0;
function $8046a78de878141f$var$hasOpener(frame) {
    if (frame.top !== frame) return false;
    if (frame.opener == null) return false;
    if (frame.opener === frame) return false;
    if (frame.opener.closed === true) return false;
    return true;
}
module.exports.hasOpener = $8046a78de878141f$var$hasOpener;

});

parcelRegister("fScni", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isntString = void 0;
function $b8e57f8b1dc238a6$var$isntString(str) {
    return typeof str !== "string";
}
module.exports.isntString = $b8e57f8b1dc238a6$var$isntString;

});

parcelRegister("5WcqU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.onMessage = void 0;

var $8C902 = parcelRequire("8C902");
function $452c037ccc0b0c8d$var$onMessage(e) {
    if ((0, $8C902.isntString)(e.data)) return;
    var payload = (0, $8C902.unpackPayload)(e);
    if (!payload) return;
    var data = payload.eventData;
    var reply = payload.reply;
    (0, $8C902.dispatch)("*", payload.event, data, reply, e);
    (0, $8C902.dispatch)(e.origin, payload.event, data, reply, e);
    (0, $8C902.broadcastToChildWindows)(e.data, payload.origin, e.source);
}
module.exports.onMessage = $452c037ccc0b0c8d$var$onMessage;

});

parcelRegister("hjA1C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.packagePayload = void 0;

var $8C902 = parcelRequire("8C902");
function $c9b027d61065b7f2$var$packagePayload(event, origin, data, reply) {
    var packaged;
    var payload = {
        event: event,
        origin: origin
    };
    if (typeof reply === "function") payload.reply = (0, $8C902.subscribeReplier)(reply, origin);
    payload.eventData = data;
    try {
        packaged = $8C902.prefix + JSON.stringify(payload);
    } catch (e) {
        throw new Error("Could not stringify event: ".concat(e.message));
    }
    return packaged;
}
module.exports.packagePayload = $c9b027d61065b7f2$var$packagePayload;

});

parcelRegister("9mdxn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sendMessage = void 0;
/**
 * A basic function for wrapping the sending of postMessages to frames.
 */ function $6d00ab57080ac5ef$var$sendMessage(frame, payload, origin) {
    try {
        frame.postMessage(payload, origin);
    } catch (error) {
    /* ignored */ }
}
module.exports.sendMessage = $6d00ab57080ac5ef$var$sendMessage;

});

parcelRegister("5XIPC", function(module, exports) {
"use strict";
var $45753d085dc2a7f6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.subscribeReplier = void 0;

var $k0Ml2 = parcelRequire("k0Ml2");

var $45753d085dc2a7f6$var$uuid_1 = $45753d085dc2a7f6$var$__importDefault((parcelRequire("eC4sQ")));
function $45753d085dc2a7f6$var$subscribeReplier(fn, origin) {
    var uuid = (0, $45753d085dc2a7f6$var$uuid_1.default)();
    function replier(data, replyOriginHandler) {
        fn(data, replyOriginHandler);
        $k0Ml2.Framebus.target({
            origin: origin
        }).off(uuid, replier);
    }
    $k0Ml2.Framebus.target({
        origin: origin
    }).on(uuid, replier);
    return uuid;
}
module.exports.subscribeReplier = $45753d085dc2a7f6$var$subscribeReplier;

});
parcelRegister("k0Ml2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Framebus = void 0;

var $8C902 = parcelRequire("8C902");
var $e9194dbe627ac690$var$DefaultPromise = typeof window !== "undefined" && window.Promise;
var $e9194dbe627ac690$var$Framebus = /** @class */ function() {
    function Framebus(options) {
        if (options === void 0) options = {};
        this.origin = options.origin || "*";
        this.channel = options.channel || "";
        this.verifyDomain = options.verifyDomain;
        // if a targetFrames configuration is not passed in,
        // the default behavior is to broadcast the payload
        // to the top level window or to the frame itself.
        // By default, the broadcast function will loop through
        // all the known siblings and children of the window.
        // If a targetFrames array is passed, it will instead
        // only broadcast to those specified targetFrames
        this.targetFrames = options.targetFrames || [];
        this.limitBroadcastToFramesArray = Boolean(options.targetFrames);
        this.isDestroyed = false;
        this.listeners = [];
        this.hasAdditionalChecksForOnListeners = Boolean(this.verifyDomain || this.limitBroadcastToFramesArray);
    }
    Framebus.setPromise = function(PromiseGlobal) {
        Framebus.Promise = PromiseGlobal;
    };
    Framebus.target = function(options) {
        return new Framebus(options);
    };
    Framebus.prototype.addTargetFrame = function(frame) {
        if (!this.limitBroadcastToFramesArray) return;
        this.targetFrames.push(frame);
    };
    Framebus.prototype.include = function(childWindow) {
        if (childWindow == null) return false;
        if (childWindow.Window == null) return false;
        if (childWindow.constructor !== childWindow.Window) return false;
        $8C902.childWindows.push(childWindow);
        return true;
    };
    Framebus.prototype.target = function(options) {
        return Framebus.target(options);
    };
    Framebus.prototype.emit = function(eventName, data, reply) {
        if (this.isDestroyed) return false;
        var origin = this.origin;
        eventName = this.namespaceEvent(eventName);
        if ((0, $8C902.isntString)(eventName)) return false;
        if ((0, $8C902.isntString)(origin)) return false;
        if (typeof data === "function") {
            reply = data;
            data = undefined; // eslint-disable-line no-undefined
        }
        var payload = (0, $8C902.packagePayload)(eventName, origin, data, reply);
        if (!payload) return false;
        if (this.limitBroadcastToFramesArray) this.targetFramesAsWindows().forEach(function(frame) {
            (0, $8C902.sendMessage)(frame, payload, origin);
        });
        else (0, $8C902.broadcast)(payload, {
            origin: origin,
            frame: window.top || window.self
        });
        return true;
    };
    Framebus.prototype.emitAsPromise = function(eventName, data) {
        var _this = this;
        return new Framebus.Promise(function(resolve, reject) {
            var didAttachListener = _this.emit(eventName, data, function(payload) {
                resolve(payload);
            });
            if (!didAttachListener) reject(new Error('Listener not added for "'.concat(eventName, '"')));
        });
    };
    Framebus.prototype.on = function(eventName, originalHandler) {
        if (this.isDestroyed) return false;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var origin = this.origin;
        var handler = originalHandler;
        eventName = this.namespaceEvent(eventName);
        if ((0, $8C902.subscriptionArgsInvalid)(eventName, handler, origin)) return false;
        if (this.hasAdditionalChecksForOnListeners) /* eslint-disable no-invalid-this, @typescript-eslint/ban-ts-comment */ handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // @ts-ignore
            if (!self.passesVerifyDomainCheck(this && this.origin)) return;
            // @ts-ignore
            if (!self.hasMatchingTargetFrame(this && this.source)) return;
            originalHandler.apply(void 0, args);
        };
        this.listeners.push({
            eventName: eventName,
            handler: handler,
            originalHandler: originalHandler
        });
        $8C902.subscribers[origin] = $8C902.subscribers[origin] || {};
        $8C902.subscribers[origin][eventName] = $8C902.subscribers[origin][eventName] || [];
        $8C902.subscribers[origin][eventName].push(handler);
        return true;
    };
    Framebus.prototype.off = function(eventName, originalHandler) {
        var handler = originalHandler;
        if (this.isDestroyed) return false;
        if (this.verifyDomain) for(var i = 0; i < this.listeners.length; i++){
            var listener = this.listeners[i];
            if (listener.originalHandler === originalHandler) handler = listener.handler;
        }
        eventName = this.namespaceEvent(eventName);
        var origin = this.origin;
        if ((0, $8C902.subscriptionArgsInvalid)(eventName, handler, origin)) return false;
        var subscriberList = $8C902.subscribers[origin] && $8C902.subscribers[origin][eventName];
        if (!subscriberList) return false;
        for(var i = 0; i < subscriberList.length; i++)if (subscriberList[i] === handler) {
            subscriberList.splice(i, 1);
            return true;
        }
        return false;
    };
    Framebus.prototype.teardown = function() {
        if (this.isDestroyed) return;
        this.isDestroyed = true;
        for(var i = 0; i < this.listeners.length; i++){
            var listener = this.listeners[i];
            this.off(listener.eventName, listener.handler);
        }
        this.listeners.length = 0;
    };
    Framebus.prototype.passesVerifyDomainCheck = function(origin) {
        if (!this.verifyDomain) // always pass this check if no verifyDomain option was set
        return true;
        return this.checkOrigin(origin);
    };
    Framebus.prototype.targetFramesAsWindows = function() {
        if (!this.limitBroadcastToFramesArray) return [];
        return this.targetFrames.map(function(frame) {
            // we can't pull off the contentWindow
            // when the iframe is originally added
            // to the array, because if it is not
            // in the DOM at that time, it will have
            // a contentWindow of `null`
            if (frame instanceof HTMLIFrameElement) return frame.contentWindow;
            return frame;
        }).filter(function(win) {
            // just in case an iframe element
            // was removed from the DOM
            // and the contentWindow property
            // is null
            return win;
        });
    };
    Framebus.prototype.hasMatchingTargetFrame = function(source) {
        if (!this.limitBroadcastToFramesArray) // always pass this check if we aren't limiting to the target frames
        return true;
        var matchingFrame = this.targetFramesAsWindows().find(function(frame) {
            return frame === source;
        });
        return Boolean(matchingFrame);
    };
    Framebus.prototype.checkOrigin = function(postMessageOrigin) {
        var merchantHost;
        var a = document.createElement("a");
        a.href = location.href;
        if (a.protocol === "https:") merchantHost = a.host.replace(/:443$/, "");
        else if (a.protocol === "http:") merchantHost = a.host.replace(/:80$/, "");
        else merchantHost = a.host;
        var merchantOrigin = a.protocol + "//" + merchantHost;
        if (merchantOrigin === postMessageOrigin) return true;
        if (this.verifyDomain) return this.verifyDomain(postMessageOrigin);
        return true;
    };
    Framebus.prototype.namespaceEvent = function(eventName) {
        if (!this.channel) return eventName;
        return "".concat(this.channel, ":").concat(eventName);
    };
    Framebus.Promise = $e9194dbe627ac690$var$DefaultPromise;
    return Framebus;
}();
module.exports.Framebus = $e9194dbe627ac690$var$Framebus;

});


parcelRegister("3BGg9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.subscriptionArgsInvalid = void 0;

var $8C902 = parcelRequire("8C902");
function $2a059baa15e83639$var$subscriptionArgsInvalid(event, fn, origin) {
    if ((0, $8C902.isntString)(event)) return true;
    if (typeof fn !== "function") return true;
    return (0, $8C902.isntString)(origin);
}
module.exports.subscriptionArgsInvalid = $2a059baa15e83639$var$subscriptionArgsInvalid;

});

parcelRegister("bwRb1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kw1q4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unpackPayload = void 0;

var $8C902 = parcelRequire("8C902");
function $eef7e5ae4dc0dfc0$var$unpackPayload(e) {
    var payload;
    if (e.data.slice(0, $8C902.prefix.length) !== $8C902.prefix) return false;
    try {
        payload = JSON.parse(e.data.slice($8C902.prefix.length));
    } catch (err) {
        return false;
    }
    if (payload.reply) {
        var replyOrigin_1 = e.origin;
        var replySource_1 = e.source;
        var replyEvent_1 = payload.reply;
        payload.reply = function reply(replyData) {
            if (!replySource_1) return;
            var replyPayload = (0, $8C902.packagePayload)(replyEvent_1, replyOrigin_1, replyData);
            if (!replyPayload) return;
            replySource_1.postMessage(replyPayload, replyOrigin_1);
        };
    }
    return payload;
}
module.exports.unpackPayload = $eef7e5ae4dc0dfc0$var$unpackPayload;

});



parcelRegister("b6BSv", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");

var $6rXUw = parcelRequire("6rXUw");

var $b3ukb = parcelRequire("b3ukb");
var $815da30eab7ccc9d$var$VERSION = "3.100.0";
function $815da30eab7ccc9d$var$createDeferredClient(options) {
    var promise = Promise.resolve();
    if (options.client) return Promise.resolve(options.client);
    if (!(window.braintree && window.braintree.client)) promise = $6rXUw.loadScript({
        src: options.assetsUrl + "/web/" + $815da30eab7ccc9d$var$VERSION + "/js/client.min.js"
    }).catch(function(err) {
        return Promise.reject(new $dcafC({
            type: $b3ukb.CLIENT_SCRIPT_FAILED_TO_LOAD.type,
            code: $b3ukb.CLIENT_SCRIPT_FAILED_TO_LOAD.code,
            message: $b3ukb.CLIENT_SCRIPT_FAILED_TO_LOAD.message,
            details: {
                originalError: err
            }
        }));
    });
    return promise.then(function() {
        if (window.braintree.client.VERSION !== $815da30eab7ccc9d$var$VERSION) return Promise.reject(new $dcafC({
            type: $b3ukb.INCOMPATIBLE_VERSIONS.type,
            code: $b3ukb.INCOMPATIBLE_VERSIONS.code,
            message: "Client (version " + window.braintree.client.VERSION + ") and " + options.name + " (version " + $815da30eab7ccc9d$var$VERSION + ") components must be from the same SDK version."
        }));
        return window.braintree.client.create({
            authorization: options.authorization,
            debug: options.debug
        });
    });
}
module.exports = {
    create: $815da30eab7ccc9d$var$createDeferredClient
};

});

parcelRegister("aTgXt", function(module, exports) {
"use strict";

var $hYQeJ = parcelRequire("hYQeJ");

var $5qThx = parcelRequire("5qThx");
module.exports = function composeUrl(assetsUrl, componentId, isDebug) {
    return assetsUrl + "/web/" + $hYQeJ.VERSION + "/html/hosted-fields-frame" + $5qThx(isDebug) + ".html#" + componentId;
};

});
parcelRegister("hYQeJ", function(module, exports) {
"use strict";

var $7GGem = parcelRequire("7GGem");

var $1bDti = parcelRequire("1bDti");
var $d1708f6037f81121$var$VERSION = "3.100.0";
var $d1708f6037f81121$var$constants = {
    VERSION: $d1708f6037f81121$var$VERSION,
    maxExpirationYearAge: 19,
    externalEvents: {
        FOCUS: "focus",
        BLUR: "blur",
        EMPTY: "empty",
        NOT_EMPTY: "notEmpty",
        VALIDITY_CHANGE: "validityChange",
        CARD_TYPE_CHANGE: "cardTypeChange"
    },
    defaultMaxLengths: {
        number: 19,
        postalCode: 8,
        expirationDate: 7,
        expirationMonth: 2,
        expirationYear: 4,
        cvv: 3
    },
    externalClasses: {
        FOCUSED: "braintree-hosted-fields-focused",
        INVALID: "braintree-hosted-fields-invalid",
        VALID: "braintree-hosted-fields-valid"
    },
    navigationDirections: {
        BACK: "before",
        FORWARD: "after"
    },
    defaultIFrameStyle: {
        border: "none",
        width: "100%",
        height: "100%",
        float: "left"
    },
    tokenizationErrorCodes: {
        81724: $1bDti.HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE,
        // NEXT_MAJOR_VERSION this error triggers for both AVS and CVV errors
        // but the code name implies that it would only trigger for CVV verification
        // failures
        81736: $1bDti.HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED
    },
    allowedStyles: [
        "-moz-appearance",
        "-moz-box-shadow",
        "-moz-osx-font-smoothing",
        "-moz-tap-highlight-color",
        "-moz-transition",
        "-webkit-appearance",
        "-webkit-box-shadow",
        "-webkit-font-smoothing",
        "-webkit-tap-highlight-color",
        "-webkit-transition",
        "appearance",
        "box-shadow",
        "color",
        "direction",
        "font",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-variant-alternates",
        "font-variant-caps",
        "font-variant-east-asian",
        "font-variant-ligatures",
        "font-variant-numeric",
        "font-weight",
        "letter-spacing",
        "line-height",
        "margin",
        "margin-top",
        "margin-right",
        "margin-bottom",
        "margin-left",
        "opacity",
        "outline",
        "padding",
        "padding-top",
        "padding-right",
        "padding-bottom",
        "padding-left",
        "text-align",
        "text-shadow",
        "transition"
    ],
    allowedFields: {
        cardholderName: {
            name: "cardholder-name",
            label: "Cardholder Name"
        },
        number: {
            name: "credit-card-number",
            label: "Credit Card Number"
        },
        cvv: {
            name: "cvv",
            label: "CVV"
        },
        expirationDate: {
            name: "expiration",
            label: "Expiration Date"
        },
        expirationMonth: {
            name: "expiration-month",
            label: "Expiration Month"
        },
        expirationYear: {
            name: "expiration-year",
            label: "Expiration Year"
        },
        postalCode: {
            name: "postal-code",
            label: "Postal Code"
        }
    },
    allowedAttributes: {
        "aria-invalid": "boolean",
        "aria-required": "boolean",
        disabled: "boolean",
        placeholder: "string"
    },
    autocompleteMappings: {
        "cardholder-name": "cc-name",
        "credit-card-number": "cc-number",
        expiration: "cc-exp",
        "expiration-month": "cc-exp-month",
        "expiration-year": "cc-exp-year",
        cvv: "cc-csc",
        "postal-code": "billing postal-code"
    }
};
$d1708f6037f81121$var$constants.events = $7GGem([
    "ADD_CLASS",
    "AUTOFILL_DATA_AVAILABLE",
    "BIN_AVAILABLE",
    "CARD_FORM_ENTRY_HAS_BEGUN",
    "CLEAR_FIELD",
    "CONFIGURATION",
    "FRAME_READY",
    "INPUT_EVENT",
    "READY_FOR_CLIENT",
    "REMOVE_ATTRIBUTE",
    "REMOVE_CLASS",
    "REMOVE_FOCUS_INTERCEPTS",
    "SET_ATTRIBUTE",
    "SET_MESSAGE",
    "SET_MONTH_OPTIONS",
    "TOKENIZATION_REQUEST",
    "TRIGGER_FOCUS_CHANGE",
    "TRIGGER_INPUT_FOCUS",
    "VALIDATE_STRICT"
], "hosted-fields:");
module.exports = $d1708f6037f81121$var$constants;

});
parcelRegister("1bDti", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");
module.exports = {
    HOSTED_FIELDS_TIMEOUT: {
        type: $dcafC.types.UNKNOWN,
        code: "HOSTED_FIELDS_TIMEOUT",
        message: "Hosted Fields timed out when attempting to set up."
    },
    HOSTED_FIELDS_INVALID_FIELD_KEY: {
        type: $dcafC.types.MERCHANT,
        code: "HOSTED_FIELDS_INVALID_FIELD_KEY"
    },
    HOSTED_FIELDS_INVALID_FIELD_SELECTOR: {
        type: $dcafC.types.MERCHANT,
        code: "HOSTED_FIELDS_INVALID_FIELD_SELECTOR",
        message: "Selector does not reference a valid DOM node."
    },
    HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME: {
        type: $dcafC.types.MERCHANT,
        code: "HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME",
        message: "Element already contains a Braintree iframe."
    },
    HOSTED_FIELDS_FIELD_INVALID: {
        type: $dcafC.types.MERCHANT,
        code: "HOSTED_FIELDS_FIELD_INVALID"
    },
    HOSTED_FIELDS_FIELD_NOT_PRESENT: {
        type: $dcafC.types.MERCHANT,
        code: "HOSTED_FIELDS_FIELD_NOT_PRESENT"
    },
    HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR: {
        type: $dcafC.types.NETWORK,
        code: "HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR",
        message: "A tokenization network error occurred."
    },
    HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE: {
        type: $dcafC.types.CUSTOMER,
        code: "HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE",
        message: "This credit card already exists in the merchant's vault."
    },
    HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED: {
        type: $dcafC.types.CUSTOMER,
        code: "HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED",
        message: "CVV verification failed during tokenization."
    },
    HOSTED_FIELDS_FAILED_TOKENIZATION: {
        type: $dcafC.types.CUSTOMER,
        code: "HOSTED_FIELDS_FAILED_TOKENIZATION",
        message: "The supplied card data failed tokenization."
    },
    HOSTED_FIELDS_FIELDS_EMPTY: {
        type: $dcafC.types.CUSTOMER,
        code: "HOSTED_FIELDS_FIELDS_EMPTY",
        message: "All fields are empty. Cannot tokenize empty card fields."
    },
    HOSTED_FIELDS_FIELDS_INVALID: {
        type: $dcafC.types.CUSTOMER,
        code: "HOSTED_FIELDS_FIELDS_INVALID",
        message: "Some payment input fields are invalid. Cannot tokenize invalid card fields."
    },
    HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED: {
        type: $dcafC.types.MERCHANT,
        code: "HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED"
    },
    HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED: {
        type: $dcafC.types.MERCHANT,
        code: "HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED"
    },
    HOSTED_FIELDS_FIELD_PROPERTY_INVALID: {
        type: $dcafC.types.MERCHANT,
        code: "HOSTED_FIELDS_FIELD_PROPERTY_INVALID"
    }
};

});


parcelRegister("5qThx", function(module, exports) {
"use strict";
function $3f4a434a3230e320$var$useMin(isDebug) {
    return isDebug ? "" : ".min";
}
module.exports = $3f4a434a3230e320$var$useMin;

});


parcelRegister("9ooKM", function(module, exports) {
"use strict";

var $hYQeJ = parcelRequire("hYQeJ");
var $6d698e76da2c344c$require$allowedStyles = $hYQeJ.allowedStyles;
module.exports = function getStylesFromClass(cssClass) {
    var element = document.createElement("input");
    var styles = {};
    var computedStyles;
    if (cssClass[0] === ".") cssClass = cssClass.substring(1);
    element.className = cssClass;
    element.style.display = "none !important";
    element.style.position = "fixed !important";
    element.style.left = "-99999px !important";
    element.style.top = "-99999px !important";
    document.body.appendChild(element);
    computedStyles = window.getComputedStyle(element);
    $6d698e76da2c344c$require$allowedStyles.forEach(function(style) {
        var value = computedStyles[style];
        if (value) styles[style] = value;
    });
    document.body.removeChild(element);
    return styles;
};

});

parcelRegister("5E25m", function(module, exports) {
"use strict";
function $41c24e53473e0477$var$findParentTags(element, tag) {
    var parent = element.parentNode;
    var parents = [];
    while(parent != null){
        if (parent.tagName != null && parent.tagName.toLowerCase() === tag) parents.push(parent);
        parent = parent.parentNode;
    }
    return parents;
}
module.exports = $41c24e53473e0477$var$findParentTags;

});

parcelRegister("hOQOA", function(module, exports) {
"use strict";

var $4ydsa = parcelRequire("4ydsa");

var $37SMC = parcelRequire("37SMC");

var $cYvvY = parcelRequire("cYvvY");

var $emZrh = parcelRequire("emZrh");
function $cf90131e8c130bd9$var$hasSoftwareKeyboard() {
    return $4ydsa() || $37SMC() || $cYvvY();
}
function $cf90131e8c130bd9$var$isChromeIos() {
    return $emZrh() && $cYvvY();
}


module.exports = {
    isAndroid: $4ydsa,
    isChromeOS: $37SMC,
    isChromeIos: $cf90131e8c130bd9$var$isChromeIos,
    isFirefox: (parcelRequire("hBWQE")),
    isIos: $cYvvY,
    isIosWebview: (parcelRequire("1LoQD")),
    hasSoftwareKeyboard: $cf90131e8c130bd9$var$hasSoftwareKeyboard
};

});
parcelRegister("4ydsa", function(module, exports) {

module.exports = (parcelRequire("cBkZu"));

});
parcelRegister("cBkZu", function(module, exports) {
"use strict";
module.exports = function isAndroid(ua) {
    ua = ua || window.navigator.userAgent;
    return /Android/i.test(ua);
};

});


parcelRegister("37SMC", function(module, exports) {

module.exports = (parcelRequire("iPu7t"));

});
parcelRegister("iPu7t", function(module, exports) {
"use strict";
module.exports = function isChromeOS(ua) {
    ua = ua || window.navigator.userAgent;
    return /CrOS/i.test(ua);
};

});


parcelRegister("cYvvY", function(module, exports) {

module.exports = (parcelRequire("hEzZy"));

});
parcelRegister("hEzZy", function(module, exports) {
"use strict";

var $auwdL = parcelRequire("auwdL");
module.exports = function isIos(ua, checkIpadOS, document) {
    if (checkIpadOS === void 0) checkIpadOS = true;
    ua = ua || window.navigator.userAgent;
    var iOsTest = /iPhone|iPod|iPad/i.test(ua);
    return checkIpadOS ? iOsTest || $auwdL(ua, document) : iOsTest;
};

});
parcelRegister("auwdL", function(module, exports) {
"use strict";
module.exports = function isIpadOS(ua, document) {
    ua = ua || window.navigator.userAgent;
    document = document || window.document;
    // "ontouchend" is used to determine if a browser is on an iPad, otherwise
    // user-agents for iPadOS behave/identify as a desktop browser
    return /Mac|iPad/i.test(ua) && "ontouchend" in document;
};

});



parcelRegister("emZrh", function(module, exports) {

module.exports = (parcelRequire("3fc67"));

});
parcelRegister("3fc67", function(module, exports) {
"use strict";

var $eU0ka = parcelRequire("eU0ka");

var $luIGb = parcelRequire("luIGb");

var $fjmu3 = parcelRequire("fjmu3");

var $cWx1U = parcelRequire("cWx1U");

var $fEy8o = parcelRequire("fEy8o");
module.exports = function isChrome(ua) {
    ua = ua || window.navigator.userAgent;
    return (ua.indexOf("Chrome") !== -1 || ua.indexOf("CriOS") !== -1) && !$eU0ka(ua) && !$luIGb(ua) && !$fjmu3(ua) && !$cWx1U(ua) && !$fEy8o(ua);
};

});
parcelRegister("eU0ka", function(module, exports) {
"use strict";
module.exports = function isEdge(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("Edge/") !== -1;
};

});

parcelRegister("luIGb", function(module, exports) {
"use strict";
module.exports = function isSamsungBrowser(ua) {
    ua = ua || window.navigator.userAgent;
    return /SamsungBrowser/i.test(ua);
};

});

parcelRegister("fjmu3", function(module, exports) {
"use strict";
module.exports = function isDuckDuckGo(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("DuckDuckGo/") !== -1;
};

});

parcelRegister("cWx1U", function(module, exports) {
"use strict";
module.exports = function isOpera(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("OPR/") !== -1 || ua.indexOf("Opera/") !== -1 || ua.indexOf("OPT/") !== -1;
};

});

parcelRegister("fEy8o", function(module, exports) {
"use strict";
module.exports = function isSilk(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("Silk/") !== -1;
};

});



parcelRegister("hBWQE", function(module, exports) {

module.exports = (parcelRequire("iVSMO"));

});
parcelRegister("iVSMO", function(module, exports) {
"use strict";
module.exports = function isFirefox(ua) {
    ua = ua || window.navigator.userAgent;
    return /Firefox/i.test(ua);
};

});


parcelRegister("1LoQD", function(module, exports) {

module.exports = (parcelRequire("inabg"));

});
parcelRegister("inabg", function(module, exports) {
"use strict";

var $hEzZy = parcelRequire("hEzZy");

var $58wT3 = parcelRequire("58wT3");
module.exports = function isIosWebview(ua) {
    ua = ua || window.navigator.userAgent;
    if ($hEzZy(ua)) {
        // The Google Search iOS app is technically a webview and doesn't support popups.
        if ($58wT3(ua)) return true;
        // Historically, a webview could be identified by the presence of AppleWebKit and _no_ presence of Safari after.
        return /.+AppleWebKit(?!.*Safari)/i.test(ua);
    }
    return false;
};

});
parcelRegister("58wT3", function(module, exports) {
"use strict";

var $hEzZy = parcelRequire("hEzZy");
function $3bd735c31929ef85$var$isGoogleSearchApp(ua) {
    return /\bGSA\b/.test(ua);
}
module.exports = function isIosGoogleSearchApp(ua) {
    ua = ua || window.navigator.userAgent;
    return $hEzZy(ua) && $3bd735c31929ef85$var$isGoogleSearchApp(ua);
};

});




parcelRegister("6aiin", function(module, exports) {
"use strict";
var $47d1de5243484781$var$EventEmitter = /** @class */ function() {
    function EventEmitter() {
        this._events = {};
    }
    EventEmitter.prototype.on = function(event, callback) {
        if (this._events[event]) this._events[event].push(callback);
        else this._events[event] = [
            callback
        ];
    };
    EventEmitter.prototype.off = function(event, callback) {
        var eventCallbacks = this._events[event];
        if (!eventCallbacks) return;
        var indexOfCallback = eventCallbacks.indexOf(callback);
        eventCallbacks.splice(indexOfCallback, 1);
    };
    EventEmitter.prototype._emit = function(event) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var eventCallbacks = this._events[event];
        if (!eventCallbacks) return;
        eventCallbacks.forEach(function(callback) {
            callback.apply(void 0, args);
        });
    };
    EventEmitter.prototype.hasListener = function(event) {
        var eventCallbacks = this._events[event];
        if (!eventCallbacks) return false;
        return eventCallbacks.length > 0;
    };
    EventEmitter.createChild = function(ChildObject) {
        ChildObject.prototype = Object.create(EventEmitter.prototype, {
            constructor: ChildObject
        });
    };
    return EventEmitter;
}();
module.exports = $47d1de5243484781$var$EventEmitter;

});

parcelRegister("gaafx", function(module, exports) {
"use strict";

var $7S4Hg = parcelRequire("7S4Hg");

var $hYQeJ = parcelRequire("hYQeJ");
var $bc4587da5d72a0aa$require$directions = $hYQeJ.navigationDirections;
module.exports = function injectFrame(id, frame, container, focusHandler) {
    var frameType = frame.getAttribute("type");
    var clearboth = document.createElement("div");
    var fragment = document.createDocumentFragment();
    var focusInterceptBefore = $7S4Hg.generate(id, frameType, $bc4587da5d72a0aa$require$directions.BACK, focusHandler);
    var focusInterceptAfter = $7S4Hg.generate(id, frameType, $bc4587da5d72a0aa$require$directions.FORWARD, focusHandler);
    clearboth.style.clear = "both";
    fragment.appendChild(focusInterceptBefore);
    fragment.appendChild(frame);
    fragment.appendChild(focusInterceptAfter);
    fragment.appendChild(clearboth);
    container.appendChild(fragment);
    return [
        frame,
        clearboth
    ];
};

});
parcelRegister("7S4Hg", function(module, exports) {
"use strict";

var $hOQOA = parcelRequire("hOQOA");

var $hYQeJ = parcelRequire("hYQeJ");
var $5bb1383bbba08502$var$allowedFields = Object.keys($hYQeJ.allowedFields);
var $5bb1383bbba08502$var$directions = $hYQeJ.navigationDirections;
var $5bb1383bbba08502$var$focusIntercept = {
    generate: function(hostedFieldsId, type, direction, handler) {
        var input = document.createElement("input");
        var focusInterceptStyles = {
            border: "none !important",
            display: "block !important",
            height: "1px !important",
            left: "-1px !important",
            opacity: "0 !important",
            position: "absolute !important",
            top: "-1px !important",
            width: "1px !important"
        };
        var shouldCreateFocusIntercept = $hOQOA.hasSoftwareKeyboard() || $hOQOA.isFirefox();
        if (!shouldCreateFocusIntercept) return document.createDocumentFragment();
        input.setAttribute("aria-hidden", "true");
        input.setAttribute("autocomplete", "off");
        input.setAttribute("data-braintree-direction", direction);
        input.setAttribute("data-braintree-type", type);
        input.setAttribute("id", "bt-" + type + "-" + direction + "-" + hostedFieldsId);
        input.setAttribute("style", JSON.stringify(focusInterceptStyles).replace(/[{}"]/g, "").replace(/,/g, ";"));
        input.classList.add("focus-intercept");
        input.addEventListener("focus", function(event) {
            handler(event);
            /*
        Certain browsers without software keyboards (Firefox, Internet
        Explorer) need the focus intercept inputs that get inserted
        around the actual input to blur themselves, otherwise the
        browser gets confused about what should have focus. Can't
        apply this to browsers with software keyboards however,
        because it blurs everything, and focus on the actual input is
        also lost.
      */ if (!$hOQOA.hasSoftwareKeyboard()) input.blur();
        });
        return input;
    },
    destroy: function(idString) {
        var focusInputs;
        if (!idString) {
            focusInputs = document.querySelectorAll("[data-braintree-direction]");
            focusInputs = [].slice.call(focusInputs);
        } else focusInputs = [
            document.getElementById(idString)
        ];
        focusInputs.forEach(function(node) {
            if (node && node.nodeType === 1 && $5bb1383bbba08502$var$focusIntercept.matchFocusElement(node.getAttribute("id"))) node.parentNode.removeChild(node);
        });
    },
    matchFocusElement: function(idString) {
        var idComponents, hasBTPrefix, isAllowedType, isValidDirection;
        if (!idString) return false;
        idComponents = idString.split("-");
        if (idComponents.length < 4) return false;
        hasBTPrefix = idComponents[0] === "bt";
        isAllowedType = $5bb1383bbba08502$var$allowedFields.indexOf(idComponents[1]) > -1;
        isValidDirection = idComponents[2] === $5bb1383bbba08502$var$directions.BACK || idComponents[2] === $5bb1383bbba08502$var$directions.FORWARD;
        return Boolean(hasBTPrefix && isAllowedType && isValidDirection);
    }
};
module.exports = $5bb1383bbba08502$var$focusIntercept;

});


parcelRegister("iENnV", function(module, exports) {
"use strict";

var $eC4sQ = parcelRequire("eC4sQ");

var $cgVjh = parcelRequire("cgVjh");
// based on https://github.com/krakenjs/belter/blob/cdddc4f8ddb172d29db9e7e1ad1eeeacfb93e215/src/dom.js#L981-L1031
// thanks @bluepnume
function $d95245394f4c2337$var$isShadowElement(element) {
    element = $cgVjh(element);
    return element.toString() === "[object ShadowRoot]";
}
function $d95245394f4c2337$var$getShadowHost(element) {
    element = $cgVjh(element);
    if (!$d95245394f4c2337$var$isShadowElement(element)) return null;
    return element.host;
}
function $d95245394f4c2337$var$transformToSlot(element, styles) {
    var styleNode = $cgVjh(element).querySelector("style");
    var shadowHost = $d95245394f4c2337$var$getShadowHost(element);
    var slotName = "shadow-slot-" + $eC4sQ();
    var slot = document.createElement("slot");
    var slotProvider = document.createElement("div");
    slot.setAttribute("name", slotName);
    element.appendChild(slot);
    slotProvider.setAttribute("slot", slotName);
    shadowHost.appendChild(slotProvider);
    if (styles) {
        if (!styleNode) {
            styleNode = document.createElement("style");
            element.appendChild(styleNode);
        }
        styleNode.sheet.insertRule('::slotted([slot="' + slotName + '"]) { ' + styles + " }");
    }
    if ($d95245394f4c2337$var$isShadowElement(shadowHost)) return $d95245394f4c2337$var$transformToSlot(slotProvider, styles);
    return slotProvider;
}
module.exports = {
    isShadowElement: $d95245394f4c2337$var$isShadowElement,
    getShadowHost: $d95245394f4c2337$var$getShadowHost,
    transformToSlot: $d95245394f4c2337$var$transformToSlot
};

});
parcelRegister("cgVjh", function(module, exports) {
"use strict";
module.exports = function findRootNode(element) {
    while(element.parentNode)element = element.parentNode;
    return element;
};

});


parcelRegister("3L5ZD", function(module, exports) {
"use strict";

var $8WUyx = parcelRequire("8WUyx");
module.exports = function(number) {
    var results = $8WUyx(number);
    results.forEach(function(card) {
        // NEXT_MAJOR_VERSION credit-card-type fixed the mastercard enum
        // but we still pass master-card in the braintree API
        // in a major version bump, we can remove this and
        // this will be mastercard instead of master-card
        if (card.type === "mastercard") card.type = "master-card";
    });
    return results;
};

});
parcelRegister("8WUyx", function(module, exports) {
"use strict";
var $683f9c5df9b6e5d0$var$__assign = module.exports && module.exports.__assign || function() {
    $683f9c5df9b6e5d0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $683f9c5df9b6e5d0$var$__assign.apply(this, arguments);
};

var $egCJK = parcelRequire("egCJK");

var $7LBY9 = parcelRequire("7LBY9");

var $33iYf = parcelRequire("33iYf");

var $bFFgL = parcelRequire("bFFgL");

var $djLdC = parcelRequire("djLdC");
var $683f9c5df9b6e5d0$var$customCards = {};
var $683f9c5df9b6e5d0$var$cardNames = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    AMERICAN_EXPRESS: "american-express",
    DINERS_CLUB: "diners-club",
    DISCOVER: "discover",
    JCB: "jcb",
    UNIONPAY: "unionpay",
    MAESTRO: "maestro",
    ELO: "elo",
    MIR: "mir",
    HIPER: "hiper",
    HIPERCARD: "hipercard"
};
var $683f9c5df9b6e5d0$var$ORIGINAL_TEST_ORDER = [
    $683f9c5df9b6e5d0$var$cardNames.VISA,
    $683f9c5df9b6e5d0$var$cardNames.MASTERCARD,
    $683f9c5df9b6e5d0$var$cardNames.AMERICAN_EXPRESS,
    $683f9c5df9b6e5d0$var$cardNames.DINERS_CLUB,
    $683f9c5df9b6e5d0$var$cardNames.DISCOVER,
    $683f9c5df9b6e5d0$var$cardNames.JCB,
    $683f9c5df9b6e5d0$var$cardNames.UNIONPAY,
    $683f9c5df9b6e5d0$var$cardNames.MAESTRO,
    $683f9c5df9b6e5d0$var$cardNames.ELO,
    $683f9c5df9b6e5d0$var$cardNames.MIR,
    $683f9c5df9b6e5d0$var$cardNames.HIPER,
    $683f9c5df9b6e5d0$var$cardNames.HIPERCARD
];
var $683f9c5df9b6e5d0$var$testOrder = $djLdC.clone($683f9c5df9b6e5d0$var$ORIGINAL_TEST_ORDER);
function $683f9c5df9b6e5d0$var$findType(cardType) {
    return $683f9c5df9b6e5d0$var$customCards[cardType] || $egCJK[cardType];
}
function $683f9c5df9b6e5d0$var$getAllCardTypes() {
    return $683f9c5df9b6e5d0$var$testOrder.map(function(cardType) {
        return $djLdC.clone($683f9c5df9b6e5d0$var$findType(cardType));
    });
}
function $683f9c5df9b6e5d0$var$getCardPosition(name, ignoreErrorForNotExisting) {
    if (ignoreErrorForNotExisting === void 0) ignoreErrorForNotExisting = false;
    var position = $683f9c5df9b6e5d0$var$testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) throw new Error('"' + name + '" is not a supported card type.');
    return position;
}
function $683f9c5df9b6e5d0$var$creditCardType(cardNumber) {
    var results = [];
    if (!$33iYf.isValidInputType(cardNumber)) return results;
    if (cardNumber.length === 0) return $683f9c5df9b6e5d0$var$getAllCardTypes();
    $683f9c5df9b6e5d0$var$testOrder.forEach(function(cardType) {
        var cardConfiguration = $683f9c5df9b6e5d0$var$findType(cardType);
        $7LBY9.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
    });
    var bestMatch = $bFFgL.findBestMatch(results);
    if (bestMatch) return [
        bestMatch
    ];
    return results;
}
$683f9c5df9b6e5d0$var$creditCardType.getTypeInfo = function(cardType) {
    return $djLdC.clone($683f9c5df9b6e5d0$var$findType(cardType));
};
$683f9c5df9b6e5d0$var$creditCardType.removeCard = function(name) {
    var position = $683f9c5df9b6e5d0$var$getCardPosition(name);
    $683f9c5df9b6e5d0$var$testOrder.splice(position, 1);
};
$683f9c5df9b6e5d0$var$creditCardType.addCard = function(config) {
    var existingCardPosition = $683f9c5df9b6e5d0$var$getCardPosition(config.type, true);
    $683f9c5df9b6e5d0$var$customCards[config.type] = config;
    if (existingCardPosition === -1) $683f9c5df9b6e5d0$var$testOrder.push(config.type);
};
$683f9c5df9b6e5d0$var$creditCardType.updateCard = function(cardType, updates) {
    var originalObject = $683f9c5df9b6e5d0$var$customCards[cardType] || $egCJK[cardType];
    if (!originalObject) throw new Error('"' + cardType + "\" is not a recognized type. Use `addCard` instead.'");
    if (updates.type && originalObject.type !== updates.type) throw new Error("Cannot overwrite type parameter.");
    var clonedCard = $djLdC.clone(originalObject);
    clonedCard = $683f9c5df9b6e5d0$var$__assign($683f9c5df9b6e5d0$var$__assign({}, clonedCard), updates);
    $683f9c5df9b6e5d0$var$customCards[clonedCard.type] = clonedCard;
};
$683f9c5df9b6e5d0$var$creditCardType.changeOrder = function(name, position) {
    var currentPosition = $683f9c5df9b6e5d0$var$getCardPosition(name);
    $683f9c5df9b6e5d0$var$testOrder.splice(currentPosition, 1);
    $683f9c5df9b6e5d0$var$testOrder.splice(position, 0, name);
};
$683f9c5df9b6e5d0$var$creditCardType.resetModifications = function() {
    $683f9c5df9b6e5d0$var$testOrder = $djLdC.clone($683f9c5df9b6e5d0$var$ORIGINAL_TEST_ORDER);
    $683f9c5df9b6e5d0$var$customCards = {};
};
$683f9c5df9b6e5d0$var$creditCardType.types = $683f9c5df9b6e5d0$var$cardNames;
module.exports = $683f9c5df9b6e5d0$var$creditCardType;

});
parcelRegister("egCJK", function(module, exports) {
"use strict";
var $a6309ba5070e0fcf$var$cardTypes = {
    visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [
            4
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            18,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [
            [
                51,
                55
            ],
            [
                2221,
                2229
            ],
            [
                223,
                229
            ],
            [
                23,
                26
            ],
            [
                270,
                271
            ],
            2720
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [
            34,
            37
        ],
        gaps: [
            4,
            10
        ],
        lengths: [
            15
        ],
        code: {
            name: "CID",
            size: 4
        }
    },
    "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [
            [
                300,
                305
            ],
            36,
            38,
            39
        ],
        gaps: [
            4,
            10
        ],
        lengths: [
            14,
            16,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [
            6011,
            [
                644,
                649
            ],
            65
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            19
        ],
        code: {
            name: "CID",
            size: 3
        }
    },
    jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [
            2131,
            1800,
            [
                3528,
                3589
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [
            620,
            [
                624,
                626
            ],
            [
                62100,
                62182
            ],
            [
                62184,
                62187
            ],
            [
                62185,
                62197
            ],
            [
                62200,
                62205
            ],
            [
                622010,
                622999
            ],
            622018,
            [
                622019,
                622999
            ],
            [
                62207,
                62209
            ],
            [
                622126,
                622925
            ],
            [
                623,
                626
            ],
            6270,
            6272,
            6276,
            [
                627700,
                627779
            ],
            [
                627781,
                627799
            ],
            [
                6282,
                6289
            ],
            6291,
            6292,
            810,
            [
                8110,
                8131
            ],
            [
                8132,
                8151
            ],
            [
                8152,
                8163
            ],
            [
                8164,
                8171
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            14,
            15,
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVN",
            size: 3
        }
    },
    maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [
            493698,
            [
                500000,
                504174
            ],
            [
                504176,
                506698
            ],
            [
                506779,
                508999
            ],
            [
                56,
                59
            ],
            63,
            67,
            6
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [
            401178,
            401179,
            438935,
            457631,
            457632,
            431274,
            451416,
            457393,
            504175,
            [
                506699,
                506778
            ],
            [
                509000,
                509999
            ],
            627780,
            636297,
            636368,
            [
                650031,
                650033
            ],
            [
                650035,
                650051
            ],
            [
                650405,
                650439
            ],
            [
                650485,
                650538
            ],
            [
                650541,
                650598
            ],
            [
                650700,
                650718
            ],
            [
                650720,
                650727
            ],
            [
                650901,
                650978
            ],
            [
                651652,
                651679
            ],
            [
                655000,
                655019
            ],
            [
                655021,
                655058
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVE",
            size: 3
        }
    },
    mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [
            [
                2200,
                2204
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVP2",
            size: 3
        }
    },
    hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [
            637095,
            63737423,
            63743358,
            637568,
            637599,
            637609,
            637612
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [
            606282
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    }
};
module.exports = $a6309ba5070e0fcf$var$cardTypes;

});

parcelRegister("7LBY9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addMatchingCardsToResults = void 0;

var $djLdC = parcelRequire("djLdC");

var $7RMLk = parcelRequire("7RMLk");
function $5a7a600e32e73522$var$addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    var i, patternLength;
    for(i = 0; i < cardConfiguration.patterns.length; i++){
        var pattern = cardConfiguration.patterns[i];
        if (!$7RMLk.matches(cardNumber, pattern)) continue;
        var clonedCardConfiguration = $djLdC.clone(cardConfiguration);
        if (Array.isArray(pattern)) patternLength = String(pattern[0]).length;
        else patternLength = String(pattern).length;
        if (cardNumber.length >= patternLength) clonedCardConfiguration.matchStrength = patternLength;
        results.push(clonedCardConfiguration);
        break;
    }
}
module.exports.addMatchingCardsToResults = $5a7a600e32e73522$var$addMatchingCardsToResults;

});
parcelRegister("djLdC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clone = void 0;
function $9b21ad53f746f06c$var$clone(originalObject) {
    if (!originalObject) return null;
    return JSON.parse(JSON.stringify(originalObject));
}
module.exports.clone = $9b21ad53f746f06c$var$clone;

});

parcelRegister("7RMLk", function(module, exports) {
"use strict";
/*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.matches = void 0;
function $5ba34ed4dd72aa46$var$matchesRange(cardNumber, min, max) {
    var maxLengthToCheck = String(min).length;
    var substr = cardNumber.substr(0, maxLengthToCheck);
    var integerRepresentationOfCardNumber = parseInt(substr, 10);
    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);
    return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}
function $5ba34ed4dd72aa46$var$matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);
    return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}
function $5ba34ed4dd72aa46$var$matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) return $5ba34ed4dd72aa46$var$matchesRange(cardNumber, pattern[0], pattern[1]);
    return $5ba34ed4dd72aa46$var$matchesPattern(cardNumber, pattern);
}
module.exports.matches = $5ba34ed4dd72aa46$var$matches;

});


parcelRegister("33iYf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidInputType = void 0;
function $23905e19476105e1$var$isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
module.exports.isValidInputType = $23905e19476105e1$var$isValidInputType;

});

parcelRegister("bFFgL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findBestMatch = void 0;
function $87f38946b2baa6c7$var$hasEnoughResultsToDetermineBestMatch(results) {
    var numberOfResultsWithMaxStrengthProperty = results.filter(function(result) {
        return result.matchStrength;
    }).length;
    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */ return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
}
function $87f38946b2baa6c7$var$findBestMatch(results) {
    if (!$87f38946b2baa6c7$var$hasEnoughResultsToDetermineBestMatch(results)) return null;
    return results.reduce(function(bestMatch, result) {
        if (!bestMatch) return result;
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */ if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) return result;
        return bestMatch;
    });
}
module.exports.findBestMatch = $87f38946b2baa6c7$var$findBestMatch;

});



parcelRegister("27Y9u", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");

var $1bDti = parcelRequire("1bDti");

var $hYQeJ = parcelRequire("hYQeJ");
var $18cae5258907a459$require$allowedAttributes = $hYQeJ.allowedAttributes;
function $18cae5258907a459$var$attributeValidationError(attribute, value) {
    var err;
    if (!$18cae5258907a459$require$allowedAttributes.hasOwnProperty(attribute)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.type,
        code: $1bDti.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.code,
        message: 'The "' + attribute + '" attribute is not supported in Hosted Fields.'
    });
    else if (value != null && !$18cae5258907a459$var$_isValid(attribute, value)) err = new $dcafC({
        type: $1bDti.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.type,
        code: $1bDti.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.code,
        message: 'Value "' + value + '" is not allowed for "' + attribute + '" attribute.'
    });
    return err;
}
function $18cae5258907a459$var$_isValid(attribute, value) {
    if ($18cae5258907a459$require$allowedAttributes[attribute] === "string") return typeof value === "string" || typeof value === "number";
    else if ($18cae5258907a459$require$allowedAttributes[attribute] === "boolean") return String(value) === "true" || String(value) === "false";
    return false;
}
module.exports = $18cae5258907a459$var$attributeValidationError;

});

parcelRegister("9ypus", function(module, exports) {
"use strict";

var $hYQeJ = parcelRequire("hYQeJ");
var $6f4b0fdce3f27f32$require$directions = $hYQeJ.navigationDirections;

var $hOQOA = parcelRequire("hOQOA");

var $7S4Hg = parcelRequire("7S4Hg");

var $5E25m = parcelRequire("5E25m");
var $6f4b0fdce3f27f32$var$userFocusableTagNames = [
    "INPUT",
    "SELECT",
    "TEXTAREA"
];
// Devices with software keyboards do not or cannot focus on input types
// that do not require keyboard-based interaction.
var $6f4b0fdce3f27f32$var$unfocusedInputTypes = [
    "hidden",
    "button",
    "reset",
    "submit",
    "checkbox",
    "radio",
    "file"
];
function $6f4b0fdce3f27f32$var$_isUserFocusableElement(element) {
    if (!$hOQOA.hasSoftwareKeyboard()) // on desktop browsers, the only input type that isn't focusable
    // is the hidden input
    return element.type !== "hidden";
    return $6f4b0fdce3f27f32$var$userFocusableTagNames.indexOf(element.tagName) > -1 && $6f4b0fdce3f27f32$var$unfocusedInputTypes.indexOf(element.type) < 0;
}
function $6f4b0fdce3f27f32$var$_createNavigationHelper(direction, numberOfElementsInForm) {
    switch(direction){
        case $6f4b0fdce3f27f32$require$directions.BACK:
            return {
                checkIndexBounds: function(index) {
                    return index < 0;
                },
                indexChange: -1
            };
        case $6f4b0fdce3f27f32$require$directions.FORWARD:
            return {
                checkIndexBounds: function(index) {
                    return index > numberOfElementsInForm - 1;
                },
                indexChange: 1
            };
        default:
    }
    return {};
}
function $6f4b0fdce3f27f32$var$_findFirstFocusableElement(elementsInForm) {
    var elementsIndex, element;
    for(elementsIndex = 0; elementsIndex < elementsInForm.length; elementsIndex++){
        element = elementsInForm[elementsIndex];
        if ($6f4b0fdce3f27f32$var$_isUserFocusableElement(element)) return element;
    }
    return null;
}
module.exports = {
    removeExtraFocusElements: function(checkoutForm, onRemoveFocusIntercepts) {
        var elements = Array.prototype.slice.call(checkoutForm.elements);
        var firstFocusableInput = $6f4b0fdce3f27f32$var$_findFirstFocusableElement(elements);
        var lastFocusableInput = $6f4b0fdce3f27f32$var$_findFirstFocusableElement(elements.reverse());
        // these should never be identical, because there will at least be the
        // before and the after input
        [
            firstFocusableInput,
            lastFocusableInput
        ].forEach(function(input) {
            if (!input) return;
            if ($7S4Hg.matchFocusElement(input.getAttribute("id"))) onRemoveFocusIntercepts(input.getAttribute("id"));
        });
    },
    createFocusChangeHandler: function(hostedFieldsId, callbacks) {
        return function(data) {
            var currentIndex, targetElement, checkoutForm, navHelper;
            var sourceElement = document.getElementById("bt-" + data.field + "-" + data.direction + "-" + hostedFieldsId);
            if (!sourceElement) return;
            checkoutForm = $5E25m(sourceElement, "form")[0];
            if (document.forms.length < 1 || !checkoutForm) {
                callbacks.onRemoveFocusIntercepts();
                return;
            }
            checkoutForm = [].slice.call(checkoutForm.elements);
            currentIndex = checkoutForm.indexOf(sourceElement);
            navHelper = $6f4b0fdce3f27f32$var$_createNavigationHelper(data.direction, checkoutForm.length);
            do {
                currentIndex += navHelper.indexChange;
                if (navHelper.checkIndexBounds(currentIndex)) return;
                targetElement = checkoutForm[currentIndex];
            }while (!$6f4b0fdce3f27f32$var$_isUserFocusableElement(targetElement));
            if ($7S4Hg.matchFocusElement(targetElement.getAttribute("id"))) callbacks.onTriggerInputFocus(targetElement.getAttribute("data-braintree-type"));
            else targetElement.focus();
        };
    }
};

});


parcelRegister("41yK6", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");

var $b3ukb = parcelRequire("b3ukb");
var $2ee23493bbcbc239$var$VERSION = "3.100.0";
function $2ee23493bbcbc239$var$basicComponentVerification(options) {
    var client, authorization, name;
    if (!options) return Promise.reject(new $dcafC({
        type: $b3ukb.INVALID_USE_OF_INTERNAL_FUNCTION.type,
        code: $b3ukb.INVALID_USE_OF_INTERNAL_FUNCTION.code,
        message: "Options must be passed to basicComponentVerification function."
    }));
    name = options.name;
    client = options.client;
    authorization = options.authorization;
    if (!client && !authorization) return Promise.reject(new $dcafC({
        type: $b3ukb.INSTANTIATION_OPTION_REQUIRED.type,
        code: $b3ukb.INSTANTIATION_OPTION_REQUIRED.code,
        // NEXT_MAJOR_VERSION in major version, we expose passing in authorization for all components
        // instead of passing in a client instance. Leave this a silent feature for now.
        message: "options.client is required when instantiating " + name + "."
    }));
    if (!authorization && client.getVersion() !== $2ee23493bbcbc239$var$VERSION) return Promise.reject(new $dcafC({
        type: $b3ukb.INCOMPATIBLE_VERSIONS.type,
        code: $b3ukb.INCOMPATIBLE_VERSIONS.code,
        message: "Client (version " + client.getVersion() + ") and " + name + " (version " + $2ee23493bbcbc239$var$VERSION + ") components must be from the same SDK version."
    }));
    return Promise.resolve();
}
module.exports = {
    verify: $2ee23493bbcbc239$var$basicComponentVerification
};

});

parcelRegister("kHc8n", function(module, exports) {

module.exports = (parcelRequire("hoZOC"));

});
parcelRegister("hoZOC", function(module, exports) {
"use strict";

var $4NhuF = parcelRequire("4NhuF");
module.exports = function supportsInputFormatting() {
    // Digits get dropped in samsung browser
    return !(0, $4NhuF.isSamsungBrowser)();
};

});
parcelRegister("4NhuF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isIos = module.exports.isIE9 = module.exports.isSamsungBrowser = module.exports.isAndroidChrome = module.exports.isKitKatWebview = void 0;
// server side rendering check
var $37d94ee9d994b05e$var$UA = typeof window !== "undefined" && window.navigator && window.navigator.userAgent;

var $liomr = parcelRequire("liomr");

var $lTPPw = parcelRequire("lTPPw");

var $19lri = parcelRequire("19lri");

var $bblTQ = parcelRequire("bblTQ");
module.exports.isIos = $bblTQ;

var $gGc8I = parcelRequire("gGc8I");
module.exports.isIE9 = $gGc8I;
/* eslint-enable @typescript-eslint/ban-ts-comment */ // Old Android Webviews used specific versions of Chrome with 0.0.0 as their version suffix
// https://developer.chrome.com/multidevice/user-agent#webview_user_agent
var $37d94ee9d994b05e$var$KITKAT_WEBVIEW_REGEX = /Version\/\d\.\d* Chrome\/\d*\.0\.0\.0/;
function $37d94ee9d994b05e$var$isOldSamsungBrowserOrSamsungWebview(ua) {
    return !$19lri(ua) && ua.indexOf("Samsung") > -1;
}
function $37d94ee9d994b05e$var$isKitKatWebview(ua) {
    if (ua === void 0) ua = $37d94ee9d994b05e$var$UA;
    return $liomr(ua) && $37d94ee9d994b05e$var$KITKAT_WEBVIEW_REGEX.test(ua);
}
module.exports.isKitKatWebview = $37d94ee9d994b05e$var$isKitKatWebview;
function $37d94ee9d994b05e$var$isAndroidChrome(ua) {
    if (ua === void 0) ua = $37d94ee9d994b05e$var$UA;
    return ($liomr(ua) || $lTPPw(ua)) && $19lri(ua);
}
module.exports.isAndroidChrome = $37d94ee9d994b05e$var$isAndroidChrome;
function $37d94ee9d994b05e$var$isSamsungBrowser(ua) {
    if (ua === void 0) ua = $37d94ee9d994b05e$var$UA;
    return /SamsungBrowser/.test(ua) || $37d94ee9d994b05e$var$isOldSamsungBrowserOrSamsungWebview(ua);
}
module.exports.isSamsungBrowser = $37d94ee9d994b05e$var$isSamsungBrowser;

});
parcelRegister("liomr", function(module, exports) {

module.exports = (parcelRequire("65kfT"));

});
parcelRegister("65kfT", function(module, exports) {
"use strict";
module.exports = function isAndroid(ua) {
    ua = ua || window.navigator.userAgent;
    return /Android/i.test(ua);
};

});


parcelRegister("lTPPw", function(module, exports) {

module.exports = (parcelRequire("atsTC"));

});
parcelRegister("atsTC", function(module, exports) {
"use strict";
module.exports = function isChromeOS(ua) {
    ua = ua || window.navigator.userAgent;
    return /CrOS/i.test(ua);
};

});


parcelRegister("19lri", function(module, exports) {

module.exports = (parcelRequire("7WaMn"));

});
parcelRegister("7WaMn", function(module, exports) {
"use strict";

var $6s8FO = parcelRequire("6s8FO");

var $6GvqD = parcelRequire("6GvqD");

var $3BycU = parcelRequire("3BycU");

var $coasU = parcelRequire("coasU");

var $i5zm2 = parcelRequire("i5zm2");
module.exports = function isChrome(ua) {
    ua = ua || window.navigator.userAgent;
    return (ua.indexOf("Chrome") !== -1 || ua.indexOf("CriOS") !== -1) && !$6s8FO(ua) && !$6GvqD(ua) && !$3BycU(ua) && !$coasU(ua) && !$i5zm2(ua);
};

});
parcelRegister("6s8FO", function(module, exports) {
"use strict";
module.exports = function isEdge(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("Edge/") !== -1 || ua.indexOf("Edg/") !== -1;
};

});

parcelRegister("6GvqD", function(module, exports) {
"use strict";
module.exports = function isSamsungBrowser(ua) {
    ua = ua || window.navigator.userAgent;
    return /SamsungBrowser/i.test(ua);
};

});

parcelRegister("3BycU", function(module, exports) {
"use strict";
module.exports = function isDuckDuckGo(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("DuckDuckGo/") !== -1;
};

});

parcelRegister("coasU", function(module, exports) {
"use strict";
module.exports = function isOpera(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("OPR/") !== -1 || ua.indexOf("Opera/") !== -1 || ua.indexOf("OPT/") !== -1;
};

});

parcelRegister("i5zm2", function(module, exports) {
"use strict";
module.exports = function isSilk(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("Silk/") !== -1;
};

});



parcelRegister("bblTQ", function(module, exports) {

module.exports = (parcelRequire("lAzY1"));

});
parcelRegister("lAzY1", function(module, exports) {
"use strict";

var $a3pL0 = parcelRequire("a3pL0");
module.exports = function isIos(ua, checkIpadOS, document) {
    if (checkIpadOS === void 0) checkIpadOS = true;
    ua = ua || window.navigator.userAgent;
    var iOsTest = /iPhone|iPod|iPad/i.test(ua);
    return checkIpadOS ? iOsTest || $a3pL0(ua, document) : iOsTest;
};

});
parcelRegister("a3pL0", function(module, exports) {
"use strict";
module.exports = function isIpadOS(ua, document) {
    ua = ua || window.navigator.userAgent;
    document = document || window.document;
    // "ontouchend" is used to determine if a browser is on an iPad, otherwise
    // user-agents for iPadOS behave/identify as a desktop browser
    return /Mac|iPad/i.test(ua) && "ontouchend" in document;
};

});



parcelRegister("gGc8I", function(module, exports) {

module.exports = (parcelRequire("dUhiN"));

});
parcelRegister("dUhiN", function(module, exports) {
"use strict";
module.exports = function isIe9(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("MSIE 9") !== -1;
};

});






parcelRegister("ip4ex", function(module, exports) {
"use strict";

var $41yK6 = parcelRequire("41yK6");

var $7GGVg = parcelRequire("7GGVg");

var $5G2mw = parcelRequire("5G2mw");
var $d65dd878f7b9b877$var$VERSION = "3.100.0";
/**
 * @static
 * @function create
 * @description There are two ways to integrate the PayPal Checkout component. See the [PayPal Checkout constructor documentation](PayPalCheckout.html#PayPalCheckout) for more information and examples.
 *
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {string} [options.merchantAccountId] A non-default merchant account ID to use for tokenization.
 * @param {boolean} [options.autoSetDataUserIdToken=false] Whether or not to render the PayPal SDK button with a customer's vaulted PayPal account. Must be used in conjunction with a Client Token generated with a customer id.
 * @param {callback} [callback] The second argument, `data`, is the {@link PayPalCheckout} instance.
 * @example
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   // set up the PayPal JS SDK
 * }).catch(function (err) {
 *   console.error('Error!', err);
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function $d65dd878f7b9b877$var$create(options) {
    var name = "PayPal Checkout";
    return $41yK6.verify({
        name: name,
        client: options.client,
        authorization: options.authorization
    }).then(function() {
        var instance = new $5G2mw(options);
        return instance._initialize(options);
    });
}
/**
 * @static
 * @function isSupported
 * @description Returns true if PayPal Checkout [supports this browser](index.html#browser-support-webviews).
 * @deprecated Previously, this method checked for Popup support in the browser. The PayPal JS SDK now falls back to a modal if popups are not supported.
 * @returns {Boolean} Returns true if PayPal Checkout supports this browser.
 */ function $d65dd878f7b9b877$var$isSupported() {
    return true;
}
module.exports = {
    create: $7GGVg($d65dd878f7b9b877$var$create),
    isSupported: $d65dd878f7b9b877$var$isSupported,
    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: $d65dd878f7b9b877$var$VERSION
};

});
parcelRegister("5G2mw", function(module, exports) {
"use strict";

var $cIYHN = parcelRequire("cIYHN");

var $8mxc9 = parcelRequire("8mxc9");
var $4222b51ac79ed3f4$require$assign = $8mxc9.assign;

var $b6BSv = parcelRequire("b6BSv");

var $ePN3B = parcelRequire("ePN3B");

var $7vJcR = parcelRequire("7vJcR");

var $7GGVg = parcelRequire("7GGVg");

var $dcafC = parcelRequire("dcafC");

var $45Qfj = parcelRequire("45Qfj");

var $fqnaK = parcelRequire("fqnaK");

var $c5XGe = parcelRequire("c5XGe");

var $kjo88 = parcelRequire("kjo88");

var $3vts9 = parcelRequire("3vts9");

var $jXxvS = parcelRequire("jXxvS");

var $5qThx = parcelRequire("5qThx");

var $fbCls = parcelRequire("fbCls");

var $2rlYa = parcelRequire("2rlYa");
var $4222b51ac79ed3f4$var$VERSION = "3.100.0";

var $3h7RY = parcelRequire("3h7RY");
var $4222b51ac79ed3f4$require$INTEGRATION_TIMEOUT_MS = $3h7RY.INTEGRATION_TIMEOUT_MS;
var $4222b51ac79ed3f4$var$REQUIRED_PARAMS_FOR_START_VAULT_INITIATED_CHECKOUT = [
    "amount",
    "currency",
    "vaultInitiatedCheckoutPaymentMethodToken"
];
var $4222b51ac79ed3f4$var$PAYPAL_SDK_PRELOAD_URL = "https://www.{ENV}paypal.com/smart/buttons/preload";
$7vJcR.suppressUnhandledPromiseMessage = true;
/**
 * PayPal Checkout tokenized payload. Returned in {@link PayPalCheckout#tokenizePayment}'s callback as the second argument, `data`.
 * @typedef {object} PayPalCheckout~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `PayPalAccount`.
 * @property {object} details Additional PayPal account details.
 * @property {string} details.email User's email address.
 * @property {string} details.payerId User's payer ID, the unique identifier for each PayPal account.
 * @property {string} details.firstName User's given name.
 * @property {string} details.lastName User's surname.
 * @property {?string} details.countryCode User's 2 character country code.
 * @property {?string} details.phone User's phone number (e.g. 555-867-5309).
 * @property {?object} details.shippingAddress User's shipping address details, only available if shipping address is enabled.
 * @property {string} details.shippingAddress.recipientName Recipient of postage.
 * @property {string} details.shippingAddress.line1 Street number and name.
 * @property {string} details.shippingAddress.line2 Extended address.
 * @property {string} details.shippingAddress.city City or locality.
 * @property {string} details.shippingAddress.state State or region.
 * @property {string} details.shippingAddress.postalCode Postal code.
 * @property {string} details.shippingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} details.billingAddress User's billing address details.
 * Not available to all merchants; [contact support](https://developer.paypal.com/braintree/help) for details on eligibility and enabling this feature.
 * Alternatively, see `shippingAddress` above as an available client option.
 * @property {string} details.billingAddress.line1 Street number and name.
 * @property {string} details.billingAddress.line2 Extended address.
 * @property {string} details.billingAddress.city City or locality.
 * @property {string} details.billingAddress.state State or region.
 * @property {string} details.billingAddress.postalCode Postal code.
 * @property {string} details.billingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} creditFinancingOffered This property will only be present when the customer pays with PayPal Credit.
 * @property {object} creditFinancingOffered.totalCost This is the estimated total payment amount including interest and fees the user will pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalCost.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalCost.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {number} creditFinancingOffered.term Length of financing terms in months.
 * @property {object} creditFinancingOffered.monthlyPayment This is the estimated amount per month that the customer will need to pay including fees and interest.
 * @property {string} creditFinancingOffered.monthlyPayment.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.monthlyPayment.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {object} creditFinancingOffered.totalInterest Estimated interest or fees amount the payer will have to pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalInterest.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalInterest.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {boolean} creditFinancingOffered.payerAcceptance Status of whether the customer ultimately was approved for and chose to make the payment using the approved installment credit.
 * @property {boolean} creditFinancingOffered.cartAmountImmutable Indicates whether the cart amount is editable after payer's acceptance on PayPal side.
 */ /**
 * @class
 * @param {object} options see {@link module:braintree-web/paypal-checkout.create|paypal-checkout.create}
 * @classdesc This class represents a PayPal Checkout component that coordinates with the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. Instances of this class can generate payment data and tokenize authorized payments.
 *
 * All UI (such as preventing actions on the parent page while authentication is in progress) is managed by the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. You must provide your PayPal `client-id` as a query parameter. You can [retrieve this value from the PayPal Dashboard](https://developer.paypal.com/docs/checkout/integrate/#1-get-paypal-rest-api-credentials).
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/paypal-checkout.create|braintree-web.paypal-checkout.create} instead.</strong>
 *
 * #### Integrate Checkout Flow with PayPal SDK
 *
 * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
 *
 * ```html
 * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id"></script>
 * <div id="paypal-button"></div>
 * ```
 *
 * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Buttons({
 *     createOrder: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'checkout',
 *         currency: 'USD',
 *         amount: '10.00',
 *         intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
 *         // your other createPayment options here
 *       });
 *     },
 *
 *     onApprove: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     },
 *
 *     onCancel: function () {
 *       // handle case where user cancels
 *     },
 *
 *     onError: function (err) {
 *       // handle case where error occurs
 *     }
 *   }).render('#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 *
 * #### Integrate Vault Flow with PayPal SDK
 *
 * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
 *
 * ```html
 * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id&vault=true"></script>
 * <div id="paypal-button"></div>
 * ```
 *
 * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Buttons({
 *     createBillingAgreement: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'vault'
 *         // your other createPayment options here
 *       });
 *     },
 *
 *     onApprove: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     },
 *
 *     onCancel: function () {
 *       // handle case where user cancels
 *     },
 *
 *     onError: function (err) {
 *       // handle case where error occurs
 *     }
 *   }).render('#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 *
 * #### Integrate with Checkout.js (deprecated PayPal SDK)
 *
 * If you are creating a new PayPal integration, please follow the previous integration guide to use the current version of the PayPal SDK. Use this integration guide only as a reference if you are already integrated with Checkout.js.
 *
 * You must have PayPal's Checkout.js script loaded on your page.
 *
 * ```html
 * <script src="https://www.paypalobjects.com/api/checkout.js" data-version-4 log-level="warn"></script>
 * ```
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Button.render({
 *     env: 'production', // or 'sandbox'
 *
 *     payment: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         // your createPayment options here
 *       });
 *     },
 *
 *     onAuthorize: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     }
 *   }, '#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 */ function $4222b51ac79ed3f4$var$PayPalCheckout(options) {
    this._merchantAccountId = options.merchantAccountId;
    // TODO remove this requirement for it to be opt in.
    // This feature is not yet GA, so we're intentionally making
    // it opt in and not publicly documenting it yet. Once it's
    // GA, we can remove the requirement to opt in to it
    this._autoSetDataUserIdToken = Boolean(options.autoSetDataUserIdToken);
}
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._initialize = function(options) {
    var config;
    if (options.client) {
        config = options.client.getConfiguration();
        this._authorizationInformation = {
            fingerprint: config.authorizationFingerprint,
            environment: config.gatewayConfiguration.environment
        };
    } else {
        config = $3vts9(options.authorization);
        this._authorizationInformation = {
            fingerprint: config.attrs.authorizationFingerprint,
            environment: config.environment
        };
    }
    this._clientPromise = $b6BSv.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: $ePN3B.create(options.authorization),
        name: "PayPal Checkout"
    }).then((function(client) {
        this._configuration = client.getConfiguration();
        // we skip these checks if a merchant account id is
        // passed in, because the default merchant account
        // may not have paypal enabled
        if (!this._merchantAccountId) {
            if (!this._configuration.gatewayConfiguration.paypalEnabled) this._setupError = new $dcafC($fqnaK.PAYPAL_NOT_ENABLED);
            else if (this._configuration.gatewayConfiguration.paypal.environmentNoNetwork === true) this._setupError = new $dcafC($fqnaK.PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED);
        }
        if (this._setupError) return Promise.reject(this._setupError);
        $cIYHN.sendEvent(client, "paypal-checkout.initialized");
        this._frameServicePromise = this._setupFrameService(client);
        return client;
    }).bind(this));
    // if client was passed in, let config checks happen before
    // resolving the instance. Otherwise, just resolve the instance
    if (options.client) return this._clientPromise.then((function() {
        return this;
    }).bind(this));
    return Promise.resolve(this);
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._setupFrameService = function(client) {
    var frameServicePromise = new $7vJcR();
    var config = client.getConfiguration();
    var timeoutRef = setTimeout(function() {
        $cIYHN.sendEvent(client, "paypal-checkout.frame-service.timed-out");
        frameServicePromise.reject(new $dcafC($fqnaK.PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED));
    }, $4222b51ac79ed3f4$require$INTEGRATION_TIMEOUT_MS);
    this._assetsUrl = config.gatewayConfiguration.paypal.assetsUrl + "/web/" + $4222b51ac79ed3f4$var$VERSION;
    this._isDebug = config.isDebug;
    // Note: this is using the static landing frame that the deprecated PayPal component builds and uses
    this._loadingFrameUrl = this._assetsUrl + "/html/paypal-landing-frame" + $5qThx(this._isDebug) + ".html";
    $kjo88.create({
        name: "braintreepaypallanding",
        dispatchFrameUrl: this._assetsUrl + "/html/dispatch-frame" + $5qThx(this._isDebug) + ".html",
        openFrameUrl: this._loadingFrameUrl
    }, (function(service) {
        this._frameService = service;
        clearTimeout(timeoutRef);
        frameServicePromise.resolve();
    }).bind(this));
    return frameServicePromise;
};
/**
 * @typedef {object} PayPalCheckout~lineItem
 * @property {string} quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
 * @property {string} unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {string} name Item name. Maximum 127 characters.
 * @property {string} kind Indicates whether the line item is a debit (sale) or credit (refund) to the customer. Accepted values: `debit` and `credit`.
 * @property {?string} unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {?string} description Item description. Maximum 127 characters.
 * @property {?string} productCode Product or UPC code for the item. Maximum 127 characters.
 * @property {?string} url The URL to product information.
 */ /**
 * @typedef {object} PayPalCheckout~shippingOption
 * @property {string} id A unique ID that identifies a payer-selected shipping option.
 * @property {string} label A description that the payer sees, which helps them choose an appropriate shipping option. For example, `Free Shipping`, `USPS Priority Shipping`, `Expédition prioritaire USPS`, or `USPS yōuxiān fā huò`. Localize this description to the payer's locale.
 * @property {boolean} selected If `selected = true` is specified as part of the API request it represents the shipping option that the payee/merchant expects to be pre-selected for the payer when they first view the shipping options within the PayPal checkout experience. As part of the response if a shipping option has `selected = true` it represents the shipping option that the payer selected during the course of checkout with PayPal. Only 1 `shippingOption` can be set to `selected = true`.
 * @property {string} type The method by which the payer wants to get their items. The possible values are:
 * * `SHIPPING` - The payer intends to receive the items at a specified address.
 * * `PICKUP` - The payer intends to pick up the items at a specified address. For example, a store address.
 * @property {object} amount The shipping cost for the selected option.
 * @property {string} amount.currency The three-character ISO-4217 currency code. PayPal does not support all currencies.
 * @property {string} amount.value The amount the shipping option will cost. Includes the specified number of digits after decimal separator for the ISO-4217 currency code.
 */ /**
 * Creates a PayPal payment ID or billing token using the given options. This is meant to be passed to the PayPal JS SDK.
 * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the PayPal JS SDK. Otherwise, it returns a Promise that resolves with the id.
 * @public
 * @param {object} options All options for the PayPalCheckout component.
 * @param {string} options.flow Set to 'checkout' for one-time payment flow, or 'vault' for Vault flow. If 'vault' is used with a client token generated with a customer ID, the PayPal account will be added to that customer as a saved payment method.
 * @param {string} [options.intent=authorize]
 * * `authorize` - Submits the transaction for authorization but not settlement.
 * * `order` - Validates the transaction without an authorization (i.e. without holding funds). Useful for authorizing and capturing funds up to 90 days after the order has been placed. Only available for Checkout flow.
 * * `capture` - Payment will be immediately submitted for settlement upon creating a transaction. `sale` can be used as an alias for this value.
 * @param {boolean} [options.offerCredit=false] Offers PayPal Credit as the default funding instrument for the transaction. If the customer isn't pre-approved for PayPal Credit, they will be prompted to apply for it.
 * @param {(string|number)} [options.amount] The amount of the transaction. Required when using the Checkout flow. Should not include shipping cost.
 * * Supports up to 2 digits after the decimal point
 * @param {string} [options.currency] The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
 * @param {string} [options.displayName] The merchant name displayed inside of the PayPal lightbox; defaults to the company name on your Braintree account
 * @param {boolean} [options.requestBillingAgreement] If `true` and `flow = checkout`, the customer will be prompted to consent to a billing agreement during the checkout flow. This value is ignored when `flow = vault`.
 * @param {object} [options.billingAgreementDetails] When `requestBillingAgreement = true`, allows for details to be set for the billing agreement portion of the flow.
 * @param {string} [options.billingAgreementDetails.description] Description of the billing agreement to display to the customer.
 * @param {string} [options.vaultInitiatedCheckoutPaymentMethodToken] Use the payment method nonce representing a PayPal account with a Billing Agreement ID to create the payment and redirect the customer to select a new financial instrument. This option is only applicable to the `checkout` flow.
 * @param {shippingOption[]} [options.shippingOptions] List of shipping options offered by the payee or merchant to the payer to ship or pick up their items.
 * @param {boolean} [options.enableShippingAddress=false] Returns a shipping address object in {@link PayPal#tokenize}.
 * @param {object} [options.shippingAddressOverride] Allows you to pass a shipping address you have already collected into the PayPal payment flow.
 * @param {string} options.shippingAddressOverride.line1 Street address.
 * @param {string} [options.shippingAddressOverride.line2] Street address (extended).
 * @param {string} options.shippingAddressOverride.city City.
 * @param {string} options.shippingAddressOverride.state State.
 * @param {string} options.shippingAddressOverride.postalCode Postal code.
 * @param {string} options.shippingAddressOverride.countryCode Country.
 * @param {string} [options.shippingAddressOverride.phone] Phone number.
 * @param {string} [options.shippingAddressOverride.recipientName] Recipient's name.
 * @param {boolean} [options.shippingAddressEditable=true] Set to false to disable user editing of the shipping address.
 * @param {string} [options.billingAgreementDescription] Use this option to set the description of the preapproved payment agreement visible to customers in their PayPal profile during Vault flows. Max 255 characters.
 * @param {string} [options.landingPageType] Use this option to specify the PayPal page to display when a user lands on the PayPal site to complete the payment.
 * * `login` - A PayPal account login page is used.
 * * `billing` - A non-PayPal account landing page is used.
 * @param {lineItem[]} [options.lineItems] The {@link PayPalCheckout~lineItem|line items} for this transaction. It can include up to 249 line items.
 * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
 * @example
 * // this paypal object is created by the PayPal JS SDK
 * // see https://github.com/paypal/paypal-checkout-components
 * paypal.Buttons({
 *   createOrder: function () {
 *     // when createPayment resolves, it is automatically passed to the PayPal JS SDK
 *     return paypalCheckoutInstance.createPayment({
 *       flow: 'checkout',
 *       amount: '10.00',
 *       currency: 'USD',
 *       intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
 *     });
 *   },
 *   // Add other options, e.g. onApproved, onCancel, onError
 * }).render('#paypal-button');
 *
 * @example
 * // shippingOptions are passed to createPayment. You can review the result from onAuthorize to determine which shipping option id was selected.
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Button.render({
 *     env: 'production'
 *
 *     payment: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'checkout',
 *         amount: '10.00',
 *         currency: 'USD',
 *         shippingOptions: [
 *           {
 *             id: 'UUID-9',
 *             type: 'PICKUP',
 *             label: 'Store Location Five',
 *             selected: true,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           },
 *           {
 *             id: 'shipping-speed-fast',
 *             type: 'SHIPPING',
 *             label: 'Fast Shipping',
 *             selected: false,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           },
 *           {
 *             id: 'shipping-speed-slow',
 *             type: 'SHIPPING',
 *             label: 'Slow Shipping',
 *             selected: false,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           }
 *         ]
 *       });
 *     },
 *
 *     onAuthorize: function (data, actions) {
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     }
 *   }, '#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype.createPayment = function(options) {
    if (!options || !$c5XGe.FLOW_ENDPOINTS.hasOwnProperty(options.flow)) return Promise.reject(new $dcafC($fqnaK.PAYPAL_FLOW_OPTION_REQUIRED));
    $cIYHN.sendEvent(this._clientPromise, "paypal-checkout.createPayment");
    return this._createPaymentResource(options).then(function(response) {
        var flowToken, urlParams;
        if (options.flow === "checkout") {
            urlParams = $2rlYa.parse(response.paymentResource.redirectUrl);
            flowToken = urlParams.token;
        } else flowToken = response.agreementSetup.tokenId;
        return flowToken;
    });
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._createPaymentResource = function(options, config) {
    var self = this;
    var endpoint = "paypal_hermes/" + $c5XGe.FLOW_ENDPOINTS[options.flow];
    delete this.intentFromCreatePayment;
    config = config || {};
    if (options.offerCredit === true) $cIYHN.sendEvent(this._clientPromise, "paypal-checkout.credit.offered");
    return this._clientPromise.then(function(client) {
        return client.request({
            endpoint: endpoint,
            method: "post",
            data: self._formatPaymentResourceData(options, config)
        }).then(function(data) {
            self.intentFromCreatePayment = options.intent;
            return data;
        });
    }).catch(function(err) {
        var status;
        if (self._setupError) return Promise.reject(self._setupError);
        status = err.details && err.details.httpStatus;
        if (status === 422) return Promise.reject(new $dcafC({
            type: $fqnaK.PAYPAL_INVALID_PAYMENT_OPTION.type,
            code: $fqnaK.PAYPAL_INVALID_PAYMENT_OPTION.code,
            message: $fqnaK.PAYPAL_INVALID_PAYMENT_OPTION.message,
            details: {
                originalError: err
            }
        }));
        return Promise.reject($45Qfj(err, {
            type: $fqnaK.PAYPAL_FLOW_FAILED.type,
            code: $fqnaK.PAYPAL_FLOW_FAILED.code,
            message: $fqnaK.PAYPAL_FLOW_FAILED.message
        }));
    });
};
/**
 * Use this function to update {@link PayPalCheckout~lineItem|line items} and/or {@link PayPalCheckout~shippingOption|shipping options} associated with a PayPalCheckout flow (`paymentId`).
 * When a {@link callback} is defined, this function returns undefined and invokes the callback. The second callback argument, <code>data</code>, is the returned server data. If no callback is provided, `updatePayment` returns a promise that resolves with the server data.
 * @public
 * @param {object} options All options for the PayPalCheckout component.
 * @param {string} options.paymentId This should be PayPal `paymentId`.
 * @param {(string|number)} options.amount The amount of the transaction, including the amount of the selected shipping option, and all `line_items`.
 * * Supports up to 2 decimal digits.
 * @param {string} options.currency The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
 * @param {shippingOption[]} [options.shippingOptions] List of {@link PayPalCheckout~shippingOption|shipping options} offered by the payee or merchant to the payer to ship or pick up their items.
 * @param {lineItem[]} [options.lineItems] The {@link PayPalCheckout~lineItem|line items} for this transaction. It can include up to 249 line items.
 * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
 * @example
 * // this paypal object is created by the PayPal JS SDK
 * // see https://github.com/paypal/paypal-checkout-components
 * paypal.Buttons({
 *   createOrder: function () {
 *     // when createPayment resolves, it is automatically passed to the PayPal JS SDK
 *     return paypalCheckoutInstance.createPayment({
 *       //
 *     });
 *   },
 *   onShippingChange: function (data) {
 *     // Examine data and determine if the payment needs to be updated.
 *     // when updatePayment resolves, it is automatically passed to the PayPal JS SDK
 *     return paypalCheckoutInstance.updatePayment({
 *         paymentId: data.paymentId,
 *         amount: '15.00',
 *         currency: 'USD',
 *         shippingOptions: [
 *           {
 *             id: 'shipping-speed-fast',
 *             type: 'SHIPPING',
 *             label: 'Fast Shipping',
 *             selected: true,
 *             amount: {
 *               value: '5.00',
 *               currency: 'USD'
 *             }
 *           },
 *           {
 *             id: 'shipping-speed-slow',
 *             type: 'SHIPPING',
 *             label: 'Slow Shipping',
 *             selected: false,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           }
 *         ]
 *     });
 *   }
 *   // Add other options, e.g. onApproved, onCancel, onError
 * }).render('#paypal-button');
 *
 * ```
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype.updatePayment = function(options) {
    var self = this;
    var endpoint = "paypal_hermes/patch_payment_resource";
    if (!options || this._hasMissingOption(options, $c5XGe.REQUIRED_OPTIONS)) {
        $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.updatePayment.missing-options");
        return Promise.reject(new $dcafC($fqnaK.PAYPAL_MISSING_REQUIRED_OPTION));
    }
    if (!this._verifyConsistentCurrency(options)) {
        $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.updatePayment.inconsistent-currencies");
        return Promise.reject(new $dcafC({
            type: $fqnaK.PAYPAL_INVALID_PAYMENT_OPTION.type,
            code: $fqnaK.PAYPAL_INVALID_PAYMENT_OPTION.code,
            message: $fqnaK.PAYPAL_INVALID_PAYMENT_OPTION.message,
            details: {
                originalError: new Error("One or more shipping option currencies differ from checkout currency.")
            }
        }));
    }
    $cIYHN.sendEvent(this._clientPromise, "paypal-checkout.updatePayment");
    return this._clientPromise.then(function(client) {
        return client.request({
            endpoint: endpoint,
            method: "post",
            data: self._formatUpdatePaymentData(options)
        });
    }).catch(function(err) {
        var status = err.details && err.details.httpStatus;
        if (status === 422) {
            $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.updatePayment.invalid");
            return Promise.reject(new $dcafC({
                type: $fqnaK.PAYPAL_INVALID_PAYMENT_OPTION.type,
                code: $fqnaK.PAYPAL_INVALID_PAYMENT_OPTION.code,
                message: $fqnaK.PAYPAL_INVALID_PAYMENT_OPTION.message,
                details: {
                    originalError: err
                }
            }));
        }
        $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.updatePayment." + $fqnaK.PAYPAL_FLOW_FAILED.code);
        return Promise.reject($45Qfj(err, {
            type: $fqnaK.PAYPAL_FLOW_FAILED.type,
            code: $fqnaK.PAYPAL_FLOW_FAILED.code,
            message: $fqnaK.PAYPAL_FLOW_FAILED.message
        }));
    });
};
/**
 * Initializes the PayPal checkout flow with a payment method nonce that represents a vaulted PayPal account.
 * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the PayPal JS SDK. Otherwise, it returns a Promise that resolves with the id.
 * @public
 * @ignore
 * @param {object} options These options are identical to the {@link PayPalCheckout#createPayment|options for creating a payment resource}, except for the following:
 * * `flow` cannot be set (will always be `'checkout'`)
 * * `amount`, `currency`, and `vaultInitiatedCheckoutPaymentMethodToken` are required instead of optional
 * * Additional configuration is available (listed below)
 * @param {boolean} [options.optOutOfModalBackdrop=false] By default, the webpage will darken and become unusable while the PayPal window is open. For full control of the UI, pass `true` for this option.
 * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @example
 * paypalCheckoutInstance.startVaultInitiatedCheckout({
 *   vaultInitiatedCheckoutPaymentMethodToken: 'nonce-that-represents-a-vaulted-paypal-account',
 *   amount: '10.00',
 *   currency: 'USD'
 * }).then(function (payload) {
 *   // send payload.nonce to your server
 * }).catch(function (err) {
 *   if (err.code === 'PAYPAL_POPUP_CLOSED') {
 *     // indicates that customer canceled by
 *     // manually closing the PayPal popup
 *   }
 *
 *   // handle other errors
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype.startVaultInitiatedCheckout = function(options) {
    var missingRequiredParam;
    var self = this;
    if (this._vaultInitiatedCheckoutInProgress) {
        $cIYHN.sendEvent(this._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.error.already-in-progress");
        return Promise.reject(new $dcafC($fqnaK.PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS));
    }
    $4222b51ac79ed3f4$var$REQUIRED_PARAMS_FOR_START_VAULT_INITIATED_CHECKOUT.forEach(function(param) {
        if (!options.hasOwnProperty(param)) missingRequiredParam = param;
    });
    if (missingRequiredParam) return Promise.reject(new $dcafC({
        type: $fqnaK.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.type,
        code: $fqnaK.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.code,
        message: "Required param " + missingRequiredParam + " is missing."
    }));
    this._vaultInitiatedCheckoutInProgress = true;
    this._addModalBackdrop(options);
    options = $4222b51ac79ed3f4$require$assign({}, options, {
        flow: "checkout"
    });
    $cIYHN.sendEvent(this._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.started");
    return this._waitForVaultInitiatedCheckoutDependencies().then(function() {
        var frameCommunicationPromise = new $7vJcR();
        var startVaultInitiatedCheckoutPromise = self._createPaymentResource(options, {
            returnUrl: self._constructVaultCheckutUrl("redirect-frame"),
            cancelUrl: self._constructVaultCheckutUrl("cancel-frame")
        }).then(function(response) {
            var redirectUrl = response.paymentResource.redirectUrl;
            self._frameService.redirect(redirectUrl);
            return frameCommunicationPromise;
        });
        self._frameService.open({}, self._createFrameServiceCallback(frameCommunicationPromise));
        return startVaultInitiatedCheckoutPromise;
    }).catch(function(err) {
        self._vaultInitiatedCheckoutInProgress = false;
        self._removeModalBackdrop();
        if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
            $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.canceled.by-customer");
            return Promise.reject(new $dcafC($fqnaK.PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED));
        }
        if (self._frameService) self._frameService.close();
        if (err.code && err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1) {
            $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.failed.popup-not-opened");
            return Promise.reject(new $dcafC({
                code: $fqnaK.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.code,
                type: $fqnaK.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.type,
                message: $fqnaK.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.message,
                details: {
                    originalError: err
                }
            }));
        }
        return Promise.reject(err);
    }).then(function(response) {
        self._frameService.close();
        self._vaultInitiatedCheckoutInProgress = false;
        self._removeModalBackdrop();
        $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.succeeded");
        return Promise.resolve(response);
    });
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._addModalBackdrop = function(options) {
    if (options.optOutOfModalBackdrop) return;
    if (!this._modalBackdrop) {
        this._modalBackdrop = document.createElement("div");
        this._modalBackdrop.setAttribute("data-braintree-paypal-vault-initiated-checkout-modal", true);
        this._modalBackdrop.style.position = "fixed";
        this._modalBackdrop.style.top = 0;
        this._modalBackdrop.style.bottom = 0;
        this._modalBackdrop.style.left = 0;
        this._modalBackdrop.style.right = 0;
        this._modalBackdrop.style.zIndex = 9999;
        this._modalBackdrop.style.background = "black";
        this._modalBackdrop.style.opacity = "0.7";
        this._modalBackdrop.addEventListener("click", (function() {
            this.focusVaultInitiatedCheckoutWindow();
        }).bind(this));
    }
    document.body.appendChild(this._modalBackdrop);
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._removeModalBackdrop = function() {
    if (!(this._modalBackdrop && this._modalBackdrop.parentNode)) return;
    this._modalBackdrop.parentNode.removeChild(this._modalBackdrop);
};
/**
 * Closes the PayPal window if it is opened via `startVaultInitiatedCheckout`.
 * @public
 * @ignore
 * @param {callback} [callback] Gets called when window is closed.
 * @example
 * paypalCheckoutInstance.closeVaultInitiatedCheckoutWindow();
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype.closeVaultInitiatedCheckoutWindow = function() {
    if (this._vaultInitiatedCheckoutInProgress) $cIYHN.sendEvent(this._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.canceled.by-merchant");
    return this._waitForVaultInitiatedCheckoutDependencies().then((function() {
        this._frameService.close();
    }).bind(this));
};
/**
 * Focuses the PayPal window if it is opened via `startVaultInitiatedCheckout`.
 * @public
 * @ignore
 * @param {callback} [callback] Gets called when window is focused.
 * @example
 * paypalCheckoutInstance.focusVaultInitiatedCheckoutWindow();
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype.focusVaultInitiatedCheckoutWindow = function() {
    return this._waitForVaultInitiatedCheckoutDependencies().then((function() {
        this._frameService.focus();
    }).bind(this));
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._createFrameServiceCallback = function(frameCommunicationPromise) {
    var self = this;
    // TODO when a merchant integrates an iOS or Android integration
    // with a webview using the web SDK, we will have to add popupbridge
    // support
    return function(err, payload) {
        if (err) frameCommunicationPromise.reject(err);
        else if (payload) {
            self._frameService.redirect(self._loadingFrameUrl);
            self.tokenizePayment({
                paymentToken: payload.token,
                payerID: payload.PayerID,
                paymentID: payload.paymentId,
                orderID: payload.orderId
            }).then(function(res) {
                frameCommunicationPromise.resolve(res);
            }).catch(function(tokenizationError) {
                frameCommunicationPromise.reject(tokenizationError);
            });
        }
    };
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._waitForVaultInitiatedCheckoutDependencies = function() {
    var self = this;
    return this._clientPromise.then(function() {
        return self._frameServicePromise;
    });
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._constructVaultCheckutUrl = function(frameName) {
    var serviceId = this._frameService._serviceId;
    return this._assetsUrl + "/html/" + frameName + $5qThx(this._isDebug) + ".html?channel=" + serviceId;
};
/**
 * Tokenizes the authorize data from the PayPal JS SDK when completing a buyer approval flow.
 * When a {@link callback} is defined, invokes the callback with {@link PayPalCheckout~tokenizePayload|tokenizePayload} and returns undefined. Otherwise, returns a Promise that resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @public
 * @param {object} tokenizeOptions Tokens and IDs required to tokenize the payment.
 * @param {string} tokenizeOptions.payerId Payer ID returned by PayPal `onApproved` callback.
 * @param {string} [tokenizeOptions.paymentId] Payment ID returned by PayPal `onApproved` callback.
 * @param {string} [tokenizeOptions.billingToken] Billing Token returned by PayPal `onApproved` callback.
 * @param {boolean} [tokenizeOptions.vault=true] Whether or not to vault the resulting PayPal account (if using a client token generated with a customer id and the vault flow).
 * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @example <caption>Opt out of auto-vaulting behavior</caption>
 * // create the paypalCheckoutInstance with a client token generated with a customer id
 * paypal.Buttons({
 *   createBillingAgreement: function () {
 *     return paypalCheckoutInstance.createPayment({
 *       flow: 'vault'
 *       // your other createPayment options here
 *     });
 *   },
 *   onApproved: function (data) {
 *     data.vault = false;
 *
 *     return paypalCheckoutInstance.tokenizePayment(data);
 *   },
 *   // Add other options, e.g. onCancel, onError
 * }).render('#paypal-button');
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype.tokenizePayment = function(tokenizeOptions) {
    var self = this;
    var shouldVault = true;
    var payload;
    var options = {
        flow: tokenizeOptions.billingToken && !tokenizeOptions.paymentID ? "vault" : "checkout",
        intent: tokenizeOptions.intent || this.intentFromCreatePayment
    };
    var params = {
        // The paymentToken provided by the PayPal JS SDK is the EC Token
        ecToken: tokenizeOptions.paymentToken,
        billingToken: tokenizeOptions.billingToken,
        payerId: tokenizeOptions.payerID,
        paymentId: tokenizeOptions.paymentID,
        orderId: tokenizeOptions.orderID,
        shippingOptionsId: tokenizeOptions.shippingOptionsId
    };
    if (tokenizeOptions.hasOwnProperty("vault")) shouldVault = tokenizeOptions.vault;
    options.vault = shouldVault;
    $cIYHN.sendEvent(this._clientPromise, "paypal-checkout.tokenization.started");
    return this._clientPromise.then(function(client) {
        return client.request({
            endpoint: "payment_methods/paypal_accounts",
            method: "post",
            data: self._formatTokenizeData(options, params)
        });
    }).then(function(response) {
        payload = self._formatTokenizePayload(response);
        $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.tokenization.success");
        if (payload.creditFinancingOffered) $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.credit.accepted");
        return payload;
    }).catch(function(err) {
        if (self._setupError) return Promise.reject(self._setupError);
        $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.tokenization.failed");
        return Promise.reject($45Qfj(err, {
            type: $fqnaK.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
            code: $fqnaK.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
            message: $fqnaK.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message
        }));
    });
};
/**
 * Resolves with the PayPal client id to be used when loading the PayPal SDK.
 * @public
 * @param {callback} [callback] The second argument, <code>id</code>, is a the PayPal client id. If no callback is provided, the promise resolves with the PayPal client id.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * paypalCheckoutInstance.getClientId().then(function (id) {
 *  var script = document.createElement('script');
 *
 *  script.src = 'https://www.paypal.com/sdk/js?client-id=' + id;
 *  script.onload = function () {
 *    // setup the PayPal SDK
 *  };
 *
 *  document.body.appendChild(script);
 * });
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype.getClientId = function() {
    return this._clientPromise.then(function(client) {
        return client.getConfiguration().gatewayConfiguration.paypal.clientId;
    });
};
/**
 * Resolves when the PayPal SDK has been successfully loaded onto the page.
 * @public
 * @param {object} [options] A configuration object to modify the query params and data-attributes on the PayPal SDK. A subset of the parameters are listed below. For a full list of query params, see the [PayPal docs](https://developer.paypal.com/docs/checkout/reference/customize-sdk/?mark=query#query-parameters).
 * @param {string} [options.client-id] By default, this will be the client id associated with the authorization used to create the Braintree component. When used in conjunction with passing `authorization` when creating the PayPal Checkout component, you can speed up the loading of the PayPal SDK.
 * @param {string} [options.intent="authorize"] By default, the PayPal SDK defaults to an intent of `capture`. Since the default intent when calling {@link PayPalCheckout#createPayment|`createPayment`} is `authorize`, the PayPal SDK will be loaded with `intent=authorize`. If you wish to use a different intent when calling {@link PayPalCheckout#createPayment|`createPayment`}, make sure it matches here. If `sale` is used, it will be converted to `capture` for the PayPal SDK. If the `vault: true` param is used, `tokenize` will be passed as the default intent.
 * @param {string} [options.locale=en_US] Use this option to change the language, links, and terminology used in the PayPal flow. This locale will be used unless the buyer has set a preferred locale for their account. If an unsupported locale is supplied, a fallback locale (determined by buyer preference or browser data) will be used and no error will be thrown.
 *
 * Supported locales are:
 * `da_DK`,
 * `de_DE`,
 * `en_AU`,
 * `en_GB`,
 * `en_US`,
 * `es_ES`,
 * `fr_CA`,
 * `fr_FR`,
 * `id_ID`,
 * `it_IT`,
 * `ja_JP`,
 * `ko_KR`,
 * `nl_NL`,
 * `no_NO`,
 * `pl_PL`,
 * `pt_BR`,
 * `pt_PT`,
 * `ru_RU`,
 * `sv_SE`,
 * `th_TH`,
 * `zh_CN`,
 * `zh_HK`,
 * and `zh_TW`.
 *
 * @param {string} [options.currency="USD"] If a currency is passed in {@link PayPalCheckout#createPayment|`createPayment`}, it must match the currency passed here.
 * @param {boolean} [options.vault] Must be `true` when using `flow: vault` in {@link PayPalCheckout#createPayment|`createPayment`}.
 * @param {string} [options.components=buttons] By default, the Braintree SDK will only load the PayPal smart buttons component. If you would like to load just the [messages component](https://developer.paypal.com/docs/business/checkout/add-capabilities/credit-messaging/), pass `messages`. If you would like to load both, pass `buttons,messages`
 * @param {object} [options.dataAttributes] The data attributes to apply to the script. Any data attribute can be passed. A subset of the parameters are listed below. For a full list of data attributes, see the [PayPal docs](https://developer.paypal.com/docs/checkout/reference/customize-sdk/#script-parameters).
 * @param {string} [options.dataAttributes.client-token] The client token to use in the script. (usually not needed)
 * @param {string} [options.dataAttributes.csp-nonce] See the [PayPal docs about content security nonces](https://developer.paypal.com/docs/checkout/reference/customize-sdk/#csp-nonce).
 * @param {callback} [callback] Called when the PayPal SDK has been loaded onto the page. The second argument is the PayPal Checkout instance. If no callback is provided, the promise resolves with the PayPal Checkout instance when the PayPal SDK has been loaded onto the page.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example <caption>Without options</caption>
 * paypalCheckoutInstance.loadPayPalSDK().then(function () {
 *   // window.paypal.Buttons is now available to use
 * });
 * @example <caption>With options</caption>
 * paypalCheckoutInstance.loadPayPalSDK({
 *   'client-id': 'PayPal Client Id', // Can speed up rendering time to hardcode this value
 *
 *   intent: 'capture', // Make sure this value matches the value in createPayment
 *   currency: 'USD', // Make sure this value matches the value in createPayment
 * }).then(function () {
 *   // window.paypal.Buttons is now available to use
 * });
 * @example <caption>With Vaulting</caption>
 * paypalCheckoutInstance.loadPayPalSDK({
 *   vault: true
 * }).then(function () {
 *   // window.paypal.Buttons is now available to use
 * });
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype.loadPayPalSDK = function(options) {
    var idPromise, src;
    var loadPromise = new $7vJcR();
    var dataAttributes = options && options.dataAttributes || {};
    var userIdToken = dataAttributes["user-id-token"] || dataAttributes["data-user-id-token"];
    if (!userIdToken) userIdToken = this._authorizationInformation.fingerprint && this._authorizationInformation.fingerprint.split("?")[0];
    this._paypalScript = document.createElement("script");
    // NEXT_MAJOR_VERSION
    // this options object should have 2 properties:
    // * queryParams
    // * dataAttributes
    // should make organizing this better than squashing
    // all the query params at the top level and extracting
    // the data attributes
    options = $4222b51ac79ed3f4$require$assign({}, {
        components: "buttons"
    }, options);
    delete options.dataAttributes;
    // NEXT_MAJOR_VERSION if merchant passes an explicit intent,
    // currency, amount, etc, save those for use in createPayment
    // if no explicit param of that type is passed in when calling
    // createPayment to reduce the number of items that need to be
    // duplicated here and in createPayment
    if (options.vault) options.intent = options.intent || "tokenize";
    else {
        options.intent = options.intent || "authorize";
        options.currency = options.currency || "USD";
    }
    src = "https://www.paypal.com/sdk/js?";
    this._paypalScript.onload = function() {
        loadPromise.resolve();
    };
    Object.keys(dataAttributes).forEach((function(attribute) {
        this._paypalScript.setAttribute("data-" + attribute.replace(/^data\-/, ""), dataAttributes[attribute]);
    }).bind(this));
    if (options["client-id"]) idPromise = Promise.resolve(options["client-id"]);
    else idPromise = this.getClientId();
    idPromise.then((function(id) {
        options["client-id"] = id;
        if (this._autoSetDataUserIdToken && userIdToken) {
            this._paypalScript.setAttribute("data-user-id-token", userIdToken);
            // preloading improves the rendering time of the PayPal button
            this._attachPreloadPixel({
                id: id,
                userIdToken: userIdToken,
                amount: dataAttributes.amount,
                currency: options.currency,
                merchantId: options["merchant-id"]
            });
        }
        this._paypalScript.src = $2rlYa.queryify(src, options);
        document.head.insertBefore(this._paypalScript, document.head.firstElementChild);
    }).bind(this));
    return loadPromise.then((function() {
        return this;
    }).bind(this));
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._attachPreloadPixel = function(options) {
    var request;
    var id = options.id;
    var userIdToken = options.userIdToken;
    var env = this._authorizationInformation.environment;
    var subdomain = env === "production" ? "" : "sandbox.";
    var url = $4222b51ac79ed3f4$var$PAYPAL_SDK_PRELOAD_URL.replace("{ENV}", subdomain);
    var preloadOptions = {
        "client-id": id,
        "user-id-token": userIdToken
    };
    if (options.amount) preloadOptions.amount = options.amount;
    if (options.currency) preloadOptions.currency = options.currency;
    if (options.merchantId) preloadOptions["merchant-id"] = options.merchantId;
    request = new XMLHttpRequest();
    request.open("GET", $2rlYa.queryify(url, preloadOptions));
    request.send();
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._formatPaymentResourceData = function(options, config) {
    var key;
    var gatewayConfiguration = this._configuration.gatewayConfiguration;
    // NEXT_MAJOR_VERSION default value for intent in PayPal SDK is capture
    // but our integrations default value is authorize. Default this to capture
    // in the next major version.
    var intent = options.intent;
    var paymentResource = {
        // returnUrl and cancelUrl are required in hermes create_payment_resource route
        // but are not used by the PayPal sdk, except to redirect to an error page
        returnUrl: config.returnUrl || "https://www.paypal.com/checkoutnow/error",
        cancelUrl: config.cancelUrl || "https://www.paypal.com/checkoutnow/error",
        offerPaypalCredit: options.offerCredit === true,
        merchantAccountId: this._merchantAccountId,
        experienceProfile: {
            brandName: options.displayName || gatewayConfiguration.paypal.displayName,
            localeCode: options.locale,
            noShipping: (!options.enableShippingAddress).toString(),
            addressOverride: options.shippingAddressEditable === false,
            landingPageType: options.landingPageType
        },
        shippingOptions: options.shippingOptions
    };
    if (options.flow === "checkout") {
        paymentResource.amount = options.amount;
        paymentResource.currencyIsoCode = options.currency;
        paymentResource.requestBillingAgreement = options.requestBillingAgreement;
        if (intent) {
            // 'sale' has been changed to 'capture' in PayPal's backend, but
            // we use an old version with 'sale'. We provide capture as an alias
            // to match the PayPal SDK
            if (intent === "capture") intent = "sale";
            paymentResource.intent = intent;
        }
        if (options.hasOwnProperty("lineItems")) paymentResource.lineItems = options.lineItems;
        if (options.hasOwnProperty("vaultInitiatedCheckoutPaymentMethodToken")) paymentResource.vaultInitiatedCheckoutPaymentMethodToken = options.vaultInitiatedCheckoutPaymentMethodToken;
        if (options.hasOwnProperty("shippingOptions")) paymentResource.shippingOptions = options.shippingOptions;
        for(key in options.shippingAddressOverride)if (options.shippingAddressOverride.hasOwnProperty(key)) paymentResource[key] = options.shippingAddressOverride[key];
        if (options.hasOwnProperty("billingAgreementDetails")) paymentResource.billingAgreementDetails = options.billingAgreementDetails;
    } else {
        paymentResource.shippingAddress = options.shippingAddressOverride;
        if (options.billingAgreementDescription) paymentResource.description = options.billingAgreementDescription;
    }
    // this needs to be set outside of the block where add it to the
    // payment request so that a follow up tokenization call can use it,
    // but if a second create payment resource call is made without
    // the correlation id, we want to reset it to undefined so that the
    // tokenization call does not use a stale correlation id
    this._riskCorrelationId = options.riskCorrelationId;
    if (options.riskCorrelationId) paymentResource.correlationId = this._riskCorrelationId;
    return paymentResource;
};
/**
 * @ignore
 * @static
 * @function _verifyConsistentCurrency
 * Verifies that `options.currency` and the currencies for each `shippingOption` the same.
 * @param {object} options `options` provided for `updatePayment`.
 * @returns {boolean} true is currencies match (or no shipping options); false if currencies do not match.
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype._verifyConsistentCurrency = function(options) {
    if (options.currency && options.hasOwnProperty("shippingOptions") && Array.isArray(options.shippingOptions)) return options.shippingOptions.every(function(item) {
        return item.amount && item.amount.currency && options.currency.toLowerCase() === item.amount.currency.toLowerCase();
    });
    return true;
};
/**
 * @ignore
 * @static
 * @function _hasMissingOption
 * @param {object} options All options provided for intiating the PayPal flow.
 * @param {array} required A list of required inputs that must be include as part of the options.
 * @returns {boolean} Returns a boolean.
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype._hasMissingOption = function(options, required) {
    var i, option;
    required = required || [];
    if (!options.hasOwnProperty("amount") && !options.hasOwnProperty("lineItems")) return true;
    for(i = 0; i < required.length; i++){
        option = required[i];
        if (!options.hasOwnProperty(option)) return true;
    }
    return false;
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._formatUpdatePaymentData = function(options) {
    var self = this;
    var paymentResource = {
        merchantAccountId: this._merchantAccountId,
        paymentId: options.paymentId || options.orderId,
        currencyIsoCode: options.currency
    };
    if (options.hasOwnProperty("amount")) paymentResource.amount = options.amount;
    if (options.hasOwnProperty("lineItems")) paymentResource.lineItems = options.lineItems;
    if (options.hasOwnProperty("shippingOptions")) paymentResource.shippingOptions = options.shippingOptions;
    /* shippingAddress not supported yet */ if (options.hasOwnProperty("shippingAddress")) {
        $cIYHN.sendEvent(self._clientPromise, "paypal-checkout.updatePayment.shippingAddress.provided.by-the-merchant");
        paymentResource.line1 = options.shippingAddress.line1;
        if (options.shippingAddress.hasOwnProperty("line2")) paymentResource.line2 = options.shippingAddress.line2;
        paymentResource.city = options.shippingAddress.city;
        paymentResource.state = options.shippingAddress.state;
        paymentResource.postalCode = options.shippingAddress.postalCode;
        paymentResource.countryCode = options.shippingAddress.countryCode;
        if (options.shippingAddress.hasOwnProperty("phone")) paymentResource.phone = options.shippingAddress.phone;
        if (options.shippingAddress.hasOwnProperty("recipientName")) paymentResource.recipientName = options.shippingAddress.recipientName;
    }
    return paymentResource;
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._formatTokenizeData = function(options, params) {
    var clientConfiguration = this._configuration;
    var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
    var isTokenizationKey = clientConfiguration.authorizationType === "TOKENIZATION_KEY";
    var isVaultFlow = options.flow === "vault";
    var correlationId = this._riskCorrelationId || params.billingToken || params.ecToken;
    var data = {
        paypalAccount: {
            correlationId: correlationId,
            options: {
                validate: isVaultFlow && !isTokenizationKey && options.vault
            }
        }
    };
    if (isVaultFlow) data.paypalAccount.billingAgreementToken = params.billingToken;
    else {
        data.paypalAccount.paymentToken = params.paymentId || params.orderId;
        data.paypalAccount.payerId = params.payerId;
        data.paypalAccount.unilateral = gatewayConfiguration.paypal.unvettedMerchant;
        if (options.intent) data.paypalAccount.intent = options.intent;
    }
    if (this._merchantAccountId) data.merchantAccountId = this._merchantAccountId;
    return data;
};
$4222b51ac79ed3f4$var$PayPalCheckout.prototype._formatTokenizePayload = function(response) {
    var payload;
    var account = {};
    if (response.paypalAccounts) account = response.paypalAccounts[0];
    payload = {
        nonce: account.nonce,
        details: {},
        type: account.type
    };
    if (account.details && account.details.payerInfo) payload.details = account.details.payerInfo;
    if (account.details && account.details.creditFinancingOffered) payload.creditFinancingOffered = account.details.creditFinancingOffered;
    if (account.details && account.details.shippingOptionId) payload.shippingOptionId = account.details.shippingOptionId;
    if (account.details && account.details.cobrandedCardLabel) payload.cobrandedCardLabel = account.details.cobrandedCardLabel;
    return payload;
};
/**
 * Cleanly tear down anything set up by {@link module:braintree-web/paypal-checkout.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * paypalCheckoutInstance.teardown();
 * @example <caption>With callback</caption>
 * paypalCheckoutInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ $4222b51ac79ed3f4$var$PayPalCheckout.prototype.teardown = function() {
    var self = this;
    $fbCls(this, $jXxvS($4222b51ac79ed3f4$var$PayPalCheckout.prototype));
    if (this._paypalScript && this._paypalScript.parentNode) this._paypalScript.parentNode.removeChild(this._paypalScript);
    return this._frameServicePromise.catch(function() {
    // no need to error in teardown for an error setting up the frame service
    }).then(function() {
        if (!self._frameService) return Promise.resolve();
        return self._frameService.teardown();
    });
};
module.exports = $7GGVg.wrapPrototype($4222b51ac79ed3f4$var$PayPalCheckout);

});
parcelRegister("7vJcR", function(module, exports) {
"use strict";
var $577e7eb99a9f2366$var$GlobalPromise = typeof Promise !== "undefined" ? Promise // eslint-disable-line no-undef
 : null;
var $577e7eb99a9f2366$var$ExtendedPromise = /** @class */ function() {
    function ExtendedPromise(options) {
        var _this = this;
        if (typeof options === "function") {
            this._promise = new ExtendedPromise.Promise(options);
            return;
        }
        this._promise = new ExtendedPromise.Promise(function(resolve, reject) {
            _this._resolveFunction = resolve;
            _this._rejectFunction = reject;
        });
        options = options || {};
        this._onResolve = options.onResolve || ExtendedPromise.defaultOnResolve;
        this._onReject = options.onReject || ExtendedPromise.defaultOnReject;
        if (ExtendedPromise.shouldCatchExceptions(options)) this._promise.catch(function() {
        // prevents unhandled promise rejection warning
        // in the console for extended promises that
        // that catch the error in an asynchronous manner
        });
        this._resetState();
    }
    ExtendedPromise.defaultOnResolve = function(result) {
        return ExtendedPromise.Promise.resolve(result);
    };
    ExtendedPromise.defaultOnReject = function(err) {
        return ExtendedPromise.Promise.reject(err);
    };
    ExtendedPromise.setPromise = function(PromiseClass) {
        ExtendedPromise.Promise = PromiseClass;
    };
    ExtendedPromise.shouldCatchExceptions = function(options) {
        if (options.hasOwnProperty("suppressUnhandledPromiseMessage")) return Boolean(options.suppressUnhandledPromiseMessage);
        return Boolean(ExtendedPromise.suppressUnhandledPromiseMessage);
    };
    // start Promise methods documented in:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#Methods
    ExtendedPromise.all = function(args) {
        return ExtendedPromise.Promise.all(args);
    };
    ExtendedPromise.allSettled = function(args) {
        return ExtendedPromise.Promise.allSettled(args);
    };
    ExtendedPromise.race = function(args) {
        return ExtendedPromise.Promise.race(args);
    };
    ExtendedPromise.reject = function(arg) {
        return ExtendedPromise.Promise.reject(arg);
    };
    ExtendedPromise.resolve = function(arg) {
        return ExtendedPromise.Promise.resolve(arg);
    };
    ExtendedPromise.prototype.then = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (_a = this._promise).then.apply(_a, args);
    };
    ExtendedPromise.prototype.catch = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (_a = this._promise).catch.apply(_a, args);
    };
    ExtendedPromise.prototype.resolve = function(arg) {
        var _this = this;
        if (this.isFulfilled) return this;
        this._setResolved();
        ExtendedPromise.Promise.resolve().then(function() {
            return _this._onResolve(arg);
        }).then(function(argForResolveFunction) {
            _this._resolveFunction(argForResolveFunction);
        }).catch(function(err) {
            _this._resetState();
            _this.reject(err);
        });
        return this;
    };
    ExtendedPromise.prototype.reject = function(arg) {
        var _this = this;
        if (this.isFulfilled) return this;
        this._setRejected();
        ExtendedPromise.Promise.resolve().then(function() {
            return _this._onReject(arg);
        }).then(function(result) {
            _this._setResolved();
            _this._resolveFunction(result);
        }).catch(function(err) {
            return _this._rejectFunction(err);
        });
        return this;
    };
    ExtendedPromise.prototype._resetState = function() {
        this.isFulfilled = false;
        this.isResolved = false;
        this.isRejected = false;
    };
    ExtendedPromise.prototype._setResolved = function() {
        this.isFulfilled = true;
        this.isResolved = true;
        this.isRejected = false;
    };
    ExtendedPromise.prototype._setRejected = function() {
        this.isFulfilled = true;
        this.isResolved = false;
        this.isRejected = true;
    };
    ExtendedPromise.Promise = $577e7eb99a9f2366$var$GlobalPromise;
    return ExtendedPromise;
}();
module.exports = $577e7eb99a9f2366$var$ExtendedPromise;

});

parcelRegister("fqnaK", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");
module.exports = {
    PAYPAL_NOT_ENABLED: {
        type: $dcafC.types.MERCHANT,
        code: "PAYPAL_NOT_ENABLED",
        message: "PayPal is not enabled for this merchant."
    },
    PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED: {
        type: $dcafC.types.MERCHANT,
        code: "PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED",
        message: "A linked PayPal Sandbox account is required to use PayPal Checkout in Sandbox. See https://developer.paypal.com/braintree/docs/guides/paypal/testing-go-live#linked-paypal-testing for details on linking your PayPal sandbox with Braintree."
    },
    PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
        type: $dcafC.types.NETWORK,
        code: "PAYPAL_ACCOUNT_TOKENIZATION_FAILED",
        message: "Could not tokenize user's PayPal account."
    },
    PAYPAL_FLOW_FAILED: {
        type: $dcafC.types.NETWORK,
        code: "PAYPAL_FLOW_FAILED",
        message: "Could not initialize PayPal flow."
    },
    PAYPAL_FLOW_OPTION_REQUIRED: {
        type: $dcafC.types.MERCHANT,
        code: "PAYPAL_FLOW_OPTION_REQUIRED",
        message: "PayPal flow property is invalid or missing."
    },
    PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED: {
        type: $dcafC.types.MERCHANT,
        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED"
    },
    PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED: {
        type: $dcafC.types.NETWORK,
        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED",
        message: "Something went wrong when setting up the checkout workflow."
    },
    PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED: {
        type: $dcafC.types.MERCHANT,
        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED",
        message: "PayPal popup failed to open, make sure to initiate the vault checkout in response to a user action."
    },
    PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED: {
        type: $dcafC.types.CUSTOMER,
        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED",
        message: "Customer closed PayPal popup before authorizing."
    },
    PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS: {
        type: $dcafC.types.MERCHANT,
        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS",
        message: "Vault initiated checkout already in progress."
    },
    PAYPAL_INVALID_PAYMENT_OPTION: {
        type: $dcafC.types.MERCHANT,
        code: "PAYPAL_INVALID_PAYMENT_OPTION",
        message: "PayPal payment options are invalid."
    },
    PAYPAL_MISSING_REQUIRED_OPTION: {
        type: $dcafC.types.MERCHANT,
        code: "PAYPAL_MISSING_REQUIRED_OPTION",
        message: "Missing required option."
    }
};

});

parcelRegister("c5XGe", function(module, exports) {
"use strict";
module.exports = {
    LANDING_FRAME_NAME: "braintreepaypallanding",
    FLOW_ENDPOINTS: {
        checkout: "create_payment_resource",
        vault: "setup_billing_agreement"
    },
    REQUIRED_OPTIONS: [
        "paymentId",
        "currency"
    ]
};

});

parcelRegister("kjo88", function(module, exports) {
"use strict";

var $6dnfV = parcelRequire("6dnfV");
/**
 * @ignore
 * @function create
 * Initializing FrameService should be done at the point when the component is created, so it is ready whenever a component needs to open a popup window.
 * Browsers have varying rules around what constitutes and async action worth blocking a popup for, but the likes of Safari
 * will block the popup if `frameService#create` is invoked during any asynchronous process (such as an API request to tokenize payment details).
 *
 * The process of setting up the dispatch frame and subsequent framebus communications via event listeners are considered async by Safari's standards.
 *
 * @param {object} options The options provided to frameservice
 * @param {string} options.name The name to use for identifying the various pieces associated with frameservice.
 * @param {string} options.dispatchFrameUrl The static asset to load for use as the dispatch frame. This allows for secure communication between the iframe and the popup, since they are on the same asset domain (usually checkout.paypal.com or assets.braintreegateway.com)
 * @param {string} options.openFrameUrl The url to load in the popup. Sometimes it is the case that you'll need info that comes _after_ the popup loads in which case we load the `landing-frame` that's a loading spinner then redirect to the proper/final destination. See the PayPal component for an example.
 * Otherwise if all the info needed is ready up-front, then you can forego a landing frame and go straight to the final destination.
 * @param {string} [options.height] The desired popup height.
 * @param {string} [options.width] The desired popup width.
 * @param {string} [options.top] The desired top value of the popup for positioning.
 * @param {string} [options.left] The desired left value of the popup for positioning.
 * @param {object} [options.state] Seems to be dead code, but allows for injecting data in to popup. NEXT_MAJOR_VERSION remove this param if no usage exists.
 * @param {function} callback The function to invoke once the frameservice is created and ready to use. FrameService instance is returned.
 */ module.exports = {
    create: function createFrameService(options, callback) {
        var frameService = new $6dnfV(options);
        frameService.initialize(function() {
            callback(frameService);
        });
    }
};

});
parcelRegister("6dnfV", function(module, exports) {
"use strict";

var $hcPhs = parcelRequire("hcPhs");

var $9QjJs = parcelRequire("9QjJs");

var $5BmG2 = parcelRequire("5BmG2");

var $efA95 = parcelRequire("efA95");

var $fUh9g = parcelRequire("fUh9g");

var $7ZK3a = parcelRequire("7ZK3a");

var $7GPXx = parcelRequire("7GPXx");

var $eC4sQ = parcelRequire("eC4sQ");

var $2DRDC = parcelRequire("2DRDC");

var $dcafC = parcelRequire("dcafC");

var $1yNUg = parcelRequire("1yNUg");

var $8mxc9 = parcelRequire("8mxc9");
var $4865ff2112455dd3$require$assign = $8mxc9.assign;

var $3h7RY = parcelRequire("3h7RY");
var $4865ff2112455dd3$require$BUS_CONFIGURATION_REQUEST_EVENT = $3h7RY.BUS_CONFIGURATION_REQUEST_EVENT;
var $4865ff2112455dd3$var$REQUIRED_CONFIG_KEYS = [
    "name",
    "dispatchFrameUrl",
    "openFrameUrl"
];
function $4865ff2112455dd3$var$noop() {}
function $4865ff2112455dd3$var$_validateFrameConfiguration(options) {
    if (!options) throw new Error("Valid configuration is required");
    $4865ff2112455dd3$var$REQUIRED_CONFIG_KEYS.forEach(function(key) {
        if (!options.hasOwnProperty(key)) throw new Error("A valid frame " + key + " must be provided");
    });
    if (!/^[\w_]+$/.test(options.name)) throw new Error("A valid frame name must be provided");
}
function $4865ff2112455dd3$var$FrameService(options) {
    $4865ff2112455dd3$var$_validateFrameConfiguration(options);
    this._serviceId = $eC4sQ().replace(/-/g, "");
    this._options = {
        name: options.name + "_" + this._serviceId,
        dispatchFrameUrl: options.dispatchFrameUrl,
        openFrameUrl: options.openFrameUrl,
        height: options.height,
        width: options.width,
        top: options.top,
        left: options.left
    };
    this.state = options.state || {};
    this._bus = new $efA95({
        channel: this._serviceId
    });
    this._setBusEvents();
}
$4865ff2112455dd3$var$FrameService.prototype.initialize = function(callback) {
    var dispatchFrameReadyHandler = (function() {
        callback();
        this._bus.off($fUh9g.DISPATCH_FRAME_READY, dispatchFrameReadyHandler);
    }).bind(this);
    this._bus.on($fUh9g.DISPATCH_FRAME_READY, dispatchFrameReadyHandler);
    this._writeDispatchFrame();
};
$4865ff2112455dd3$var$FrameService.prototype._writeDispatchFrame = function() {
    var frameName = $7GPXx.DISPATCH_FRAME_NAME + "_" + this._serviceId;
    var frameSrc = this._options.dispatchFrameUrl;
    this._dispatchFrame = $2DRDC({
        "aria-hidden": true,
        name: frameName,
        title: frameName,
        src: frameSrc,
        class: $7GPXx.DISPATCH_FRAME_CLASS,
        height: 0,
        width: 0,
        style: {
            position: "absolute",
            left: "-9999px"
        }
    });
    document.body.appendChild(this._dispatchFrame);
};
$4865ff2112455dd3$var$FrameService.prototype._setBusEvents = function() {
    this._bus.on($fUh9g.DISPATCH_FRAME_REPORT, (function(res, reply) {
        if (this._onCompleteCallback) this._onCompleteCallback.call(null, res.err, res.payload);
        this._frame.close();
        this._onCompleteCallback = null;
        if (reply) reply();
    }).bind(this));
    this._bus.on($4865ff2112455dd3$require$BUS_CONFIGURATION_REQUEST_EVENT, (function(reply) {
        reply(this.state);
    }).bind(this));
};
$4865ff2112455dd3$var$FrameService.prototype.open = function(options, callback) {
    options = options || {};
    this._frame = this._getFrameForEnvironment(options);
    this._frame.initialize(callback);
    if (this._frame instanceof $9QjJs) // Frameservice loads a spinner then redirects to the final destination url.
    // For Popupbridge it doesn't have the same rules around popups since it's deferred to the mobile side
    // therefore, skips the regular open path and instead uses `#redirect` to handle things
    return;
    $4865ff2112455dd3$require$assign(this.state, options.state);
    this._onCompleteCallback = callback;
    this._frame.open();
    if (this.isFrameClosed()) {
        this._cleanupFrame();
        if (callback) callback(new $dcafC($7ZK3a.FRAME_SERVICE_FRAME_OPEN_FAILED));
        return;
    }
    this._pollForPopupClose();
};
$4865ff2112455dd3$var$FrameService.prototype.redirect = function(url) {
    if (this._frame && !this.isFrameClosed()) this._frame.redirect(url);
};
$4865ff2112455dd3$var$FrameService.prototype.close = function() {
    if (!this.isFrameClosed()) this._frame.close();
};
$4865ff2112455dd3$var$FrameService.prototype.focus = function() {
    if (!this.isFrameClosed()) this._frame.focus();
};
$4865ff2112455dd3$var$FrameService.prototype.createHandler = function(options) {
    options = options || {};
    return {
        close: (function() {
            if (options.beforeClose) options.beforeClose();
            this.close();
        }).bind(this),
        focus: (function() {
            if (options.beforeFocus) options.beforeFocus();
            this.focus();
        }).bind(this)
    };
};
$4865ff2112455dd3$var$FrameService.prototype.createNoopHandler = function() {
    return {
        close: $4865ff2112455dd3$var$noop,
        focus: $4865ff2112455dd3$var$noop
    };
};
$4865ff2112455dd3$var$FrameService.prototype.teardown = function() {
    this.close();
    this._dispatchFrame.parentNode.removeChild(this._dispatchFrame);
    this._dispatchFrame = null;
    this._cleanupFrame();
};
$4865ff2112455dd3$var$FrameService.prototype.isFrameClosed = function() {
    return this._frame == null || this._frame.isClosed();
};
$4865ff2112455dd3$var$FrameService.prototype._cleanupFrame = function() {
    this._frame = null;
    clearInterval(this._popupInterval);
    this._popupInterval = null;
};
$4865ff2112455dd3$var$FrameService.prototype._pollForPopupClose = function() {
    this._popupInterval = setInterval((function() {
        if (this.isFrameClosed()) {
            this._cleanupFrame();
            if (this._onCompleteCallback) this._onCompleteCallback(new $dcafC($7ZK3a.FRAME_SERVICE_FRAME_CLOSED));
        }
    }).bind(this), $7GPXx.POPUP_POLL_INTERVAL);
    return this._popupInterval;
};
$4865ff2112455dd3$var$FrameService.prototype._getFrameForEnvironment = function(options) {
    var usePopup = $1yNUg.supportsPopups();
    var popupBridgeExists = Boolean(window.popupBridge);
    var initOptions = $4865ff2112455dd3$require$assign({}, this._options, options);
    if (popupBridgeExists) return new $9QjJs(initOptions);
    else if (usePopup) return new $hcPhs(initOptions);
    return new $5BmG2(initOptions);
};
module.exports = $4865ff2112455dd3$var$FrameService;

});
parcelRegister("hcPhs", function(module, exports) {
"use strict";

var $7vZfg = parcelRequire("7vZfg");
function $c86b55ee3dccde5c$var$noop() {}
function $c86b55ee3dccde5c$var$Popup(options) {
    this._frame = null;
    this._options = options || {};
}
$c86b55ee3dccde5c$var$Popup.prototype.initialize = $c86b55ee3dccde5c$var$noop;
$c86b55ee3dccde5c$var$Popup.prototype.open = function() {
    this._frame = window.open(this._options.openFrameUrl, this._options.name, $7vZfg(this._options));
};
$c86b55ee3dccde5c$var$Popup.prototype.focus = function() {
    this._frame.focus();
};
$c86b55ee3dccde5c$var$Popup.prototype.close = function() {
    if (this._frame.closed) return;
    this._frame.close();
};
$c86b55ee3dccde5c$var$Popup.prototype.isClosed = function() {
    return !this._frame || Boolean(this._frame.closed);
};
$c86b55ee3dccde5c$var$Popup.prototype.redirect = function(redirectUrl) {
    this._frame.location.href = redirectUrl;
};
module.exports = $c86b55ee3dccde5c$var$Popup;

});
parcelRegister("7vZfg", function(module, exports) {
"use strict";

var $7GPXx = parcelRequire("7GPXx");

var $fnzIh = parcelRequire("fnzIh");
function $578aefb28ed7c3df$var$calculatePosition(type, userDefinedPosition, size) {
    if (typeof userDefinedPosition !== "undefined") return userDefinedPosition;
    return $fnzIh[type](size);
}
module.exports = function composePopupOptions(options) {
    var height = options.height || $7GPXx.DEFAULT_POPUP_HEIGHT;
    var width = options.width || $7GPXx.DEFAULT_POPUP_WIDTH;
    var top = $578aefb28ed7c3df$var$calculatePosition("top", options.top, height);
    var left = $578aefb28ed7c3df$var$calculatePosition("left", options.left, width);
    return [
        $7GPXx.POPUP_BASE_OPTIONS,
        "height=" + height,
        "width=" + width,
        "top=" + top,
        "left=" + left
    ].join(",");
};

});
parcelRegister("7GPXx", function(module, exports) {
"use strict";
module.exports = {
    DISPATCH_FRAME_NAME: "dispatch",
    DISPATCH_FRAME_CLASS: "braintree-dispatch-frame",
    POPUP_BASE_OPTIONS: "resizable,scrollbars",
    DEFAULT_POPUP_WIDTH: 450,
    DEFAULT_POPUP_HEIGHT: 535,
    POPUP_POLL_INTERVAL: 100,
    POPUP_CLOSE_TIMEOUT: 100
};

});

parcelRegister("fnzIh", function(module, exports) {
"use strict";
function $b324b4e9e9efdd9d$var$top(height) {
    var windowHeight = window.outerHeight || document.documentElement.clientHeight;
    var windowTop = window.screenY == null ? window.screenTop : window.screenY;
    return $b324b4e9e9efdd9d$var$center(windowHeight, height, windowTop);
}
function $b324b4e9e9efdd9d$var$left(width) {
    var windowWidth = window.outerWidth || document.documentElement.clientWidth;
    var windowLeft = window.screenX == null ? window.screenLeft : window.screenX;
    return $b324b4e9e9efdd9d$var$center(windowWidth, width, windowLeft);
}
function $b324b4e9e9efdd9d$var$center(windowMetric, popupMetric, offset) {
    return (windowMetric - popupMetric) / 2 + offset;
}
module.exports = {
    top: $b324b4e9e9efdd9d$var$top,
    left: $b324b4e9e9efdd9d$var$left,
    center: $b324b4e9e9efdd9d$var$center
};

});



parcelRegister("9QjJs", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");

var $7ZK3a = parcelRequire("7ZK3a");
function $72a846cd833d6f14$var$noop() {}
function $72a846cd833d6f14$var$PopupBridge(options) {
    this._closed = null;
    this._options = options;
}
$72a846cd833d6f14$var$PopupBridge.prototype.initialize = function(callback) {
    var self = this;
    window.popupBridge.onComplete = function(err, payload) {
        var popupDismissed = !payload && !err;
        self._closed = true;
        if (err || popupDismissed) {
            // User clicked "Done" button of browser view
            callback(new $dcafC($7ZK3a.FRAME_SERVICE_FRAME_CLOSED));
            return;
        }
        // User completed popup flow (includes success and cancel cases)
        callback(null, payload);
    };
};
$72a846cd833d6f14$var$PopupBridge.prototype.open = function(options) {
    var url;
    options = options || {};
    url = options.openFrameUrl || this._options.openFrameUrl;
    this._closed = false;
    window.popupBridge.open(url);
};
$72a846cd833d6f14$var$PopupBridge.prototype.focus = $72a846cd833d6f14$var$noop;
$72a846cd833d6f14$var$PopupBridge.prototype.close = $72a846cd833d6f14$var$noop;
$72a846cd833d6f14$var$PopupBridge.prototype.isClosed = function() {
    return Boolean(this._closed);
};
$72a846cd833d6f14$var$PopupBridge.prototype.redirect = function(redirectUrl) {
    this.open({
        openFrameUrl: redirectUrl
    });
};
module.exports = $72a846cd833d6f14$var$PopupBridge;

});
parcelRegister("7ZK3a", function(module, exports) {
"use strict";

var $dcafC = parcelRequire("dcafC");
module.exports = {
    FRAME_SERVICE_FRAME_CLOSED: {
        type: $dcafC.types.INTERNAL,
        code: "FRAME_SERVICE_FRAME_CLOSED",
        message: "Frame closed before tokenization could occur."
    },
    FRAME_SERVICE_FRAME_OPEN_FAILED: {
        type: $dcafC.types.INTERNAL,
        code: "FRAME_SERVICE_FRAME_OPEN_FAILED",
        message: "Frame failed to open."
    }
};

});


parcelRegister("5BmG2", function(module, exports) {
"use strict";

var $2DRDC = parcelRequire("2DRDC");

var $8mxc9 = parcelRequire("8mxc9");
var $4141ff9d27d380d1$require$assign = $8mxc9.assign;

var $1yNUg = parcelRequire("1yNUg");
var $4141ff9d27d380d1$var$ELEMENT_STYLES = {
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    padding: 0,
    margin: 0,
    border: 0,
    outline: "none",
    zIndex: 20001,
    background: "#FFFFFF"
};
function $4141ff9d27d380d1$var$noop() {}
/**
 *
 * We should not ever really use the Modal. Modals are _like_  popups, but the key difference is that the customer can't actually verify it's app domain and thus secure/valid. Old PP sdk (./src/paypal) uses this
 * to get info from webviews (e.g. facebook).
 */ function $4141ff9d27d380d1$var$Modal(options) {
    this._closed = null;
    this._frame = null;
    this._options = options || {};
    this._container = this._options.container || document.body;
}
$4141ff9d27d380d1$var$Modal.prototype.initialize = $4141ff9d27d380d1$var$noop;
$4141ff9d27d380d1$var$Modal.prototype.open = function() {
    var iframerConfig = {
        src: this._options.openFrameUrl,
        name: this._options.name,
        scrolling: "yes",
        height: "100%",
        width: "100%",
        style: $4141ff9d27d380d1$require$assign({}, $4141ff9d27d380d1$var$ELEMENT_STYLES),
        title: "Lightbox Frame"
    };
    if ($1yNUg.isIos()) {
        // WKWebView has buggy behavior when scrolling a fixed position modal. The workaround is to lock scrolling in
        // the background. When modal is closed, we restore scrolling and return to the previous scroll position.
        if ($1yNUg.isIosWKWebview()) {
            this._lockScrolling();
            // Allows WKWebView to scroll all the way down to bottom
            iframerConfig.style = {};
        }
        this._el = document.createElement("div");
        $4141ff9d27d380d1$require$assign(this._el.style, $4141ff9d27d380d1$var$ELEMENT_STYLES, {
            height: "100%",
            width: "100%",
            overflow: "auto",
            "-webkit-overflow-scrolling": "touch"
        });
        this._frame = $2DRDC(iframerConfig);
        this._el.appendChild(this._frame);
    } else this._el = this._frame = $2DRDC(iframerConfig);
    this._closed = false;
    this._container.appendChild(this._el);
};
$4141ff9d27d380d1$var$Modal.prototype.focus = $4141ff9d27d380d1$var$noop;
$4141ff9d27d380d1$var$Modal.prototype.close = function() {
    this._container.removeChild(this._el);
    this._frame = null;
    this._closed = true;
    if ($1yNUg.isIosWKWebview()) this._unlockScrolling();
};
$4141ff9d27d380d1$var$Modal.prototype.isClosed = function() {
    return Boolean(this._closed);
};
$4141ff9d27d380d1$var$Modal.prototype.redirect = function(redirectUrl) {
    this._frame.src = redirectUrl;
};
$4141ff9d27d380d1$var$Modal.prototype._unlockScrolling = function() {
    document.body.style.overflow = this._savedBodyProperties.overflowStyle;
    document.body.style.position = this._savedBodyProperties.positionStyle;
    window.scrollTo(this._savedBodyProperties.left, this._savedBodyProperties.top);
    delete this._savedBodyProperties;
};
$4141ff9d27d380d1$var$Modal.prototype._lockScrolling = function() {
    var doc = document.documentElement;
    // From https://stackoverflow.com/questions/9538868/prevent-body-from-scrolling-when-a-modal-is-opened#comment65626743_24727206
    this._savedBodyProperties = {
        left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
        top: (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
        overflowStyle: document.body.style.overflow,
        positionStyle: document.body.style.position
    };
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    window.scrollTo(0, 0);
};
module.exports = $4141ff9d27d380d1$var$Modal;

});
parcelRegister("1yNUg", function(module, exports) {
"use strict";



module.exports = {
    isIos: (parcelRequire("cYvvY")),
    isIosWKWebview: (parcelRequire("crn0O")),
    supportsPopups: (parcelRequire("e3mmi"))
};

});
parcelRegister("crn0O", function(module, exports) {

module.exports = (parcelRequire("g4Ofy"));

});
parcelRegister("g4Ofy", function(module, exports) {
"use strict";

var $inabg = parcelRequire("inabg");
module.exports = function isIosWKWebview(ua, statusBarVisible) {
    statusBarVisible = typeof statusBarVisible !== "undefined" ? statusBarVisible : window.statusbar.visible;
    return $inabg(ua) && statusBarVisible;
};

});


parcelRegister("e3mmi", function(module, exports) {

module.exports = (parcelRequire("9XjD9"));

});
parcelRegister("9XjD9", function(module, exports) {
"use strict";
var $73f8d9ede23e0338$var$MINIMUM_SUPPORTED_CHROME_IOS_VERSION = 48;

var $cBkZu = parcelRequire("cBkZu");

var $h6sJD = parcelRequire("h6sJD");

var $inabg = parcelRequire("inabg");

var $3fc67 = parcelRequire("3fc67");

var $luIGb = parcelRequire("luIGb");

var $fjmu3 = parcelRequire("fjmu3");
function $73f8d9ede23e0338$var$isUnsupportedIosChrome(ua) {
    ua = ua || window.navigator.userAgent;
    var match = ua.match(/CriOS\/(\d+)\./);
    if (!match) return false;
    var version = parseInt(match[1], 10);
    return version < $73f8d9ede23e0338$var$MINIMUM_SUPPORTED_CHROME_IOS_VERSION;
}
function $73f8d9ede23e0338$var$isOperaMini(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("Opera Mini") > -1;
}
function $73f8d9ede23e0338$var$isAndroidWebview(ua) {
    var androidWebviewRegExp = /Version\/[\d.]+/i;
    ua = ua || window.navigator.userAgent;
    if ($cBkZu(ua)) return androidWebviewRegExp.test(ua) && !$73f8d9ede23e0338$var$isOperaMini(ua) && !$fjmu3(ua);
    return false;
}
function $73f8d9ede23e0338$var$isOldSamsungBrowserOrSamsungWebview(ua) {
    return !$3fc67(ua) && !$luIGb(ua) && /samsung/i.test(ua);
}
module.exports = function supportsPopups(ua) {
    ua = ua || window.navigator.userAgent;
    return !($inabg(ua) || $h6sJD(ua) || $73f8d9ede23e0338$var$isAndroidWebview(ua) || $73f8d9ede23e0338$var$isOperaMini(ua) || $73f8d9ede23e0338$var$isUnsupportedIosChrome(ua) || $73f8d9ede23e0338$var$isOldSamsungBrowserOrSamsungWebview(ua));
};

});
parcelRegister("h6sJD", function(module, exports) {
"use strict";
module.exports = function isIosFirefox(ua) {
    ua = ua || window.navigator.userAgent;
    return /FxiOS/i.test(ua);
};

});





parcelRegister("fUh9g", function(module, exports) {
"use strict";

var $7GGem = parcelRequire("7GGem");
module.exports = $7GGem([
    "DISPATCH_FRAME_READY",
    "DISPATCH_FRAME_REPORT"
], "frameService:");

});







// Javascript hints
// Variables included in file scope, etc
/**
 * @name products
 * @type {object}
 */ /**
 * @name paypal_env
 * @type {string}
 */ /**
 * @name ajax_order_create_url
 * @type {string}
 */ /**
 * @name client_token_get_url
 * @type {string}
 */ /**
 * @name customer_support_email
 * @type {string}
 */ /**
 * @name close_super_crazy
 * @type {boolean}
 */ // Libraries
// we bring them into the global namespace for console usage and debugging

$parcel$global.$ = (parcelRequire("iUSsr"));
parcelRequire("yIC3S");
parcelRequire("3qR9V");

// knockout
$parcel$global.ko = (parcelRequire("cLR2A"));
var $44be2d61aaeeb65d$exports = {};

/*!
  Knockout pre-rendered binding handlers v$npm_package_version
  By: Erik Schierboom (C) 2019
  License: Apache 2

  Adds binding handlers that can be populated based on existing HTML.

  The foreach code is adapted from:

  Knockout Fast Foreach v0.3.1 (2015-03-18T15:15:11.505Z)
  By: Brian M Hunt (C) 2015
  License: MIT
  URL: https://github.com/brianmhunt/knockout-fast-foreach
*/ (function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "knockout"
    ], factory);
    else $44be2d61aaeeb65d$exports = factory((parcelRequire("cLR2A")));
})($44be2d61aaeeb65d$exports, function(ko) {
    // index.js
    // --------
    // Pre-rendered binding handlers.
    // --------
    "use strict";
    // Utilities
    // from https://github.com/jonschlinkert/is-plain-object
    function isPlainObject(o) {
        return !!o && typeof o === "object" && o.constructor === Object;
    }
    // From knockout/src/virtualElements.js
    var commentNodesHaveTextProperty = window.document && window.document.createComment("test").text === "<!--test-->";
    var startCommentRegex = commentNodesHaveTextProperty ? /^<!--\s*ko(?:\s+([\s\S]+))?\s*-->$/ : /^\s*ko(?:\s+([\s\S]+))?\s*$/;
    function isVirtualNode(node) {
        return node.nodeType == 8 && startCommentRegex.test(commentNodesHaveTextProperty ? node.text : node.nodeValue);
    }
    // Check if a node is an element node
    function isElementNode(node) {
        return node && node.nodeType && node.nodeType === 1;
    }
    // Check if a node is a valid child node
    function isValidChildNode(attribute, childNode) {
        if (typeof attribute === "string") return isElementNode(childNode) && childNode.attributes && childNode.attributes[attribute];
        return isElementNode(childNode);
    }
    // Find the first children of the specified parent node. If the attribute is defined, the child node
    // also need to have that attribute
    function findFirstChild(parentNode, attribute) {
        return ko.utils.arrayFirst(ko.virtualElements.childNodes(parentNode), isValidChildNode.bind(this, attribute));
    }
    // Find children of the specified parent node. If the attribute is defined, the child nodes
    // also need to have that attribute
    function findChildren(parentNode, attribute) {
        return ko.utils.arrayFilter(ko.virtualElements.childNodes(parentNode), isValidChildNode.bind(this, attribute));
    }
    // Get a copy of the template node of the given element,
    // put them into a container, then remove the template node.
    function makeTemplateNode(sourceNode, namedTemplate, deleteTemplateNodes, nodesPerElement) {
        var container = document.createElement("div");
        var parentNode;
        var namedTemplate;
        if (sourceNode.content) // For e.g. <template> tags
        parentNode = sourceNode.content;
        else if (sourceNode.tagName === "SCRIPT") {
            if (sourceNode.innerHTML.match(/^\s*<tr[\s\S]*?<\/tr>\s*$/i)) {
                var tbl = document.createElement("table");
                tbl.innerHTML = "<tbody>" + sourceNode.innerHTML + "</tbody>";
                parentNode = tbl.firstChild;
            } else {
                parentNode = document.createElement("div");
                parentNode.innerHTML = sourceNode.innerHTML;
            }
        } else // Anything else e.g. <div>
        parentNode = sourceNode;
        // Find the template and add it to the container
        var template = findFirstChild(parentNode, namedTemplate ? null : "data-template");
        for(var i = 0, node = template; i < nodesPerElement; i++){
            var currentNode = node;
            container.insertBefore(node.cloneNode(true), null);
            // Find next element sibling. (Some older browsers don't support nextElementSibling).
            do node = node.nextElementSibling || node.nextSibling;
            while (node && node.nodeType !== 1);
            // Remove current template node
            if (deleteTemplateNodes) ko.removeNode(currentNode);
        }
        return container;
    }
    // Add an existing element
    function valueToChangeAddExistingItem(value, index) {
        return {
            status: "existing",
            value: value,
            index: index
        };
    }
    // Knockout automatically generates "_ko_property_writers" for a subset of its
    // built-in bindings, registered as "_twoWayBindings". Here, we can compel it to
    // do the same for the rest of the bindings that we want to support with "init".
    ko.utils.extend(ko.expressionRewriting._twoWayBindings, {
        text: true,
        html: true,
        visible: true,
        enable: true,
        disable: true
    });
    // KO's built-in "_twoWayBindings" logic can only carry us so far. For other bindings,
    // we need to generate our own property writers, in much the same way as KO does.
    // Generate property writers for all properties referenced in "attr" and "css" bindings.
    generatePropertyWritersForBinding("attr", "_ko_prerender_attrPropertyWriters", "attr");
    generatePropertyWritersForBinding("css", "_ko_prerender_cssPropertyWriters", "css");
    // This method generates a binding preprocessor for the specified binding, and for each
    // applicable field referenced in the binding params, it generates a writer.
    function generatePropertyWritersForBinding(bindingName, propertyWritersBindingName, defaultWriterName, mapExpressionsCallback) {
        // Chain this with any existing preprocessor.
        var existingPreprocessor = ko.bindingHandlers[bindingName].preprocess;
        ko.bindingHandlers[bindingName].preprocess = function(value, name, addBinding) {
            if (existingPreprocessor) value = existingPreprocessor(value, name, addBinding);
            var expressions = ko.expressionRewriting.parseObjectLiteral(value);
            if (mapExpressionsCallback) expressions = ko.utils.arrayMap(expressions, mapExpressionsCallback);
            var writers = [];
            ko.utils.arrayForEach(expressions, function(expression) {
                if (expression != null) {
                    var writableExpression = getWritableValue("unknown" in expression ? expression["unknown"] : expression.value);
                    if (writableExpression) writers.push("'" + ("unknown" in expression ? defaultWriterName : expression.key) + "':function(_v){" + writableExpression + "=_v}");
                }
            });
            if (writers.length != 0) addBinding(propertyWritersBindingName, "{" + writers.join(",") + "}");
            return value || true;
        };
    }
    // from knockout/src/binding/expressionRewriting.js
    var javaScriptReservedWords = [
        "true",
        "false",
        "null",
        "undefined"
    ];
    var javaScriptAssignmentTarget = /^(?:[$_a-z][$\w]*|(.+)(\.\s*[$_a-z][$\w]*|\[.+\]))$/i;
    function getWritableValue(expression) {
        if (ko.utils.arrayIndexOf(javaScriptReservedWords, expression) == -1) {
            var match = expression.match(javaScriptAssignmentTarget);
            return match === null ? false : match[1] ? "Object(" + match[1] + ")" + match[2] : expression;
        }
        return false;
    }
    function InitializedForeach(element, valueAccessor, bindings, viewModel, context) {
        var self = this;
        this.element = element;
        this.container = isVirtualNode(element) ? this.element.parentNode : element;
        this.$context = context;
        var useRawData = false; // If true, the binding received an array, rather than an object with a "data" property.
        var spec = valueAccessor();
        if (!isPlainObject(spec)) {
            useRawData = ko.unwrap(context.$rawData) === spec;
            spec = {
                data: useRawData ? context.$rawData : spec,
                createElement: spec.createElement
            };
        }
        this.data = spec.data;
        this.as = spec.as;
        this.createElement = spec.createElement;
        this.noContext = spec.noContext;
        this.namedTemplate = spec.name !== undefined;
        this.nodesPerElement = spec.nodesPerElement || 1;
        this.templateNode = makeTemplateNode(spec.name ? document.getElementById(spec.name) : element, this.namedTemplate, !spec.name, this.nodesPerElement);
        this.afterQueueFlush = spec.afterQueueFlush;
        this.beforeQueueFlush = spec.beforeQueueFlush;
        this.dataChanged = spec.dataChanged;
        this.changeQueue = [];
        this.lastNodesList = [];
        this.childContexts = [];
        this.indexesToDelete = [];
        this.rendering_queued = false;
        // Find the existing elements that will be bound to the data array
        this.existingElements = findChildren(this.namedTemplate ? this.element : this.container, this.namedTemplate ? null : "data-init");
        // Check to see if we should manually create the array elements
        if (typeof this.createElement === "function") this.createElements();
        // Prime content
        var primeData = ko.unwrap(this.data);
        this.onArrayChange(ko.utils.arrayMap(primeData, valueToChangeAddExistingItem));
        // If observable, subscribe to change notification the normal way.
        if (ko.isObservable(this.data)) {
            if (!this.data.indexOf) // Make sure the observable is trackable.
            this.data = this.data.extend({
                trackArrayChanges: true
            });
            this.changeSubs = this.data.subscribe(this.onArrayChange, this, "arrayChange");
        } else // If not observable, use a ko.computed as a means of subscribing to array changes via
        // ko's dependency tracking magic. This allows tracking of reactive ko-es5 property that
        // wraps an observableArray internally.
        this.changeSubs = ko.computed(function() {
            var value = useRawData ? context.$rawData : valueAccessor();
            var newContents = ko.unwrap(isPlainObject(value) ? value.data : value);
            // Since we have no direct reference to the underlying observable (if any), we can't just call
            // .subscribe('arrayChange') on it to get change tracking notifications. So we need to track
            // the before/after array contents explicitly, but can use knockout's own logic to get the
            // diffs between them.
            if (this.previousContents != null) {
                var diff = ko.utils.compareArrays(this.previousContents, newContents, {
                    sparse: true
                });
                if (diff.length != 0) self.onArrayChange(diff);
            }
            this.previousContents = [].concat(newContents);
        }, {
            previousContents: null
        });
    }
    InitializedForeach.animateFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function(cb) {
        return window.setTimeout(cb, 1000 / 60);
    };
    InitializedForeach.prototype.dispose = function() {
        if (this.changeSubs) this.changeSubs.dispose();
    };
    // If the array changes we register the change.
    InitializedForeach.prototype.onArrayChange = function(changeSet) {
        var self = this;
        var changeMap = {
            added: [],
            existing: [],
            deleted: []
        };
        ko.utils.arrayForEach(changeSet, function(changeItem) {
            changeMap[changeItem.status].push(changeItem);
        });
        if (typeof this.dataChanged === "function") this.dataChanged(changeMap);
        if (changeMap.deleted.length > 0) {
            this.changeQueue.push.apply(this.changeQueue, changeMap.deleted);
            this.changeQueue.push({
                status: "clearDeletedIndexes"
            });
        }
        this.changeQueue.push.apply(this.changeQueue, changeMap.existing);
        this.changeQueue.push.apply(this.changeQueue, changeMap.added);
        // Once a change is registered, the ticking count-down starts for the processQueue.
        if (this.changeQueue.length > 0 && !this.rendering_queued) {
            this.rendering_queued = true;
            InitializedForeach.animateFrame.call(window, function() {
                self.processQueue();
            });
        }
    };
    // Reflect all the changes in the queue in the DOM, then wipe the queue.
    InitializedForeach.prototype.processQueue = function() {
        var self = this;
        // Callback so folks can do things before the queue flush.
        if (typeof this.beforeQueueFlush === "function") this.beforeQueueFlush(this.changeQueue);
        ko.utils.arrayForEach(this.changeQueue, function(changeItem) {
            self[changeItem.status](changeItem.index, changeItem.value);
        });
        this.rendering_queued = false;
        // Callback so folks can do things.
        if (typeof this.afterQueueFlush === "function") this.afterQueueFlush(this.changeQueue);
        this.changeQueue = [];
    };
    InitializedForeach.prototype.createChildContext = function(index, value) {
        if (this.noContext) return this.$context.extend({
            $item: value
        });
        return this.$context.createChildContext(value, this.as || null, function(context) {
            context["$index"] = ko.observable(index);
        });
    };
    // Process a changeItem with {status: 'existing', ...}
    InitializedForeach.prototype.existing = function(index, value) {
        var context = this.childContexts[index] = this.createChildContext(index, value);
        var elementIndex = index * this.nodesPerElement;
        var existingElement;
        for(var i = 0; i < this.nodesPerElement; i++){
            existingElement = this.existingElements[elementIndex + i];
            ko.applyBindings(context, existingElement);
        }
        this.lastNodesList.splice(index, 0, existingElement);
    };
    // Process a changeItem with {status: 'added', ...}
    InitializedForeach.prototype.added = function(index, value) {
        var referenceElement = this.lastNodesList[index - 1] || null;
        var templateClone = this.templateNode.cloneNode(true);
        var childNodes = ko.virtualElements.childNodes(templateClone);
        this.lastNodesList.splice(index, 0, childNodes[childNodes.length - 1]);
        this.childContexts[index] = this.createChildContext(index, value);
        ko.applyBindingsToDescendants(this.childContexts[index], templateClone);
        // Nodes are inserted in reverse order - pushed down immediately after
        // the last node for the previous item or as the first node of element.
        for(var i = childNodes.length - 1; i >= 0; --i){
            var child = childNodes[i];
            if (!child) return;
            ko.virtualElements.insertAfter(this.element, child, referenceElement);
        }
    };
    // Process a changeItem with {status: 'deleted', ...}
    InitializedForeach.prototype.deleted = function(index, value) {
        var ptr = this.lastNodesList[index], // We use this.element because that will be the last previous node
        // for virtual element lists.
        lastNode = this.lastNodesList[index - 1] || this.element;
        do {
            ptr = ptr.previousSibling;
            ko.removeNode(ptr && ptr.nextSibling || ko.virtualElements.firstChild(this.element));
        }while (ptr && ptr !== lastNode);
        // The "last node" in the DOM from which we begin our deletes of the next adjacent node is
        // now the sibling that preceded the first node of this item.
        this.lastNodesList[index] = this.lastNodesList[index - 1];
        this.indexesToDelete.push(index);
    };
    // We batch our deletion of item indexes in our parallel array.
    // See brianmhunt/knockout-fast-foreach#6/#8
    InitializedForeach.prototype.clearDeletedIndexes = function() {
        // We iterate in reverse on the presumption (following the unit tests) that KO's diff engine
        // processes diffs (esp. deletes) monotonically ascending i.e. from index 0 -> N.
        for(var i = this.indexesToDelete.length - 1; i >= 0; --i){
            this.lastNodesList.splice(this.indexesToDelete[i], 1);
            this.childContexts.splice(this.indexesToDelete[i], 1);
        }
        // Having deleted items means we need to update the index observables
        for(var j = this.childContexts.length - 1; j >= 0; --j)if (this.childContexts[j] && this.childContexts[j]["$index"]) this.childContexts[j]["$index"](j);
        this.indexesToDelete = [];
    };
    // Create the elements in the data (observable) array for each of
    // the existing elements
    InitializedForeach.prototype.createElements = function() {
        var self = this;
        var elements = [];
        for(var i = 0; i < this.existingElements.length / this.nodesPerElement; i++)elements.push(this.createElement());
        if (ko.isObservable(this.data)) this.data(elements);
        else ko.utils.arrayForEach(elements, function(element) {
            self.data.push(element);
        });
    };
    // This binding handler is similar to the regular foreach binding handler, but with
    // one major difference: it binds the underlying array to existing HTML elements instead
    // of creating new elements. Existing elements must be marked with the "data-init" attribute.
    // What happens is that when the foreachInit binding handler is initialized, it will look for
    // all child elements with the "data-init" attribute and bind them to the values in the
    // underlying (observable) array. To be able to support adding new items, there must be a template.
    // This template is found by looking for a mode marked with the "data-template" attribute.
    ko.bindingHandlers.foreachInit = {
        // Valid valueAccessors:
        //    []
        //    ko.observable([])
        //    ko.observableArray([])
        //    ko.computed
        //    {data: array, name: string, as: string}
        init: function init(element, valueAccessor, bindings, viewModel, context) {
            var initializedForeach = new InitializedForeach(element, valueAccessor, bindings, viewModel, context);
            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                initializedForeach.dispose();
            });
            return {
                controlsDescendantBindings: true
            };
        },
        // Export for testing, debugging, and overloading.
        InitializedForeach: InitializedForeach
    };
    ko.virtualElements.allowedBindings.foreachInit = true;
    function elementIsHidden(element) {
        return element.offsetWidth <= 0 && element.offsetHeight <= 0 || element.style && element.style.display && element.style.display == "none";
    }
    function isObjectWithExplicitValues(value) {
        return isPlainObject(value) && value["value"] === undefined && value["convert"] === undefined && value["field"] === undefined;
    }
    function setExplicitObjectValues(value, viewModel, allBindings) {
        var propertyWriters = allBindings.get("_ko_prerender_initPropertyWriters");
        for(var key in value){
            if (value.hasOwnProperty(key) && viewModel[key] instanceof Function) viewModel[key](value[key]);
            else if (propertyWriters) {
                // Try to get the writer for the non-observable property.
                var writer = propertyWriters[key];
                if (writer) writer(value[key]);
            }
        }
    }
    // Extend single-value bindings.
    extendBindingInit("value");
    extendBindingInit("text");
    extendBindingInit("textInput");
    extendBindingInit("checked", function(element) {
        return element.checked;
    });
    extendBindingInit("visible", function(element) {
        return !elementIsHidden(element);
    });
    extendBindingInit("html", function(element) {
        return element.innerHTML;
    });
    extendBindingInit("enable", function(element) {
        return !element.disabled;
    });
    extendBindingInit("disable", function(element) {
        return element.disabled;
    });
    // Extend multi-value bindings.
    extendBindingInit("attr", function(element, name) {
        return element.attributes[name] ? element.attributes[name].value : undefined;
    }, true, "_ko_prerender_attrPropertyWriters");
    extendBindingInit("css", function(element, name) {
        return new RegExp("\\b" + name + "\\b", "i").test(element.className);
    }, true, "_ko_prerender_cssPropertyWriters");
    function defaultMarkupReader(element) {
        return element.innerText || element.textContent || element.value;
    }
    // Extends the "init" method of a binding handler, to extract the existing value from the markup and write it to the view model before running the normal init logic.
    function extendBindingInit(bindingName, markupReader, isMultiValue, propertyWritersBindingName) {
        // Default arguments
        markupReader = markupReader || defaultMarkupReader;
        propertyWritersBindingName = propertyWritersBindingName || (ko.expressionRewriting._twoWayBindings[bindingName] ? "_ko_property_writers" : undefined);
        var bindingHandler = ko.bindingHandlers[bindingName];
        var existingInit = bindingHandler.init;
        bindingHandler.init = function(element, valueAccessor, allBindings, viewModel) {
            // Look for an init binding.
            var initBinding = allBindings.get("init");
            if (initBinding) {
                var convert = initBinding["convert"];
                if (!isMultiValue) {
                    // Single-value binding.
                    var valueFromMarkup = markupReader(element);
                    // If the init binding is bound to its own field but does not also specify its own value...
                    if (hasFieldOverride(initBinding) && !initBinding.hasOwnProperty("value")) // Then write the value to the init field instead.
                    writeValueToModel(valueFromMarkup, initBinding.hasOwnProperty("field") ? initBinding["field"] : initBinding, convert, "field", allBindings, "_ko_prerender_initPropertyWriters");
                    else // Otherwise write the value to the model as normal.
                    writeValueToModel(valueFromMarkup, valueAccessor(), convert, bindingName, allBindings, propertyWritersBindingName);
                } else {
                    // For a multi-value binding, loop through its properties, read the markup for each key, and write to the model.
                    var props = valueAccessor();
                    for(var key in props){
                        var valueFromMarkup = markupReader(element, key);
                        writeValueToModel(valueFromMarkup, props[key], convert, key, allBindings, propertyWritersBindingName);
                    }
                }
            }
            // Now call the original "init" method.
            if (existingInit) existingInit.apply(this, arguments);
        };
    }
    function writeValueToModel(value, fieldAccessor, convert, key, allBindings, propertyWritersBindingName) {
        if (convert) {
            var conversion = convert.hasOwnProperty(key) ? convert[key] : convert;
            if (conversion instanceof Function) value = conversion(value);
        }
        if (ko.isObservable(fieldAccessor)) fieldAccessor(value, ko.unwrap(fieldAccessor));
        else {
            var propertyWriter = getPropertyWriter(allBindings, propertyWritersBindingName, key);
            if (propertyWriter) propertyWriter(value);
        }
    }
    function getPropertyWriter(allBindings, propertyWritersBindingName, key) {
        if (propertyWritersBindingName) {
            var propertyWriters = allBindings.get(propertyWritersBindingName);
            if (propertyWriters) return propertyWriters[key];
        }
        return null;
    }
    // Returns true if the init binding specifies a field in which to write values extracted from the markup.
    function hasFieldOverride(initBinding) {
        if (isPlainObject(initBinding)) // init: { field: fieldName }
        return initBinding.hasOwnProperty("field");
        // init: fieldName
        return initBinding !== true;
    }
    // This binding handler initializes an observable to a value from the HTML element
    ko.bindingHandlers.init = {
        init: function(element, valueAccessor, allBindings, viewModel) {
            var initBinding = valueAccessor();
            if (initBinding === true) return;
            if (isObjectWithExplicitValues(initBinding)) setExplicitObjectValues(initBinding, viewModel, allBindings);
            var valueElement = isVirtualNode(element) ? ko.virtualElements.firstChild(element) : element;
            var value = initBinding.hasOwnProperty("value") ? initBinding["value"] : defaultMarkupReader(valueElement);
            writeValueToModel(value, initBinding.hasOwnProperty("field") ? initBinding["field"] : initBinding, initBinding["convert"], "field", allBindings, "_ko_prerender_initPropertyWriters");
        }
    };
    generatePropertyWritersForBinding("init", "_ko_prerender_initPropertyWriters", "field", function(expression) {
        var key = expression.key;
        return key === "convert" || key === "value" ? null //'convert' and 'value' do not reference writable fields
         : key === undefined || key === "field" ? expression // these should be left unchanged.
         : {
            key: key,
            value: key
        }; // for all others, the key should also be the value expression.
    });
    ko.virtualElements.allowedBindings.init = true;
});


var $90477eadab3a882f$exports = {};

/*=============================================================================
	Author:			Eric M. Barnard - @ericmbarnard								
	License:		MIT (http://opensource.org/licenses/mit-license.php)		
																				
	Description:	Validation Library for KnockoutJS							
	Version:		2.0.4											
===============================================================================
*/ /*globals require: false, exports: false, define: false, ko: false */ (function(factory) {
    // CommonJS or Node: hard-coded dependency on "knockout"
    factory((parcelRequire("cLR2A")), $90477eadab3a882f$exports);
})(function(ko, exports1) {
    if (typeof ko === "undefined") throw new Error("Knockout is required, please ensure it is loaded before loading this validation plug-in");
    // create our namespace object
    ko.validation = exports1;
    var kv = ko.validation, koUtils = ko.utils, unwrap = koUtils.unwrapObservable, forEach = koUtils.arrayForEach, extend = koUtils.extend;
    var defaults = {
        registerExtenders: true,
        messagesOnModified: true,
        errorsAsTitle: true,
        errorsAsTitleOnModified: false,
        messageTemplate: null,
        insertMessages: true,
        parseInputAttributes: false,
        writeInputAttributes: false,
        decorateInputElement: false,
        decorateElementOnModified: true,
        errorClass: null,
        errorElementClass: "validationElement",
        errorMessageClass: "validationMessage",
        allowHtmlMessages: false,
        grouping: {
            deep: false,
            observable: true,
            live: false //react to changes to observableArrays if observable === true
        },
        validate: {
        }
    };
    // make a copy  so we can use 'reset' later
    var configuration = extend({}, defaults);
    configuration.html5Attributes = [
        "required",
        "pattern",
        "min",
        "max",
        "step"
    ];
    configuration.html5InputTypes = [
        "email",
        "number",
        "date"
    ];
    configuration.reset = function() {
        extend(configuration, defaults);
    };
    kv.configuration = configuration;
    kv.utils = function() {
        var seedId = new Date().getTime();
        var domData = {}; //hash of data objects that we reference from dom elements
        var domDataKey = "__ko_validation__";
        return {
            isArray: function(o) {
                return o.isArray || Object.prototype.toString.call(o) === "[object Array]";
            },
            isObject: function(o) {
                return o !== null && typeof o === "object";
            },
            isNumber: function(o) {
                return !isNaN(o);
            },
            isObservableArray: function(instance) {
                return !!instance && typeof instance["remove"] === "function" && typeof instance["removeAll"] === "function" && typeof instance["destroy"] === "function" && typeof instance["destroyAll"] === "function" && typeof instance["indexOf"] === "function" && typeof instance["replace"] === "function";
            },
            values: function(o) {
                var r = [];
                for(var i in o)if (o.hasOwnProperty(i)) r.push(o[i]);
                return r;
            },
            getValue: function(o) {
                return typeof o === "function" ? o() : o;
            },
            hasAttribute: function(node, attr) {
                return node.getAttribute(attr) !== null;
            },
            getAttribute: function(element, attr) {
                return element.getAttribute(attr);
            },
            setAttribute: function(element, attr, value) {
                return element.setAttribute(attr, value);
            },
            isValidatable: function(o) {
                return !!(o && o.rules && o.isValid && o.isModified);
            },
            insertAfter: function(node, newNode) {
                node.parentNode.insertBefore(newNode, node.nextSibling);
            },
            newId: function() {
                return seedId += 1;
            },
            getConfigOptions: function(element) {
                var options = kv.utils.contextFor(element);
                return options || kv.configuration;
            },
            setDomData: function(node, data) {
                var key = node[domDataKey];
                if (!key) node[domDataKey] = key = kv.utils.newId();
                domData[key] = data;
            },
            getDomData: function(node) {
                var key = node[domDataKey];
                if (!key) return undefined;
                return domData[key];
            },
            contextFor: function(node) {
                switch(node.nodeType){
                    case 1:
                    case 8:
                        var context = kv.utils.getDomData(node);
                        if (context) return context;
                        if (node.parentNode) return kv.utils.contextFor(node.parentNode);
                        break;
                }
                return undefined;
            },
            isEmptyVal: function(val) {
                if (val === undefined) return true;
                if (val === null) return true;
                if (val === "") return true;
                return false;
            },
            getOriginalElementTitle: function(element) {
                var savedOriginalTitle = kv.utils.getAttribute(element, "data-orig-title"), currentTitle = element.title, hasSavedOriginalTitle = kv.utils.hasAttribute(element, "data-orig-title");
                return hasSavedOriginalTitle ? savedOriginalTitle : currentTitle;
            },
            async: function(expr) {
                if (window.setImmediate) window.setImmediate(expr);
                else window.setTimeout(expr, 0);
            },
            forEach: function(object, callback) {
                if (kv.utils.isArray(object)) return forEach(object, callback);
                for(var prop in object)if (object.hasOwnProperty(prop)) callback(object[prop], prop);
            }
        };
    }();
    var api = function() {
        var isInitialized = 0, configuration = kv.configuration, utils = kv.utils;
        function cleanUpSubscriptions(context) {
            forEach(context.subscriptions, function(subscription) {
                subscription.dispose();
            });
            context.subscriptions = [];
        }
        function dispose(context) {
            if (context.options.deep) {
                forEach(context.flagged, function(obj) {
                    delete obj.__kv_traversed;
                });
                context.flagged.length = 0;
            }
            if (!context.options.live) cleanUpSubscriptions(context);
        }
        function traverseGraph(obj, context, level) {
            var objValues = [], val = obj.peek ? obj.peek() : obj;
            if (obj.__kv_traversed === true) return;
            if (context.options.deep) {
                obj.__kv_traversed = true;
                context.flagged.push(obj);
            }
            //default level value depends on deep option.
            level = level !== undefined ? level : context.options.deep ? 1 : -1;
            // if object is observable then add it to the list
            if (ko.isObservable(obj)) {
                // ensure it's validatable but don't extend validatedObservable because it
                // would overwrite isValid property.
                if (!obj.errors && !utils.isValidatable(obj)) obj.extend({
                    validatable: true
                });
                context.validatables.push(obj);
                if (context.options.live && utils.isObservableArray(obj)) context.subscriptions.push(obj.subscribe(function() {
                    context.graphMonitor.valueHasMutated();
                }));
            }
            //get list of values either from array or object but ignore non-objects
            // and destroyed objects
            if (val && !val._destroy) {
                if (utils.isArray(val)) objValues = val;
                else if (utils.isObject(val)) objValues = utils.values(val);
            }
            //process recursively if it is deep grouping
            if (level !== 0) utils.forEach(objValues, function(observable) {
                //but not falsy things and not HTML Elements
                if (observable && !observable.nodeType && (!ko.isComputed(observable) || observable.rules)) traverseGraph(observable, context, level + 1);
            });
        }
        function runTraversal(obj, context) {
            context.validatables = [];
            cleanUpSubscriptions(context);
            traverseGraph(obj, context);
            dispose(context);
        }
        function collectErrors(array) {
            var errors = [];
            forEach(array, function(observable) {
                // Do not collect validatedObservable errors
                if (utils.isValidatable(observable) && !observable.isValid()) // Use peek because we don't want a dependency for 'error' property because it
                // changes before 'isValid' does. (Issue #99)
                errors.push(observable.error.peek());
            });
            return errors;
        }
        return {
            //Call this on startup
            //any config can be overridden with the passed in options
            init: function(options, force) {
                //done run this multiple times if we don't really want to
                if (isInitialized > 0 && !force) return;
                //because we will be accessing options properties it has to be an object at least
                options = options || {};
                //if specific error classes are not provided then apply generic errorClass
                //it has to be done on option so that options.errorClass can override default
                //errorElementClass and errorMessage class but not those provided in options
                options.errorElementClass = options.errorElementClass || options.errorClass || configuration.errorElementClass;
                options.errorMessageClass = options.errorMessageClass || options.errorClass || configuration.errorMessageClass;
                extend(configuration, options);
                if (configuration.registerExtenders) kv.registerExtenders();
                isInitialized = 1;
            },
            // resets the config back to its original state
            reset: kv.configuration.reset,
            // recursively walks a viewModel and creates an object that
            // provides validation information for the entire viewModel
            // obj -> the viewModel to walk
            // options -> {
            //	  deep: false, // if true, will walk past the first level of viewModel properties
            //	  observable: false // if true, returns a computed observable indicating if the viewModel is valid
            // }
            group: function group(obj, options) {
                options = extend(extend({}, configuration.grouping), options);
                var context = {
                    options: options,
                    graphMonitor: ko.observable(),
                    flagged: [],
                    subscriptions: [],
                    validatables: []
                };
                var result = null;
                //if using observables then traverse structure once and add observables
                if (options.observable) result = ko.computed(function() {
                    context.graphMonitor(); //register dependency
                    runTraversal(obj, context);
                    return collectErrors(context.validatables);
                });
                else result = function() {
                    runTraversal(obj, context);
                    return collectErrors(context.validatables);
                };
                result.showAllMessages = function(show) {
                    if (show === undefined) show = true;
                    result.forEach(function(observable) {
                        if (utils.isValidatable(observable)) observable.isModified(show);
                    });
                };
                result.isAnyMessageShown = function() {
                    var invalidAndModifiedPresent;
                    invalidAndModifiedPresent = !!result.find(function(observable) {
                        return utils.isValidatable(observable) && !observable.isValid() && observable.isModified();
                    });
                    return invalidAndModifiedPresent;
                };
                result.filter = function(predicate) {
                    predicate = predicate || function() {
                        return true;
                    };
                    // ensure we have latest changes
                    result();
                    return koUtils.arrayFilter(context.validatables, predicate);
                };
                result.find = function(predicate) {
                    predicate = predicate || function() {
                        return true;
                    };
                    // ensure we have latest changes
                    result();
                    return koUtils.arrayFirst(context.validatables, predicate);
                };
                result.forEach = function(callback) {
                    callback = callback || function() {};
                    // ensure we have latest changes
                    result();
                    forEach(context.validatables, callback);
                };
                result.map = function(mapping) {
                    mapping = mapping || function(item) {
                        return item;
                    };
                    // ensure we have latest changes
                    result();
                    return koUtils.arrayMap(context.validatables, mapping);
                };
                /**
			 * @private You should not rely on this method being here.
			 * It's a private method and it may change in the future.
			 *
			 * @description Updates the validated object and collects errors from it.
			 */ result._updateState = function(newValue) {
                    if (!utils.isObject(newValue)) throw new Error("An object is required.");
                    obj = newValue;
                    if (options.observable) context.graphMonitor.valueHasMutated();
                    else {
                        runTraversal(newValue, context);
                        return collectErrors(context.validatables);
                    }
                };
                return result;
            },
            formatMessage: function(message, params, observable) {
                if (utils.isObject(params) && params.typeAttr) params = params.value;
                if (typeof message === "function") return message(params, observable);
                var replacements = unwrap(params);
                if (replacements == null) replacements = [];
                if (!utils.isArray(replacements)) replacements = [
                    replacements
                ];
                return message.replace(/{(\d+)}/gi, function(match, index) {
                    if (typeof replacements[index] !== "undefined") return replacements[index];
                    return match;
                });
            },
            // addRule:
            // This takes in a ko.observable and a Rule Context - which is just a rule name and params to supply to the validator
            // ie: kv.addRule(myObservable, {
            //		  rule: 'required',
            //		  params: true
            //	  });
            //
            addRule: function(observable, rule) {
                observable.extend({
                    validatable: true
                });
                var hasRule = !!koUtils.arrayFirst(observable.rules(), function(item) {
                    return item.rule && item.rule === rule.rule;
                });
                if (!hasRule) //push a Rule Context to the observables local array of Rule Contexts
                observable.rules.push(rule);
                return observable;
            },
            // addAnonymousRule:
            // Anonymous Rules essentially have all the properties of a Rule, but are only specific for a certain property
            // and developers typically are wanting to add them on the fly or not register a rule with the 'kv.rules' object
            //
            // Example:
            // var test = ko.observable('something').extend{(
            //	  validation: {
            //		  validator: function(val, someOtherVal){
            //			  return true;
            //		  },
            //		  message: "Something must be really wrong!',
            //		  params: true
            //	  }
            //  )};
            addAnonymousRule: function(observable, ruleObj) {
                if (ruleObj["message"] === undefined) ruleObj["message"] = "Error";
                //make sure onlyIf is honoured
                if (ruleObj.onlyIf) ruleObj.condition = ruleObj.onlyIf;
                //add the anonymous rule to the observable
                kv.addRule(observable, ruleObj);
            },
            addExtender: function(ruleName) {
                ko.extenders[ruleName] = function(observable, params) {
                    //params can come in a few flavors
                    // 1. Just the params to be passed to the validator
                    // 2. An object containing the Message to be used and the Params to pass to the validator
                    // 3. A condition when the validation rule to be applied
                    //
                    // Example:
                    // var test = ko.observable(3).extend({
                    //	  max: {
                    //		  message: 'This special field has a Max of {0}',
                    //		  params: 2,
                    //		  onlyIf: function() {
                    //			return specialField.IsVisible();
                    //		  }
                    //	  }
                    //  )};
                    //
                    if (params && (params.message || params.onlyIf)) return kv.addRule(observable, {
                        rule: ruleName,
                        message: params.message,
                        params: utils.isEmptyVal(params.params) ? true : params.params,
                        condition: params.onlyIf
                    });
                    else return kv.addRule(observable, {
                        rule: ruleName,
                        params: params
                    });
                };
            },
            // loops through all kv.rules and adds them as extenders to
            // ko.extenders
            registerExtenders: function() {
                if (configuration.registerExtenders) for(var ruleName in kv.rules){
                    if (kv.rules.hasOwnProperty(ruleName)) {
                        if (!ko.extenders[ruleName]) kv.addExtender(ruleName);
                    }
                }
            },
            //creates a span next to the @element with the specified error class
            insertValidationMessage: function(element) {
                var span = document.createElement("SPAN");
                span.className = utils.getConfigOptions(element).errorMessageClass;
                utils.insertAfter(element, span);
                return span;
            },
            // if html-5 validation attributes have been specified, this parses
            // the attributes on @element
            parseInputValidationAttributes: function(element, valueAccessor) {
                forEach(kv.configuration.html5Attributes, function(attr) {
                    if (utils.hasAttribute(element, attr)) {
                        var params = element.getAttribute(attr) || true;
                        if (attr === "min" || attr === "max") {
                            // If we're validating based on the min and max attributes, we'll
                            // need to know what the 'type' attribute is set to
                            var typeAttr = element.getAttribute("type");
                            if (typeof typeAttr === "undefined" || !typeAttr) // From http://www.w3.org/TR/html-markup/input:
                            //   An input element with no type attribute specified represents the
                            //   same thing as an input element with its type attribute set to "text".
                            typeAttr = "text";
                            params = {
                                typeAttr: typeAttr,
                                value: params
                            };
                        }
                        kv.addRule(valueAccessor(), {
                            rule: attr,
                            params: params
                        });
                    }
                });
                var currentType = element.getAttribute("type");
                forEach(kv.configuration.html5InputTypes, function(type) {
                    if (type === currentType) kv.addRule(valueAccessor(), {
                        rule: type === "date" ? "dateISO" : type,
                        params: true
                    });
                });
            },
            // writes html5 validation attributes on the element passed in
            writeInputValidationAttributes: function(element, valueAccessor) {
                var observable = valueAccessor();
                if (!observable || !observable.rules) return;
                var contexts = observable.rules(); // observable array
                // loop through the attributes and add the information needed
                forEach(kv.configuration.html5Attributes, function(attr) {
                    var ctx = koUtils.arrayFirst(contexts, function(ctx) {
                        return ctx.rule && ctx.rule.toLowerCase() === attr.toLowerCase();
                    });
                    if (!ctx) return;
                    // we have a rule matching a validation attribute at this point
                    // so lets add it to the element along with the params
                    ko.computed({
                        read: function() {
                            var params = ko.unwrap(ctx.params);
                            // we have to do some special things for the pattern validation
                            if (ctx.rule === "pattern" && params instanceof RegExp) // we need the pure string representation of the RegExpr without the //gi stuff
                            params = params.source;
                            element.setAttribute(attr, params);
                        },
                        disposeWhenNodeIsRemoved: element
                    });
                });
                contexts = null;
            },
            //take an existing binding handler and make it cause automatic validations
            makeBindingHandlerValidatable: function(handlerName) {
                var init = ko.bindingHandlers[handlerName].init;
                ko.bindingHandlers[handlerName].init = function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                    init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
                    return ko.bindingHandlers["validationCore"].init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
                };
            },
            // visit an objects properties and apply validation rules from a definition
            setRules: function(target, definition) {
                var setRules = function(target, definition) {
                    if (!target || !definition) return;
                    for(var prop in definition){
                        if (!definition.hasOwnProperty(prop)) continue;
                        var ruleDefinitions = definition[prop];
                        //check the target property exists and has a value
                        if (!target[prop]) continue;
                        var targetValue = target[prop], unwrappedTargetValue = unwrap(targetValue), rules = {}, nonRules = {};
                        for(var rule in ruleDefinitions){
                            if (!ruleDefinitions.hasOwnProperty(rule)) continue;
                            if (kv.rules[rule]) rules[rule] = ruleDefinitions[rule];
                            else nonRules[rule] = ruleDefinitions[rule];
                        }
                        //apply rules
                        if (ko.isObservable(targetValue)) targetValue.extend(rules);
                        //then apply child rules
                        //if it's an array, apply rules to all children
                        if (unwrappedTargetValue && utils.isArray(unwrappedTargetValue)) for(var i = 0; i < unwrappedTargetValue.length; i++)setRules(unwrappedTargetValue[i], nonRules);
                        else setRules(unwrappedTargetValue, nonRules);
                    }
                };
                setRules(target, definition);
            }
        };
    }();
    // expose api publicly
    extend(ko.validation, api);
    // You can view and override messages or rules via:
    // kv.rules[ruleName]
    //
    // To implement a custom Rule, simply use this template:
    // kv.rules['<custom rule name>'] = {
    //      validator: function (val, param) {
    //          <custom logic>
    //          return <true or false>;
    //      },
    //      message: '<custom validation message>' //optionally you can also use a '{0}' to denote a placeholder that will be replaced with your 'param'
    // };
    //
    // Example:
    // kv.rules['mustEqual'] = {
    //      validator: function( val, mustEqualVal ){
    //          return val === mustEqualVal;
    //      },
    //      message: 'This field must equal {0}'
    // };
    //
    kv.rules = {};
    kv.rules["required"] = {
        validator: function(val, required) {
            var testVal;
            if (val === undefined || val === null) return !required;
            testVal = val;
            if (typeof val === "string") {
                if (String.prototype.trim) testVal = val.trim();
                else testVal = val.replace(/^\s+|\s+$/g, "");
            }
            if (!required) return true;
            return (testVal + "").length > 0;
        },
        message: "This field is required."
    };
    function minMaxValidatorFactory(validatorName) {
        var isMaxValidation = validatorName === "max";
        return function(val, options) {
            if (kv.utils.isEmptyVal(val)) return true;
            var comparisonValue, type;
            if (options.typeAttr === undefined) {
                // This validator is being called from javascript rather than
                // being bound from markup
                type = "text";
                comparisonValue = options;
            } else {
                type = options.typeAttr;
                comparisonValue = options.value;
            }
            // From http://www.w3.org/TR/2012/WD-html5-20121025/common-input-element-attributes.html#attr-input-min,
            // if the value is parseable to a number, then the minimum should be numeric
            if (!isNaN(comparisonValue) && !(comparisonValue instanceof Date)) type = "number";
            var regex, valMatches, comparisonValueMatches;
            switch(type.toLowerCase()){
                case "week":
                    regex = /^(\d{4})-W(\d{2})$/;
                    valMatches = val.match(regex);
                    if (valMatches === null) throw new Error("Invalid value for " + validatorName + " attribute for week input.  Should look like " + "'2000-W33' http://www.w3.org/TR/html-markup/input.week.html#input.week.attrs.min");
                    comparisonValueMatches = comparisonValue.match(regex);
                    // If no regex matches were found, validation fails
                    if (!comparisonValueMatches) return false;
                    if (isMaxValidation) return valMatches[1] < comparisonValueMatches[1] || // older year
                    // same year, older week
                    valMatches[1] === comparisonValueMatches[1] && valMatches[2] <= comparisonValueMatches[2];
                    else return valMatches[1] > comparisonValueMatches[1] || // newer year
                    // same year, newer week
                    valMatches[1] === comparisonValueMatches[1] && valMatches[2] >= comparisonValueMatches[2];
                    break;
                case "month":
                    regex = /^(\d{4})-(\d{2})$/;
                    valMatches = val.match(regex);
                    if (valMatches === null) throw new Error("Invalid value for " + validatorName + " attribute for month input.  Should look like " + "'2000-03' http://www.w3.org/TR/html-markup/input.month.html#input.month.attrs.min");
                    comparisonValueMatches = comparisonValue.match(regex);
                    // If no regex matches were found, validation fails
                    if (!comparisonValueMatches) return false;
                    if (isMaxValidation) return valMatches[1] < comparisonValueMatches[1] || // older year
                    // same year, older month
                    valMatches[1] === comparisonValueMatches[1] && valMatches[2] <= comparisonValueMatches[2];
                    else return valMatches[1] > comparisonValueMatches[1] || // newer year
                    // same year, newer month
                    valMatches[1] === comparisonValueMatches[1] && valMatches[2] >= comparisonValueMatches[2];
                    break;
                case "number":
                case "range":
                    if (isMaxValidation) return !isNaN(val) && parseFloat(val) <= parseFloat(comparisonValue);
                    else return !isNaN(val) && parseFloat(val) >= parseFloat(comparisonValue);
                    break;
                default:
                    if (isMaxValidation) return val <= comparisonValue;
                    else return val >= comparisonValue;
            }
        };
    }
    kv.rules["min"] = {
        validator: minMaxValidatorFactory("min"),
        message: "Please enter a value greater than or equal to {0}."
    };
    kv.rules["max"] = {
        validator: minMaxValidatorFactory("max"),
        message: "Please enter a value less than or equal to {0}."
    };
    kv.rules["minLength"] = {
        validator: function(val, minLength) {
            if (kv.utils.isEmptyVal(val)) return true;
            var normalizedVal = kv.utils.isNumber(val) ? "" + val : val;
            return normalizedVal.length >= minLength;
        },
        message: "Please enter at least {0} characters."
    };
    kv.rules["maxLength"] = {
        validator: function(val, maxLength) {
            if (kv.utils.isEmptyVal(val)) return true;
            var normalizedVal = kv.utils.isNumber(val) ? "" + val : val;
            return normalizedVal.length <= maxLength;
        },
        message: "Please enter no more than {0} characters."
    };
    kv.rules["pattern"] = {
        validator: function(val, regex) {
            return kv.utils.isEmptyVal(val) || val.toString().match(regex) !== null;
        },
        message: "Please check this value."
    };
    kv.rules["step"] = {
        validator: function(val, step) {
            // in order to handle steps of .1 & .01 etc.. Modulus won't work
            // if the value is a decimal, so we have to correct for that
            if (kv.utils.isEmptyVal(val) || step === "any") return true;
            var dif = val * 100 % (step * 100);
            return Math.abs(dif) < 0.00001 || Math.abs(1 - dif) < 0.00001;
        },
        message: "The value must increment by {0}."
    };
    kv.rules["email"] = {
        validator: function(val, validate) {
            if (!validate) return true;
            //I think an empty email address is also a valid entry
            //if one want's to enforce entry it should be done with 'required: true'
            return kv.utils.isEmptyVal(val) || // jquery validate regex - thanks Scott Gonzalez
            validate && /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(val);
        },
        message: "Please enter a proper email address."
    };
    kv.rules["date"] = {
        validator: function(value, validate) {
            if (!validate) return true;
            return kv.utils.isEmptyVal(value) || validate && !/Invalid|NaN/.test(new Date(value));
        },
        message: "Please enter a proper date."
    };
    kv.rules["dateISO"] = {
        validator: function(value, validate) {
            if (!validate) return true;
            return kv.utils.isEmptyVal(value) || validate && /^\d{4}[-/](?:0?[1-9]|1[012])[-/](?:0?[1-9]|[12][0-9]|3[01])$/.test(value);
        },
        message: "Please enter a proper date."
    };
    kv.rules["number"] = {
        validator: function(value, validate) {
            if (!validate) return true;
            return kv.utils.isEmptyVal(value) || validate && /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);
        },
        message: "Please enter a number."
    };
    kv.rules["digit"] = {
        validator: function(value, validate) {
            if (!validate) return true;
            return kv.utils.isEmptyVal(value) || validate && /^\d+$/.test(value);
        },
        message: "Please enter a digit."
    };
    kv.rules["phoneUS"] = {
        validator: function(phoneNumber, validate) {
            if (!validate) return true;
            if (kv.utils.isEmptyVal(phoneNumber)) return true;
             // makes it optional, use 'required' rule if it should be required
            if (typeof phoneNumber !== "string") return false;
            phoneNumber = phoneNumber.replace(/\s+/g, "");
            return validate && phoneNumber.length > 9 && phoneNumber.match(/^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
        },
        message: "Please specify a valid phone number."
    };
    kv.rules["equal"] = {
        validator: function(val, params) {
            var otherValue = params;
            return val === kv.utils.getValue(otherValue);
        },
        message: "Values must equal."
    };
    kv.rules["notEqual"] = {
        validator: function(val, params) {
            var otherValue = params;
            return val !== kv.utils.getValue(otherValue);
        },
        message: "Please choose another value."
    };
    //unique in collection
    // options are:
    //    collection: array or function returning (observable) array
    //              in which the value has to be unique
    //    valueAccessor: function that returns value from an object stored in collection
    //              if it is null the value is compared directly
    //    external: set to true when object you are validating is automatically updating collection
    kv.rules["unique"] = {
        validator: function(val, options) {
            var c = kv.utils.getValue(options.collection), external = kv.utils.getValue(options.externalValue), counter = 0;
            if (!val || !c) return true;
            koUtils.arrayFilter(c, function(item) {
                if (val === (options.valueAccessor ? options.valueAccessor(item) : item)) counter++;
            });
            // if value is external even 1 same value in collection means the value is not unique
            return counter < (!!external ? 1 : 2);
        },
        message: "Please make sure the value is unique."
    };
    //now register all of these!
    (function() {
        kv.registerExtenders();
    })();
    // this allows us to setup any value binding that internally always
    // performs the same functionality
    ko.bindingHandlers["validationCore"] = function() {
        return {
            init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var config = kv.utils.getConfigOptions(element);
                var observable = valueAccessor();
                // parse html5 input validation attributes, optional feature
                if (config.parseInputAttributes) kv.utils.async(function() {
                    kv.parseInputValidationAttributes(element, valueAccessor);
                });
                // if requested insert message element and apply bindings
                if (config.insertMessages && kv.utils.isValidatable(observable)) {
                    // insert the <span></span>
                    var validationMessageElement = kv.insertValidationMessage(element);
                    // if we're told to use a template, make sure that gets rendered
                    if (config.messageTemplate) ko.renderTemplate(config.messageTemplate, {
                        field: observable
                    }, null, validationMessageElement, "replaceNode");
                    else ko.applyBindingsToNode(validationMessageElement, {
                        validationMessage: observable
                    });
                }
                // write the html5 attributes if indicated by the config
                if (config.writeInputAttributes && kv.utils.isValidatable(observable)) kv.writeInputValidationAttributes(element, valueAccessor);
                // if requested, add binding to decorate element
                if (config.decorateInputElement && kv.utils.isValidatable(observable)) ko.applyBindingsToNode(element, {
                    validationElement: observable
                });
            }
        };
    }();
    // override for KO's default 'value', 'checked', 'textInput' and selectedOptions bindings
    kv.makeBindingHandlerValidatable("value");
    kv.makeBindingHandlerValidatable("checked");
    if (ko.bindingHandlers.textInput) kv.makeBindingHandlerValidatable("textInput");
    kv.makeBindingHandlerValidatable("selectedOptions");
    ko.bindingHandlers["validationMessage"] = {
        update: function(element, valueAccessor) {
            var obsv = valueAccessor(), config = kv.utils.getConfigOptions(element), val = unwrap(obsv), msg = null, isModified = false, isValid = false;
            if (obsv === null || typeof obsv === "undefined") throw new Error("Cannot bind validationMessage to undefined value. data-bind expression: " + element.getAttribute("data-bind"));
            isModified = obsv.isModified && obsv.isModified();
            isValid = obsv.isValid && obsv.isValid();
            var error = null;
            if (!config.messagesOnModified || isModified) error = isValid ? null : obsv.error;
            var isVisible = !config.messagesOnModified || isModified ? !isValid : false;
            var isCurrentlyVisible = element.style.display !== "none";
            if (config.allowHtmlMessages) koUtils.setHtml(element, error);
            else ko.bindingHandlers.text.update(element, function() {
                return error;
            });
            if (isCurrentlyVisible && !isVisible) element.style.display = "none";
            else if (!isCurrentlyVisible && isVisible) element.style.display = "";
        }
    };
    ko.bindingHandlers["validationElement"] = {
        update: function(element, valueAccessor, allBindingsAccessor) {
            var obsv = valueAccessor(), config = kv.utils.getConfigOptions(element), val = unwrap(obsv), msg = null, isModified = false, isValid = false;
            if (obsv === null || typeof obsv === "undefined") throw new Error("Cannot bind validationElement to undefined value. data-bind expression: " + element.getAttribute("data-bind"));
            isModified = obsv.isModified && obsv.isModified();
            isValid = obsv.isValid && obsv.isValid();
            // create an evaluator function that will return something like:
            // css: { validationElement: true }
            var cssSettingsAccessor = function() {
                var css = {};
                var shouldShow = !config.decorateElementOnModified || isModified ? !isValid : false;
                // css: { validationElement: false }
                css[config.errorElementClass] = shouldShow;
                return css;
            };
            //add or remove class on the element;
            ko.bindingHandlers.css.update(element, cssSettingsAccessor, allBindingsAccessor);
            if (!config.errorsAsTitle) return;
            ko.bindingHandlers.attr.update(element, function() {
                var hasModification = !config.errorsAsTitleOnModified || isModified, title = kv.utils.getOriginalElementTitle(element);
                if (hasModification && !isValid) return {
                    title: obsv.error,
                    "data-orig-title": title
                };
                else if (!hasModification || isValid) return {
                    title: title,
                    "data-orig-title": null
                };
            });
        }
    };
    // ValidationOptions:
    // This binding handler allows you to override the initial config by setting any of the options for a specific element or context of elements
    //
    // Example:
    // <div data-bind="validationOptions: { insertMessages: true, messageTemplate: 'customTemplate', errorMessageClass: 'mySpecialClass'}">
    //      <input type="text" data-bind="value: someValue"/>
    //      <input type="text" data-bind="value: someValue2"/>
    // </div>
    ko.bindingHandlers["validationOptions"] = function() {
        return {
            init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var options = unwrap(valueAccessor());
                if (options) {
                    var newConfig = extend({}, kv.configuration);
                    extend(newConfig, options);
                    //store the validation options on the node so we can retrieve it later
                    kv.utils.setDomData(element, newConfig);
                }
            }
        };
    }();
    // This is for creating custom validation logic on the fly
    // Example:
    // var test = ko.observable('something').extend{(
    //      validation: {
    //          validator: function(val, someOtherVal){
    //              return true;
    //          },
    //          message: "Something must be really wrong!',
    //          params: true
    //      }
    //  )};
    ko.extenders["validation"] = function(observable, rules) {
        forEach(kv.utils.isArray(rules) ? rules : [
            rules
        ], function(rule) {
            // the 'rule' being passed in here has no name to identify a core Rule,
            // so we add it as an anonymous rule
            // If the developer is wanting to use a core Rule, but use a different message see the 'addExtender' logic for examples
            kv.addAnonymousRule(observable, rule);
        });
        return observable;
    };
    //This is the extender that makes a Knockout Observable also 'Validatable'
    //examples include:
    // 1. var test = ko.observable('something').extend({validatable: true});
    // this will ensure that the Observable object is setup properly to respond to rules
    //
    // 2. test.extend({validatable: false});
    // this will remove the validation properties from the Observable object should you need to do that.
    ko.extenders["validatable"] = function(observable, options) {
        if (!kv.utils.isObject(options)) options = {
            enable: options
        };
        if (!("enable" in options)) options.enable = true;
        if (options.enable && !kv.utils.isValidatable(observable)) {
            var config = kv.configuration.validate || {};
            var validationOptions = {
                throttleEvaluation: options.throttle || config.throttle
            };
            observable.error = ko.observable(null); // holds the error message, we only need one since we stop processing validators when one is invalid
            // observable.rules:
            // ObservableArray of Rule Contexts, where a Rule Context is simply the name of a rule and the params to supply to it
            //
            // Rule Context = { rule: '<rule name>', params: '<passed in params>', message: '<Override of default Message>' }
            observable.rules = ko.observableArray(); //holds the rule Contexts to use as part of validation
            //in case async validation is occurring
            observable.isValidating = ko.observable(false);
            //the true holder of whether the observable is valid or not
            observable.__valid__ = ko.observable(true);
            observable.isModified = ko.observable(false);
            // a semi-protected observable
            observable.isValid = ko.computed(observable.__valid__);
            //manually set error state
            observable.setError = function(error) {
                var previousError = observable.error.peek();
                var previousIsValid = observable.__valid__.peek();
                observable.error(error);
                observable.__valid__(false);
                if (previousError !== error && !previousIsValid) // if the observable was not valid before then isValid will not mutate,
                // hence causing any grouping to not display the latest error.
                observable.isValid.notifySubscribers();
            };
            //manually clear error state
            observable.clearError = function() {
                observable.error(null);
                observable.__valid__(true);
                return observable;
            };
            //subscribe to changes in the observable
            var h_change = observable.subscribe(function() {
                observable.isModified(true);
            });
            // we use a computed here to ensure that anytime a dependency changes, the
            // validation logic evaluates
            var h_obsValidationTrigger = ko.computed(extend({
                read: function() {
                    var obs = observable(), ruleContexts = observable.rules();
                    kv.validateObservable(observable);
                    return true;
                }
            }, validationOptions));
            extend(h_obsValidationTrigger, validationOptions);
            observable._disposeValidation = function() {
                //first dispose of the subscriptions
                observable.isValid.dispose();
                observable.rules.removeAll();
                h_change.dispose();
                h_obsValidationTrigger.dispose();
                delete observable["rules"];
                delete observable["error"];
                delete observable["isValid"];
                delete observable["isValidating"];
                delete observable["__valid__"];
                delete observable["isModified"];
                delete observable["setError"];
                delete observable["clearError"];
                delete observable["_disposeValidation"];
            };
        } else if (options.enable === false && observable._disposeValidation) observable._disposeValidation();
        return observable;
    };
    function validateSync(observable, rule, ctx) {
        //Execute the validator and see if its valid
        if (!rule.validator(observable(), ctx.params === undefined ? true : unwrap(ctx.params))) {
            //not valid, so format the error message and stick it in the 'error' variable
            observable.setError(kv.formatMessage(ctx.message || rule.message, unwrap(ctx.params), observable));
            return false;
        } else return true;
    }
    function validateAsync(observable, rule, ctx) {
        observable.isValidating(true);
        var callBack = function(valObj) {
            var isValid = false, msg = "";
            if (!observable.__valid__()) {
                // since we're returning early, make sure we turn this off
                observable.isValidating(false);
                return; //if its already NOT valid, don't add to that
            }
            //we were handed back a complex object
            if (valObj["message"]) {
                isValid = valObj.isValid;
                msg = valObj.message;
            } else isValid = valObj;
            if (!isValid) {
                //not valid, so format the error message and stick it in the 'error' variable
                observable.error(kv.formatMessage(msg || ctx.message || rule.message, unwrap(ctx.params), observable));
                observable.__valid__(isValid);
            }
            // tell it that we're done
            observable.isValidating(false);
        };
        kv.utils.async(function() {
            //fire the validator and hand it the callback
            rule.validator(observable(), ctx.params === undefined ? true : unwrap(ctx.params), callBack);
        });
    }
    kv.validateObservable = function(observable) {
        var i = 0, rule, ctx, ruleContexts = observable.rules(), len = ruleContexts.length; //cache for iterator
        for(; i < len; i++){
            //get the Rule Context info to give to the core Rule
            ctx = ruleContexts[i];
            // checks an 'onlyIf' condition
            if (ctx.condition && !ctx.condition()) continue;
            //get the core Rule to use for validation
            rule = ctx.rule ? kv.rules[ctx.rule] : ctx;
            if (rule["async"] || ctx["async"]) //run async validation
            validateAsync(observable, rule, ctx);
            else {
                //run normal sync validation
                if (!validateSync(observable, rule, ctx)) return false; //break out of the loop
            }
        }
        //finally if we got this far, make the observable valid again!
        observable.clearError();
        return true;
    };
    var _locales = {};
    var _currentLocale;
    kv.defineLocale = function(name, values) {
        if (name && values) {
            _locales[name.toLowerCase()] = values;
            return values;
        }
        return null;
    };
    kv.locale = function(name) {
        if (name) {
            name = name.toLowerCase();
            if (_locales.hasOwnProperty(name)) {
                kv.localize(_locales[name]);
                _currentLocale = name;
            } else throw new Error("Localization " + name + " has not been loaded.");
        }
        return _currentLocale;
    };
    //quick function to override rule messages
    kv.localize = function(msgTranslations) {
        var rules = kv.rules;
        //loop the properties in the object and assign the msg to the rule
        for(var ruleName in msgTranslations)if (rules.hasOwnProperty(ruleName)) rules[ruleName].message = msgTranslations[ruleName];
    };
    // Populate default locale (this will make en-US.js somewhat redundant)
    (function() {
        var localeData = {};
        var rules = kv.rules;
        for(var ruleName in rules)if (rules.hasOwnProperty(ruleName)) localeData[ruleName] = rules[ruleName].message;
        kv.defineLocale("en-us", localeData);
    })();
    // No need to invoke locale because the messages are already defined along with the rules for en-US
    _currentLocale = "en-us";
    ko.applyBindingsWithValidation = function(viewModel, rootNode, options) {
        var node = document.body, config;
        if (rootNode && rootNode.nodeType) {
            node = rootNode;
            config = options;
        } else config = rootNode;
        kv.init();
        if (config) {
            config = extend(extend({}, kv.configuration), config);
            kv.utils.setDomData(node, config);
        }
        ko.applyBindings(viewModel, node);
    };
    //override the original applyBindings so that we can ensure all new rules and what not are correctly registered
    var origApplyBindings = ko.applyBindings;
    ko.applyBindings = function() {
        kv.init();
        origApplyBindings.apply(this, arguments);
    };
    ko.validatedObservable = function(initialValue, options) {
        if (!options && !kv.utils.isObject(initialValue)) return ko.observable(initialValue).extend({
            validatable: true
        });
        var obsv = ko.observable(initialValue);
        obsv.errors = kv.group(kv.utils.isObject(initialValue) ? initialValue : {}, options);
        obsv.isValid = ko.observable(obsv.errors().length === 0);
        if (ko.isObservable(obsv.errors)) obsv.errors.subscribe(function(errors) {
            obsv.isValid(errors.length === 0);
        });
        else ko.computed(obsv.errors).subscribe(function(errors) {
            obsv.isValid(errors.length === 0);
        });
        obsv.subscribe(function(newValue) {
            if (!kv.utils.isObject(newValue)) /*
			 * The validation group works on objects.
			 * Since the new value is a primitive (scalar, null or undefined) we need
			 * to create an empty object to pass along.
			 */ newValue = {};
            // Force the group to refresh
            obsv.errors._updateState(newValue);
            obsv.isValid(obsv.errors().length === 0);
        });
        return obsv;
    };
});



// apply validation rules
(parcelRequire("fO0lp"))(ko);

// locutus
$parcel$global.print_r = (parcelRequire("7mGb1"));

$parcel$global.sprintf = (parcelRequire("aULbU"));

$parcel$global.number_format = (parcelRequire("gDfUQ"));

var $il6dQ = parcelRequire("il6dQ");
var $ef9c86f387726c6b$var$order_form_selector = "#order-form";
// configure payment fuctions
var $ef9c86f387726c6b$var$hosted_fields_styles_object = {
    "input": {
        "font-size": "16pt",
        "color": "#3A3A3A",
        "font-family": "monospace",
        "text-align": "center"
    },
    ".number": {},
    ".valid": {
        "color": "green"
    }
};
var $ef9c86f387726c6b$var$hosted_fields_number_selector = "#card-number";
var $ef9c86f387726c6b$var$hosted_fields_cvv_selector = "#cvv";
var $ef9c86f387726c6b$var$hosted_fields_exp_selector = "#expiration-date";
var $ef9c86f387726c6b$var$hosted_fields_post_code_selector = "#postal-code";
var $ef9c86f387726c6b$var$paypal_button_styles_object = {
    size: "responsive",
    color: "gold",
    shape: "pill",
    label: "checkout"
};
var $ef9c86f387726c6b$var$paypal_button_selector = "#paypal-button";
var $ef9c86f387726c6b$var$pppin4_selector = "#pppin4-button";
vm = new $il6dQ.OrderViewModel($ef9c86f387726c6b$var$order_form_selector, products, customer_support_email, client_token_get_url, ajax_order_create_url, paypal_env, $ef9c86f387726c6b$var$hosted_fields_styles_object, $ef9c86f387726c6b$var$hosted_fields_number_selector, $ef9c86f387726c6b$var$hosted_fields_cvv_selector, $ef9c86f387726c6b$var$hosted_fields_exp_selector, $ef9c86f387726c6b$var$hosted_fields_post_code_selector, $ef9c86f387726c6b$var$paypal_button_selector, $ef9c86f387726c6b$var$paypal_button_styles_object, $ef9c86f387726c6b$var$pppin4_selector);
$(document).ready(function() {
    ko.validation.init({
        insertMessages: false
    });
    // VIEW MODEL INITIALIZATION
    ko.applyBindings(vm);
    // the way these are initialized, this is the only way to avoid triggering
    // validation immediately
    vm.purchaser.country.isModified(false);
    vm.recipient.country.isModified(false);
    vm.order_type($("[name=order_type]:first").val());
    if (close_super_crazy) {
        $("#id\\.order_type_2").attr("disabled", true);
        var ex_text = $("#id\\.order_type_2").parent().find("span").text();
        $("#id\\.order_type_2").parent().find("span").text(ex_text + " (SOLD OUT)");
        $("#id\\.order_type_2").parent().find("span").css("color", "grey");
    }
});

})();
//# sourceMappingURL=order-form.js.map
